import React, {useCallback, useEffect, useRef, useState} from 'react'
import debounce from 'lodash.debounce';
import store from "./store"
import {
    checkData,
    checkData0,
    checkDataArray,
    checkDataBool,
    checkDataFunction,
    checkDataObject,
    checkDataString,
    connectClass,
    dispatch,
    isNotNull,
    isNotNullOrEmpty,
    requireDefault,
    square,
    ternaryArray,
    ternaryObject,
} from 'functions'
import {Navigate, Route, Routes} from 'react-router-dom'
import {
    http,
    WagmiProvider,
    useWriteContract,
    useWatchAsset
} from 'wagmi'
import {
    mainnet, base, linea, scroll, optimism, arbitrum, polygonZkEvm, sepolia
} from 'wagmi/chains'
import monadTestnet from "./otherChains/monadTestnet";
import blast from "./otherChains/blast";
import bob from "./otherChains/bob";
import taiko from "./otherChains/taiko";
import bnb from "./otherChains/bnb";
import vizing from "./otherChains/vizing";
import vizingTestnet from "./otherChains/vizingTestnet";
import {
    signMessage,
    simulateContract,
    waitForTransactionReceipt,
} from '@wagmi/core'
import {message} from 'antd'
import axios from 'axios'
import Web3 from "web3";
import {divide as npDivide, minus as npMinus, plus as npPlus, times as npTimes} from 'number-precision'
// import SwiperCore, {Autoplay} from 'swiper';
// import {Swiper, SwiperSlide} from 'swiper/react';
import 'swiper/swiper.min.css'
import erc20Abi from './erc20Abi';
// import {formatEther, parseEther} from "viem";
import {ethers} from "ethers";
import {QueryClient, QueryClientProvider} from '@tanstack/react-query'
import {WagmiAdapter} from '@reown/appkit-adapter-wagmi'
import {
    createAppKit,
    useAppKit,
    useAppKitAccount,
    useAppKitNetwork
} from '@reown/appkit/react'
import bnbTestnet from "./otherChains/bnbTestnet";
// import monadTestnet from "./otherChains/monadTestnet";
import unichainSepolia from "./otherChains/unichainSepolia";
import injectiveTestnet from "./otherChains/injectiveTestnet";
import injective from "./otherChains/injective";
import SpotlightCard from "./reactbits/SpotlightCard";
import Orb from "./reactbits/Orb";
import GradientText from "./reactbits/GradientText";
import Squares from "./reactbits/Squares";
import ScrollFloat from "./reactbits/ScrollFloat";
import BlurText from "./reactbits/BlurText";
import {BlurGradientBg} from "reactbits/BlurGradientBg.module.js"
import sonicBlazeTestnet from "./otherChains/sonicBlazeTestnet";
import hyperliquidTestnet from "./otherChains/hyperliquidTestnet";
import somniaTestnet from "./otherChains/somniaTestnet";

let switchSearchNetwork
const sessionDev = true,//sessionStorage.getItem('dev'),
    masterChain = sessionDev ? vizingTestnet : vizing,
    prdChains = [base, linea, scroll, arbitrum, optimism, polygonZkEvm, blast, bob, taiko, bnb, mainnet],
    memeSlaveContracts = [sepolia, bnbTestnet, monadTestnet], // sessionDev
    //     ? [sepolia]
    //     : prdChains,
    portfolioPrdOpen = true || sessionDev, likwidMemeTG = 'https://t.me/likwid_fi',
    twitterURL = 'https://x.com/likwid_fi',
    githubURL = 'https://github.com/likwid-fi',
    socialLinks = [
        ['medium1', 'https://medium.com/@likwidofficial'],
        ['twitter1', twitterURL],
        ['telegeram1', likwidMemeTG],
        ['github1', githubURL],
        ['YouTube1', 'https://www.youtube.com/@LIKWIDFI']
    ],
    {
        location, open: windowOpen
    } = window,
    {href: locationHref} = location,
    locationHrefTo = href => location.href = href,
    searchChain = checkDataString(new URLSearchParams(location.search).get('chain')).toLowerCase(),
    searchChains = [
        ['bnb', bnb],
        // ['mon-testnet', monadTestnet],
        // ['inj', injective],
        // ['inj-testnet', injectiveTestnet],
        // ['somnia-testnet', somniaTestnet]
        // ['sep', sepolia],
        // ['bnb-testnet', bnbTestnet],
        // ['uni', unichain],
        // ['uni-testnet', unichainSepolia],
        // ['s-testnet', sonicBlazeTestnet],
        // ['hype-testnet', hyperliquidTestnet]
    ],
    searchChainIsIncludes = searchChains.map(([name]) => name).includes(searchChain),
    chains = searchChains.map(v => v[1]),
    searchChainData = checkDataObject(searchChains.filter(([name]) => name === searchChain), 0, 1),
    searchChainId = searchChainData.id,
    //[...memeSlaveContracts, ...ternaryArray(portfolioPrdOpen && location.pathname.slice(1).split('/')[0] === 'portfolio', [masterChain])],
    defaultChain = chains[0], chainIds = chains.map(v => v.id), initData = {},
    windowReplaceExternal = path => location.href = path,
    windowReplace = path => {
        const newUrl = new URL(`${location.origin}${path}`)
        searchChainIsIncludes && newUrl.searchParams.set('chain', searchChain)
        location.href = newUrl.href
    },
    projectId = '2006745ac580b61f1610d79f53496c97',
    // wagmiConfig = createConfig({
    //     autoConnect: true,
    //     connectors: w3mConnectors({chains, projectId, version: 2}),
    //     publicClient: configureChains(chains, [w3mProvider({projectId})]).publicClient,
    // }),
    // wagmiConfig = createConfig({
    //     autoConnect: true,
    //     connectors: w3mConnectors({chains, projectId, version: 2}),
    //     publicClient: configureChains(chains, [
    //         jsonRpcProvider({
    //             rpc: chain => ({
    //                 http: require(`./rpc/${chain.id}`).default
    //             })
    //         })
    //     ]).publicClient,
    // }),
    wagmiAdapter = new WagmiAdapter({
        projectId,
        ssr: true,
        networks: chains,
        transports: Object.fromEntries(chains.map(v => [v.id, http(require(`./rpc/${v.id}`).default)]))
    }),
    {wagmiConfig} = wagmiAdapter,
    queryClient = new QueryClient(),
    height = '.6rem', heightPhone = '2rem',
    leaveOut = (str, start = 6, end = 4) => str ? [str.slice(0, start), str.slice(str.length - end)].join('...') : '',
    contractStatuData = () => JSON.parse(store.getState().contractStatuData),
    Oracles = [
        ['No Oracle', `Does not rely on 
third-party oracles`, `Listing of Any Assets permissionless`],
        ['Project-Friendly', 'Dual liquidation mechanism', `Swap-based liquidation mechanism and repayment-based liquidation mechanism`],
        ['LP-Friendly', 'Dynamic fee', `Implementing the Swap-based liquidation mechanism 
will cause the fee to change, and liquidation penalties 
will be sent to LPs.`],
    ],
    Oracles1 = [
        ['Group 427320801', `Truncated price for 
Anti Price manipulation`, `The first implementation uses truncated price proposed by Uniswap as the liq.price to prevent flash loan attacks and price manipulation.`],
        ['cross-ring', 'Structured Liquidity', `Users can freely choose the tokens that can be 
borrowed`],
        ['Group 427320803', 'Enhanced Security', 'All LPs are managed directly by Uniswap v4\'s singleton contracts'],
    ],
    formula1 = `This simple formula bridges the gap between lending and swapping, achieving the unification of the two largest sectors in DeFi.

where:
x,y: Represents the target ERC-20 token quantity.
x',y′: A mapped derivative token created by the protocol.`,
    likwidFormula = [['Uniswap v2', 'K = 20 * 100', 100], ['Likwid formula', 'K = ( 20 + 0 ) * ( 90 + 10 )', 90, 'y’=10']],
    Roadmaps = [
        [
            '2024 Q4',
            `Kickoff 
Team Construction
Product Prototype
Testnet Launch`],
        [
            '2025 Q1',
            `Security Audit
Launch β Version on Mainnet
V1 Version Testnet Launch`],
        [
            '2025 Q2',
            `V1 Version Mainnet Launch
DAO Governance & Voting
V2 Product Conception
V2 Version Testnet Launch
Security Audit for V2 Version  
V2 Version Mainnet Launch`],
        [
            '2025 Q3',
            `V3 Product Conception 
V3 Version Testnet Launch
Token Economics Proposals`
        ]
    ],
    lkwidHook = [['Singleton contract', 'Provide important gas savings'], ['Flash accounting( EIP-1153)', 'Bring cleaner contract designs'], ['Native ETH', 'Additional gas savings'],],
    whitepaper = (url = '') => windowOpen(`https://likwidfi.gitbook.io/likwid-protocol-docs/${url}`),
    defaultPage = 1,
    searchSymbolOnKeyUp = (e, func = () => {
    }) => e.keyCode === 13 && func(),
    address0 = '0x0000000000000000000000000000000000000000',
    scientificToString = num => {
        try {
            const str = num.toString(); // 将数字转换为字符串形式
            if (!str.includes('e')) {
                // 如果不是科学计数法，直接返回原字符串
                return str;
            }

            const [base, exponent] = str.split('e'); // 分割科学计数法的基数和指数
            const sign = base.startsWith('-') ? '-' : ''; // 检查并保存符号
            const absBase = base.replace('-', '').replace('.', ''); // 去掉负号并移除小数点
            const expValue = parseInt(exponent, 10); // 指数部分

            if (expValue < 0) {
                // 处理负指数：生成小数形式
                const decimals = Math.abs(expValue);
                return `${sign}0.${'0'.repeat(decimals - 1)}${absBase}`;
            } else {
                // 处理正指数：生成大数形式
                const zerosToAdd = expValue - (absBase.length - 1);
                if (zerosToAdd >= 0) {
                    return `${sign}${absBase}${'0'.repeat(zerosToAdd)}`;
                } else {
                    const decimalPointIndex = absBase.length + zerosToAdd;
                    return `${sign}${absBase.slice(0, decimalPointIndex)}.${absBase.slice(decimalPointIndex)}`;
                }
            }
        } catch {
            return '0'
        }
    },
    toInt = num => num.toString().replace(/\.\d*$/, ''),
    trimDecimalZeros = num => num.toString()
        .replace(/(\.\d*?)0+$/, '$1').replace(/\.$/, ''),
    toFixed = (num, decimals = defaultDecimals) =>
        trimDecimalZeros(num.toString().replace(new RegExp(`(\\.\\d{${decimals}})\\d*`), '$1')),
    num8 = num => {
        num = scientificToString(num).replace(/(\.\d{8})\d*/, '$1')
            .replace(/(\.\d*?)0+$/, '$1').replace(/\.$/, '')
        return num === '-0' ? '0' : num
    },
    amountReplace = (num = 0, removeZero = true) => {
        num = num.toString().replace(/[^\d.]/g, '').replace(/\.{2,}/g, ".")
            // replace(/^(\.)/, "0.")
            .replace(/^\./g, "").replace(".", "$#$").replace(/\./g, "").replace("$#$", ".")
            .replace(/^(\-)*(\d+)\.(\d{8}).*$/, '$1$2.$3')
        return removeZero ? num.replace(/(?:\.0*|(\.\d+?)0+)$/, '$1') : num
    },
    percentageReplace = (num, carry) => {
        num = times(num.toString(), 100).replace(/(\.\d{2})\d*/, '$1')
        return carry && num === '99.99' ? '100' : num
    },
    defaultDecimals = 18,
    defaultDecimalsMinus = decimals => 10 ** minus(defaultDecimals, decimals),
    formatEther = (num, decimals = defaultDecimals) => ethers.formatUnits(scientificToString(num).replace(/\.\d*$/, ''), Number(decimals))
        .replace(/(\.\d*?)0+$/, '$1').replace(/\.$/, ''),
    numberETH = (num = 0, decimals = defaultDecimals) => num8(formatEther(num.toString(), decimals)),
    parseEtherNum = (num, decimals = defaultDecimals) => {
        decimals = Number(decimals)
        try {
            return ethers.parseUnits(scientificToString(num).replace(new RegExp(`(\\.\\d{${decimals}})\\d*`), '$1'), decimals)
        } catch {
            return 0n
        }
    },
    apiNumETH = (num, decimals) => formatEther(num, decimals),
    lessThan = (a, b) => parseEtherNum(a) < parseEtherNum(b),
    greaterThan = (a, b) => parseEtherNum(a) > parseEtherNum(b),
    greaterThanOrEqualTo = (a, b) => parseEtherNum(a) >= parseEtherNum(b),
    lessThanOrEqualTo = (a, b) => parseEtherNum(a) <= parseEtherNum(b),
    equalTo = (a, b) => parseEtherNum(a) === parseEtherNum(b),
    minBigInt = 0.000001,
    {utils} = Web3,
    hexToNumber = (hex = address0) => utils.hexToNumber(hex),
    plus = (a, b) => formatEther(parseEtherNum(a) + parseEtherNum(b)),
    minus = (a, b) => formatEther(parseEtherNum(a) - parseEtherNum(b)), times = (a, b) => {
        [a, b = ''] = formatEther(parseEtherNum(a) * parseEtherNum(b)).split('.')
        return `${formatEther(a)}${b}`
    }, divide = (a, b) => {
        try {
            return formatEther(parseEtherNum(parseEtherNum(a)) / parseEtherNum(b))
        } catch {
            return '0'
        }
    },
    formatCurrencyCompact = (value = '') => {
        const abs = value.toString().replace(/[^\d.]/g, '')
        if (!isNotNullOrEmpty(abs)) {
            return ''
        }
        const B = '1e9',
            M = '1e6',
            K = '1e3'
        let suffix = '', num = abs
        if (greaterThanOrEqualTo(abs, B)) {
            num = divide(abs, B)
            suffix = 'B'
        } else if (greaterThanOrEqualTo(abs, M)) {
            num = divide(abs, M)
            suffix = 'M'
        } else if (greaterThanOrEqualTo(abs, K)) {
            num = divide(abs, K)
            suffix = 'K'
        }
        return `${lessThan(value) ? '-' : ''}$${toFixed(num, 2)}${suffix}`
    },
    pageSize = 10,
    needApproveButton = (needApprove, text) => `${needApprove ? 'Approve and ' : ''}${text}`,
    leverageMin = 1, leverageMax = 20,
    defaultDeadlineSecond = 1800,
    percentageNum = num => num.toString().replace(/(\.\d{2})\d*/, '$1'),
    numToPercentage = num => percentageNum(divide(num, 10000)),
    levelKeys = ['One', 'Two', 'Three', 'Four'],
    splitUint224ToUint112 = value => [
        value >> BigInt(112),
        value & ((BigInt(1) << BigInt(112)) - BigInt(1))
    ],
    homeLPPools = require('./homeLPPools'),
    Profile = connectClass(props => {
        const pathname = location.pathname.slice(1), pNs = pathname.split('/'), pNs0 = pNs[0], pNs1 = pNs[1],
            isHome = pNs0 === '', isContest = pNs0 === 'contest', isTrade = pNs0 === 'trade',
            isEarn = pNs0 === 'earn',
            isSwap = isTrade && pNs1 === 'swap',
            isMargin = isTrade && !isSwap,
            showPath = isContest ? '' : pNs0,
            isPool = pNs0 === 'pool',
            isPoolCreate = isPool && pNs1 === 'create',
            isPoolAdd = isPool && pNs1 === 'add',
            isPoolIncrease = isPoolAdd,//isPool && pNs1 === 'increase',
            isPoolAddIncrease = isPoolAdd || isPoolIncrease,
            isTradeSupply = isTrade && pNs1 === 'supply',
            isPoolSupply = isPool && pNs1 === 'supply',
            isSupply = isTradeSupply || isPoolSupply,
            isPoolWithdraw = isPool && pNs1 === 'withdraw',
            isPoolSupplyWithdraw = isPoolSupply || isPoolWithdraw,
            isSupplyWithdraw = isSupply || isPoolSupplyWithdraw,
            isHandelLiquidity = isPoolCreate || isPoolAddIncrease || isPoolSupplyWithdraw,
            urlPoolId = new URLSearchParams(location.search).get('poolid'),
            urlLevel = Number(new URLSearchParams(location.search).get('level')),
            urlTokenIndex = new URLSearchParams(location.search).get('tokenIndex'),
            isPoolDetail = isPool && !isNotNullOrEmpty(pNs1) && urlPoolId,
            isPoolList = isPool && !isNotNullOrEmpty(pNs1) && !urlPoolId,
            isMarginOrTradeSupply = isMargin || isTradeSupply,
            isPoolNeedUrlPoolId = isPoolIncrease || isPoolDetail || isPoolSupplyWithdraw || isMarginOrTradeSupply,
            [messageApi, contextHolder] = message.useMessage(),
            toast = content => messageApi.open({content, style: {marginTop: '1.5rem'}}),
            toastSuccessful = success => toast(success ? 'Successful' : 'Failed'), {isPhoneClientWidth} = store.getState(),
            [data, stateData] = useState({...initData}),
            copyText = (text = '', func) => {
                const input = document.createElement('input')
                input.value = text
                document.body.appendChild(input)
                input.select()
                document.execCommand('Copy')
                document.body.removeChild(input)
                isNotNull(func) ? func() : toastSuccessful(true)
            },
            setData = (d, clean) => stateData(data => ({...(clean ? {} : data), ...d})),
            navigations = [
                ['Trade', () => windowReplace('/trade')],
                ['Pool', () => windowReplace('/pool')],
                ['Earn', () => windowReplace('/earn')],
                ['Docs', () => whitepaper()]
            ],
            devCount = checkData0(data, 'devCount'),
            {address} = useAppKitAccount(),
            // address = '0x79347d7207C5c99445E6E386f1CCcbB31bfe3b1B',
            // address = '0x513c8FEA5DbdF199d1181AAe7131A4F136562B20',
            prevAddress = useRef(),
            devCountAdd = () => setData({
                devCount: devCount + 1
            }), showList = checkDataBool(data, 'showList'),
            toggleShowList = () => setData({showList: !showList}),
            {
                open = () => {
                }
            } = checkDataObject(useAppKit()),
            connectLoading = width => checkDataBool(data, 'showConnectLoading') &&
                <div className={'positionFixed flexColumnCenter'}
                     style={{
                         top: 0, left: 0, right: 0, bottom: 0, zIndex: 1000, background: 'rgba(0,0,0,.56)',
                     }}>
                    <img src={requireDefault('loading')} alt="" style={{width: `${width}rem`}}/>
                </div>,
            {caipNetwork: currentChain, switchNetwork} = useAppKitNetwork(),
            currentChainId = checkData([currentChain, 'id']),
            wrongNetwork = isNotNull(currentChainId) && !chainIds.includes(Number(currentChainId)),
            chainValue = wrongNetwork ? defaultChain : currentChain,
            chainId = checkData([chainValue, 'id'], defaultChain.id),
            blockExplorers = chainValue.blockExplorers.default.url,
            windowOpenTokenAddress = tokenAddress => windowOpen(`${blockExplorers}/address/${tokenAddress}`),
            isBNBFunc = id => [bnbTestnet, bnb].map(v => v['id']).includes(Number(id)),
            coinDatas = {
                56: bnb,
                97: bnbTestnet,
                10143: monadTestnet,
                1439: injectiveTestnet,
                1776: injective,
                57054: sonicBlazeTestnet,
                998: hyperliquidTestnet,
                50312: somniaTestnet,
            },
            coinNames = id => checkData(
                [
                    coinDatas,
                    id,
                    'nativeCurrency',
                    'symbol'
                ],
                'ETH'
            ),
            coinName = coinNames(chainId),
            isShowBorrow = true,//[11155111, 1301, 97, 56].includes(chainId),
            isBorrow = isShowBorrow && isMargin && pNs1 === 'borrow' && !isTradeSupply,
            isOnlyMargin = isMargin && !isBorrow,
            ethAvatar = requireDefault(coinName),
            toggleShowLoading = showLoading => setData({showLoading}),
            showLoading = checkDataBool(data, 'showLoading'),
            loading = showLoading && <div className={'positionFixed flexColumnCenter'}
                                          style={{
                                              top: 0,
                                              left: 0,
                                              right: 0,
                                              bottom: 0,
                                              zIndex: 1000,
                                              background: 'rgba(0,0,0,.56)',
                                          }}>
                <img src={requireDefault('loading')} alt="" style={{width: `${isPhoneClientWidth ? 10 : 5}rem`}}/>
            </div>,
            getSetNewAmount = (num = 0) => amountReplace(num, false),
            urlPools = checkDataArray(data, 'urlPools'),
            // isSelectToken = isSwap || isPoolCreate,
            isNeedToken = isSwap || isPoolCreate,
            // isSelectToken = (!isHome && !isPool && !isEarn) || isTrade || isHandelLiquidity,
            isSelectToken = (!isHome && !isPool && !isEarn && (!isTrade || isSwap)) || isPoolCreate,
            isSelectTokenNotNeedToken = isSelectToken && !isNeedToken,
            isAddress0 = address => address === address0,
            ethToken = {
                name: coinName,
                symbol: coinName,
                avatar: ethAvatar,
                tokenAddress: address0,
                decimals: defaultDecimals
            },
            isETHAddress = (tokenAddress = '') => utils.isAddress(tokenAddress.toLowerCase()) && tokenAddress.includes('0x'),
            addressToCurrencyAddress = addr => isAddress0(addr) ? 'NATIVE' : (isETHAddress(addr) ? addr.toLowerCase() : undefined),
            currencyAddress = key => {
                if (isSwap) {
                    const c = checkDataString(new URLSearchParams(location.search).get(key))
                    return c === 'NATIVE' ? address0 : (isETHAddress(c) ? c.toLowerCase() : undefined)
                } else {
                    return undefined
                }
            },
            inputCurrencyAddress = currencyAddress('inputCurrency'),
            inputCurrencyAddressIsNotNull = isNotNull(inputCurrencyAddress),
            inputCurrency = inputCurrencyAddressIsNotNull
                ? (
                    isAddress0(inputCurrencyAddress)
                        ? ethToken
                        : {
                            ...checkDataObject(data, 'inputCurrency'),
                            tokenAddress: inputCurrencyAddress
                        }
                )
                : {},
            outputCurrencyAddress = currencyAddress('outputCurrency'),
            outputCurrencyAddressIsNotNull = isNotNull(outputCurrencyAddress),
            outputCurrency = outputCurrencyAddressIsNotNull
                ? (isAddress0(outputCurrencyAddress)
                    ? ethToken
                    : {
                        ...checkDataObject(data, 'outputCurrency'),
                        tokenAddress: outputCurrencyAddress
                    })
                : {},
            showPoolName = (name = '') => name.replace('/', ' / '),
            pools = [...isSelectToken ? urlPools : [], ...checkDataArray(data, 'pools')].filter((item, index, self) => self.findIndex(obj => obj.poolId === item.poolId) === index),
            recentSearchesPoolsKey = `recentSearchesPools${pNs0}${isOnlyMargin ? '' : pNs1}${chainId}`,
            recentSearchesPools = JSON.parse(checkData([localStorage.getItem(recentSearchesPoolsKey)], '[]')),
            poolData = checkData(
                [data, 'poolData'],
                isPoolNeedUrlPoolId ? checkDataObject([...((isSelectToken || urlPoolId) ? [] : recentSearchesPools), ...pools], 0) : {}
            ),
            poolDataName = checkDataString(poolData, 'name'),
            poolName = (v, i) => checkDataString(v, 'name').split('/')[i],
            getPoolData = (i, pD = poolData) => {
                const currency = `currency${i}`,
                    tokenAddress = pD[currency],
                    avatarKey = `${currency}Avatar`,
                    avatar = isAddress0(tokenAddress) ? ethAvatar : pD[avatarKey]
                return isNotNull(tokenAddress)
                    ? {avatar, tokenAddress, [avatarKey]: avatar, symbol: poolName(pD, i)}
                    : {}
            },
            pageTokenKey = index => `${
                isBorrow
                    ? 'borrow'
                    : (
                        isMargin
                            ? 'margin'
                            : (
                                isSwap
                                    ? 'swap'
                                    : (
                                        isTradeSupply
                                            ? 'supply'
                                            : (
                                                isPoolCreate
                                                    ? 'poolCreate'
                                                    : 'poolAdd'
                                            )
                                    )
                            )
                    )
            }Token${index}${chainId}`,
            isCloseFunc = (i, level) => (i
                ? [1, 2]
                : [1, 3]).includes(level),
            tokenDecimalsList = JSON.parse(checkData([localStorage.getItem(chainId)], '{}')),
            token0Data = (() => {
                const obj = {
                    isClose: isCloseFunc(0, urlLevel),
                    ...checkData(
                        [data, 'token0Data'],
                        inputCurrencyAddressIsNotNull ? inputCurrency : checkData(
                            [JSON.parse(localStorage.getItem(pageTokenKey(0)))],
                            ethToken
                        )
                    ),
                    ...isNeedToken ? {} : getPoolData(0),
                }
                return {
                    ...obj,
                    decimals: checkData(
                        [tokenDecimalsList, checkDataString(obj, 'tokenAddress').toLowerCase()],
                        checkData([obj, 'decimals'], 18)
                    ),
                    keyName: 'token0Data'
                }
            })(),
            {
                tokenAddress: token0Address,
                symbol: token0Symbol,
                newAmount: token0NewAmount,
                needApprove: token0NeedApprove,
                newAmountWei: token0NewAmountWei = 0n,
                decimals: token0Decimals = defaultDecimals
            } = token0Data,
            token0IsETH = isAddress0(token0Address),
            yourTokens = checkDataArray(data, 'yourTokens'),
            recommendTokens = [ethToken, ...checkDataArray(data, 'recommendTokens')],
            searchAddressTokens = checkDataArray(data, 'searchAddressTokens'),
            recentSearchTokens = JSON.parse(checkData([localStorage.getItem(`recentSearchTokens${chainId}`)], '[]')),
            setRecentSearchTokens = (v = {}) => {
                const tokenAddress = checkDataString(v, 'tokenAddress').toLowerCase()
                if (!isAddress0(tokenAddress)) {
                    const index = recentSearchTokens.findIndex(v => checkDataString(v, 'tokenAddress').toLowerCase() === tokenAddress)
                    if (index > -1) {
                        const [item] = recentSearchTokens.splice(index, 1)
                        recentSearchTokens.unshift(item)
                        localStorage.setItem(`recentSearchTokens${chainId}`, JSON.stringify(recentSearchTokens))
                    } else {
                        const obj = {
                            ...v,
                            tokenAddress: checkDataString(v, 'tokenAddress').toLowerCase()
                        }
                        localStorage.setItem(`recentSearchTokens${chainId}`, JSON.stringify([obj, ...recentSearchTokens]))
                        return obj
                    }
                }
            },
            tokens = checkDataArray(data, 'tokens').filter((item, index, self) => self.findIndex(obj => obj.tokenAddress === item.tokenAddress) === index),
            allTokens = [...tokens, ...yourTokens, ...recommendTokens, ...recentSearchTokens],
            tokenBalances = Object.fromEntries(yourTokens.map(v => [checkDataString(v, 'tokenAddress').toLowerCase(), v.balance])),
            tokenMetadatas = Object.fromEntries(tokens.map(v => [
                checkDataString(v, 'tokenAddress').toLowerCase(),
                {
                    tokenAddress: checkDataString(v, 'tokenAddress').toLowerCase(),
                    ...v
                }
            ])),
            getTokenIcon = tokenAddress => isAddress0(tokenAddress)
                ? ethAvatar
                : (() => {
                    const icon = checkData([tokenMetadatas, checkDataString(tokenAddress).toLowerCase(), 'avatar'])
                    return isNotNull(icon)
                        ? (/^ipfs:\/\/Qm[a-zA-Z0-9]{44}$/.test(icon) ? icon.replace('ipfs://', 'https://ipfs.io/ipfs/') : icon)
                        : undefined
                })(),
            tokenRecentSearchTokens = [...tokens, ...recentSearchTokens],
            tokenRecentSearchTokensMetadatas = Object.fromEntries(tokenRecentSearchTokens.map(v => [
                checkDataString(v, 'tokenAddress').toLowerCase(),
                {
                    tokenAddress: checkDataString(v, 'tokenAddress').toLowerCase(),
                    ...v
                }
            ])),
            token1Data = (() => {
                const obj = {
                    isClose: isCloseFunc(1, urlLevel),
                    ...checkData(
                        [data, 'token1Data'],
                        outputCurrencyAddressIsNotNull ? outputCurrency : checkData(
                            [JSON.parse(localStorage.getItem(pageTokenKey(1)))],
                            checkDataObject(tokens, 0)
                        )
                    ),
                    ...isNeedToken ? {} : getPoolData(1)
                }
                return {
                    ...obj,
                    decimals: checkData(
                        [tokenDecimalsList, checkDataString(obj, 'tokenAddress').toLowerCase()],
                        checkData([obj, 'decimals'], 18)
                    ),
                    keyName: 'token1Data'
                }
            })(),
            {
                tokenAddress: token1Address,
                symbol: token1Symbol,
                newAmount: token1NewAmount,
                needApprove: token1NeedApprove,
                newAmountWei: token1NewAmountWei = 0n,
                decimals: token1Decimals = defaultDecimals
            } = token1Data,
            liquidityLevel = (() => {
                const token0IsClose = checkDataBool(token0Data, 'isClose'),
                    token1IsClose = checkDataBool(token1Data, 'isClose')
                return token0IsClose && token1IsClose
                    ? 1
                    : (
                        !token0IsClose
                            ? (
                                token1IsClose
                                    ? 2
                                    : 4
                            )
                            : 3
                    )
            })(),
            token1AddressIsNotNull = isNotNull(token1Address),
            tokenDataNeedApprove = token0NeedApprove || token1NeedApprove,
            setTokenData = (v, obj) => setData({[v.keyName]: {...v, ...obj}}),
            tokenDatas = [token0Data, token1Data],
            tokenAddresses = tokenDatas.map(v => v.tokenAddress),
            urlLongShort = new URLSearchParams(location.search).get('longShort'),
            isMarginSell = checkData(
                [data, 'isMarginSell'],
                isOnlyMargin && urlLongShort
                    ? urlLongShort === '1'
                    : (inputCurrencyAddressIsNotNull
                        ? inputCurrencyAddress.toLowerCase() === token0Address.toLowerCase()
                        : !(isMargin || (isPoolSupplyWithdraw && urlTokenIndex !== '1') || isTradeSupply))
            ),
            marginTokenDatas = isSupplyWithdraw
                ? (isMarginSell ? tokenDatas.reverse() : tokenDatas)
                : (isMarginSell ? tokenDatas : tokenDatas.reverse()),
            marginToken0Data = marginTokenDatas[0],
            marginToken1Data = marginTokenDatas[1],
            {
                symbol: marginToken0Symbol,
                balance: marginToken0DataBalance = 0,
                tokenAddress: marginToken0TokenAddress,
                needApprove: marginToken0DataNeedApprove,
                decimals: marginToken0DataDecimals = defaultDecimals,
            } = marginToken0Data,
            addLendingFinish = checkDataBool(data, 'addLendingFinish'),
            needAddLending = checkDataBool(data, 'needAddLending'),
            setNewAmount = (num, decimals = marginToken0DataDecimals) => {
                const newAmount = getSetNewAmount(num)
                setData({
                    inputNewAmount: num,
                    newAmount, newAmountWei: parseEtherNum(newAmount, decimals)
                })
            },
            debounceSetNewAmount = useCallback(
                debounce((value, decimals) => {
                    setNewAmount(value, decimals)
                }, 500),
                []
            ),
            setInputNewAmount = num => {
                setData({inputNewAmount: num})
                debounceSetNewAmount(num, marginToken0DataDecimals)
            },
            setNewAmountWei = newAmountWei => setData({
                newAmountWei, newAmount: numberETH(newAmountWei, marginToken0DataDecimals)
            }),
            token = () => sessionStorage.getItem('token'),
            requestApi = (url, data, method, headers = {}, noError) => {
                const t = token()
                return axios({
                    method,
                    url: `${sessionDev ? 'https://test-api.likwid.fi/v1/' : 'https://api.likwid.fi/v1/'}${url}`,
                    // url: `${false ? 'https://test-api.likwid.fi/v1/' : 'https://api.likwid.fi/v1/'}${url}`,
                    [method ? 'data' : 'params']: data,
                    headers: {
                        ...headers, ...ternaryObject(t, {'Authorization': `Bearer ${t}`})
                    },
                },).then(r => {
                    const d = checkDataObject(r, 'data'),
                        {code} = d,
                        isTokenExpires = code == '-5',
                        isSuccess = code == '1' || isTokenExpires
                    if (!isSuccess) {
                        toast(d.msg)
                        toggleShowLoading()
                    }
                    if (isTokenExpires) {
                        sessionStorage.removeItem('token')
                        toggleShowLoading()
                    }
                    return isSuccess ? checkDataObject(d, 'data') : null
                }).catch(e => {
                    toggleShowLoading()
                    if (!noError) {
                        toast('Unknown error')
                    }
                    // console.error(`------------------------------\n`, e, `------------------------------\n`)
                })
            },
            getTokenPrice = (addr = address0) => requestApi(`tool/price/${chainId}/${addr}`).then(
                v => setData({[`${addr}Price`]: v})
            ),
            loginThenFunc = (func = () => {
                             },
                             errorFunc = () => {
                             }) => token() ? func() : new Promise(resolve => requestApi('login/code', {address}).then(r => {
                setTimeout(() => {
                    const code = checkData([r, 'code'])
                    signMessage(wagmiConfig, {message: code}).then(sign => requestApi('login/login', {
                        code, sign, address, loginType: 'WEB',
                    }, 'post').then(r => {
                        const token = checkData([r, 'token'])
                        if (token) {
                            sessionStorage.setItem('token', token)
                            resolve(func())
                        }
                    })).catch(e => {
                        errorFunc()
                        toast(checkDataString(checkDataString(e, 'message').split('\n'), 0))
                    })
                }, 1000)
            })),
            chainName = checkData([chainValue, 'name'], defaultChain.name),
            addressIsNotNull = isNotNull(address),
            rpc = require(`./rpc/${chainId}`).default,
            addressLeaveOut = leaveOut(address),
            {eth: slaveContractETH} = new Web3(rpc),
            contractCall = (eth, address, abi, funcName, ...params) => {
                const func = checkData([new eth.Contract(abi, address), 'methods', funcName])
                return func ? func(...params).call() : new Promise(resolve => resolve())
            },
            {
                address: oLIKWIDAddress, abi: oLIKWIDAbi,
            } = require(`./${sessionDev ? 'testContract' : 'mainContract'}/oLIKWID/${chainId}`).default,
            {
                address: helperAddress, abi: helperAbi,
            } = require(`./${sessionDev ? 'testContract' : 'mainContract'}/helper/${chainId}`).default,
            {
                address: lendPositionAddress, abi: lendPositionAbi,
            } = require(`./${sessionDev ? 'testContract' : 'mainContract'}/lendPosition/${chainId}`).default,
            {
                address: marginPositionAddress, abi: marginPositionAbi,
            } = require(`./${sessionDev ? 'testContract' : 'mainContract'}/marginPosition/${chainId}`).default,
            {
                address: pairPositionAddress, abi: pairPositionAbi,
            } = require(`./${sessionDev ? 'testContract' : 'mainContract'}/pairPosition/${chainId}`).default,
            {
                address: vaultAddress, abi: vaultAbi,
            } = require(`./${sessionDev ? 'testContract' : 'mainContract'}/vault/${chainId}`).default,
            notLiquidityLevelChain = true,
            helperCall = (funcName, ...params) => contractCall(slaveContractETH, helperAddress, helperAbi, funcName, ...params),
            lendPositionCall = (funcName, ...params) => contractCall(slaveContractETH, lendPositionAddress, lendPositionAbi, funcName, ...params),
            marginPositionCall = (funcName, ...params) => contractCall(slaveContractETH, marginPositionAddress, marginPositionAbi, funcName, ...params),
            pairPositionCall = (funcName, ...params) => contractCall(slaveContractETH, pairPositionAddress, pairPositionAbi, funcName, ...params),
            erc20Call = (contractAddress, funcName, ...params) => contractCall(slaveContractETH, contractAddress, erc20Abi, funcName, ...params),
            erc20CallDecimals = contractAddress => isAddress0(contractAddress)
                ? new Promise(resolve => resolve(defaultDecimals))
                : (() => {
                    const contractAddressLowerCase = checkDataString(contractAddress).toLowerCase(),
                        tokenDecimals = checkData(
                            [tokenDecimalsList, contractAddressLowerCase],
                            checkData([tokenMetadatas, contractAddressLowerCase, 'decimals'])
                        )
                    return isNotNull(tokenDecimals)
                        ? new Promise(resolve => resolve(tokenDecimals))
                        : erc20Call(contractAddress, 'decimals').then(decimals => {
                            localStorage.setItem(chainId, JSON.stringify({
                                ...tokenDecimalsList, [contractAddressLowerCase]: Number(decimals)
                            }))
                            return decimals
                        })
                })(),
            erc20CallBalanceOfTokens = () => address && tokenDatas.map(v => {
                    const {tokenAddress} = v
                    return (isAddress0(tokenAddress)
                        ? slaveContractETH.getBalance(address).then(v => [v])
                        : erc20Call(tokenAddress, 'balanceOf', address)).then(balance =>
                        setTokenData(
                            v,
                            {balance: numberETH(balance, v.decimals)}
                        ))
                }
            ),
            erc20CallBalance = contractAddress => isAddress0(contractAddress)
                ? slaveContractETH.getBalance(address).then(v => [v])
                : erc20Call(contractAddress, 'balanceOf', address)
                    .then(balanceOf => erc20CallDecimals(contractAddress).then(decimals => [balanceOf, decimals])),
            openWeb3Modal = (...params) => {
                if (addressIsNotNull) {
                    open(...params)
                } else {
                    const toggleShowConnectLoading = sCL => setData({showConnectLoading: sCL})
                    toggleShowConnectLoading(true)
                    toggleShowConnectLoading()
                    open(...params)
                }
            }, selectNetworkObj = {view: 'Networks'},
            connect = () => openWeb3Modal(),
            selectNetwork = () => openWeb3Modal(selectNetworkObj),
            switchEthereumChain = (func = () => {
            }, falseFunc = () => {
            }, needConnect, chain = {}) => {
                const pleaseConnect = () => {
                    const {name} = chain
                    toast(isNotNullOrEmpty(name) ? `Please connect ${name}` : 'Please connect to the network')
                    setTimeout(() => connect(), 1000)
                }, {id: chainId1} = chain, chainId1IsNotNull = isNotNull(chainId1)
                if (addressIsNotNull) {
                    if ((!chainId1IsNotNull || (chainId1IsNotNull && chainId === chainId1)) && !wrongNetwork) {
                        func()
                    } else {
                        falseFunc()
                        pleaseConnect()
                    }
                } else {
                    falseFunc()
                    if (needConnect) {
                        pleaseConnect()
                    }
                }
            },
            inputNewAmount = checkDataString(data, 'inputNewAmount'),
            newAmountStr = checkDataString(data, 'newAmount'),
            newAmount = checkData0(data, 'newAmount'),
            newAmountNumber = Number(newAmount),
            showApprove = checkDataBool(data, 'showApprove'),
            isSwapNeedAddLending = isSwap && needAddLending,
            toggleShowApprove = showApprove => setData({showApprove}),
            {writeContractAsync} = useWriteContract(),
            wC = (contractAddress, contractAbi, functionName, value, args = [], successFunc = () => {
            }, failFunc = () => {
            }) => {
                console.log(functionName);
                dispatch(props, {contractStatuData: localStorage.getItem('contractStatuData') || '{}'})
                const toggleShowLoadingToast = text => {
                        toggleShowLoading();
                        text && toast(text)
                    },
                    wCFunc = () => {
                        toggleShowLoading(true);
                        simulateContract(
                            wagmiConfig,
                            {
                                args,
                                value,
                                chainId,
                                functionName,
                                account: address,
                                abi: contractAbi,
                                address: contractAddress,
                                walletClient: {account: address},
                            }).then(r =>
                            writeContractAsync(r.request).then(r => {
                                const hash = r
                                return successFunc ? successFunc(hash) : toggleShowLoadingToast(hash ? 'Successful' : 'Failed')
                            })
                                .catch(e => {
                                    const error = e.message.split('\n')[0]
                                    toggleShowLoadingToast(
                                        error.includes('The current chain of the wallet')
                                            ? `Please switch the network to (${chainName}) in the wallet`
                                            : error
                                    )
                                }))
                            .catch(e => {
                                console.log(e, '-----------------------------');
                                const errorStr = [1, 2].map(v => e.message.split('\n')[v]).join('\n'), obj = {}
                                let eStr
                                Object.keys(obj).map(v => {
                                    if (errorStr.includes(v)) eStr = obj[v]
                                })
                                toggleShowLoadingToast(eStr || errorStr)
                                checkDataFunction(failFunc)()
                            })
                    }
                switchEthereumChain(() => {
                    if (Object.values(checkDataObject(contractStatuData(), chainId, address)).map(v => v.functionName).includes(functionName)) {
                        setData({showPreviousTips: true, previousTipsFunc: wCFunc})
                    } else {
                        wCFunc()
                    }
                }, toggleShowLoadingToast, true)
            },
            waitForTransactionFunc = (hash, func, errFunc = () => {
            }) =>
                waitForTransactionReceipt(wagmiConfig, {chainId, hash, timeout: 60000}).then(func)
                    .catch(() => {
                        errFunc()
                        toastSuccessful()
                        toggleShowLoading()
                    }),
            oLIKWIDWriteContract = (...params) => wC(oLIKWIDAddress, oLIKWIDAbi, ...params),
            lendPositionWriteContract = (...params) => wC(lendPositionAddress, lendPositionAbi, ...params),
            marginPositionWriteContract = (...params) => wC(marginPositionAddress, marginPositionAbi, ...params),
            pairPositionWriteContract = (...params) => wC(pairPositionAddress, pairPositionAbi, ...params),
            vaultWriteContract = (...params) => wC(vaultAddress, vaultAbi, ...params),
            getOLIKWIDReward = () => requestApi('margin/reward/balance', {
                sender: address,
                chainId
            }).then(v => setData({oLIKWIDReward: v})),
            oLIKWIDClaim = (amount, nonce) => switchEthereumChain(
                () => loginThenFunc(
                    () => {
                        const nonceIsNoNull = isNotNull(nonce)
                        return requestApi(
                            nonceIsNoNull ? `sign/nonce/${nonce}` : 'sign/nonce',
                            {
                                biz: 'claim_option',
                                ...nonceIsNoNull
                                    ? {}
                                    : {
                                        chainId,
                                        amount
                                    }
                            },
                            nonceIsNoNull ? undefined : 'post'
                        ).then(v => {
                            !nonceIsNoNull && getOLIKWIDReward();
                            return oLIKWIDWriteContract(
                                'claim',
                                undefined,
                                [v.nonce, amount, v.sign],
                                hash => waitForTransactionFunc(
                                    hash,
                                    () => {
                                        toggleShowLoading()
                                        toastSuccessful(hash)
                                    }
                                )
                            )
                        })
                    }
                ),
                undefined,
                true
            ),
            launchAPPConnect = () => isHome ? windowReplace('/trade') : connect(),
            isTop = checkData([data, 'isTop'], true),
            isTopColor = `isTop${isTop ? 'Transparent' : 'White'}`,
            walletImageUrl = localStorage.getItem('@w3m/connected_wallet_image_url'),
            showPositionsPools = checkDataBool(data, 'showPositionsPools'),
            selectNetworkContent = address && !isHome && <div onClick={selectNetwork}
                                                              className={`borderRadius999 saf backgroundGrey flexCenter ${isPhoneClientWidth ? 'childrenSpacingLeftSmallPhone' : 'childrenSpacingLeft'} cursorPointer`}
                                                              style={{
                                                                  height: `${isPhoneClientWidth ? 1.7 : .8}rem`,
                                                                  padding: `0 ${isPhoneClientWidth ? .7 : .3}rem`,
                                                              }}>
                {!wrongNetwork && <img src={requireDefault(`chainIcons/${chainId}`)}
                                       alt=""
                                       style={{height: '70%'}}/>}
                <div style={isPhoneClientWidth ? {maxWidth: '5rem'} : {}}
                     className={`${wrongNetwork ? 'colorRed' : ''} ${isPhoneClientWidth ? 'smallFontSizePhone' : ''} textOverflowEllipsis`}>{wrongNetwork ? 'Wrong network' : chainName}</div>
                <img src={requireDefault('toBottom')} alt="" style={{height: `${isPhoneClientWidth ? 50 : 30}%`}}/>
            </div>,
            showSelectToken = checkDataBool(data, 'showSelectToken'),
            toggleShowSelectToken = showSelectToken => setData({showSelectToken}),
            showMarginSelling = checkDataBool(data, 'showMarginSelling'),
            showRepaying = checkDataBool(data, 'showRepaying'),
            showAdjust = checkDataBool(data, 'showAdjust'),
            ethUSDT = checkData0(data, 'ethUSDT'),
            minBorrowLevel = checkData0(data, 'minBorrowLevel'),
            getTokenUSDTPrice = (amount, eU = ethUSDT) => `$${times(amount, eU).replace(/(\.\d{2})\d*/, '$1')}`,
            showSwapping = checkDataBool(data, 'showSwapping'),
            tokenIcon = (v = {}, size) => {
                const style = square(size)
                return isNotNullOrEmpty(v.poolId)
                    ? <div style={style} className={'flex'}>
                        {['', 'justifyContentFlexEnd'].map((v1, i1) => {
                            const currencyName = checkData([v, `currency${i1}Name`], checkDataString(v, 'name').split('/')[i1]),
                                icon = (isAddress0(v[`currency${i1}`]) || currencyName === coinName)
                                    ? ethAvatar
                                    : getTokenIcon(v[`currency${i1}`])
                            return <div className={`overflowHidden flex ${v1}`}
                                        style={{
                                            width: `calc(${size} / 2 )`,
                                            height: size, ...i1 === 0 ? {} : {marginLeft: `calc(${size} / 15 )`}
                                        }}>
                                {
                                    isNotNull(icon)
                                        ? <img className={'borderRadius999 flexShrink0'} src={icon} alt=""
                                               style={style}/>
                                        : <div style={{...style, fontSize: `calc(${size} / 6 )`}}
                                               className={`flexCenter ${[
                                                   'justifyContentFlexStart',
                                                   'justifyContentFlexEnd'
                                               ][i1]} backgroundGrey borderRadius999 flexShrink0 saf1`}>{
                                            checkData([v, `currency${i1}Symbol`], currencyName).slice(0, 3)
                                        }</div>
                                }
                            </div>
                        })}
                    </div>
                    : (() => {
                        const icon = getTokenIcon(v.tokenAddress)
                        return isNotNull(icon)
                            ? <img className={'borderRadius999'} src={icon} alt="" style={style}/>
                            : <div style={{...style, fontSize: `calc(${size} / 3 )`}}
                                   className={'flexCenter backgroundGrey borderRadius999 saf1'}>{
                                checkData([v, 'symbol'], checkDataString(v, 'name')).slice(0, 3)
                            }</div>
                    })()

            },
            tokenDataPoolName = tokenDatas.map(v => v.symbol).join('/'),
            reserve0 = checkData0(data, 'reserve0'),
            reserve1 = checkData0(data, 'reserve1'),
            swapReserve0 = checkData0(data, 'swapReserve0'),
            reserve0DivideReserve1 = divide(numberETH(reserve0, token0Decimals), numberETH(reserve1, token1Decimals)),
            swapReserve1 = checkData0(data, 'swapReserve1'),
            setTokenNewAmount = (v, balance, setOther = true, amountWei) => {
                const amountWeiIsNotNull = isNotNull(amountWei), {decimals} = v,
                    newAmount = amountWeiIsNotNull ? numberETH(amountWei, decimals) : getSetNewAmount(balance),
                    newAmountWei = amountWeiIsNotNull ? amountWei : parseEtherNum(newAmount, decimals)
                if (isNotNull(balance) || amountWeiIsNotNull) {
                    setTokenData(v, {newAmount, newAmountWei})
                } else {
                    setTokenData(v, {newAmount: undefined, newAmountWei: undefined})
                }
                if (setOther && (!isSelectToken || isPoolAddIncrease)) {
                    const ratio = divide(reserve0, reserve1)
                    if (ratio != 0) {
                        const isToken0 = v.keyName === 'token0Data',
                            num = toInt(isToken0 ? divide(newAmountWei, ratio) : times(newAmountWei, ratio))
                        setTokenNewAmount(isToken0 ? token1Data : token0Data, undefined, false, Number(num) === 0 ? undefined : num)
                    }
                }
            },
            newAmountWei = checkData([data, 'newAmountWei'], 0n),
            newBorrowAmount = checkData0(data, 'newBorrowAmount'),
            newBorrowAmountWei = checkData([data, 'newBorrowAmountWei'], 0n),
            minMarginLevel = checkData0(data, 'minMarginLevel'),
            borrowMaxAmount = checkData0(data, 'borrowMaxAmount'),
            borrowMaxAmountToast = (func = () => {
            }) => {
                if (greaterThan(newBorrowAmount, borrowMaxAmount)) {
                    toast(`The maximum borrow amount is  ${borrowMaxAmount}`)
                } else {
                    func()
                }
            },
            marginToken0IsETH = isAddress0(marginToken0TokenAddress), {
                symbol: marginToken1Symbol,
                needApprove: marginToken1DataNeedApprove,
                balance: marginToken1DataBalance = 0,
                tokenAddress: marginToken1TokenAddress,
                decimals: marginToken1DataDecimals = defaultDecimals,
            } = marginToken1Data, marginToken1IsETH = isAddress0(marginToken1TokenAddress),
            zeroForOne = hexToNumber(marginToken1TokenAddress) > hexToNumber(marginToken0TokenAddress),
            marginForOne = !zeroForOne,
            marginMaxLeverages = ['1x', '2x', '3x', '4x', '5x'],
            otherMarginMaxLeverage = checkData0(data, 'otherMarginMaxLeverage') || 0,
            urlMarginMaxLeverageIndex = new URLSearchParams(location.search).get('marginMaxLeverageIndex'),
            marginMaxLeverageIndex = checkData([data, 'marginMaxLeverageIndex'], isHome ? 4 : (isOnlyMargin && urlMarginMaxLeverageIndex ? Number(urlMarginMaxLeverageIndex) : 0)),
            currentLeverages = marginMaxLeverages[marginMaxLeverageIndex],
            leverage = Number(currentLeverages.split('x')[0]),
            marginMax = checkData0(data, 'marginMax'),
            erc20Allowance = (marginAddress, contractAddress, amount) =>
                isAddress0(contractAddress)
                    ? new Promise(resolve => resolve(0))
                    : erc20Call(contractAddress, 'allowance', address, marginAddress)
                        .then(v => erc20CallDecimals(contractAddress).then(decimals => minus(amount, v) > 0 ? amount : 0)),
            erc20MarginPositionAllowance = (...params) => erc20Allowance(marginPositionAddress, ...params),
            erc20PairPositionAllowance = (...params) => erc20Allowance(pairPositionAddress, ...params),
            marginToken0Allowance = pA => (
                pA || (isMargin ? erc20MarginPositionAllowance : erc20PairPositionAllowance)
            )(marginToken0TokenAddress, newAmountWei).then(num => {
                setTokenData(marginToken0Data, {needApprove: num > 0})
                return num
            }),
            transitionPrice = checkData0(data, 'transitionPrice'),
            transitionPriceWei = checkData([data, 'transitionPriceWei'], 0n),
            poolDataPoolId = checkDataString(poolData, 'poolId'),
            isETHPool = tokenAddresses.includes(address0),
            helperGetAmountIn = (amount = parseEtherNum(1), zFO = zeroForOne, pI = poolDataPoolId, useDynamicFee) => helperCall(
                'getAmountIn',
                pI,
                zFO,
                amount,
                !!useDynamicFee
            ).catch(() => ({amountIn: 0n})),
            helperGetAmountOut = (amount = parseEtherNum(1), zFO = zeroForOne, pI = poolDataPoolId, useDynamicFee) => helperCall(
                'getAmountOut',
                pI,
                zFO,
                amount,
                !!useDynamicFee
            ).catch(() => ({amountOut: 0n})),
            getAmountOutFunc = (amount = parseEtherNum(1), zFO = zeroForOne, pI = poolDataPoolId) =>
                helperGetAmountOut(amount, zFO, pI).then(v => checkData0(v, 'amountOut')).catch(() => 0n),
            getAmountOut = (amount, zFO, pI, decimals) => getAmountOutFunc(amount, zFO, pI).then(v => numberETH(v, decimals)),
            toggleShowCloseRepay = (show, showKey, repayTokenData) => {
                toggleShowLoading(show);
                (show ? (() => {
                    const isShowAdjust = showKey === 'showAdjust'
                    return erc20CallBalance(repayTokenData.borrowToken).then(async ([balance, decimals]) => {
                        setData({
                            ...showKey === 'showClosePosition' ? {range: 0} : {},
                            repayTokenData: {
                                ...repayTokenData,
                                ...isShowAdjust ? await (async () => {
                                        const mD = repayTokenData.marginDecimals,
                                            marginBalance = numberETH((await erc20CallBalance(repayTokenData.marginToken))[0], mD),
                                            maxDecrease = toFixed(
                                                times(
                                                    numberETH(
                                                        await helperCall('getMaxDecrease', repayTokenData.tokenId).catch(() => 0n),
                                                        mD
                                                    ),
                                                    '0.99'
                                                ),
                                                greaterThan(mD, 8) ? 8 : mD
                                            )
                                        return {
                                            marginBalance,
                                            marginBalancePrice: getTokenUSDTPrice(isAddress0(repayTokenData.marginToken)
                                                ? marginBalance
                                                : numberETH(checkData0(await helperGetAmountOut(parseEtherNum(marginBalance, repayTokenData.marginDecimals), repayTokenData.marginForOne, repayTokenData.poolId), 'amountOut'), repayTokenData.borrowDecimals)),
                                            maxDecrease,
                                            maxDecreasePrice: getTokenUSDTPrice(isAddress0(repayTokenData.marginToken)
                                                ? maxDecrease
                                                : numberETH(checkData0(await helperGetAmountOut(parseEtherNum(maxDecrease, repayTokenData.marginDecimals), repayTokenData.marginForOne, repayTokenData.poolId), 'amountOut'), repayTokenData.borrowDecimals)),
                                        }
                                    })()
                                    : {}
                            },
                            showLoading: false
                        })
                    })
                })() : new Promise(resolve => resolve())).then(() => setData({
                    [showKey]: show, ...!show ? {
                        showApprove: false,
                        repayTokenDataNewAmount: undefined,
                        repayTokenDataNewAmountWei: undefined
                    } : {},
                }))
            },
            toggleShowAdjust = (showAdjust, repayTokenData) => toggleShowCloseRepay(showAdjust, 'showAdjust', repayTokenData),
            toggleShowRepaying = (showRepaying, repayTokenData) => toggleShowCloseRepay(showRepaying, 'showRepaying', repayTokenData),
            showClosePosition = checkDataBool(data, 'showClosePosition'),
            toggleShowClosePosition = (showClosePosition, repayTokenData) => toggleShowCloseRepay(showClosePosition, 'showClosePosition', repayTokenData),
            focusInput = React.createRef(),
            autoMaxSlippage = 0.5,
            removeDataKey = 'Remove',
            maxSlippage = checkData([data, 'maxSlippage'], autoMaxSlippage),
            maxSlippageAmount = (amount, mS = maxSlippage) => BigInt(toInt(times(amount, divide(minus(100, mS), 100)))),
            maxSlippageAmountPlus = (amount, mS = maxSlippage) => BigInt(toInt(times(amount, divide(plus(100, mS), 100)))),
            marginTotal = checkData0(data, 'marginTotal'),
            borrowAmount = checkData0(data, 'borrowAmount'),
            poolDataPoolIdIsNotNull = isNotNullOrEmpty(poolDataPoolId),
            removePoolData = checkDataObject(data, 'removePoolData'),
            removePoolTokenDatas = [getPoolData(0, removePoolData), getPoolData(1, removePoolData)],
            removePoolDataPoolId = checkDataString(removePoolData, 'poolId'),
            removePoolDataLevel = checkData([removePoolData, 'level'], 4),
            removePoolDataPoolIdIsNotNull = isNotNullOrEmpty(removePoolDataPoolId),
            swapMax = marginToken0DataBalance,//poolDataPoolIdIsNotNull ? checkData0(data, 'swapMax') : 0,
            marginIsComposite = newAmountNumber <= marginMax,
            leverageIsComposite = leverage >= leverageMin && leverage <= leverageMax,
            liquidationLTV = checkData0(data, 'liquidationLTV'),
            liquidationLTVNum = divide(checkData0(data, 'liquidationLTV'), 100),
            beforeAfterMergedIndex = checkData0(data, 'beforeAfterMergedIndex'),
            isAfterMerged = beforeAfterMergedIndex === 1,
            marginTotalETH = numberETH(marginTotal, marginToken0DataDecimals),
            positionMarginAmount = checkData0(data, 'positionMarginAmount'),
            afterMarginTotal = plus(marginTotal, checkData0(data, 'positionMarginTotal')),
            positionBorrowAmount = checkData0(data, 'positionBorrowAmount'),
            afterBorrowAmount = plus(borrowAmount, positionBorrowAmount),
            showMarginTotalETH = isAfterMerged ? numberETH(afterMarginTotal, marginToken0DataDecimals) : marginTotalETH,
            borrowAmountETH = numberETH(borrowAmount, marginToken1DataDecimals),
            showBorrowAmountETH = isAfterMerged ? numberETH(afterBorrowAmount, marginToken1DataDecimals) : borrowAmountETH,
            entryToken = poolDataPoolIdIsNotNull ? checkData0(data, 'entryToken') : 0,
            liqToken = (() => {
                const num = divide(plus(newAmount, marginTotalETH), times(borrowAmountETH, 1.1))
                return num8(isMarginSell ? num : divide(1, num))
            })(),
            showLiqToken = isAfterMerged
                ? (() => {
                    const num = divide(
                        plus(
                            plus(
                                newAmount,
                                numberETH(positionMarginAmount, marginToken0DataDecimals)
                            ),
                            showMarginTotalETH
                        ),
                        times(showBorrowAmountETH, 1.1)
                    )
                    return num8(isMarginSell ? num : divide(1, num))
                })()
                : liqToken,
            showMarginEntryToken = isAfterMerged
                ? num8(
                    divide(
                        ...isNotNullOrEmpty(newAmountStr)
                            ? (() => {
                                const arr = [showBorrowAmountETH, showMarginTotalETH]
                                return isMarginSell ? arr.reverse() : arr
                            })()
                            : [numberETH(reserve0, token0Decimals), numberETH(reserve1, token1Decimals)]
                    )
                ) : entryToken,
            marginEntryPriceNum = !token0IsETH ? checkData0(data, 'entryTokenETH') : entryToken,
            marginEntryPrice = isETHPool ? `(${getTokenUSDTPrice(marginEntryPriceNum)})` : '',
            showMarginData = poolDataPoolIdIsNotNull && newAmountNumber > 0 && marginIsComposite,
            getMarginLevel = v => [
                ['marginLevelRed', 'marginLevelYellow', 'marginLevelGreen'],
                ['#FF0000', '#FFDD29', '#22C55F']
            ].map(v1 => v1[lessThan(v, 1.17) ? 0 : (lessThan(v, 1.97) ? 1 : 2)]),
            apyNum = checkData0(data, 'apy'),
            apy = `${apyNum}%`,
            // getBorrowMarginLevel = borrowAmount => toFixed(
            //     equalTo(borrowAmount, borrowMaxAmount)
            //         ? minMarginLevel
            //         : divide(minMarginLevel, divide(borrowAmount, borrowMaxAmount)),
            //     2
            // ),
            // borrowMarginLevel = checkData0(data, 'borrowMarginLevel'),
            getLendingInterest = lendingAPR => numToPercentage(lendingAPR),
            lendingInterest = getLendingInterest(checkData0(data, 'lendingAPR')),
            marginFee_ = checkData0(data, 'fee'),
            marginFee_Num = divide(marginFee_, 100),
            marginFee_Amount = num8(times(times(newAmount, leverage), marginFee_Num)),
            feeDataFunc = (key = '_fee') => {
                const a = 3000,
                    a1 = divide(a, 10000)
                return [a1, toFixed(divide(minus(checkData0(data, key), a), 10000), 2)]
            },
            feeData = feeDataFunc(),
            dynamicFeeTooHigh = greaterThan(feeData[1], '10'),
            dynamicFeeTooHighText = 'Dynamic Fee Too High',
            toFeeUrl = () => windowOpen('https://likwidfi.gitbook.io/likwid-protocol-docs/whitepaper/risk-management-and-strategies/dynamic-fee-strategy-against-mev-and-arbitrage-attacks'),
            showFeeData = (a1, b, iM) => <div
                className={`flexCenter colorGray ${isPhoneClientWidth ? 'childrenSpacingLeftSmallPhone smallFontSizePhone' : 'childrenSpacingLeftSmall smallFontSize'}`}>
                <pre
                    className={`flexCenter ${isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'}`}>{iM ? ' (' : ''}Fee{iM ? ': ' : ''}
                    {iM ? '' : '('}{a1}%{
                        greaterThan(b, 0) && <pre
                            className={`colorRed ${isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'}`}> + {b}%</pre>
                    })
                </pre>
                <img
                    onClick={toFeeUrl}
                    src={requireDefault('Question mark 1')} alt=""
                    className={'cursorPointer'}
                    style={square(`${isPhoneClientWidth ? .9 : .3}rem`)}/>
            </div>,
            marginBorrowMax = maxSlippageAmountPlus(
                isBorrow
                    ? parseEtherNum(borrowMaxAmount, marginToken1DataDecimals)
                    : borrowAmount
            ),
            long0 = checkData(
                [data, 'long0'],
                isOnlyMargin && ['USDT', 'USDC', 'DAI'].includes(poolDataName.split('/')[1])
            ),
            marginData = isDetail => {
                const marginEntryToken = isDetail ? entryToken : showMarginEntryToken,
                    marginLevelText = `Initial Margin Level`,
                    mD = [
                        [
                            marginLevelText,
                            isBorrow
                                ? percentageNum(
                                    isAfterMerged
                                        ? divide(
                                            checkData0(data, 'afterBorrowMaxAmount'),
                                            formatEther(
                                                plus(
                                                    newBorrowAmountWei,
                                                    positionBorrowAmount
                                                ),
                                                marginToken1DataDecimals
                                            )
                                        )
                                        : divide(
                                            checkData0(data, 'beforeBorrowMaxAmount'),
                                            formatEther(
                                                newBorrowAmountWei,
                                                marginToken1DataDecimals
                                            )
                                        )
                                )
                                : toFixed(
                                    divide(
                                        plus(
                                            plus(
                                                newAmount,
                                                formatEther((isDetail || !isAfterMerged) ? 0 : positionMarginAmount, marginToken0DataDecimals)
                                            ),
                                            formatEther((isDetail || !isAfterMerged) ? marginTotal : afterMarginTotal, marginToken0DataDecimals)
                                        ),
                                        (() => {
                                            const truncatedReserveEntryToken = divide(
                                                formatEther(checkData0(data, 'truncatedReserve0'), token0Decimals),
                                                formatEther(checkData0(data, 'truncatedReserve1'), token1Decimals)
                                            )
                                            return times(
                                                marginForOne ? divide(1, truncatedReserveEntryToken) : truncatedReserveEntryToken,
                                                formatEther((isDetail || !isAfterMerged) ? borrowAmount : afterBorrowAmount, marginToken1DataDecimals)
                                            )
                                        })()
                                    ),
                                    2
                                )
                            // toFixed(
                            //     divide(
                            //         plus(
                            //             plus(
                            //                 parseEtherNum(newAmount, marginToken0DataDecimals),
                            //                 (isDetail || !isAfterMerged) ? 0 : positionMarginAmount
                            //             ),
                            //             (isDetail || !isAfterMerged) ? marginTotal : afterMarginTotal
                            //         ),
                            //         times(
                            //             divide(
                            //                 ...marginForOne ? [reserve1, reserve0] : [reserve0, reserve1]
                            //             ),
                            //             (isDetail || !isAfterMerged) ? borrowAmount : afterBorrowAmount
                            //         )
                            //     ),
                            //     2
                            // )
                        ],
                        ['Liquidation Margin Level', /*`${liquidationLTV}%`*/'1.1'],
                        ...isBorrow
                            ? []
                            : [
                                [`Total (Using Margin ${currentLeverages})`, `${isDetail ? marginTotalETH : showMarginTotalETH} ${marginToken0Symbol}`]
                            ],
                        ...isBorrow
                            ? []
                            : [
                                [
                                    <div
                                        className={`colorGray flex flexWrap alignItemsCenter ${isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'}`}>
                                        Borrow Amount{showFeeData(...feeData, true)}
                                    </div>,
                                    `${isDetail ? borrowAmountETH : showBorrowAmountETH} ${marginToken1Symbol}`
                                ]
                            ],
                        ...isBorrow
                            ? []
                            : [['Borrow APY', apy]],
                        ...isBorrow
                            ? []
                            : (isDetail ?
                                [
                                    [
                                        'Entry Price',
                                        `${long0 ? num8(divide(1, marginEntryToken)) : marginEntryToken} ${long0 ? token1Symbol : token0Symbol}`,
                                        // isAfterMerged && !isDetail ? (isETHPool ? `(${getTokenUSDTPrice(!token0IsETH ? checkData0(data, 'entryTokenETH')
                                        //     : (isDetail ? marginEntryToken : showMarginEntryToken))})` : '') : marginEntryPrice
                                    ]
                                ]
                                : []),
                        ...isBorrow
                            ? []
                            : [
                                [
                                    'Liq.Price',
                                    `${(() => {
                                        const num = isDetail ? liqToken : showLiqToken
                                        return long0 ? num8(divide(1, num)) : num
                                    })()} ${long0 ? token1Symbol : token0Symbol}`,
                                    // isETHPool ? `(${getTokenUSDTPrice(token0IsETH ? (isDetail ? liqToken : showLiqToken) : checkData0(data, isDetail ? 'liqTokenETH' : 'showLiqTokenETH'))})` : ''
                                ]
                            ],
                        ...isDetail
                            ? []
                            : (
                                isOnlyMargin
                                    ? []
                                    : [
                                        [
                                            `${isBorrow ? 'Collacteral' : 'Margin'} APY`,
                                            `${lendingInterest}%`
                                        ]
                                    ]
                            ),
                        ...isBorrow
                            ? []
                            : [
                                ...isOnlyMargin
                                    ? []
                                    : [
                                        (() => {
                                            // const fee = checkData0(data, 'fee'), feeNum = divide(fee, 100),
                                            //     feeAmount = num8(times(newAmount, feeNum))
                                            return [
                                                `Fee (${marginFee_}%)`,
                                                `${marginFee_Amount} ${marginToken0Symbol}`,
                                                // isETHPool ? `(${getTokenUSDTPrice(marginToken0IsETH ? marginFee_Amount : num8(times(transitionPrice, marginFee_Num)))})` : ''
                                            ]
                                        })()
                                    ],
                                ['Max Slippage', `${maxSlippage}%`],
                                ['Borrow Max Amount', `${numberETH(marginBorrowMax, marginToken1DataDecimals)} ${marginToken1Symbol}`]
                            ],
                    ]
                return mD.map((v, i) => {
                    const isMarginLevel = v[0] === marginLevelText,
                        [marginLevelIcon, marginLevelColor] = getMarginLevel(v[1])
                    return <div
                        style={{opacity: showMarginData ? 1 : 0}}
                        className={'flexCenter justifyContentSpaceBetween'}>
                        <div
                            className={`colorGray ${isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'}`}>{v[0]}</div>
                        <div
                            className={`flexCenter ${isPhoneClientWidth ? 'childrenSpacingLeftSmallPhone' : 'childrenSpacingLeftSmall'}`}>
                            {isMarginLevel && <img
                                src={requireDefault(marginLevelIcon)}
                                style={{
                                    width: `${isPhoneClientWidth ? 0.9 : 0.3}rem`,
                                    height: `${isPhoneClientWidth ? 0.9 : 0.3}rem`
                                }}/>}
                            {v[0] === 'Max Slippage' && maxSlippage == autoMaxSlippage && <div
                                className={`colorGray ${isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'}`}>Auto</div>}
                            <div
                                style={isMarginLevel ? {color: marginLevelColor} : {}}
                                className={`${isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'}`}>{v[1]}</div>
                            {isNotNull(v[2]) && <div
                                className={`colorGray ${isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'}`}>{v[2]}</div>}
                        </div>
                    </div>
                })
            },
            showUSD1 = (str = '') => {
                const [num, s] = str.split(' ')
                return s === 'USD1' ? `$${toFixed(num, 2)}` : str
            },
            ovl = (v, key, isPoolData = true, isUsd) => {
                const value = checkData0(v, key)
                return isUsd ? formatCurrencyCompact(value) : ([v.currency0, v.currency1].includes(address0)
                    ? getTokenUSDTPrice(formatEther(value))
                    : `${num8(apiNumETH(value, isPoolData ? token0Decimals : v.currency0Decimals))} ${
                        isPoolData ? token0Symbol : checkDataString(v, 'currency0Symbol')}`)
            },
            apr = v => numToPercentage(checkData0(v, 'apr')),
            opacityShow = checkData([data, 'opacityShow'], true),
            setNewBorrowAmount = (newAmount, borrowMaxAmount) => setData({
                newBorrowAmount: newAmount,
                newBorrowAmountWei: parseEtherNum(newAmount, marginToken1DataDecimals),
                ...isNotNull(borrowMaxAmount)
                    ? {borrowMaxAmount}
                    : {}
            }),
            showTradingContest = checkDataBool(data, 'showTradingContest'),
            toggleShowTradingContest = (showTradingContest, other = {}) => setData({showTradingContest, ...other}),
            tradingContestPool = checkDataObject(data, 'tradingContestPool'),
            poolTradingContest = (() => {
                try {
                    return JSON.parse(tradingContestPool['tradingContest'])
                } catch {
                    return {}
                }
            })(),
            tradingContest = (v, img = 'fire1', width = `${isPhoneClientWidth ? 1.5 : .5}rem`) => isOnlyMargin && isNotNullOrEmpty(v['tradingContest']) &&
                <img src={requireDefault(img)} alt=""
                     className={'cursorPointer'}
                     onClick={e => {
                         e.stopPropagation()
                         toggleShowTradingContest(
                             true,
                             {tradingContestPool: v}
                         )
                     }}
                     style={{width}}/>,
            selectTokenContainer = (() => {
                const isReverse = isSupplyWithdraw ? isMarginSell : (isMargin && !isMarginSell)
                return isSelectToken
                    ? <div onClick={() => toggleShowSelectToken(true)}
                           className={`${
                               isPhoneClientWidth ?
                                   `${isSelectToken ? '' : 'borderSmallGrayLinePhone'}`
                                   : `${isSelectToken ? '' : 'borderSmallGrayLine'}`
                           } ${isPhoneClientWidth ? 'borderRadius999' : 'borderRadius'} 
                                        ${isSelectToken ? (isPhoneClientWidth ? 'childrenSpacingLeftPhone' : 'childrenSpacingLeft') : ''} flexCenter childrenFlexGrow1 cursorPointer`}>
                        {(isReverse ? tokenDatas.reverse() : tokenDatas).map((v, i) =>
                            <div
                                onClick={() => setData({selectTokenIndex: i})}
                                style={{height: `${isPhoneClientWidth ? 3 : 1}rem`}}
                                className={`flexCenter justifyContentSpaceBetween ${isPhoneClientWidth ? 'paddingLeftRightBigPhone' : 'paddingLeftRightBig'} 
                                                            ${isSelectToken ? `borderRadius999 ${i === 0 ? 'backgroundGrey' : ''} 
                                                            ${isPhoneClientWidth ? 'borderSmallGrayLinePhone' : 'borderSmallGrayLine'}` : ''}`}>
                                {!isSelectToken && <div
                                    className={i !== 0 ? 'borderLeftSmallGrayLine' : ''}
                                    style={{height: `${isPhoneClientWidth ? 1.5 : .5}rem`}}/>}
                                <div
                                    className={`flexCenter ${isPhoneClientWidth ? 'childrenSpacingLeftPhone' : 'childrenSpacingLeft'}`}>
                                    {tokenIcon(v, `${isPhoneClientWidth ? 1.5 : .5}rem`)}
                                    <div>
                                        <div
                                            className={isPhoneClientWidth ? 'bigFontSizePhone' : ''}>{v.symbol}</div>
                                        {/*{isPoolCreate && greaterThan(*/}
                                        {/*    hexToNumber(v.tokenAddress), hexToNumber(tokenDatas[isReverse ? (i ? 1 : 0) : (i ? 0 : 1)].tokenAddress)*/}
                                        {/*) && <div*/}
                                        {/*    className={`flex alignItemsCenter`}>*/}
                                        {/*    <div*/}
                                        {/*        style={{fontSize: `${isPhoneClientWidth ? .45 : .15}rem`}}*/}
                                        {/*        className={'activeColor smallerFontSize'}>*/}
                                        {/*        Margin Token*/}
                                        {/*    </div>*/}
                                        {/*</div>}*/}
                                    </div>
                                </div>
                                {(isSelectToken || i !== 0) ?
                                    <img src={requireDefault('toBottom')}
                                         alt=""
                                         style={{width: `${isPhoneClientWidth ? 1 : .25}rem`}}/> :
                                    <div/>}
                            </div>)}
                    </div>
                    : <div className={'flexCenter justifyContentSpaceBetween childrenFlexGrow1'}>
                        <div
                            className={`flex alignItemsCenter ${isPhoneClientWidth ? 'childrenSpacingLeftPhone' : 'childrenSpacingLeft'} `}>
                            <div onClick={() => toggleShowSelectToken(true)}
                                 className={`flexCenter ${isPhoneClientWidth ? 'childrenSpacingLeftPhone' : 'childrenSpacingLeft'} cursorPointer`}>
                                {tokenIcon(poolData, `${isPhoneClientWidth ? 2.4 : .8}rem`)}
                                <div className={isPhoneClientWidth ? 'smallFontSizePhone' : ''}>
                                    {showPoolName(poolDataName)}
                                </div>
                                <img src={requireDefault('toBottom')} alt=""
                                     style={{width: `${isPhoneClientWidth ? .8 : .2}rem`}}/>
                            </div>
                            {tradingContest(
                                {
                                    ...poolData,
                                    tradingContest: checkData([data, 'poolDataTradingContest'])
                                },
                                'tradingContest',
                                `${isPhoneClientWidth ? 6.9 : 2.3}rem`)
                            }
                        </div>
                        <div
                            className={`flex justifyContentFlexEnd alignItemsCenter ${isPhoneClientWidth ? 'childrenSpacingLeftSmallPhone' : 'childrenSpacingLeftSmall'}`}>
                            <div
                                className={`colorGray ${isPhoneClientWidth ? 'smallerFontSizePhone' : 'smallFontSize'}`}>TVL:
                            </div>
                            <div
                                className={`textOverflowEllipsis ${isPhoneClientWidth ? 'smallFontSizePhone' : ''}`}>{ovl({
                                ...poolData,
                                poolDataTVL: checkData0(data, 'poolDataTVL')
                            }, 'tvlUsd', undefined, true)}</div>
                        </div>
                    </div>
            })(),
            marginTokenId = checkData0(data, 'marginTokenId'),
            swapFocusIndex = checkData0(data, 'swapFocusIndex'),
            isInputTransitionPrice = swapFocusIndex === 1,
            swapReserve = marginToken0TokenAddress === poolData.currency0 ? swapReserve1 : swapReserve0,
            isExactInput = lessThan(transitionPriceWei, swapReserve),
            isExactOutput = isExactInput && isInputTransitionPrice,
            swapFee = isL => {
                const [a1, b] = feeData,
                    fee = plus(a1, b)
                return [
                    <div className={'flexCenter justifyContentSpaceBetween'}>
                        {showFeeData(a1, b)}
                        <div
                            className={`colorGray ${isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'}`}>
                            {(() => {
                                // const feeAmount = times(newAmount, divide(fee, 100))
                                return `${checkData0(data, 'swapFeeAmount')} ${marginToken0Symbol}`//marginToken0IsETH ? getTokenUSDTPrice(feeAmount) : `${num8(feeAmount)} ${marginToken0Symbol}`
                            })()}
                        </div>
                    </div>,
                    <div className={'flexCenter justifyContentSpaceBetween'}>
                        <div
                            className={`flexCenter colorGray ${isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'}`}>
                            Max Slippage
                        </div>
                        <div
                            className={`flexCenter justifyContentSpaceBetween ${isPhoneClientWidth ? 'childrenSpacingLeftSmallPhone' : 'childrenSpacingLeftSmall'}`}>
                            {maxSlippage == autoMaxSlippage && <div
                                className={`colorGray ${isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'}`}>Auto
                            </div>}
                            <div
                                className={`${isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'}`}>{maxSlippage}%
                            </div>
                        </div>
                    </div>,
                    <div className={'flexCenter justifyContentSpaceBetween'}>
                        <div
                            className={`flexCenter colorGray ${isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'}`}>
                            {isExactOutput ? 'Max. Sent' : 'Min. Received'}
                        </div>
                        <div
                            className={`flexCenter justifyContentSpaceBetween ${isPhoneClientWidth ? 'childrenSpacingLeftSmallPhone' : 'childrenSpacingLeftSmall'}`}>
                            <div
                                className={`${isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'}`}>
                                {isExactOutput
                                    ? `${num8(times(newAmount, divide(plus(100, maxSlippage), 100)))} ${marginToken0Symbol}`
                                    : `${num8(times(transitionPrice, divide(minus(100, maxSlippage), 100)))} ${isL ? 'l' : ''}${marginToken1Symbol}`}
                            </div>
                        </div>
                    </div>
                ]
            },
            highDynamicFees = f => greaterThan(f, 0) &&
                <div
                    className={`${isPhoneClientWidth ? 'paddingBigPhone childrenSpacingLeftPhone' : 'paddingBig childrenSpacingLeft'} flex backgroundGrey`}
                    style={{borderRadius: `${isPhoneClientWidth ? .9 : .3}rem`}}
                >
                    <img src={requireDefault('attention 1')} alt=""
                         style={square(`${isPhoneClientWidth ? .9 : .3}rem`)}/>
                    <div className={isPhoneClientWidth ? 'childrenSpacingTopPhone' : 'childrenSpacingTop'}>
                        <div style={{color: 'red'}}
                             className={`saf1 ${isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'}`}>High
                            dynamic fees ({f}%)
                        </div>
                        <pre
                            className={`${isPhoneClientWidth ? 'smallFontSizePhone' : 'smallerFontSize'} colorGray`}>{`This transaction will have a huge price impact on the 
market price of this pool and will result in a loss of funds.`}</pre>
                        <div onClick={toFeeUrl}
                             className={`cursorPointer ${isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'}`}>
                            Learn more
                        </div>
                    </div>
                </div>,
            tokenUSDTPrice = isETHPool
                ? ''//getTokenUSDTPrice(marginToken0IsETH ? newAmount : transitionPrice)
                : '',
            swapMirrorReserve = checkData0(data, `swapMirrorReserve${
                marginToken0TokenAddress === poolData.currency0 ? 1 : 0
            }`),
            isSwapMirrorError = !isExactInput && greaterThan(transitionPriceWei, swapMirrorReserve),
            erc20LendPositionAllowance = (...params) => erc20Allowance(lendPositionAddress, ...params),
            erc20WriteContract = (contractAddress, ...params) => wC(contractAddress, erc20Abi, ...params),
            erc20Approve = (marginAddress, contractAddress, amount, func) =>
                erc20WriteContract(contractAddress, 'approve', undefined, [marginAddress, 115792089237316195423570985008687907853269984665640564039457584007913129639935n], func),
            erc20LendPositionApprove = (...params) => erc20Approve(lendPositionAddress, ...params),
            depositAllowance = () => erc20LendPositionAllowance(
                marginToken0TokenAddress, newAmountWei
            ).then(num => {
                setTokenData(marginToken0Data, {needApprove: num > 0})
                return num
            }),
            toggleShowDeposit = showDeposit => (showDeposit ? (() => {
                toggleShowLoading(true)
                return (!marginToken0IsETH ? depositAllowance()
                    : new Promise(resolve => resolve())).then(() => toggleShowLoading())
            })() : new Promise(resolve => resolve())).then(() => setData({showDeposit, ...!showDeposit ? {showApprove: false} : {}})),
            marginPositionTokenId = (poolId = poolDataPoolId, mFO = marginForOne) => requestApi('margin/position/list', {
                chainId, poolId, page: 1, pageSize: 1,
                owner: address, marginForOne: mFO, borrow: isBorrow, burned: false
            }).then(v => checkData([v, 'items', 0, 'tokenId'])),
            lendPoolTokenId = (poolId = poolDataPoolId, lendToken = isSwap ? marginToken1TokenAddress : marginToken0TokenAddress) => requestApi('margin/lending/pool/list', {
                chainId,
                poolId,
                page: 1,
                pageSize: 1,
                owner: address,
                lendToken
            }).then(v => checkData([v, 'items', 0, 'tokenId'])),
            defaultDeadline = plus(Math.floor(npDivide(Date.now(), 1000)), defaultDeadlineSecond),
            transactionDeadline = checkData([data, 'transactionDeadline'], defaultDeadlineSecond / 60),
            deadline = Number(plus(Math.floor(divide(Date.now(), 1000)), times(transactionDeadline || 0, 60))),
            poolKey = checkDataArray(data, 'poolKey'),
            supplyWithdrawFunc = () => lendPoolTokenId().then(
                tokenId => {
                    const tokenIdIsNotNull = isNotNull(tokenId)
                    return lendPositionWriteContract(
                        isSupply ? (tokenIdIsNotNull ? 'deposit' : 'addLending') : 'withdraw',
                        (isSupply && marginToken0IsETH) ? newAmountWei : undefined,
                        [
                            ...(isSupply && !tokenIdIsNotNull)
                                ? [
                                    poolKey,
                                    isMarginSell,
                                    address,
                                    newAmountWei
                                ]
                                : [tokenId, newAmountWei],
                            deadline
                        ],
                        hash => waitForTransactionFunc(
                            hash,
                            () => {
                                isSupply && setData({marginSuccess: true})
                                toggleShowDeposit()
                                isSupply ? toggleShowLoadingShowPositionsPools(3) : toggleShowLoading()
                                toastSuccessful(true)
                                erc20CallBalanceOfTokens()
                            }
                        )
                    )
                }
            ),
            approveContent = arr => <div
                className={isPhoneClientWidth ? 'childrenSpacingTopPhone' : 'childrenSpacingTop'}>
                {(() => {
                    const size = `${isPhoneClientWidth ? 1.5 : .5}rem`,
                        isCreateInitializeEnd = checkDataBool(data, 'isCreateInitializeEnd')
                    return [
                        ...isPoolCreate
                            ? [['Initialize', isCreateInitializeEnd ? 'Group 427320704-2' : 'rotatingLoading', !isCreateInitializeEnd]]
                            : [],
                        ...arr.map(({needApprove}) =>
                            [
                                `Approve ${needApprove ? 'pending' : ''}`,
                                needApprove ? ((!isPoolCreate || isCreateInitializeEnd) ? 'rotatingLoading' : 'Group 427320704') : 'Group 427320704-2',
                                !needApprove
                            ]
                        ),
                        ...isSwapNeedAddLending
                            ? [[
                                'Add Lending',
                                !arr.map(v => v.needApprove).includes(true) ? (
                                    addLendingFinish ? 'Group 427320704-3' : 'rotatingLoading'
                                ) : 'Group 427320704-4',
                                addLendingFinish
                            ]]
                            : [],
                        ['Confirm', !arr.map(v => v.needApprove).includes(true) && (isSwapNeedAddLending ? addLendingFinish : true) ? 'rotatingLoading' : 'Confirm Swap']
                    ].map((v, i) => [i !== 0 &&
                    <div style={{width: size, height: `calc(${size} / 2 )`}}
                         className={'flexCenter'}>
                        <div className={'height100'} style={{width: '10%', background: '#C0C0C0'}}/>
                    </div>, <div
                        className={`flex alignItemsCenter ${isPhoneClientWidth ? 'childrenSpacingLeftPhone' : 'childrenSpacingLeft'}`}>
                        <img src={requireDefault(v[1])} alt="" style={square(size)}/>
                        <div
                            className={`${v[2] ? '' : 'colorGray'} ${isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'}`}>{v[0]}</div>
                    </div>])
                })()}
            </div>,
            maskContent = (title, show, toggle, content, webWidth, isBack, followWeb, other) =>
                show && <div onClick={() => toggle()}
                             className={`positionFixed ${isPhoneClientWidth && !followWeb ? 'flexColumn justifyContentFlexEnd' : 'flexColumnCenter'}`}
                             style={{
                                 top: 0,
                                 left: 0,
                                 right: 0,
                                 bottom: 0,
                                 zIndex: 1000,
                                 background: 'rgba(0,0,0,.56)',
                             }}>
                    {isPhoneClientWidth && !followWeb
                        ? <div onClick={event => event.stopPropagation()}
                               className={'backgroundWhite paddingBigPhone boxSizingBorderBox childrenSpacingTopBigPhone overflowVisible'}
                               style={{borderTopLeftRadius: '1.5rem', borderTopRightRadius: '1.5rem'}}>
                            {title && <div className={'flexCenter justifyContentSpaceBetween paddingTopPhone'}>
                                <div className={'flex alignItemsCenter childrenSpacingLeftPhone'}>
                                    {isBack && <img onClick={() => toggle()} src={requireDefault('leftArrow')}
                                                    alt="" className={'cursorPointer'} style={{width: '1.2rem'}}/>}
                                    <div className={'saf1'}>{title}</div>
                                </div>
                                <div
                                    className={`flexCenter ${isPhoneClientWidth ? 'childrenSpacingLeftPhone' : 'childrenSpacingLeft'}`}>
                                    {other}
                                    {!isBack && <img onClick={() => toggle()} src={requireDefault('close')}
                                                     alt="" className={'cursorPointer'} style={{width: '1.2rem'}}/>}
                                </div>
                            </div>}
                            {content}
                        </div>
                        : <div onClick={event => event.stopPropagation()}
                               className={`${isPhoneClientWidth ? 'borderRadiusPhone paddingBigPhone childrenSpacingTopBigPhone'
                                   : 'borderRadius paddingBigger childrenSpacingTopBig'} backgroundWhite boxSizingBorderBox overflowVisible`}
                               style={{width: `${checkData([webWidth], isPhoneClientWidth ? 28 : 8)}rem`}}>
                            <div className={'flexCenter justifyContentSpaceBetween'}>
                                <div
                                    className={`flex alignItemsCenter ${isPhoneClientWidth ? 'childrenSpacingLeftPhone' : 'childrenSpacingLeft'}`}>
                                    {isBack && <img onClick={() => toggle()} src={requireDefault('leftArrow')}
                                                    alt="" className={'cursorPointer'}
                                                    style={{width: `${isPhoneClientWidth ? .9 : .3}rem`}}/>}
                                    <div className={'saf1'}>{title}</div>
                                </div>
                                <div
                                    className={`flexCenter ${isPhoneClientWidth ? 'childrenSpacingLeftPhone' : 'childrenSpacingLeft'}`}>
                                    {other}
                                    {!isBack && <img onClick={() => toggle()} src={requireDefault('close')}
                                                     alt="" className={'cursorPointer'}
                                                     style={{width: `${isPhoneClientWidth ? .9 : .3}rem`}}/>}
                                </div>

                            </div>
                            {content}
                        </div>}
                </div>,
            depositMask = maskContent(
                'You’re Supply',
                checkDataBool(data, 'showDeposit'),
                toggleShowDeposit,
                <div
                    style={{marginTop: `${isPhoneClientWidth ? 3 : .7}rem`}}
                    className={isPhoneClientWidth ? 'childrenSpacingTopBiggerPhone' : 'childrenSpacingTopBigger'}>
                    <div
                        className={isPhoneClientWidth ? 'childrenSpacingTopBigPhone' : 'childrenSpacingTopBig'}>
                        <div
                            className={isPhoneClientWidth ? 'paddingBigPhone borderRadiusPhone borderSmallGrayLinePhone childrenSpacingTopPhone' : 'paddingBig borderRadius borderSmallGrayLine childrenSpacingTop'}>
                            <div
                                className={`flexCenter justifyContentSpaceBetween ${isPhoneClientWidth ? 'childrenSpacingLeftPhone' : 'childrenSpacingLeft'}`}>
                                <div
                                    className={isPhoneClientWidth ? 'bigFontSizePhone' : 'bigFontSize'}>{newAmount}</div>
                                <div
                                    className={`borderRadius999 saf flexCenter ${isPhoneClientWidth ? 'childrenSpacingLeftPhone borderSmallGrayLinePhone' : 'childrenSpacingLeft borderSmallGrayLine'}`}
                                    style={{
                                        height: `${isPhoneClientWidth ? 2.5 : .8}rem`,
                                        padding: `0 ${isPhoneClientWidth ? .7 : .3}rem`,
                                    }}>
                                    {
                                        (() => {
                                            const size = `${isPhoneClientWidth ? 1.5 : .5}rem`
                                            return [
                                                <div className={'positionRelative'}
                                                     style={square(size)}>
                                                    {tokenIcon(marginToken0Data, size)}
                                                </div>,
                                                <div>{marginToken0Symbol}</div>
                                            ]
                                        })()
                                    }
                                </div>
                            </div>
                            <div
                                className={`${isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'} colorGray`}>{tokenUSDTPrice}</div>
                        </div>
                    </div>
                    <div className={'flexCenter justifyContentSpaceBetween'}>
                        <div
                            className={`${isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'} colorGray`}>
                            Supply APY
                        </div>
                        <div
                            className={`${isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'}`}>{lendingInterest}%
                        </div>
                    </div>
                    {showApprove
                        ? approveContent([{
                            symbol: marginToken0Symbol,
                            needApprove: marginToken0DataNeedApprove
                        }])
                        : <div style={isPhoneClientWidth ? {marginBottom: '2rem'} : {}}
                               onClick={async () => {
                                   toggleShowApprove(marginToken0DataNeedApprove)
                                   const allowance = () => depositAllowance().then(num => {
                                       setTokenData(marginToken0Data, {needApprove: num > 0})
                                       return num
                                   }).then(tA => tA > 0
                                       ? erc20LendPositionApprove(marginToken0TokenAddress, tA, hash => waitForTransactionFunc(hash, allowance))
                                       : supplyWithdrawFunc());
                                   (marginToken0IsETH ? supplyWithdrawFunc : allowance)()
                               }}
                               className={`${isPhoneClientWidth ? 'borderRadiusPhone paddingTopBottomPhone' : 'borderRadius paddingTopBottomBig'} flexCenter colorWhite saf1 backgroundActiveColor cursorPointer`}>
                            {needApproveButton(marginToken0DataNeedApprove, 'Deposit')}
                        </div>}
                </div>),
            feeDecimals = '10000',
            poolDataFee = checkData0(poolData, 'fee'),
            poolDataMarginFee = checkData0(poolData, 'marginFee'),
            defaultFeeTiers = '0.3',
            feeTiers = ['0.01', defaultFeeTiers, '0.5', '1'],
            feeTierIndex = checkData([data, 'feeTierIndex'], feeTiers.indexOf(defaultFeeTiers)),
            toFeeNum = num => toFixed(divide(num, feeDecimals), 2),
            poolDataFeeNum = toFeeNum(poolDataFee),
            feeTier = isPoolAddIncrease ? poolDataFeeNum : feeTiers[feeTierIndex],
            feeLT = lessThan(feeTier, defaultFeeTiers),
            marginFeeTiers = ['0.1', '0.2', defaultFeeTiers, '0.5'],
            marginFeeTierIndex = checkData([data, 'marginFeeTierIndex'], marginFeeTiers.indexOf(defaultFeeTiers)),
            marginFeeTier = isPoolAddIncrease ? toFeeNum(poolDataMarginFee) : marginFeeTiers[marginFeeTierIndex],
            toFeeTierBigInt = num => BigInt(times(num, feeDecimals)),
            feeTierBigInt = isPoolAddIncrease ? poolDataFee : toFeeTierBigInt(feeTier),
            marginFeeTierBigInt = isPoolAddIncrease ? poolDataMarginFee : (feeLT ? 0 : toFeeTierBigInt(marginFeeTier)),
            poolDataFeeLTText = 'Unavailable at This Fee Tier',
            poolDataFeeLT = poolDataPoolId && lessThan(poolDataFeeNum, defaultFeeTiers),
            supplyWithdrawContainer = (() => {
                const withdrawMax = checkData0(data, 'withdrawMax'),
                    withdrawIndex = isMarginSell ? 1 : 0,
                    withdrawMax_ = plus(
                        checkData0(data, `realReserve${withdrawIndex}`),
                        checkData0(data, `lendingRealReserve${withdrawIndex}`)
                    ),
                    supplyWithdrawMaxBalance = isSupply
                        ? marginToken0DataBalance
                        : numberETH(lessThan(withdrawMax, withdrawMax_) ? withdrawMax : withdrawMax_, marginToken0DataDecimals)
                return [
                    <div style={isPhoneClientWidth ? {} : {borderRadius: '.3rem'}}
                         className={`backgroundWhite ${isPhoneClientWidth ? 'borderSmallGrayLinePhone paddingBigPhone childrenSpacingTopSmallPhone borderRadiusPhone' : 'borderSmallGrayLine paddingBig childrenSpacingTopSmall'}`}
                    >
                        <div
                            className={isPhoneClientWidth ? 'childrenSpacingTopPhone' : 'childrenSpacingTop'}>
                            {isSelectToken && isTradeSupply &&
                                <div className={'flexCenter justifyContentSpaceBetween'}>
                                    <div
                                        className={`${isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'} colorGray`}>
                                        Liquidity Pool TVL
                                    </div>
                                    <div
                                        className={`${isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'} colorGray`}>{ovl(poolData, 'tvl')}</div>
                                </div>}
                            {selectTokenContainer}
                        </div>
                        {
                            isTradeSupply
                                ? [
                                    <img src={requireDefault('Line 2')} alt="" className={'width100'}/>,
                                    <div
                                        className={`${isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'} colorGray`}>
                                        Entry Price
                                    </div>,
                                    <div
                                        className={`flex alignItemsCenter ${opacityShow ? 'opacityShow' : 'opacityHidden'} ${isPhoneClientWidth ? 'childrenSpacingLeftPhone' : 'childrenSpacingLeft'}`}>
                                        <div
                                            className={isPhoneClientWidth ? 'bigFontSizePhone' : 'bigFontSize'}>
                                            {entryToken} {token0Symbol}
                                        </div>
                                        {isETHPool && <div
                                            className={`${isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'} colorGray`}>
                                            {marginEntryPrice}
                                        </div>}
                                    </div>
                                ]
                                : []
                        }
                    </div>,
                    <div
                        className={`flex alignItemsCenter ${isPhoneClientWidth ? 'childrenSpacingLeftBigPhone childrenFlexGrow1' : 'childrenSpacingLeft'}`}>
                        {
                            [
                                [token0Data, token0Symbol, false],
                                [token1Data, token1Symbol, true]
                            ].map(v => {
                                    const iMS = v[2], isCurrent = isMarginSell === iMS
                                    return <div
                                        className={`flexCenter borderRadius999 cursorPointer ${
                                            isCurrent
                                                ? 'backgroundActiveColor'
                                                : (isPhoneClientWidth ? 'borderSmallGrayLinePhone' : 'borderSmallGrayLine')
                                        } 
                                                        ${isPhoneClientWidth ? 'childrenSpacingLeftPhone' : 'childrenSpacingLeft'}`}
                                        style={{padding: `${isPhoneClientWidth ? .45 : .15}rem ${isPhoneClientWidth ? 0 : .5}rem`}}
                                        onClick={() => setData({isMarginSell: iMS})}
                                    >
                                        {tokenIcon(v[0], `${isPhoneClientWidth ? 1.5 : .5}rem`)}
                                        <div
                                            className={`${isCurrent ? 'colorWhite saf1' : 'colorGray'}`}>{isSupply ? 'Supply' : 'Withdraw'} {v[1]}</div>
                                    </div>
                                }
                            )
                        }
                    </div>,
                    <div
                        className={`backgroundGrey ${isPhoneClientWidth ? 'paddingBigPhone childrenSpacingTopPhone borderRadiusPhone' : 'paddingBig childrenSpacingTopBig'}`}
                        style={isPhoneClientWidth ? {} : {borderRadius: '.3rem'}}
                    >
                        <div
                            className={`flex alignItemsCenter justifyContentSpaceBetween ${isPhoneClientWidth ? 'childrenSpacingLeftPhone' : 'childrenSpacingLeft'}`}>
                            <input type="text"
                                   ref={focusInput}
                                   placeholder='0'
                                   value={inputNewAmount}
                                   onChange={e => setInputNewAmount(e.target.value)}
                                   className={`${isPhoneClientWidth ? 'biggerFontSizePhone' : 'biggerFontSize'} flexGrow1`}/>
                            <div
                                className={`borderRadius999 saf backgroundWhite flexCenter ${isPhoneClientWidth ? 'childrenSpacingLeftSmallPhone' : 'childrenSpacingLeft'}`}
                                style={{
                                    height: `${isPhoneClientWidth ? 2.4 : .8}rem`,
                                    padding: `0 ${isPhoneClientWidth ? .7 : .3}rem`,
                                }}>
                                {tokenIcon(marginToken0Data, `${isPhoneClientWidth ? 1.5 : .5}rem`)}
                                <div>{marginToken0Symbol}</div>
                            </div>
                        </div>
                        <div className={'flexCenter justifyContentSpaceBetween'}>
                            <div
                                className={`${isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'} colorGray`}>
                                {tokenUSDTPrice}
                            </div>
                            <div
                                className={`flexCenter ${isPhoneClientWidth ? 'childrenSpacingLeftPhone' : 'childrenSpacingLeft'}`}>
                                <div
                                    className={`${isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'}`}>
                                    {supplyWithdrawMaxBalance} {marginToken0Symbol}
                                </div>
                                <div
                                    style={{fontSize: `${isPhoneClientWidth ? .6 : .15}rem`}}
                                    onClick={() => setNewAmount(supplyWithdrawMaxBalance)}
                                    className={`backgroundActiveColor ${isPhoneClientWidth ? 'paddingSmallPhone' : 'paddingSmall'} borderRadius999 colorWhite cursorPointer`}>
                                    MAX
                                </div>
                            </div>
                        </div>
                    </div>,
                    isSupply && <div
                        className={`flexCenter justifyContentFlexEnd ${isPhoneClientWidth ? 'childrenSpacingLeftPhone' : 'childrenSpacingLeft'}`}>
                        <div>Supply APY</div>
                        <img src={requireDefault('interestIncome')} alt=""
                             style={{width: `${isPhoneClientWidth ? 1.2 : .4}rem`}}/>
                        <div>{lendingInterest}%</div>
                    </div>,
                    (() => {
                        const canDeposit = poolDataPoolId && (isSupply ? !poolDataFeeLT : true)
                        return <div style={{
                            ...canDeposit ? {} : {color: '#B8BCBF'},
                            ...(isPhoneClientWidth && isTradeSupply) ? {marginBottom: '21rem'} : {}
                        }}
                                    onClick={() => canDeposit && (
                                        newAmountNumber <= supplyWithdrawMaxBalance
                                            ? (
                                                isSupply
                                                    ? (
                                                        lessThanOrEqualTo(newAmountNumber)
                                                            ? toast('Amount must be greater than zero.')
                                                            : toggleShowDeposit(true)
                                                    )
                                                    : supplyWithdrawFunc()
                                            )
                                            : (() => {
                                                toast(`The maximum ${isSupply ? 'supply' : 'withdraw'} amount is  ${supplyWithdrawMaxBalance}`)
                                                !isSupply && supplyWithdrawFunc()
                                            })()
                                    )}
                                    className={`${isPhoneClientWidth ? 'borderRadiusPhone paddingTopBottomPhone bigFontSizePhone' : 'borderRadius paddingTopBottomBig bigFontSize'} 
                                             flexCenter colorWhite saf1 ${canDeposit ? 'backgroundActiveColor' : 'backgroundGrey1'}  cursorPointer`}>
                            {isSupply ? (poolDataFeeLT ? poolDataFeeLTText : 'Deposit') : 'Withdraw'}
                        </div>
                    })()
                ]
            })(),
            getMarginMaxing = checkData([data, 'getMarginMaxing']),
            toggleMarginMaxLeverageIndex = marginMaxLeverageIndex => setData({marginMaxLeverageIndex}),
            isLendPositionSwap = isSwap && !isSwapMirrorError && !isExactInput,
            toggleShowMarginSwap = (key, show) => (show ? (() => {
                toggleShowLoading(true)
                return (!marginToken0IsETH ? marginToken0Allowance(
                        (isSwap && isLendPositionSwap) ? erc20LendPositionAllowance : undefined
                    )
                    : new Promise(resolve => resolve())).then(() => toggleShowLoading())
            })() : new Promise(resolve => resolve())).then(() => setData({[key]: show, ...!show ? {showApprove: false} : {}})),
            toggleShowSwapping = showSwapping => {
                const func = () => toggleShowMarginSwap('showSwapping', showSwapping)
                showSwapping
                    ? switchEthereumChain(func, undefined, true)
                    : (() => {
                        func();
                        isSwap && setData(
                            {addLendingFinish: undefined, needAddLending: undefined}
                        )
                    })()
            },
            toggleShowDespite = showDespite => setData({showDespite}),
            toggleShowMarginSelling = showMarginSelling => {
                const func = () => toggleShowMarginSwap('showMarginSelling', showMarginSelling)
                showMarginSelling
                    ? switchEthereumChain(func, undefined, true)
                    : func()
            },
            marginSwap = (() => {
                const unitPrice = checkData0(data, 'unitPrice'), uint = 1,
                    getTokenUSDTUintPrice = getTokenUSDTPrice(marginToken0IsETH ? unitPrice : uint),
                    beforeAfterMerged = ['Before Merged', 'After Merged']
                return [
                    [
                        'Margin',
                        () => {
                            const showMarginMaxLeverages = checkDataBool(data, 'showMarginMaxLeverages'),
                                toggleShowMarginMaxLeverages = () => setData({showMarginMaxLeverages: !showMarginMaxLeverages}),
                                marginMaxBalance = lessThanOrEqualTo(marginToken0DataBalance, marginMax) ? marginToken0DataBalance : marginMax
                            return [
                                <div style={isPhoneClientWidth ? {} : {borderRadius: '.3rem'}}
                                     className={`backgroundWhite ${isPhoneClientWidth ? 'borderSmallGrayLinePhone paddingBigPhone childrenSpacingTopSmallPhone borderRadiusPhone' : 'borderSmallGrayLine paddingBig childrenSpacingTopSmall'}`}
                                >
                                    <div
                                        className={isPhoneClientWidth ? 'childrenSpacingTopPhone' : 'childrenSpacingTop'}>
                                        {isSelectToken && <div className={'flexCenter justifyContentSpaceBetween'}>
                                            <div
                                                className={`${isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'} colorGray`}>
                                                Liquidity Pool TVL
                                            </div>
                                            <div
                                                className={`${isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'} colorGray`}>{ovl(poolData, 'tvl')}</div>
                                        </div>}
                                        {selectTokenContainer}
                                    </div>
                                    {/*<div className={'flexCenter justifyContentSpaceBetween'}>*/}
                                    {/*    <div onClick={() => toggleShowSelectToken(true)}*/}
                                    {/*         className={`flexCenter ${isPhoneClientWidth ? 'childrenSpacingLeftPhone' : 'childrenSpacingLeft'} cursorPointer`}>*/}
                                    {/*        {tokenIcon(poolData, `${isPhoneClientWidth ? 2.4 : .8}rem`)}*/}
                                    {/*        <div className={isPhoneClientWidth ? 'smallFontSizePhone' : ''}>*/}
                                    {/*            {poolData.name}*/}
                                    {/*        </div>*/}
                                    {/*        <img src={requireDefault('toBottom')} alt=""*/}
                                    {/*             style={{width: `${isPhoneClientWidth ? .8 : .2}rem`}}/>*/}
                                    {/*    </div>*/}
                                    {/*    <div*/}
                                    {/*        className={isPhoneClientWidth ? 'smallFontSizePhone' : ''}>{ovl(poolData, 'tvl')}</div>*/}
                                    {/*</div>*/}
                                    <img src={requireDefault('Line 2')} alt="" className={'width100'}/>
                                    <div
                                        className={`${isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'} colorGray`}>
                                        Entry Price
                                    </div>
                                    <div className={'flex alignItemsCenter childrenSpacingLeft'}>
                                        <img src={requireDefault('Group 427321071')} alt=""
                                             className={'cursorPointer'} onClick={() => setData({long0: !long0})}
                                             style={square(`${isPhoneClientWidth ? '2.1' : '.7'}rem`)}/>
                                        <div
                                            className={`flex alignItemsCenter ${opacityShow ? 'opacityShow' : 'opacityHidden'} ${isPhoneClientWidth ? 'childrenSpacingLeftPhone' : 'childrenSpacingLeft'}`}>
                                            <div
                                                className={isPhoneClientWidth ? 'bigFontSizePhone' : 'bigFontSize'}>
                                                {long0 ? num8(divide(1, entryToken)) : entryToken} {long0 ? token1Symbol : token0Symbol}
                                            </div>
                                            {isETHPool && <div
                                                className={`${isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'} colorGray`}>
                                                {`(${getTokenUSDTPrice(long0 ? 1 : marginEntryPriceNum)})`}
                                            </div>}
                                        </div>
                                    </div>
                                </div>,
                                <div
                                    className={`flex alignItemsCenter ${isPhoneClientWidth ? 'childrenSpacingLeftBigPhone childrenFlexGrow1' : 'childrenSpacingLeft'}`}>
                                    {
                                        [
                                            [`${long0 ? 'mS' : 'mB'}${!isMarginSell ? 'Active' : ''}`, long0 ? 'Short' : 'Long', !isMarginSell, false],
                                            [`${long0 ? 'mB' : 'mS'}${isMarginSell ? 'Active' : ''}`, long0 ? 'Long' : 'Short', isMarginSell, true]
                                        ].map(v => {
                                            const isCurrent = v[2]
                                            return <div
                                                onClick={() => setData({
                                                    isMarginSell: v[3],
                                                    getMarginMaxing: true
                                                })}
                                                className={`flexCenter borderRadius999 cursorPointer ${
                                                    isCurrent
                                                        ? 'backgroundActiveColor'
                                                        : (isPhoneClientWidth ? 'borderSmallGrayLinePhone' : 'borderSmallGrayLine')
                                                } 
                                                        ${isPhoneClientWidth ? 'childrenSpacingLeftPhone' : 'childrenSpacingLeft'}`}
                                                style={{padding: `${isPhoneClientWidth ? .45 : .15}rem ${isPhoneClientWidth ? 0 : .5}rem`}}
                                            >
                                                <img src={requireDefault(v[0])} alt=""
                                                     className={'cursorPointer'}
                                                     style={square(`${isPhoneClientWidth ? 1.5 : .5}rem`)}
                                                />
                                                <div
                                                    className={`${isCurrent ? 'colorWhite saf1' : 'colorGray'}`}>{v[1]} {long0 ? token0Symbol : token1Symbol}</div>
                                            </div>
                                        })
                                    }
                                </div>,
                                <div
                                    className={`backgroundGrey ${isPhoneClientWidth ? 'paddingBigPhone childrenSpacingTopPhone borderRadiusPhone' : 'paddingBig childrenSpacingTopBig'}`}
                                    style={isPhoneClientWidth ? {} : {borderRadius: '.3rem'}}
                                >
                                    <div
                                        className={`flex alignItemsCenter justifyContentSpaceBetween ${isPhoneClientWidth ? 'childrenSpacingLeftPhone' : 'childrenSpacingLeft'}`}>
                                        <input type="text"
                                               ref={focusInput}
                                               placeholder='0'
                                               value={inputNewAmount}
                                               onChange={e => setInputNewAmount(e.target.value)}
                                               className={`${isPhoneClientWidth ? 'biggerFontSizePhone' : 'biggerFontSize'} flexGrow1`}/>
                                        <div
                                            className={`borderRadius999 saf backgroundWhite flexCenter ${isPhoneClientWidth ? 'childrenSpacingLeftSmallPhone' : 'childrenSpacingLeft'}`}
                                            style={{
                                                height: `${isPhoneClientWidth ? 2.4 : .8}rem`,
                                                padding: `0 ${isPhoneClientWidth ? .7 : .3}rem`,
                                            }}>
                                            {tokenIcon(marginToken0Data, `${isPhoneClientWidth ? 1.5 : .5}rem`)}
                                            <div>{marginToken0Symbol}</div>
                                        </div>
                                    </div>
                                    <div className={'flexCenter justifyContentSpaceBetween'}>
                                        <div
                                            className={`${isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'} colorGray`}>
                                            {tokenUSDTPrice}
                                        </div>
                                        <div style={{opacity: getMarginMaxing ? 0 : 1}}
                                             className={`flexCenter ${isPhoneClientWidth ? 'childrenSpacingLeftPhone' : 'childrenSpacingLeft'}`}>
                                            <div
                                                className={`${isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'}`}>
                                                {marginMaxBalance} {marginToken0Symbol}
                                            </div>
                                            <div
                                                style={{fontSize: `${isPhoneClientWidth ? .6 : .15}rem`}}
                                                onClick={() => setNewAmount(marginMaxBalance)}
                                                className={`backgroundActiveColor ${isPhoneClientWidth ? 'paddingSmallPhone' : 'paddingSmall'} borderRadius999 colorWhite cursorPointer`}>
                                                MAX
                                            </div>
                                        </div>
                                    </div>
                                </div>,
                                <div
                                    className={`${isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'} colorGray`}>
                                    Margin Max Leverage
                                </div>,
                                <div
                                    className={`flexCenter justifyContentSpaceBetween ${isPhoneClientWidth ? 'childrenSpacingLeftPhone' : 'childrenSpacingLeft'}`}>
                                    {[// currentLeverages,
                                        ...marginMaxLeverages, // <input type="text"
                                        //        style={{width: `${isPhoneClientWidth ? 75 : 65}%`, height: '80%'}}
                                        //        className={`saf1 ${marginMaxLeverageIndex === 3 ? 'colorWhite' : ''}`}
                                        //        value={checkDataString(data, 'otherMarginMaxLeverage')}
                                        //        onChange={e => setData({otherMarginMaxLeverage: e.target.value.replace(/[^\d]/g, '')})}
                                        //        placeholder={marginMaxLeverageIndex === 3 ? '' : 'Other'}/>
                                    ].map((v, i) => {
                                        const isFirst = false// i === 0
                                        return [
                                            <div onClick={() => !isFirst && toggleMarginMaxLeverageIndex(i)}
                                                 className={`borderRadius999 flexCenter ${(isFirst || i === marginMaxLeverageIndex) ? 'backgroundActiveColor colorWhite' : 'borderSmallGrayLine'} saf1 ${isPhoneClientWidth ? '' : 'bigFontSize'} boxSizingBorderBox ${isFirst ? '' : 'cursorPointer'}`}
                                                 style={{
                                                     ...isPhoneClientWidth ? {
                                                         width: '4.5rem', height: '2.1rem',
                                                     } : {
                                                         width: '1.5rem', height: '.7rem',
                                                     }, // ...!isFirst && !showMarginMaxLeverages
                                                     //     ? {opacity: 0}
                                                     //     : {}
                                                 }}>
                                                {v}
                                            </div>,
                                            ...isFirst ? [
                                                <div
                                                    onClick={toggleShowMarginMaxLeverages}
                                                    className={'borderRadius999 flexCenter backgroundGrey cursorPointer'}
                                                    style={square(`${isPhoneClientWidth ? 1.5 : .5}rem`)}>
                                                    <img
                                                        src={requireDefault(showMarginMaxLeverages ? 'toLeft' : 'toRight')}
                                                        alt=""
                                                        style={{width: '40%'}}/>
                                                </div>
                                            ] : []
                                        ]
                                    })}
                                </div>,
                                (() => {
                                    const canReview = poolDataPoolId && !poolDataFeeLT && !dynamicFeeTooHigh
                                    return <div style={canReview ? {} : {color: '#B8BCBF'}}
                                                onClick={() => canReview && (
                                                    newAmountNumber <= marginMaxBalance
                                                        ? (
                                                            lessThanOrEqualTo(newAmountNumber)
                                                                ? toast('Amount must be greater than zero.')
                                                                : toggleShowMarginSelling(true)
                                                        )
                                                        : toast(`The maximum amount is ${marginMaxBalance}`)
                                                )}
                                                className={`${isPhoneClientWidth ? 'borderRadiusPhone paddingTopBottomPhone bigFontSizePhone' : 'borderRadius paddingTopBottomBig bigFontSize'}
                                     ${canReview ? 'backgroundActiveColor' : 'backgroundGrey1'} 
                                     flexCenter colorWhite saf1 cursorPointer`}>
                                        {poolDataFeeLT ? poolDataFeeLTText : (dynamicFeeTooHigh ? dynamicFeeTooHighText : 'Review')}
                                    </div>
                                })(),
                                showMarginData && !!marginTokenId &&
                                <div style={{padding: `${isPhoneClientWidth ? .5 : .1}rem`}}
                                     className={'borderSmallGrayLine borderRadius999 childrenFlexGrow1 flexCenter'}>
                                    {beforeAfterMerged.map((v, i) => <div
                                        onClick={() => setData({beforeAfterMergedIndex: i})}
                                        className={`borderRadius999 flexCenter ${isPhoneClientWidth ? 'paddingTopBottomPhone' : 'paddingTopBottom'} cursorPointer 
                                             ${beforeAfterMergedIndex === i ? 'backgroundGrey saf1' : 'colorGray'}`}>
                                        {v}
                                    </div>)}
                                </div>,
                                <div
                                    className={isPhoneClientWidth ? 'childrenSpacingTopBigPhone marginTopBigPhone' : 'childrenSpacingTopBig marginTopPhone'}>
                                    {marginData()}
                                </div>
                            ]
                        }
                    ],
                    [
                        'Swap',
                        () => <div style={isPhoneClientWidth ? {paddingBottom: '21rem'} : {}}
                                   className={isPhoneClientWidth ? 'childrenSpacingTopBigPhone' : 'childrenSpacingTopBig'}>
                            <div
                                className={`${isPhoneClientWidth ? 'childrenSpacingTopBigPhone' : 'childrenSpacingTopBig'} positionRelative`}>
                                <div
                                    className={`backgroundWhite ${isPhoneClientWidth ? 'borderRadiusPhone borderSmallGrayLinePhone paddingBigPhone childrenSpacingTopBigPhone' : 'borderRadius borderSmallGrayLine paddingBig childrenSpacingTopBig'} ${isInputTransitionPrice ? 'backgroundGrey' : ''}`}
                                >
                                    <div
                                        className={`${isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'} colorGray`}>Sell
                                    </div>
                                    <div
                                        className={`flex alignItemsCenter justifyContentSpaceBetween ${isPhoneClientWidth ? 'childrenSpacingLeftPhone' : 'childrenSpacingLeft'}`}>
                                        <input type="text"
                                               placeholder='0'
                                               ref={focusInput}
                                               value={inputNewAmount}
                                               onFocus={() => setData({swapFocusIndex: 0})}
                                               onChange={e => setInputNewAmount(e.target.value)}
                                               className={`flexGrow1 ${isPhoneClientWidth ? 'biggerFontSizePhone' : 'biggerFontSize'}`}/>
                                        <div onClick={() => {
                                            setData({selectTokenIndex: isMarginSell ? 0 : 1})
                                            toggleShowSelectToken(true)
                                        }}
                                             className={`borderRadius999 saf flexCenter ${isPhoneClientWidth ? 'childrenSpacingLeftPhone borderSmallGrayLinePhone' : 'childrenSpacingLeft borderSmallGrayLine'} cursorPointer`}
                                             style={{
                                                 height: `${isPhoneClientWidth ? 2.4 : .8}rem`,
                                                 padding: `0 ${isPhoneClientWidth ? .7 : .3}rem`,
                                             }}>
                                            {tokenIcon(marginToken0Data, `${isPhoneClientWidth ? 1.5 : .5}rem`)}
                                            <div>{marginToken0Symbol}</div>
                                            <img src={requireDefault('toBottom')} alt=""
                                                 style={square(`${isPhoneClientWidth ? .7 : .2}rem`)}/>
                                        </div>
                                    </div>
                                    <div className={'flexCenter justifyContentSpaceBetween'}>
                                        <div
                                            className={`${isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'} colorGray`}>{tokenUSDTPrice}
                                        </div>
                                        <div
                                            className={`flexCenter ${isPhoneClientWidth ? 'childrenSpacingLeftPhone' : 'childrenSpacingLeft'}`}>
                                            {(() => {
                                                const maxBalance = lessThanOrEqualTo(marginToken0DataBalance, swapMax) ? marginToken0DataBalance : swapMax
                                                return [
                                                    <div
                                                        className={`${isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'}`}>
                                                        {maxBalance} {marginToken0Symbol}
                                                    </div>,
                                                    <div style={{fontSize: `${isPhoneClientWidth ? .6 : .15}rem`}}
                                                         onClick={() => {
                                                             setData({swapFocusIndex: 0})
                                                             setNewAmount(maxBalance)
                                                         }}
                                                         className={`backgroundActiveColor ${isPhoneClientWidth ? 'paddingSmallPhone' : 'paddingSmall'} borderRadius999 colorWhite cursorPointer`}>MAX
                                                    </div>
                                                ]
                                            })()}
                                        </div>
                                    </div>
                                </div>
                                <div
                                    className={`${isPhoneClientWidth ? 'borderRadiusPhone borderSmallGrayLinePhone paddingBigPhone childrenSpacingTopBigPhone' : 'borderRadius borderSmallGrayLine paddingBig childrenSpacingTopBig'} ${isInputTransitionPrice ? '' : 'backgroundGrey'}`}
                                >
                                    <div
                                        className={`${isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'} colorGray`}>Buy
                                    </div>
                                    <div
                                        className={`flex alignItemsCenter justifyContentSpaceBetween ${isPhoneClientWidth ? 'childrenSpacingLeftPhone' : 'childrenSpacingLeft'}`}>
                                        <input type="text"
                                               placeholder='0'
                                               value={checkDataString(data, 'transitionPrice')}
                                               onFocus={() => setData({swapFocusIndex: 1})}
                                               onChange={e => {
                                                   const tP = getSetNewAmount(e.target.value)
                                                   setData({
                                                       transitionPrice: tP,
                                                       transitionPriceWei: parseEtherNum(
                                                           tP,
                                                           marginToken1DataDecimals
                                                       ),
                                                   })
                                               }}
                                               className={`flexGrow1 ${isPhoneClientWidth ? 'biggerFontSizePhone' : 'biggerFontSize'}`}
                                        />
                                        <div onClick={() => {
                                            setData({selectTokenIndex: isMarginSell ? 1 : 0})
                                            toggleShowSelectToken(true)
                                        }}
                                             className={`borderRadius999 saf flexCenter backgroundWhite ${isPhoneClientWidth ? 'childrenSpacingLeftPhone borderSmallGrayLinePhone' : 'childrenSpacingLeft borderSmallGrayLine'} cursorPointer`}
                                             style={{
                                                 height: `${isPhoneClientWidth ? 2.4 : .8}rem`,
                                                 padding: `0 ${isPhoneClientWidth ? .7 : .3}rem`,
                                             }}>
                                            {tokenIcon(marginToken1Data, `${isPhoneClientWidth ? 1.5 : .5}rem`)}
                                            <div>{marginToken1Symbol}</div>
                                            <img src={requireDefault('toBottom')} alt=""
                                                 style={square(`${isPhoneClientWidth ? .7 : .2}rem`)}/>
                                        </div>
                                    </div>
                                    <div className={'flexCenter justifyContentSpaceBetween'}>
                                        <div
                                            className={`${isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'} colorGray`}>{tokenUSDTPrice}
                                        </div>
                                        <div className={'flexCenter childrenSpacingLeft'}>
                                        </div>
                                    </div>
                                </div>
                                <img style={{
                                    top: isPhoneClientWidth ? '6.7rem' : '2.3rem',
                                    left: '45%',
                                    width: `${isPhoneClientWidth ? 3.5 : 1}rem`

                                }} onClick={() => setData({
                                    isMarginSell: !isMarginSell,
                                    newAmount: 0,
                                    newAmountWei: 0n,
                                    transitionPrice: undefined
                                })}
                                     className={'positionAbsolute cursorPointer marginTop0'}
                                     src={requireDefault('swap-2')} alt=""/>
                            </div>
                            {(() => {
                                const canReview = poolDataPoolId && !equalTo(times(
                                    plus(
                                        swapReserve0,
                                        checkData0(data, 'swapMirrorReserve0')
                                    ),
                                    plus(
                                        swapReserve1,
                                        checkData0(data, 'swapMirrorReserve1')
                                    )
                                )) && !dynamicFeeTooHigh
                                return <div onClick={() => canReview && (
                                    lessThanOrEqualTo(newAmountNumber)
                                        ? toast('Amount must be greater than zero.')
                                        : (
                                            isSwapMirrorError
                                                ? toast(`Please make sure the share you purchase is less than ${
                                                    numberETH(
                                                        greaterThan(swapReserve, swapMirrorReserve) ? swapReserve : swapMirrorReserve,
                                                        marginToken1DataDecimals
                                                    )
                                                }`)
                                                : (
                                                    isExactInput
                                                        ? toggleShowSwapping(true)
                                                        : toggleShowDespite(true)
                                                )
                                        )
                                )}
                                            style={canReview ? {} : {color: '#7D7D7D'}}
                                            className={`${isPhoneClientWidth ? 'borderRadiusPhone paddingTopBottomPhone bigFontSizePhone' : 'borderRadius paddingTopBottomBig bigFontSize'} flexCenter colorWhite saf1 ${canReview ? 'backgroundActiveColor' : 'backgroundGrey'} cursorPointer`}>
                                    {dynamicFeeTooHigh ? dynamicFeeTooHighText : 'Review'}
                                </div>
                            })()}
                            {isNotNullOrEmpty(newAmountStr) && [
                                <div
                                    className={`colorGray ${isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'}`}>
                                    {`${uint} ${marginToken1Symbol} = ${unitPrice} ${marginToken0Symbol} ${isETHPool ? `(${getTokenUSDTUintPrice})` : ''}`}
                                </div>,
                                swapFee()
                            ]}
                        </div>
                    ],
                    ...isShowBorrow
                        ? [
                            [
                                'Borrow',
                                () => {
                                    const showMarginMaxLeverages = checkDataBool(data, 'showMarginMaxLeverages'),
                                        toggleShowMarginMaxLeverages = () => setData({showMarginMaxLeverages: !showMarginMaxLeverages}),
                                        toggleMarginMaxLeverageIndex = marginMaxLeverageIndex => setData({marginMaxLeverageIndex}),
                                        borrowMaxBalance = lessThanOrEqualTo(marginToken0DataBalance, marginMax) ? marginToken0DataBalance : marginMax
                                    return [
                                        <div style={isPhoneClientWidth ? {} : {borderRadius: '.3rem'}}
                                             className={`backgroundWhite ${isPhoneClientWidth ? 'borderSmallGrayLinePhone paddingBigPhone childrenSpacingTopSmallPhone borderRadiusPhone' : 'borderSmallGrayLine paddingBig childrenSpacingTopSmall'}`}
                                        >
                                            <div
                                                className={isPhoneClientWidth ? 'childrenSpacingTopPhone' : 'childrenSpacingTop'}>
                                                {isSelectToken &&
                                                    <div className={'flexCenter justifyContentSpaceBetween'}>
                                                        <div
                                                            className={`${isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'} colorGray`}>
                                                            Liquidity Pool TVL
                                                        </div>
                                                        <div
                                                            className={`${isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'} colorGray`}>{ovl(poolData, 'tvl')}</div>
                                                    </div>}
                                                {selectTokenContainer}
                                            </div>
                                            {/*<div className={'flexCenter justifyContentSpaceBetween'}>*/}
                                            {/*    <div onClick={() => toggleShowSelectToken(true)}*/}
                                            {/*         className={`flexCenter ${isPhoneClientWidth ? 'childrenSpacingLeftPhone' : 'childrenSpacingLeft'} cursorPointer`}>*/}
                                            {/*        {tokenIcon(poolData, `${isPhoneClientWidth ? 2.4 : .8}rem`)}*/}
                                            {/*        <div className={isPhoneClientWidth ? 'smallFontSizePhone' : ''}>*/}
                                            {/*            {poolData.name}*/}
                                            {/*        </div>*/}
                                            {/*        <img src={requireDefault('toBottom')} alt=""*/}
                                            {/*             style={{width: `${isPhoneClientWidth ? .8 : .2}rem`}}/>*/}
                                            {/*    </div>*/}
                                            {/*    <div*/}
                                            {/*        className={isPhoneClientWidth ? 'smallFontSizePhone' : ''}>{ovl(poolData, 'tvl')}</div>*/}
                                            {/*</div>*/}
                                            <img src={requireDefault('Line 2')} alt="" className={'width100'}/>
                                            <div className={'flexCenter justifyContentSpaceBetween'}>
                                                {
                                                    [
                                                        // ['APY', poolDataPoolIdIsNotNull ? apy : '0%'],
                                                        [
                                                            'Entry Price',
                                                            `${entryToken} ${token0Symbol}`,
                                                            opacityShow ? 'opacityShow' : 'opacityHidden',
                                                            isETHPool && <div
                                                                className={`${isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'} colorGray`}>
                                                                {marginEntryPrice}
                                                            </div>,
                                                        ]
                                                    ].map(v =>
                                                        <div
                                                            className={isPhoneClientWidth ? 'childrenSpacingTopSmallPhone' : 'childrenSpacingTopSmall'}>
                                                            <div
                                                                className={`${isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'} colorGray`}>
                                                                {v[0]}
                                                            </div>
                                                            <div
                                                                className={`flex alignItemsCenter ${checkDataString(v, 2)} ${isPhoneClientWidth ? 'childrenSpacingLeftPhone' : 'childrenSpacingLeft'}`}>
                                                                <div
                                                                    className={isPhoneClientWidth ? 'bigFontSizePhone' : 'bigFontSize'}>
                                                                    {v[1]}
                                                                </div>
                                                                {v[3]}
                                                            </div>
                                                        </div>)
                                                }
                                            </div>
                                        </div>,
                                        <div
                                            className={`flex alignItemsCenter ${isPhoneClientWidth ? 'childrenSpacingLeftBigPhone childrenFlexGrow1' : 'childrenSpacingLeft'}`}>
                                            {
                                                [
                                                    [token0Data, token0Symbol, false],
                                                    [token1Data, token1Symbol, true]
                                                ].map(v => {
                                                        const iMS = v[2], isCurrent = isMarginSell === iMS
                                                        return <div
                                                            className={`flexCenter borderRadius999 cursorPointer ${
                                                                isCurrent
                                                                    ? 'backgroundActiveColor'
                                                                    : (isPhoneClientWidth ? 'borderSmallGrayLinePhone' : 'borderSmallGrayLine')
                                                            } 
                                                        ${isPhoneClientWidth ? 'childrenSpacingLeftPhone' : 'childrenSpacingLeft'}`}
                                                            style={{padding: `${isPhoneClientWidth ? .45 : .15}rem ${isPhoneClientWidth ? 0 : .5}rem`}}
                                                            onClick={() => setData({
                                                                isMarginSell: iMS,
                                                                getMarginMaxing: true
                                                            })}
                                                        >
                                                            {tokenIcon(v[0], `${isPhoneClientWidth ? 1.5 : .5}rem`)}
                                                            <div
                                                                className={`${isCurrent ? 'colorWhite saf1' : 'colorGray'}`}>Borrow {v[1]}</div>
                                                        </div>
                                                    }
                                                )
                                            }
                                        </div>,
                                        <div className={'colorGray'}>Supply</div>,
                                        <div
                                            className={`backgroundGrey ${isPhoneClientWidth ? 'paddingBigPhone childrenSpacingTopPhone borderRadiusPhone' : 'paddingBig childrenSpacingTopBig'}`}
                                            style={isPhoneClientWidth ? {} : {borderRadius: '.3rem'}}
                                        >
                                            <div
                                                className={`flex alignItemsCenter justifyContentSpaceBetween ${isPhoneClientWidth ? 'childrenSpacingLeftPhone' : 'childrenSpacingLeft'}`}>
                                                <input type="text"
                                                       ref={focusInput}
                                                       placeholder='0'
                                                       value={inputNewAmount}
                                                       onChange={e => setInputNewAmount(e.target.value)}
                                                       className={`${isPhoneClientWidth ? 'biggerFontSizePhone' : 'biggerFontSize'} flexGrow1`}/>
                                                <div
                                                    className={`borderRadius999 saf backgroundWhite flexCenter ${isPhoneClientWidth ? 'childrenSpacingLeftSmallPhone' : 'childrenSpacingLeft'}`}
                                                    style={{
                                                        height: `${isPhoneClientWidth ? 2.4 : .8}rem`,
                                                        padding: `0 ${isPhoneClientWidth ? .7 : .3}rem`,
                                                    }}>
                                                    {tokenIcon(marginToken0Data, `${isPhoneClientWidth ? 1.5 : .5}rem`)}
                                                    <div>{marginToken0Symbol}</div>
                                                </div>
                                            </div>
                                            <div className={'flexCenter justifyContentSpaceBetween'}>
                                                <div
                                                    className={`${isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'} colorGray`}>
                                                    {tokenUSDTPrice}
                                                </div>
                                                <div style={{opacity: getMarginMaxing ? 0 : 1}}
                                                     className={`flexCenter ${isPhoneClientWidth ? 'childrenSpacingLeftPhone' : 'childrenSpacingLeft'}`}>
                                                    <div
                                                        className={`${isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'}`}>
                                                        {borrowMaxBalance} {marginToken0Symbol}
                                                    </div>
                                                    <div
                                                        style={{fontSize: `${isPhoneClientWidth ? .6 : .15}rem`}}
                                                        onClick={() => setNewAmount(borrowMaxBalance)}
                                                        className={`backgroundActiveColor ${isPhoneClientWidth ? 'paddingSmallPhone' : 'paddingSmall'} borderRadius999 colorWhite cursorPointer`}>
                                                        MAX
                                                    </div>
                                                </div>
                                            </div>
                                        </div>,
                                        <div className={'colorGray'}>Borrow</div>,
                                        <div
                                            className={`${isPhoneClientWidth ? 'paddingBigPhone childrenSpacingTopPhone borderRadiusPhone borderSmallGrayLinePhone' : 'paddingBig childrenSpacingTopBig borderSmallGrayLine'}`}
                                            style={isPhoneClientWidth ? {} : {borderRadius: '.3rem'}}
                                        >
                                            <div
                                                className={`flex alignItemsCenter justifyContentSpaceBetween ${isPhoneClientWidth ? 'childrenSpacingLeftPhone' : 'childrenSpacingLeft'}`}>
                                                <input type="text"
                                                       placeholder='0'
                                                       value={checkDataString(data, 'newBorrowAmount')}
                                                       onChange={e => setNewBorrowAmount(getSetNewAmount(e.target.value))}
                                                       className={`${isPhoneClientWidth ? 'biggerFontSizePhone' : 'biggerFontSize'} flexGrow1`}/>
                                                <div
                                                    className={`borderRadius999 saf backgroundWhite flexCenter ${isPhoneClientWidth ? 'childrenSpacingLeftSmallPhone' : 'childrenSpacingLeft'}`}
                                                    style={{
                                                        height: `${isPhoneClientWidth ? 2.4 : .8}rem`,
                                                        padding: `0 ${isPhoneClientWidth ? .7 : .3}rem`,
                                                    }}>
                                                    {tokenIcon(marginToken1Data, `${isPhoneClientWidth ? 1.5 : .5}rem`)}
                                                    <div>{marginToken1Symbol}</div>
                                                </div>
                                            </div>
                                        </div>,
                                        <div
                                            className={`flexCenter justifyContentFlexEnd ${isPhoneClientWidth ? 'childrenSpacingLeftPhone' : 'childrenSpacingLeft'}`}>
                                            <div>Borrow APY</div>
                                            <img src={requireDefault('interestExpense')} alt=""
                                                 style={{width: `${isPhoneClientWidth ? 1.2 : .4}rem`}}/>
                                            <div>{poolDataPoolIdIsNotNull ? apy : '0%'}</div>
                                        </div>,
                                        (() => {
                                            const canReview = poolDataPoolId && !poolDataFeeLT
                                            return <div style={canReview ? {} : {color: '#B8BCBF'}}
                                                        onClick={() => canReview && (
                                                            newAmountNumber <= borrowMaxBalance
                                                                ? (
                                                                    lessThanOrEqualTo(newBorrowAmountWei)
                                                                        ? toast('Amount must be greater than zero.')
                                                                        : borrowMaxAmountToast(() => toggleShowMarginSelling(true))
                                                                )
                                                                : toast(`The maximum supply amount is  ${borrowMaxBalance}`)
                                                        )}
                                                        className={`${isPhoneClientWidth ? 'borderRadiusPhone paddingTopBottomPhone bigFontSizePhone' : 'borderRadius paddingTopBottomBig bigFontSize'} 
                                             flexCenter colorWhite saf1 ${canReview ? 'backgroundActiveColor' : 'backgroundGrey1'}  cursorPointer`}>
                                                {poolDataFeeLT ? poolDataFeeLTText : 'Review'}
                                            </div>
                                        })(),
                                        showMarginData && !!marginTokenId &&
                                        <div style={{padding: `${isPhoneClientWidth ? .5 : .1}rem`}}
                                             className={'borderSmallGrayLine borderRadius999 childrenFlexGrow1 flexCenter'}>
                                            {beforeAfterMerged.map((v, i) => <div
                                                onClick={() => setData({beforeAfterMergedIndex: i})}
                                                className={`borderRadius999 flexCenter ${isPhoneClientWidth ? 'paddingTopBottomPhone' : 'paddingTopBottom'} cursorPointer 
                                             ${beforeAfterMergedIndex === i ? 'backgroundGrey saf1' : 'colorGray'}`}>
                                                {v}
                                            </div>)}
                                        </div>,
                                        <div
                                            className={isPhoneClientWidth ? 'childrenSpacingTopBigPhone marginTopBigPhone' : 'childrenSpacingTopBig marginTopPhone'}>
                                            {marginData()}
                                        </div>
                                    ]
                                }
                            ]
                        ]
                        : [],
                    [
                        'Supply',
                        () => supplyWithdrawContainer
                    ]
                ]
            })(),
            marginSwapIndex = (() => {
                const index = marginSwap.map(v => v[0].toLocaleLowerCase()).indexOf(pNs1)
                return index === -1 ? 0 : index
            })(),
            toggleMarginSwapIndex = marginSwapIndex => windowReplace(`/trade/${marginSwap[marginSwapIndex][0].toLocaleLowerCase()}`),
            pageFoot = isHome
                ? <div style={{
                    padding: `${isPhoneClientWidth ? '3rem' : '1.5rem 2rem 1.5rem 2rem'}`,
                    background: 'linear-gradient(270deg, #230C0D 0%, #0B0B0B 100%)'
                }}>
                    <div
                        className={isPhoneClientWidth ? 'childrenSpacingTopBigPhone' : 'flex justifyContentSpaceBetween childrenFlexGrow1'}
                        style={isPhoneClientWidth ? {} : {height: '2.5rem'}}>
                        <div
                            className={`flexColumn justifyContentSpaceBetween ${isPhoneClientWidth ? 'alignItemsCenter childrenSpacingTopBigPhone' : 'height100'}`}>
                            <img src={requireDefault('logo11')} alt=""
                                 style={{width: `${isPhoneClientWidth ? 9 : 4}rem`}}/>
                            <pre
                                className={`colorWhite ${isPhoneClientWidth ? '' : 'bigFontSize'}`}>{`Revolutionizing DeFi ${isPhoneClientWidth ? '' : '\n'}with Unified Liquidity.`}</pre>
                        </div>
                        <div
                            className={`flex justifyContentSpaceBetween ${isPhoneClientWidth ? 'flexWrap' : 'height100'}`}>
                            {[
                                [
                                    ['Products'],
                                    ['Margin', () => windowReplace('/trade/margin')],
                                    ['Borrow', () => windowReplace('/trade/borrow')],
                                    ['Earn', () => windowReplace('/earn')]
                                ],
                                [
                                    ['Developers'],
                                    ['Github', () => windowOpen(githubURL)],
                                    ['Audits', () => whitepaper('product/security-audits')],
                                    ['Bug Bounty', () => whitepaper('product/security-audits')]
                                ],
                                [
                                    ['Company'],
                                    ['Docs', () => whitepaper()],
                                    ['Media Kit', () => whitepaper('support/brand-kit')],
                                    ['Contact Us', () => window.location.href = 'mailto:support@likwid.fi']
                                ]
                            ].map(v => <div style={isPhoneClientWidth ? {width: '10rem', marginTop: '3rem'} : {}}
                                            className={`flexColumn justifyContentSpaceBetween ${isPhoneClientWidth ? 'childrenSpacingTopBigPhone' : 'height100'}`}>
                                {v.map((v, i) => <div
                                    onClick={checkDataFunction(v, 1)}
                                    className={`${i ? 'homeTopText cursorPointer' : 'colorWhite saf1'}`}>{v[0]}</div>)}
                            </div>)}
                        </div>
                    </div>
                    <div
                        className={`${isPhoneClientWidth ? 'paddingTopBiggerPhone flexColumn alignItemsCenter childrenSpacingTopBiggerPhone' : 'paddingTopBigger flex alignItemsCenter justifyContentSpaceBetween  childrenFlexGrow1'}`}
                        style={{
                            marginTop: `${isPhoneClientWidth ? 6 : 1}rem`,
                            borderTop: `solid ${isPhoneClientWidth ? .15 : .05}rem rgba(255,255,255,.2)`
                        }}>
                        <div
                            className={`${isPhoneClientWidth ? 'childrenSpacingLeftBigPhone' : 'childrenSpacingLeftBig'} flex alignItemsCenter`}>
                            {socialLinks.map(v => <div
                                className={'cursorPointer homeTopIcon borderRadius999 flexCenter'}
                                style={{
                                    ...square(`${isPhoneClientWidth ? 3 : .5}rem`),
                                    borderWidth: `${isPhoneClientWidth ? .09 : .03}rem`
                                }}>
                                <img
                                    onClick={() => windowOpen(v[1])}
                                    src={requireDefault(v[0])} alt="" style={{width: '50%'}}/>
                            </div>)}
                        </div>
                        <div className={`flex justifyContentSpaceBetween ${isPhoneClientWidth ? 'width100' : ''}`}>
                            {[
                                ['Privacy Policy', () => whitepaper('legal/privacy-policy')],
                                ['Terms and Conditions', () => whitepaper('legal/terms-of-service')],
                                ['Disclaimer', () => whitepaper('legal/disclaimer')]
                            ].map(v => <div
                                onClick={v[1]}
                                className={`homeTopText cursorPointer ${isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'}`}>{v[0]}</div>)}
                        </div>
                    </div>
                </div>
                : <div style={{marginTop: '1rem'}}>
                    <div style={{
                        height: `${isPhoneClientWidth ? 3 : 1}rem`,
                        padding: '0 2rem',
                        left: 0,
                        right: 0,
                        bottom: 0
                    }}
                         className={
                             isHome
                                 ? 'flexCenter justifyContentSpaceBetween boxSizingBorderBox backgroundWhite'
                                 : 'positionFixed zIndex999 flexCenter justifyContentSpaceBetween boxSizingBorderBox backgroundWhite'
                         }
                    >
                        <div onClick={devCountAdd} className={'saf2'}>
                            © All rights reserved, 2024
                        </div>
                        <div className={'flex childrenSpacingLeft'}>
                            {socialLinks.slice(0, -1).map(v => <img
                                src={requireDefault(`${v[0]}3`)}
                                alt=""
                                onClick={() => windowOpen(v[1])}
                                className={'cursorPointer'}
                                style={square(`${isPhoneClientWidth ? 1.5 : .5}rem`)}/>)}
                        </div>
                    </div>
                </div>,
            rightArrowText = (a, b) => <div
                className={`flexCenter ${isPhoneClientWidth ? 'childrenSpacingLeftSmallPhone' : 'childrenSpacingLeftSmall'}`}>
                <div
                    className={`${isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'} textAlignRight`}>{a}</div>
                <img src={requireDefault('rightArrow')} alt="" style={{width: `${isPhoneClientWidth ? .6 : .2}rem`}}/>
                <div
                    className={`${isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'} textAlignRight`}>{b}</div>
            </div>,
            positionsPoolIndex = checkData0(data, 'positionsPoolIndex'),
            isOnlyMarginPositions = positionsPoolIndex === 0,
            isBorrowPositions = isShowBorrow && positionsPoolIndex === 1,
            isMarginPositions = (isBorrowPositions || isOnlyMarginPositions),
            isHistory = checkDataBool(data, 'isHistory'),
            promiseList = (list, setValue = () => {
            }) => {
                const arr = []
                return new Promise(async (resolve, reject) => {
                    try {
                        if (isNotNullOrEmpty(list)) {
                            for (const i in list) {
                                arr.push(await setValue(list[i], i))
                                i === minus(list.length, 1) && resolve(arr)
                            }
                        } else {
                            resolve(arr)
                        }
                    } catch (err) {
                        reject(err)
                    }
                })
            },
            getPositionState = tokenId => marginPositionCall('getPositionState', tokenId),
            pairPositionGetPositionState = tokenId => pairPositionCall('getPositionState', tokenId),
            getPositions = async items => {
                const obj = {}
                await promiseList(
                    items,
                    v => getPositionState(v.tokenId).catch(() => ({})).then(
                        item => {
                            const {marginAmount, marginTotal, debtAmount} = item
                            obj[v.tokenId] = {marginAmount, marginTotal, borrowAmount: debtAmount}
                        }
                    )
                )
                return obj
            },
            getAPY = (poolId, marginForOne) =>
                helperCall('getBorrowRate', poolId, marginForOne),
            getLendingTotal = tokenId => lendPositionCall('getPositionState', tokenId)
                .then(v => checkData0(v, 'lendAmount')).catch(() => 0),
            getLendingAPR = (poolId, mFO = marginForOne, input = 0) => helperCall(
                'getLendingAPR',
                poolId,
                mFO,
                input
            ).catch(() => 0),
            getPoolStateInfo = poolId => helperCall('getPoolStateInfo', poolId),
            getReserves = poolId => getPoolStateInfo(poolId)
                .then(({
                           pairReserve0: reserve0,
                           pairReserve1: reserve1
                       }) => [reserve0, reserve1]).catch(() => [0, 0]),
            ethCarry = num => /^\d+\.\d{9,}$/.test(num) ? plus(num, '0.00000001') : num,
            getClosePNL = (borrowAmountWei, rS, marginForOne, poolId, marginAmount, marginTotal, marginDecimals) => helperGetAmountIn(
                toInt(times(borrowAmountWei, rS)),
                !marginForOne,
                poolId
            ).then(v => {
                const closeAmount = minus(
                    times(plus(marginAmount, marginTotal), rS),
                    formatEther(v.amountIn, marginDecimals)
                )
                return num8(minus(closeAmount, times(marginAmount, rS)))
            }),
            positionDetail = async (v, position, eU = ethUSDT) => {
                const {poolId, marginForOne, borrowToken, marginToken, poolName} = v,
                    poolNameArr = checkDataString(poolName).split('/'),
                    borrowDecimals = await erc20CallDecimals(borrowToken),
                    marginDecimals = await erc20CallDecimals(marginToken),
                    marginSymbol = checkData([v, 'marginSymbol'], poolNameArr[marginForOne ? 1 : 0]),
                    borrowSymbol = checkData([v, 'borrowSymbol'], poolNameArr[marginForOne ? 0 : 1]),
                    [reserve0, reserve1] = await getReserves(poolId),
                    markToken = num8(divide(reserve0, reserve1)),
                    marginTotal = checkData0(isHistory ? v : position, 'marginTotal'),
                    marginAmount = checkData0(isHistory ? v : position, 'marginAmount'),
                    borrowAmount = isHistory ? checkData0(v, 'debtAmount') : position.borrowAmount,
                    marginTotalETH = formatEther(marginTotal, marginDecimals),
                    borrowAmountETH = formatEther(borrowAmount, borrowDecimals),
                    marginAmountETH = formatEther(marginAmount, marginDecimals),
                    t0Symbol = marginForOne ? borrowSymbol : marginSymbol,
                    entryToken = num8(divide(
                        ...marginForOne ? [borrowAmountETH, marginTotalETH] : [marginTotalETH, borrowAmountETH]
                    )),
                    liqToken = num8((() => {
                            const num = divide(
                                plus(marginAmountETH, marginTotalETH),
                                times(borrowAmountETH, 1.1)
                            )
                            return marginForOne ? divide(1, num) : num
                        })()
                    ),
                    iEA = [marginToken, borrowToken].includes(address0),
                    reserve0Decimals = marginForOne ? borrowDecimals : marginDecimals,
                    reserve1Decimals = marginForOne ? marginDecimals : borrowDecimals,
                    markTokenETH = num8(divide(
                        formatEther(reserve0, reserve0Decimals),
                        formatEther(reserve1, reserve1Decimals)
                    )),
                    {
                        truncatedReserve0,
                        truncatedReserve1,
                        realReserve0,
                        realReserve1
                    } = await getPoolStateInfo(poolId).catch(() => ({
                        truncatedReserve0: 0,
                        truncatedReserve1: 0,
                        realReserve0: 0,
                        realReserve1: 0
                    })),
                    truncatedTokenETHOriginal = divide(
                        formatEther(truncatedReserve0, reserve0Decimals),
                        formatEther(truncatedReserve1, reserve1Decimals)
                    ),
                    truncatedTokenETH = num8(truncatedTokenETHOriginal),
                    marginTokenIs0 = isAddress0(marginToken),
                    purchaseAmount = numberETH(checkData0(v, 'purchaseAmount'), marginDecimals),
                    sellAmount = numberETH(checkData0(v, 'sellAmount'), marginDecimals),
                    borrowAmountOriginal = ethCarry(formatEther(borrowAmount, borrowDecimals)),
                    borrowAmount1 = num8(borrowAmountOriginal),
                    marginTotalOriginal = formatEther(marginTotal, marginDecimals),
                    marginAmountOriginal = formatEther(marginAmount, marginDecimals)
                return {
                    ...v,
                    reserve0,
                    reserve1,
                    t0Symbol,
                    marginSymbol,
                    borrowDecimals,
                    marginDecimals,
                    oracleReserve0: truncatedReserve0,
                    oracleReserve1: truncatedReserve1,
                    marginTotalWei: marginTotal,
                    marginTotalOriginal,
                    marginTotal: num8(marginTotalOriginal),
                    marginAmountWei: marginAmount,
                    marginAmount: num8(marginAmountOriginal),
                    marginAmountOriginal,
                    borrowAmountWei: borrowAmount,
                    borrowSymbol,
                    entryToken: `${entryToken} ${t0Symbol}`,
                    entryPrice: iEA ? `(${getTokenUSDTPrice(entryToken, eU)})` : '',
                    markTokenNum: marginForOne ? divide(1, markToken) : markToken,
                    markToken: `${markTokenETH} ${t0Symbol}`,
                    markPrice: iEA ? `(${getTokenUSDTPrice(markTokenETH, eU)})` : '',
                    truncatedTokenNumOriginal: marginForOne ? divide(1, truncatedTokenETHOriginal) : truncatedTokenETHOriginal,
                    truncatedTokenNum: marginForOne ? divide(1, truncatedTokenETH) : truncatedTokenETH,
                    truncatedToken: `${truncatedTokenETH} ${t0Symbol}`,
                    truncatedPrice: iEA ? `(${getTokenUSDTPrice(truncatedTokenETH, eU)})` : '',
                    liqToken: `${liqToken} ${t0Symbol}`,
                    liqPrice: iEA ? `(${getTokenUSDTPrice(liqToken, eU)})` : '',
                    ...isHistory
                        ? {}
                        : {
                            apy: await getAPY(poolId, marginForOne).then(v => numToPercentage(v)),
                            borrowBalance: numberETH((await erc20CallBalance(borrowToken))[0], borrowDecimals),
                            lendingInterest: await getLendingAPR(poolId, marginForOne, 0).then(getLendingInterest)
                        },
                    marginHistoryLiqToken: `${num8((() => {
                            const num = divide(
                                numberETH(v[`liquidatedOracleReserve${marginForOne ? 1 : 0}`], marginDecimals),
                                numberETH(v[`liquidatedOracleReserve${marginForOne ? 0 : 1}`], borrowDecimals),
                            )
                            return marginForOne ? divide(1, num) : num
                        })()
                    )} ${t0Symbol}`,
                    borrowAmountOriginal,
                    borrowAmount: borrowAmount1,
                    apiBorrowAmount: v.borrowAmount,
                    estimatedPNL: isHistory
                        ? numberETH(checkData0(v, 'pnl'), marginDecimals)
                        : await getClosePNL(borrowAmount, 1, marginForOne, poolId, marginAmountOriginal, marginTotalOriginal, marginDecimals),
                    purchaseAmountETH: `${purchaseAmount} ${marginSymbol}`,
                    purchaseAmountPrice: marginTokenIs0 ? `(${getTokenUSDTPrice(purchaseAmount, eU)})` : '',
                    sellAmountETH: `${sellAmount} ${marginSymbol}`,
                    sellAmountPrice: marginTokenIs0 ? `(${getTokenUSDTPrice(sellAmount, eU)})` : '',
                    ...isBorrowPositions && !isHistory
                        ? {
                            borrowListMarginLevel: greaterThan(borrowAmount1)
                                ? percentageNum(
                                    divide(
                                        formatEther(
                                            (await helperGetAmountOut(
                                                marginAmount,
                                                !marginForOne,
                                                poolId
                                            )).amountOut,
                                            borrowDecimals
                                        ),
                                        borrowAmount1
                                    )
                                )
                                : '9999'
                        }
                        : {},
                    canNotClose: greaterThan(parseEtherNum(borrowAmount1, borrowDecimals), times(marginForOne ? realReserve0 : realReserve1, '0.2'))
                }
            },
            positionsKey = `${isBorrowPositions ? 'borrow' : 'margin'}Positions${isHistory ? 'History' : ''}`,
            positions = checkDataArray(data, positionsKey),
            positionsOpacityShow = checkDataObject(data, 'positionsOpacityShow'),
            closePositionMarginLevel = item => isBorrowPositions
                ? checkData0(item, 'borrowListMarginLevel')
                : percentageNum(
                    divide(
                        plus(checkData0(item, 'marginAmountOriginal'), checkData0(item, 'marginTotalOriginal')),
                        times(checkData0(item, 'truncatedTokenNumOriginal'), checkData0(item, 'borrowAmountOriginal'))
                    )
                ),
            closePositionData = (isDetail, item = {}) => [
                ...[
                    ...isHistory ? [] : [['Debt', `${checkData0(item, 'borrowAmount')} ${checkDataString(item, 'borrowSymbol')}`]],
                    ...isHistory ? (isBorrowPositions ? [] : [
                        // ['ROI', `${numToPercentage(checkData0(item, 'roi'))}%`]
                    ]) : [['Borrow APY', `${checkData0(item, 'apy')}%`]],
                    ...isHistory
                        ? [
                            // ['Total Purchase Amount', checkData0(item, 'purchaseAmountETH'), checkData0(item, 'purchaseAmountPrice')],
                            // ['Total Sell Amount', checkData0(item, 'sellAmountETH'), checkData0(item, 'sellAmountPrice')],
                            ['Repay Amount', `${numberETH(checkData0(item, 'repayAmount'), checkData0(item, 'borrowDecimals'))} ${checkDataString(item, 'borrowSymbol')}`],
                            ['Close Amount', `${numberETH(checkData0(item, 'closeAmount'), checkData0(item, 'marginDecimals'))} ${checkDataString(item, 'marginSymbol')}`],
                        ]
                        : [
                            ...isBorrowPositions
                                ? []
                                : [
                                    // ['Entry Price', checkData0(item, 'entryToken'), /*checkData0(item, 'entryPrice')*/],
                                    // ['Mark Price', checkData0(item, 'markToken'), /*checkData0(item, 'markPrice')*/],
                                    ['Truncated Price', checkData0(item, 'truncatedToken')],
                                    ['Liq.Price', checkData0(item, 'liqToken'), /*checkData0(item, 'liqPrice')*/]
                                ],
                            [
                                'Margin Level',
                                closePositionMarginLevel(item)
                            ]
                        ]
                ].map(v => {
                        const [label] = v,
                            isMarginLevel = label === 'Margin Level',
                            [marginLevelIcon, marginLevelColor] = getMarginLevel(v[1])
                        return [
                            label,
                            <div
                                className={`flexCenter ${isPhoneClientWidth ? 'childrenSpacingLeftSmallPhone' : 'childrenSpacingLeftSmall'}`}>
                                {isMarginLevel && <img
                                    src={requireDefault(marginLevelIcon)}
                                    style={{
                                        width: `${isPhoneClientWidth ? 0.9 : 0.3}rem`,
                                        height: `${isPhoneClientWidth ? 0.9 : 0.3}rem`
                                    }}/>}
                                {label === 'Borrow APY' &&
                                    <img src={requireDefault('interestExpense')} alt=""
                                         style={{width: `${isPhoneClientWidth ? .9 : .3}rem`}}/>}
                                <div style={isMarginLevel ? {color: marginLevelColor} : {}}
                                     className={`${isMarginLevel ? 'saf1' : ''} ${isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'}`}>{v[1]}</div>
                                {isNotNull(v[2]) && <div
                                    className={`colorGray ${isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'}`}>{v[2]}</div>}
                            </div>
                        ]
                    }
                ),
                ...isDetail || isBorrowPositions
                    ? []
                    : (
                        isHistory
                            ? []
                            : [
                                [
                                    `${isHistory ? '' : 'Estimated '}PNL`,
                                    (() => {
                                        const estimatedPNL = checkDataString(item, 'estimatedPNL')
                                        return <div
                                            className={`saf1 ${isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'}
                                    ${Number(estimatedPNL) < 0 ? 'colorRed' : 'colorGreen'}`}>{estimatedPNL} {checkDataString(item, 'marginSymbol')}</div>
                                    })()
                                ]
                            ]
                    )
            ].map(v => {
                const [label] = v,
                    isTruncatedPrice = !isDetail && label === 'Truncated Price'
                return <div
                    className={`flexCenter justifyContentSpaceBetween ${isTruncatedPrice ? `${isPhoneClientWidth ? 'paddingPhone' : 'padding'}` : ''}`}
                    style={
                        isTruncatedPrice
                            ? {
                                borderRadius: `${isPhoneClientWidth ? .6 : .2}rem`,
                                background: 'linear-gradient(90deg, rgba(255, 255, 255, 0.2) 0%, rgba(255, 142, 157, 0.2) 100%)'
                            }
                            : {}
                    }
                >
                    <div
                        className={`flexCenter ${isPhoneClientWidth ? 'childrenSpacingLeftSmallPhone' : 'childrenSpacingLeftSmall'}`}>
                        {
                            isTruncatedPrice &&
                            <div className={'borderRadius999 backgroundActiveColor'}
                                 style={square(`${isPhoneClientWidth ? .45 : .15}rem`)}/>
                        }
                        <div
                            className={`colorGray ${isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'}`}>{label}</div>
                        {
                            isTruncatedPrice &&
                            <img onClick={() =>
                                windowOpen('https://likwidfi.gitbook.io/likwid-protocol-docs/whitepaper/risk-management-and-strategies/truncated-oracles')
                            } className={'cursorPointer'} src={requireDefault('tips1')} alt=""
                                 style={{width: `${isPhoneClientWidth ? .9 : .3}rem`}}/>
                        }
                        {isBorrowPositions && label === 'Margin Level' &&
                            <img onClick={() =>
                                windowOpen('https://likwidfi.gitbook.io/likwid-protocol-docs/whitepaper/protocol-mechanics/liquidation-mechanism')
                            } className={'cursorPointer'} src={requireDefault('tips1')} alt=""
                                 style={{width: `${isPhoneClientWidth ? .9 : .3}rem`}}/>
                        }
                    </div>
                    <div
                        className={`flexCenter ${isPhoneClientWidth ? 'childrenSpacingLeftSmallPhone' : 'childrenSpacingLeftSmall'}`}>
                        <div
                            className={checkData([positionsOpacityShow, item.tokenId], true) ? 'opacityShow' : 'opacityHidden'}>{v[1]}</div>
                        {
                            isTruncatedPrice &&
                            <img className={'cursorPointer'}
                                 onClick={
                                     () => {
                                         if (isTruncatedPrice) {
                                             const {id, tokenId} = item
                                             setData({
                                                 positionsOpacityShow: {
                                                     ...positionsOpacityShow,
                                                     [tokenId]: false
                                                 }
                                             });
                                             (isNotNull(id)
                                                     ? requestApi(`margin/position/${id}`).then(async v => {
                                                         const p = [...positions]
                                                         p[positions.map(v => v.tokenId).indexOf(tokenId)] = await positionDetail(
                                                             v,
                                                             checkDataObject(await getPositions([v]), v.tokenId)
                                                         )
                                                         setData({[positionsKey]: p})
                                                     })
                                                     : getPositions([item]).then(async v => {
                                                         const p = [...positions]
                                                         p[positions.map(v => v.tokenId).indexOf(tokenId)] = await positionDetail(
                                                             item,
                                                             checkDataObject(v, tokenId)
                                                         )
                                                         setData({[positionsKey]: p})
                                                     })
                                             ).finally(() => setTimeout(
                                                 () => setData({
                                                     positionsOpacityShow: {
                                                         ...positionsOpacityShow,
                                                         [tokenId]: true
                                                     }
                                                 }),
                                                 500
                                             ))
                                         }
                                     }
                                 }
                                 src={requireDefault('refresh-one 1')} alt=""
                                 style={{width: `${isPhoneClientWidth ? .9 : .3}rem`}}/>
                        }
                    </div>
                </div>
            }),
            range = checkData0(data, 'range'), rangeStep = 25, defaultMaxRange = 100,
            maxRange = showClosePosition ? defaultMaxRange : checkData([data, 'maxRange'], defaultMaxRange),
            setRange = range => {
                range = greaterThan(range, maxRange) ? maxRange : range
                setData({range})
                return range
            },
            rangeContent = (changeEnd = () => {
            }) => {
                const size = `${isPhoneClientWidth ? .9 : .3}rem`
                return <div className={'positionRelative zIndex1'}
                            style={{margin: `${isPhoneClientWidth ? 2.5 : .7}rem 0 ${isPhoneClientWidth ? 2 : .5}rem 0`}}>
                    <input
                        min={0}
                        step={1}
                        max={defaultMaxRange}
                        type='range'
                        value={range}
                        onMouseUp={() => changeEnd(range)}
                        className={isPhoneClientWidth ? 'customRangePhone' : 'customRange'}
                        style={{'--value': `${range}%`}}
                        onChange={e => setRange(e.target.value)}
                    />
                    <div
                        className={`positionAbsolute width100 backgroundRed zIndex-1 ${isPhoneClientWidth ? 'childrenSpacingTopPhone' : 'childrenSpacingTop'}`}
                        style={{
                            bottom: `${isPhoneClientWidth ? 2.2 : .63}rem`, height: 0
                        }}
                    >
                        <div className={'flexCenter justifyContentSpaceBetween'}>
                            {Array.from({length: 101}, (_, i) => i).map(v => {
                                const isCurrent = Math.round(range) == v
                                return <div
                                    style={{width: isCurrent ? (`${isPhoneClientWidth ? .9 : .3}rem`) : 0}}
                                    className={`flexColumnCenter ${isCurrent ? '' : 'overflowHidden'}`}>
                                    <div
                                        className={`${isPhoneClientWidth ? 'smallerFontSizePhone' : 'smallerFontSize'}`}>{range}%
                                    </div>
                                </div>
                            })}
                        </div>
                        <div className={'flexCenter justifyContentSpaceBetween positionRelative'}>
                            {Array.from({length: (100 / rangeStep) + 1}, (_, i) => rangeStep * i).map(v => {
                                const isCurrent = range == v
                                return <div
                                    style={{width: size}}
                                    className={`flexColumnCenter ${isPhoneClientWidth ? 'childrenSpacingTopPhone' : 'childrenSpacingTop'}`}>
                                    <div
                                        onClick={() => {
                                            changeEnd(setRange(v))
                                        }}
                                        className={'borderRadius999 cursorPointer'}
                                        style={{
                                            ...square(size), background: range > v ? '#FFB9C2' : '#EFEFEF'
                                        }}/>
                                    <div
                                        className={`${isCurrent ? '' : 'colorGray'} ${isPhoneClientWidth ? 'smallerFontSizePhone' : 'smallerFontSize'}`}>{v}%
                                    </div>
                                </div>
                            })}
                        </div>
                    </div>
                    <div className={'positionAbsolute width100'}
                         style={{
                             pointerEvents: 'none', top: `${isPhoneClientWidth ? .95 : .27}rem`, height: 0
                         }}
                    >
                        <div className={'flexCenter justifyContentSpaceBetween positionRelative'}>
                            {lessThan(maxRange, defaultMaxRange) && <div className={'positionAbsolute flexCenter'}
                                                                         style={{
                                                                             zIndex: 100,
                                                                             width: 0,
                                                                             height: 0,
                                                                             left: maxRange <= 0 ? `calc(${size}/2)` : (maxRange < 50 ? `calc(${maxRange}% + ${size}/2*${divide(maxRange * 2, 100)} )` : (maxRange == 50 ? `${maxRange}%` : (maxRange < 100 ? `calc(${maxRange}% - ${size}/2*${divide(maxRange / (maxRange > 75 ? 1 : 1.25), 100)} )` : `calc(${maxRange}% - ${size}/2)`)))
                                                                         }}
                            >
                                <div
                                    style={{width: `${isPhoneClientWidth ? .9 : .3}rem`}}
                                    className={`flexColumnCenter ${isPhoneClientWidth ? 'childrenSpacingTopPhone' : 'childrenSpacingTop'}`}>
                                    <div
                                        onClick={() => {
                                            changeEnd(setRange(maxRange))
                                        }}
                                        className={'borderRadius999 cursorPointer'}
                                        style={{
                                            ...square(`${isPhoneClientWidth ? .9 : .3}rem`), background: '#22C55F',
                                        }}/>
                                    <div style={{opacity: 0}}
                                         className={`${range == maxRange ? '' : 'colorGreen'} ${isPhoneClientWidth ? 'smallerFontSizePhone' : 'smallerFontSize'}`}>{maxRange}%
                                    </div>
                                </div>
                            </div>}
                        </div>
                    </div>
                </div>
            },
            isLiquidityPool = positionsPoolIndex === (isShowBorrow ? 2 : 1),
            poolPositionsKey = `poolPositions${isLiquidityPool ? 'Liquidity' : 'Supply'}`,
            poolPositions = checkDataArray(data, poolPositionsKey),
            // erc20MarginHookManagerAllowance = (...params) => erc20MarginAllowance(marginHookManagerAddress, ...params),
            token0Allowance = () => erc20PairPositionAllowance(token0Address, token0NewAmountWei).then(num => {
                setTokenData(token0Data, {needApprove: num > 0})
                return num
            }),
            token1Allowance = () => erc20PairPositionAllowance(token1Address, token1NewAmountWei).then(num => {
                setTokenData(token1Data, {needApprove: num > 0})
                return num
            }),
            earnIsPoolPositions = checkData([data, 'earnIsPoolPositions']),
            earnIsPoolPositionData = checkDataObject(data, 'earnIsPoolPositionData'),
            isPoolPositions = checkData([earnIsPoolPositions], !checkDataBool(data, 'noRemovePool') && (isLiquidityPool || (positionsPoolIndex === (isShowBorrow ? 3 : 2)))),
            showLiquidity = checkDataBool(data, 'showLiquidity'),
            toggleShowLiquidity = (showLiquidity, noRemovePool) => (showLiquidity && !isPoolPositions ? (() => {
                toggleShowLoading(true)
                return (!token0IsETH
                    ? (token0Allowance().then(() => token1Allowance()))
                    : token1Allowance()).then(() => toggleShowLoading())
            })() : new Promise(resolve => resolve())).then(() =>
                setData({
                    showLiquidity,
                    noRemovePool,
                    ...!showLiquidity ? {
                        showApprove: false,
                        earnIsPoolPositions: undefined,
                        [`isAuto${removeDataKey}`]: undefined,
                        [`showSettings${removeDataKey}`]: undefined,
                        [`maxSlippage${removeDataKey}`]: undefined,
                        [`transactionDeadline${removeDataKey}`]: undefined,
                    } : {}
                })
            ),
            page = checkData([data, 'page'], defaultPage),
            earnYourPoolsPage = checkData([data, 'earnYourPoolsPage'], defaultPage),
            claimedHistorysPage = checkData([data, 'claimedHistorysPage'], defaultPage),
            isFirstPage = (p = page) => p === defaultPage,
            positionsPageKey = `${positionsKey}Page`,
            positionsPage = checkData([data, positionsPageKey], defaultPage),
            poolPositionsPageKey = `${poolPositionsKey}Page`,
            positionsPoolPageKey = isPoolPositions ? poolPositionsPageKey : positionsPageKey,
            listLoadingKey = `${isPoolPositions ? poolPositionsKey : positionsKey}ListLoading`,
            poolPositionsPage = checkData([data, poolPositionsPageKey], defaultPage),
            positionPoolData = [
                [`margin/position/list?borrow=${isBorrowPositions}&burned=${isHistory}`, positionsPage, positionsKey, positions],
                [`margin/${isLiquidityPool ? 'pool/liquidity' : 'lending/pool'}/list`, poolPositionsPage, poolPositionsKey, poolPositions]
            ],
            getPoolDetail = pI => requestApi(`margin/pool/${chainId}/${pI}`, undefined, undefined, undefined, true),
            getLiquiditySupplyPositions = async (items, iLp = isLiquidityPool, arr = []) => {
                if (isNotNullOrEmpty(items)) {
                    for (const i in items) {
                        const v = items[i],
                            {tokenId, poolId, currency0, currency1} = v,
                            {
                                totalSupply,
                                retainSupply0,
                                retainSupply1
                            } = {},
                            {
                                realReserve0,
                                realReserve1,
                                mirrorReserve0,
                                mirrorReserve1
                            } = await getPoolStateInfo(poolId)
                        arr.push({
                            ...v,
                            removeRealReserve0: realReserve0,
                            removeRealReserve1: realReserve1,
                            removeReserve0: plus(realReserve0, mirrorReserve0),
                            removeReserve1: plus(realReserve1, mirrorReserve1),
                            currency0Decimals: await erc20CallDecimals(currency0),
                            currency1Decimals: await erc20CallDecimals(currency1),
                            getPoolSuppliesTotalSupply: totalSupply,
                            getPoolSuppliesRetainSupply0: retainSupply0,
                            getPoolSuppliesRetainSupply1: retainSupply1,
                            ...iLp
                                ? await (async () => {
                                    const poolStateInfo = await getPoolStateInfo(poolId),
                                        poolDetail = await getPoolDetail(poolId)
                                    return {
                                        liquidity: checkData0(await pairPositionGetPositionState(tokenId), 'liquidity'),
                                        totalSupply: checkData0(poolStateInfo, 'totalSupply'),
                                        pairReserve0: checkData0(poolStateInfo, 'pairReserve0'),
                                        pairReserve1: checkData0(poolStateInfo, 'pairReserve1'),
                                        fee: checkData0(poolDetail, 'fee'),
                                        marginFee: checkData0(poolDetail, 'marginFee')
                                    }
                                })()
                                : {
                                    lendingInterest0: await getLendingAPR(poolId, v.lendForOne, 0).then(getLendingInterest),
                                    lendingInterest1: await getLendingAPR(poolId, v.lendForOne, 0).then(getLendingInterest),
                                    withdrawMax0: await getLendingTotal(tokenId),
                                    withdrawMax1: await getLendingTotal(tokenId),
                                }
                        });
                        if (i === minus(items.length, 1)) {
                            return arr
                        }
                    }
                } else {
                    return arr
                }
            },
            getPositionPool = i => (isNotNull(i) ? [positionPoolData[i]] : positionPoolData).map((v, i1) => {
                const page = v[1], iF = isFirstPage(page)
                requestApi(v[0], {
                    chainId,
                    page,
                    pageSize: (isMarginPositions && !isHistory) ? 1 : 5,
                    owner: address
                }, undefined, undefined, true).then(v1 => {
                    const isPositions = (isNotNull(i) ? i : i1) === 0, items = checkDataArray(v1, 'items')
                    let arr = [];
                    let noNewPositionId;
                    (isPositions ? new Promise(async resolve => {
                        const itemsIsNotNullOrEmpty = isNotNullOrEmpty(items);
                        if (iF && !isHistory && ((isBorrow && isBorrowPositions) || (isOnlyMargin && isOnlyMarginPositions))) {
                            // const newPositionId = Number(await marginPositionManagerCall('getPositionId', poolDataPoolId, marginForOne, address, isOnlyMargin).catch(() => {
                            // }))
                            // noNewPositionId = !equalTo(newPositionId) && (!itemsIsNotNullOrEmpty || !items.map(v => v.positionId).includes(newPositionId))
                            // noNewPositionId && items.unshift({
                            //     burnType: 0,
                            //     marginForOne,
                            //     poolId: poolDataPoolId,
                            //     positionId: newPositionId,
                            //     poolName: poolDataName,
                            //     marginToken: marginToken0TokenAddress,
                            //     borrowToken: marginToken1TokenAddress,
                            // })
                        }
                        if (isNotNullOrEmpty(items)) {
                            const positions = isHistory ? [] : (await getPositions(items))
                            for (const i in items) {
                                const v = items[i]
                                arr.push(await positionDetail(v, checkDataObject(positions, v.tokenId)));
                                i === minus(items.length, 1) && resolve(arr)
                            }
                        } else {
                            resolve(arr)
                        }
                    }) : new Promise(async resolve => {
                        arr = await getLiquiditySupplyPositions(items, undefined, arr)
                        resolve(arr)
                    })).then(() => {
                        setData({
                            [`${v[2]}ListLoading`]: false,
                            [v[2]]: [...isFirstPage(page) ? [] : v[3], ...arr],
                            [`${v[2]}Total`]: noNewPositionId ? plus(checkData0(v1, 'total'), 1) : checkData0(v1, 'total')
                        })
                        !isHandelLiquidity && toggleShowLoading()
                    })
                })
            }),
            searchPositionPool = i => {
                if (isFirstPage(positionPoolData[i][1])) {
                    getPositionPool(i)
                } else {
                    (isNotNull(i) ? [positionPoolData[i]] : positionPoolData).map(v => setData({[`${v[2]}Page`]: defaultPage}))
                }
            },
            cleanPositionsPools = {
                [positionsPoolPageKey]: defaultPage,
                [isPoolPositions ? poolPositionsKey : positionsKey]: undefined,
                [`${isPoolPositions ? poolPositionsKey : positionsKey}Total`]: undefined,
            },
            toggleShowPositionsPools = (i, i1) => {
                if (!showPositionsPools) {
                    setData({positionsPoolIndex: i, [listLoadingKey]: undefined})
                    if (positionsPoolIndex == 0) {
                        searchPositionPool(0)
                    } else if (isNotNull(i)) {
                        searchPositionPool(i1)
                    }
                }
                setData({
                    showPositionsPools: !showPositionsPools,
                    ...showPositionsPools
                        ? cleanPositionsPools
                        : {}
                })
            },
            docs = (() => {
                const key = 'docsToLeft'
                return <div onClick={() => whitepaper()}
                            onMouseEnter={() => setData({[key]: true})}
                            onMouseLeave={() => setData({[key]: false})}
                            className={`homeTopButton borderRadius999 cursorPointer flexCenter positionRelative ${isPhoneClientWidth ? '' : ''}`}
                            style={{
                                width: `${isPhoneClientWidth ? 5 : 2}rem`,
                                height: `${isPhoneClientWidth ? 2.5 : .8}rem`,
                            }}>
                    <div
                        className={`${isHome ? 'saf1' : ((!isHome && address) ? '' : 'saf1 activeColor')}`}>
                        Docs
                    </div>
                    {checkDataBool(data, key) &&
                        <img src={requireDefault('Group 427321185')} alt="" className={'paddingLeftSmall'}
                             style={square(`${isPhoneClientWidth ? 1.5 : .5}rem`)}/>}
                </div>
            })(),
            launchAPP = (() => {
                const key = 'launchAPPToLeft'
                return <div onClick={launchAPPConnect}
                            onMouseEnter={() => setData({[key]: true})}
                            onMouseLeave={() => setData({[key]: false})}
                            className={'homeTopButton borderRadius999 flexCenter saf1 cursorPointer flex alignItemsCenter'}
                            style={{
                                width: `${isPhoneClientWidth ? 9 : 3}rem`,
                                height: `${isPhoneClientWidth ? 2.5 : .8}rem`
                            }}
                >
                    Launch APP
                    {checkDataBool(data, key) &&
                        <img src={requireDefault('Group 427321185')} alt="" className={'paddingLeftSmall'}
                             style={square(`${isPhoneClientWidth ? 1.5 : .5}rem`)}/>}
                </div>
            })(),
            addressData = isDetail => {
                const click = () => isDetail ? () => {
                    } : ((address && !isHome) ? toggleShowPositionsPools : launchAPPConnect)(),
                    isFirstKey = `isFirst${
                        isBorrow
                            ? 'Borrow'
                            : (isSupply
                                    ? 'Supply'
                                    : (
                                        isPoolCreate
                                            ? 'Create'
                                            : (
                                                isPoolAddIncrease
                                                    ? 'Add'
                                                    : 'Margin'
                                            )
                                    )
                            )
                    }`,
                    showMarginPositions = false//!isDetail && (isMargin || isSupply || isPoolCreate || isPoolAddIncrease) && checkDataBool(data, 'marginSuccess') && !localStorage.getItem(isFirstKey)
                return <div onClick={() => {
                    if (!isDetail) {
                        setData({marginSuccess: false})
                        localStorage.setItem(isFirstKey, true)
                    }
                }}>
                    {
                        showMarginPositions &&
                        <div className={'positionFixed flexColumnCenter'}
                             style={{
                                 top: 0,
                                 left: 0,
                                 right: 0,
                                 bottom: 0,
                                 background: 'rgba(0,0,0,.56)'
                             }}>
                            <img className={'positionAbsolute'}
                                 style={{
                                     right: `${isPhoneClientWidth ? 1 : 1.3}rem`,
                                     top: `${isPhoneClientWidth ? 3 : 1.2}rem`,
                                     width: `${isPhoneClientWidth ? 23 : 5}rem`
                                 }}
                                 src={requireDefault(isPhoneClientWidth ? 'marginPositionsPhone' : 'marginPositions')}
                            />
                        </div>
                    }
                    {
                        // (!isHome && address && isPhoneClientWidth && !isDetail) ?
                        //     <img onClick={click}
                        //          className={`cursorPointer positionRelative borderRadius999 ${showMarginPositions ? (isPhoneClientWidth ? 'borderActiveColorPhone' : 'borderActiveColor') : ''}`}
                        //          src={requireDefault('account')} alt=""
                        //          style={{height: '1.7rem'}}/>
                        //     :
                        isHome
                            ? launchAPP
                            : <div onClick={click}
                                   className={`borderRadius999 flexCenter positionRelative ${isDetail ? '' : 'cursorPointer'} ${showMarginPositions ? (isPhoneClientWidth ? 'borderActiveColorPhone' : 'borderActiveColor') : ''} ${
                                       isHome ? (isPhoneClientWidth ? 'childrenSpacingLeftSmallPhone' : 'childrenSpacingLeftSmall') : (isPhoneClientWidth ? 'childrenSpacingLeftPhone' : 'childrenSpacingLeft')
                                   } ${!isHome && address && !isDetail ? (isPhoneClientWidth ? 'borderActiveColorSmallPhone' : 'borderActiveColorSmall') : ''}`}
                                   style={{
                                       ...isDetail ? {
                                           height: `${isPhoneClientWidth ? 1.5 : .8}rem`,
                                       } : {
                                           height: `${isPhoneClientWidth ? 1.5 : .8}rem`,
                                           padding: `0 ${isPhoneClientWidth ? .7 : .3}rem`,
                                           background: isHome ? '#FF8E9D' : (!isHome && address) ? 'white' : '#FFF4F5',
                                       },
                                   }}>
                                {isHome
                                    ? <img
                                        src={requireDefault('phone')}
                                        alt="" style={{height: `${isPhoneClientWidth ? 60 : 50}%`}}/>
                                    : <div className={'positionRelative height100 flexCenter'}>
                                        <img
                                            src={requireDefault(address ? 'account' : 'wallet')}
                                            alt="" style={{height: isDetail ? '100%' : '70%'}}/>
                                        {address && walletImageUrl && <img
                                            src={walletImageUrl}
                                            className={'positionAbsolute'}
                                            alt=""
                                            style={{
                                                height: isDetail ? '30%' : '20%',
                                                bottom: isDetail ? 0 : `${isPhoneClientWidth ? .3 : .1}rem`,
                                                right: '0'
                                            }}/>}
                                    </div>}
                                <div
                                    className={`${isHome ? 'colorWhite saf1' : ((!isHome && address) ? '' : 'saf1 activeColor')} ${isDetail ? (isPhoneClientWidth ? '' : 'bigFontSize') : (isPhoneClientWidth ? 'smallerFontSizePhone' : 'smallFontSize')}`}>{
                                    isHome ? 'Launch APP' : (address ? addressLeaveOut : 'Connect')
                                }</div>
                                {address && !isDetail && <img
                                    src={requireDefault('floatingWindow')}
                                    alt="" style={{height: '50%'}}/>}
                            </div>
                    }
                </div>
            },
            pageTopPhone = <div className={'positionFixed zIndex999'} style={{left: 0, right: 0}}>
                <div
                    className={`width100 boxSizingBorderBox flex justifyContentSpaceBetween alignItemsCenter paddingLeftRightBigPhone ${isTopColor}`}
                    style={{height: '3.5rem'}}>
                    <img onClick={replaceHome} src={requireDefault('LIKWID')}
                         style={{height: '2.5rem'}} alt=""/>
                    <div className={'childrenSpacingLeftPhone flexCenter'}>
                        {selectNetworkContent}
                        {!isHome && addressData()}
                        {!isHome && <img onClick={toggleShowList} src={requireDefault('list')} alt=""
                                         className={'cursorPointer'} style={{height: '1.7rem'}}/>}
                    </div>
                    {isHome && <div className={'flex alignItemsCenter childrenSpacingLeftPhone'}>
                        {[docs, launchAPP]}
                    </div>}
                </div>
                {showList && <div onClick={toggleShowList}
                                  style={{height: '100vh', background: 'rgba(0, 0, 0, 0.5)'}}
                >
                    <div className={'backgroundWhite overflowYScroll'}
                         style={{
                             maxHeight: '85vh',
                             borderBottomRightRadius: '1rem',
                             borderBottomLeftRadius: '1rem',
                             padding: '2rem 0'
                         }}
                    >
                        {navigations.map(v => {
                            const path = v[0],
                                isCurrent = (path === 'home' ? '' : path).toLocaleLowerCase() === showPath
                            return <div
                                className={`flexColumnCenter childrenSpacingTopPhone ${isCurrent ? 'backgroundGrey' : ''}`}
                                style={{padding: '1.5rem'}}
                                onClick={() => {
                                    v[1]()
                                    toggleShowList()
                                }}
                            >
                                <div className={isCurrent ? 'saf1' : 'colorGray'}>{path}</div>
                            </div>
                        })}
                    </div>
                </div>}
            </div>,
            pageTopFootPhone = (content, showEnd = true) => <div>
                {pageTopPhone}
                {content}
                {showEnd && pageFoot}
                {connectLoading(10)}
            </div>,
            pageTop = [
                <div
                    className={`ttf positionFixed flex alignItemsCenter zIndex999 ${isTopColor}`}
                    style={{
                        left: 0, right: 0, height: '1.2rem', padding: '0 2rem'
                    }}>
                    <img onClick={replaceHome} src={requireDefault('logo')}
                         style={{height}} alt="" className={'cursorPointer'}/>
                    <div style={{padding: '0 2rem'}}
                         className={'flexGrow1 boxSizingBorderBox childrenSpacingLeftBigPhone flex alignItemsCenter'}>
                        {!isHome && navigations.map(v => {
                            const [path] = v, pathIsTrade = path === 'Trade'
                            return <div onClick={v[1]}
                                        onMouseEnter={() => pathIsTrade && setData({showTopMarginSwap: true})}
                                        onMouseLeave={() => pathIsTrade && setData({showTopMarginSwap: false})}
                                        className={`cursorPointer positionRelative flexCenter ${pNs0 === path.toLocaleLowerCase() ? 'saf1' : ''}`}>
                                {path}
                                {pathIsTrade && checkDataBool(data, 'showTopMarginSwap') &&
                                    <div className={'positionAbsolute'}
                                         style={{
                                             top: '.35rem',
                                             paddingTop: '.15rem'
                                         }}>
                                        <div
                                            className={'borderRadius boxShadow paddingBig childrenSpacingTop backgroundWhite boxSizingBorderBox'}
                                            style={{width: '3.5rem'}}>
                                            {marginSwap.map((v, i) => <div
                                                onClick={event => {
                                                    event.stopPropagation()
                                                    toggleMarginSwapIndex(i)
                                                }}
                                                className={'borderRadius999 boxSizingBorderBox backgroundGrey flex alignItemsCenter childrenSpacingLeft marginSwap'}
                                                style={{height: '.7rem', paddingLeft: '20%'}}
                                            >
                                                <img src={requireDefault(v[0])} alt="" style={{height: '50%'}}/>
                                                <div className={'saf1'}>{v[0]}</div>
                                            </div>)}
                                        </div>
                                    </div>}
                            </div>
                        })}
                    </div>
                    <div className={'flex alignItemsCenter childrenSpacingLeft'}>
                        {selectNetworkContent}
                        {isHome && [
                            ...[
                                ['x2', twitterURL],
                                ['telegeram2', likwidMemeTG]
                            ].map(v => {
                                const k = `homeTopSocialize${v[0]}`
                                return <div style={{...square('.7rem'), borderRadius: '.2rem'}}
                                            onMouseEnter={() => setData({[k]: true})}
                                            onMouseLeave={() => setData({[k]: false})}
                                            className={'homeTopButton flexCenter'}
                                            onClick={() => windowOpen(v[1])}
                                >
                                    <img src={requireDefault(`${v[0]}${checkDataBool(data, k) ? 'White' : ''}`)}
                                         className={'borderRadius cursorPointer'}
                                         alt=""
                                         style={{width: '70%'}}/>
                                </div>
                            }),
                            docs
                        ]}
                        {addressData()}
                    </div>
                </div>,
                connectLoading(5)
            ],
            addRemoveApi = (name, hash) =>
                waitForTransactionFunc(
                    hash,
                    ({logs}) => {
                        const isAdd = name === 'add'
                        setTimeout(
                            () => {
                                setData({marginSuccess: true})
                                searchPositionPool(1)
                                toastSuccessful(true)
                                isAdd ? toggleShowLoadingShowPositionsPools(2) : toggleShowLoading()
                                toggleShowLiquidity()
                            },
                            isAdd ? 5000 : 0
                        )
                        // !isPoolPositions && windowReplace('/pool')
                    }
                    // loginThenFunc(() => requestApi(
                    //     `margin/pool/liquidity/${name}`,
                    //     {
                    //         poolId,
                    //         chainId,
                    //         owner: address,
                    //         liquidity: liquidityFunc(logs),
                    //         ...Object.fromEntries(amountsFunc(logs).map((v, i) => [`amount${i}`, v])),
                    //     },
                    //     'post'
                    // ).then(r => {
                    //     searchPositionPool(1)
                    //     toastSuccessful(r)
                    //     toggleShowLoading()
                    //     toggleShowLiquidity()
                    // }))
                ),
            setTransitionPrice = opacity => newAmountWei > 0
                ? helperGetAmountOut(
                    newAmountWei,
                    undefined,
                    undefined,
                    true
                ).then(({amountOut: transitionPriceWei, fee: _fee, feeAmount}) => setData({
                    _fee,
                    swapFeeAmount: numberETH(
                        feeAmount,
                        marginToken0DataDecimals
                    ),
                    transitionPriceWei,
                    transitionPrice: numberETH(
                        transitionPriceWei,
                        marginToken1DataDecimals
                    ),
                    ...opacity ? {opacityShow: true} : {}
                })).catch(e => {
                    setData({transitionPrice: undefined, transitionPriceWei: undefined})
                    opacity && setData({opacityShow: true}) //: toast(checkDataString(e, 'cause', 'errorArgs', 'message'))
                })
                : (() => {
                    setData({transitionPrice: undefined, transitionPriceWei: undefined})
                    opacity && setData({opacityShow: true})
                })(),
            setNewAmountTransitionPrice = () => transitionPriceWei > 0
                ? helperGetAmountIn(
                    transitionPriceWei,
                    undefined,
                    undefined,
                    true
                ).then(({amountIn: num, fee: _fee, feeAmount}) => {
                        num = numberETH(num, marginToken0DataDecimals)
                        setData({
                            _fee,
                            swapFeeAmount: numberETH(
                                feeAmount,
                                marginToken0DataDecimals
                            ),
                            inputNewAmount: num,
                            newAmount: num,
                            newAmountWei: parseEtherNum(num, marginToken0DataDecimals)
                        })
                    }
                ).catch(() => setData({inputNewAmount: undefined, newAmount: undefined, newAmountWei: undefined}))
                : setData({inputNewAmount: undefined, newAmount: undefined, newAmountWei: undefined}),
            selectTokenIndex = checkData0(data, 'selectTokenIndex'),
            onScrollFunc = (ref, list, total, setPage, isOnClick) => {
                const {current} = ref
                if (list.length < total && (isOnClick || (current['scrollHeight'] - current['scrollTop'] - 1 <= current['clientHeight'])) && !showLoading) {
                    setPage()
                    toggleShowLoading(true)
                }
            },
            tradingContestScroll = React.createRef(),
            tradingContestList = checkDataArray(data, 'tradingContestList'),
            tradingContestTotal = checkData0(data, 'tradingContestTotal'),
            tradingContestPage = checkData([data, 'tradingContestPage'], defaultPage),
            tradingContestMask = maskContent(
                poolTradingContest.endTime,
                showTradingContest,
                toggleShowTradingContest,
                <div
                    className={`positionRelative ${isPhoneClientWidth ? 'childrenSpacingTopBigPhone' : 'childrenSpacingTopBig'} flexColumn`}
                    style={{height: isPhoneClientWidth ? '80vh' : '9rem'}}>
                    <div className={isPhoneClientWidth ? 'childrenSpacingTopPhone' : 'childrenSpacingTop'}
                         style={{
                             borderRadius: `${isPhoneClientWidth ? .9 : .3}rem`,
                             background: 'linear-gradient(90deg, #FFB9C2 0%, #FC1A50 100%)'
                         }}
                    >
                        <div style={{transform: `translateY(-${isPhoneClientWidth ? .15 : .05}rem)`}}
                             className={`flex justifyContentSpaceBetween alignItemsFlexEnd ${isPhoneClientWidth ? 'paddingLeftRightBigPhone' : 'paddingLeftRightBig'}`}
                        >
                            <div
                                className={`flex ${isPhoneClientWidth ? 'childrenSpacingLeftPhone' : 'childrenSpacingLeft'} alignItemsFlexEnd`}>
                                <img src={requireDefault('fire1')} alt=""
                                     style={{width: `${isPhoneClientWidth ? 2.4 : .8}rem`}}/>
                                <div className={'colorWhite'}>Total prize pool</div>
                            </div>
                            <div
                                className={`saf1 colorWhite ${isPhoneClientWidth ? 'bigFontSizePhone' : 'bigFontSize'}`}>
                                {poolTradingContest.totalPrizePool}
                            </div>
                        </div>
                        <div
                            className={`${isPhoneClientWidth ? 'paddingBigPhone' : 'paddingBig'} flex alignItemsCenter`}
                            style={{borderRadius: `${isPhoneClientWidth ? .9 : .3}rem`, background: '#FFDDE2'}}
                        >
                            <div
                                className={isPhoneClientWidth ? 'childrenSpacingTopSmallPhone' : 'childrenSpacingTopSmall'}>{
                                ['Ranking', 'Reward amount'].map(v =>
                                    <div
                                        className={`colorGray ${isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'}`}>{v}</div>
                                )
                            }</div>
                            <div
                                className={`${isPhoneClientWidth ? 'paddingLeftBigPhone childrenSpacingLeftSmallPhone' : 'paddingLeftBig childrenSpacingLeftSmall'} flexGrow1 childrenFlexGrow1 flex alignItemsCenter`}>{(
                                () => {
                                    const arr = Object.entries(checkDataObject(poolTradingContest, 'items'))
                                    return arr.map((v, i) => <div
                                        className={`${isPhoneClientWidth ? 'childrenSpacingTopSmallPhone' : 'childrenSpacingTopSmall'} ${i
                                            ? (
                                                i === arr.length - 1
                                                    ? 'flexColumn alignItemsFlexEnd'
                                                    : 'flexColumnCenter'
                                            )
                                            : ''}`}>{
                                        v.map((v1, i1) =>
                                            <div
                                                className={`${i1 ? 'saf1' : 'colorGray'} ${isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'}`}>{v1}</div>
                                        )
                                    }</div>)
                                })()}</div>
                        </div>
                    </div>
                    <div style={{borderRadius: `${isPhoneClientWidth ? .9 : .3}rem`, overflow: 'hidden'}}
                         className={'flexGrow1Column flexColumn'}>
                        <div
                            className={`backgroundGrey ${isPhoneClientWidth ? 'paddingBigPhone' : 'paddingBig'} flex alignItemsCenter childrenFlexGrow1`}>{
                            ['Rank', 'Address', 'Margin Volume'].map((v, i) => <div
                                className={`colorGray ${isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'} ${i ? (i === 1 ? 'flexCenter' : 'flex alignItemsCenter justifyContentFlexEnd') : ''}`}>{v}</div>)
                        }</div>
                        <div
                            className={`${isPhoneClientWidth ? 'childrenSpacingTopBiggerPhone paddingBigPhone' : 'childrenSpacingTopBigger paddingBig'} flexGrow1Column overflowYScroll`}
                            onScroll={() => onScrollFunc(
                                tradingContestScroll,
                                tradingContestList,
                                tradingContestTotal,
                                () => setData({tradingContestPage: positionsPage + 1})
                            )}
                        >{
                            tradingContestList.map((v, i) => <div
                                className={'flex alignItemsCenter childrenFlexGrow1'}>{
                                [plus(i, 1), leaveOut(checkDataString(v, 'owner')), `${numberETH(checkData0(v, 'totalMarginAmount'), tradingContestPool.currency1Decimals)} ${checkDataString(tradingContestPool, 'name').split('/')[1]}`].map((v, i) =>
                                    <div
                                        className={`${isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'} ${i ? (i === 1 ? 'flexCenter' : 'flex alignItemsCenter justifyContentFlexEnd') : ''}`}>{v}</div>)
                            }</div>)
                        }</div>
                    </div>
                    <div className={'positionAbsolute flexCenter'}
                         style={{left: 0, right: 0, top: `-${isPhoneClientWidth ? 7.9 : 2.19}rem`}}>
                        <img src={requireDefault('tradingContestTop')} alt=""
                             style={{width: `${isPhoneClientWidth ? 12 : 3}rem`}}/>
                    </div>
                </div>,
                9
            ),
            erc20MarginPositionApprove = (...params) => erc20Approve(marginPositionAddress, ...params),
            erc20PairPositionApprove = (...params) => erc20Approve(pairPositionAddress, ...params),
            liquidityTitle = isPoolCreate ? 'Create a Pair' : (isPoolAdd ? 'Add liquidity' :
                (
                    isPoolSupplyWithdraw
                        ? (
                            isPoolSupply
                                ? 'Supply lending liquidity'
                                : 'Withdraw'
                        )
                        : 'Add liquidity'
                )),
            liquidityButton = isPoolCreate ? 'Create' : (isPoolAdd ? 'Add' : 'Increase'),
            percentageToNum = num => times(num, 10000),
            positionsScroll = React.createRef(),
            getLevelShare = (item, levelDivideSupply, i) => num8(apiNumETH(
                times(
                    levelDivideSupply,
                    checkData0(item, `pairReserve${i}`)
                ),
                item[`currency${i}Decimals`]
            )),
            repayTokenData = checkDataObject(data, 'repayTokenData'),
            isLiquidateCallFunc = v => lessThan(closePositionMarginLevel(v), '1.1'),
            isLiquidateCall = isLiquidateCallFunc(repayTokenData),
            removeLiquidityOnclick = async (level, levelLiquidity, item) => {
                // level1: amount0，amount1，【
                // realReserve0/amount0
                // realReserve1/amount1
                // 】 取小的百分数

                // level2: amount0，amount1，【
                // (realReserve0 - reserve0 * getPoolSuppliesRetainSupply0/getPoolSuppliesTotalSupply)/amount0
                // realReserve1/amount1
                // 】 取小的百分数

                // level3: amount0，amount1，【
                // realReserve0/amount0
                // (realReserve1 - reserve1 * getPoolSuppliesRetainSupply1/getPoolSuppliesTotalSupply)/amount1
                // 】 取小的百分数

                // level4: amount0，amount1，【
                // (realReserve0 - reserve0 * getPoolSuppliesRetainSupply0/getPoolSuppliesTotalSupply)/amount0
                // (realReserve1 - reserve1 * getPoolSuppliesRetainSupply1/getPoolSuppliesTotalSupply)/amount1
                // 】 取小的百分数
                const liquidity = divide(levelLiquidity, checkData0(item, 'totalSupply')),
                    realReserve0 = checkData0(item, 'removeRealReserve0'),
                    realReserve1 = checkData0(item, 'removeRealReserve1'),
                    reserve0 = checkData0(item, 'removeReserve0'),
                    reserve1 = checkData0(item, 'removeReserve1'),
                    amount0 = times(liquidity, reserve0),
                    amount1 = times(liquidity, reserve1),
                    openNum = (realReserve, reserve, poolSupplies) => minus(
                        realReserve,
                        divide(
                            times(
                                reserve,
                                poolSupplies
                            ),
                            checkData0(item, 'getPoolSuppliesTotalSupply')
                        )
                    ),
                    num0 = isCloseFunc(0, level)
                        ? realReserve0
                        : openNum(
                            realReserve0,
                            reserve0,
                            checkData0(item, 'getPoolSuppliesRetainSupply0')
                        ),
                    num1 = isCloseFunc(1, level)
                        ? realReserve1
                        : openNum(
                            realReserve1,
                            reserve1,
                            checkData0(item, 'getPoolSuppliesRetainSupply1')
                        ),
                    range0 = lessThanOrEqualTo(amount0, num0)
                        ? 100
                        : times(divide(num0, amount0), 100),
                    range1 = lessThanOrEqualTo(amount1, num1)
                        ? 100
                        : times(divide(num1, amount1), 100),
                    hasLevel = !notLiquidityLevelChain,
                    totalSupply = hasLevel
                        ? item.totalSupply
                        : (await getPoolStateInfo(item.poolId).then(v => checkData0(v, 'totalSupply')).catch(() => 0)).toString(),
                    maxRangeTrue = hasLevel
                        ? (() => {
                            const maxRange = lessThan(range0, range1) ? range0 : range1
                            return lessThan(maxRange) ? 0 : maxRange
                        })()
                        : await (async () => {
                            const {poolId} = item,
                                releasedLiquidity = await helperCall('getReleasedLiquidity', poolId).catch(() => 0),
                                {
                                    realReserve0,
                                    realReserve1,
                                    mirrorReserve0,
                                    mirrorReserve1
                                } = await getPoolStateInfo(poolId).catch(() => ({
                                    realReserve0: 0,
                                    realReserve1: 0,
                                    mirrorReserve0: 0,
                                    mirrorReserve1: 0
                                })),
                                n0 = times(
                                    divide(
                                        realReserve0,
                                        plus(mirrorReserve0, realReserve0)
                                    ),
                                    totalSupply
                                ),
                                n1 = times(
                                    divide(
                                        realReserve1,
                                        plus(mirrorReserve1, realReserve1)
                                    ),
                                    totalSupply
                                ),
                                n = lessThan(n0, n1) ? n0 : n1,
                                liquidity = checkData0(item, 'liquidity'),
                                _n = lessThan(n, releasedLiquidity) ? n : releasedLiquidity
                            return times(divide(lessThan(_n, liquidity) ? _n : liquidity, liquidity), 100)
                        })()
                setData({
                    range: 0,
                    maxRangeTrue,
                    removePoolOwnerLiquidity: undefined,
                    maxRange: toInt(maxRangeTrue),
                    removePoolData: {
                        ...item,
                        amount0: parseEtherNum(amount0, await erc20CallDecimals(item.currency0)),
                        amount1: parseEtherNum(amount1, await erc20CallDecimals(item.currency1)),
                        level,
                        totalSupply
                    }
                })
                toggleShowLiquidity(true)
            },
            showFees = (v, size = 'smallFontSize', noToFee) => <div
                className={`flex alignItemsCenter ${isPhoneClientWidth ? 'childrenSpacingLeftPhone' : 'childrenSpacingLeft'}`}>
                {[
                    ['Swap Fee', 'fee'],
                    ...(() => {
                        const key = 'marginFee'
                        return equalTo(checkData0(v, key)) ? [] : [['Margin Fee', key]]
                    })()
                ].map(v1 => {
                    const fee = checkData0(v, v1[1])
                    return <div
                        className={`flex alignItemsCenter ${isPhoneClientWidth ? 'childrenSpacingLeftSmallPhone' : 'childrenSpacingLeftSmall'}`}>
                        <div
                            className={`${size}${isPhoneClientWidth ? 'Phone' : ''} colorGray`}>{v1[0]}:
                        </div>
                        <div
                            className={`${size}${isPhoneClientWidth ? 'Phone' : ''}`}>{noToFee ? fee : toFeeNum(fee)}%
                        </div>
                    </div>
                })}
            </div>,
            positionsPools = [
                [
                    ['Margin', 'Positions'],
                    (() => {
                        const total = checkData0(data, `${positionsKey}Total`),
                            oSF = isOnClick => onScrollFunc(positionsScroll, positions, total, () => setData({[positionsPageKey]: positionsPage + 1}), isOnClick)
                        return <div style={isPhoneClientWidth ? {height: '50vh'} : {}}
                                    ref={positionsScroll}
                                    onScroll={() => isHistory && oSF()}
                                    className={`${isPhoneClientWidth ? 'borderRadiusPhone borderSmallGrayLinePhone paddingBigPhone childrenSpacingTopPhone' : 'borderRadius borderSmallGrayLine flexGrow1Column paddingBig childrenSpacingTop'} overflowYScroll boxSizingBorderBox backgroundWhite`}>
                            {
                                checkData([data, listLoadingKey], true)
                                    ? <div
                                        className={`height100 flexColumnCenter ${isPhoneClientWidth ? 'childrenSpacingTopBigPhone' : 'childrenSpacingTopBig'}`}>
                                        <img src={requireDefault('loading')}
                                             alt=""
                                             style={{width: `${isPhoneClientWidth ? 12 : 4}rem`}}/>
                                    </div>
                                    : [
                                        (() => {
                                            const arr = isHistory ? positions : positions.filter(v => isNotNull(v.marginTotalWei))
                                            return arr.length > 0
                                                ? arr.map((v, i) => <div
                                                    className={`${isPhoneClientWidth ? 'childrenSpacingTopPhone' : 'childrenSpacingTop'}`}>
                                                    {i !== 0 && <img src={requireDefault('Line 3')} alt=""
                                                                     className={'width100'}/>}
                                                    <div className={'flex alignItemsCenter justifyContentSpaceBetween'}>
                                                        {/*<div*/}
                                                        {/*    className={`flex alignItemsCenter ${isPhoneClientWidth ? 'childrenSpacingLeftPhone' : 'childrenSpacingLeft'}`}>*/}
                                                        {/*    {(() => {*/}
                                                        {/*        const text = v.marginForOne ? 'Buy' : 'Sell'*/}
                                                        {/*        return [<img src={requireDefault(text)} alt=""*/}
                                                        {/*                     style={{width: `${isPhoneClientWidth ? 1.5 : .5}rem`}}/>,*/}
                                                        {/*            <div*/}
                                                        {/*                className={`${isPhoneClientWidth ? 'bigFontSizePhone' : 'bigFontSize'} saf1`}>{text}</div>]*/}
                                                        {/*    })()}*/}
                                                        {/*</div>*/}
                                                        {(() => {
                                                            const iLC = isLiquidateCallFunc(v)
                                                            return (isHistory || iLC) &&
                                                                (() => {
                                                                    const {burnType} = v,
                                                                        isCurrentLiquidated = !isHistory && iLC,
                                                                        isLiquidated = isCurrentLiquidated || [2, 3].includes(burnType)
                                                                    return <div
                                                                        className={`flex alignItemsCenter ${isPhoneClientWidth ? 'childrenSpacingLeftSmallPhone' : 'childrenSpacingLeftSmall'}`}>
                                                                        <div
                                                                            className={`borderRadius999 ${isLiquidated ? 'backGroundBlueGray' : 'backgroundRed'}`}
                                                                            style={square(`${isPhoneClientWidth ? .5 : .15}rem`)}/>
                                                                        <div
                                                                            className={`${isLiquidated ? 'colorGray' : 'colorRed'} saf1 ${isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'}`}>
                                                                            {isCurrentLiquidated ? 'Liquidated' : [
                                                                                'REPAY', 'CLOSE', 'LIQUIDATE_BURN', 'LIQUIDATE_CALL'
                                                                            ][burnType]}
                                                                        </div>
                                                                    </div>
                                                                })()
                                                        })()}
                                                    </div>
                                                    {
                                                        (() => {
                                                            const marginForOne = v.marginForOne,
                                                                currency0Name = v[marginForOne ? 'borrowSymbol' : 'marginSymbol'],
                                                                currency1Name = v[marginForOne ? 'marginSymbol' : 'borrowSymbol']
                                                            return <div
                                                                className={`flex alignItemsCenter ${isPhoneClientWidth ? 'childrenSpacingLeftSmallPhone' : 'childrenSpacingLeftSmall'}`}>
                                                                {
                                                                    tokenIcon(
                                                                        {
                                                                            poolId: v.poolId,
                                                                            currency0: v[marginForOne ? 'borrowToken' : 'marginToken'],
                                                                            currency1: v[marginForOne ? 'marginToken' : 'borrowToken'],
                                                                            currency0Name,
                                                                            currency1Name,
                                                                            currency0Avatar: v[marginForOne ? 'borrowAvatar' : 'marginAvatar'],
                                                                            currency1Avatar: v[marginForOne ? 'marginAvatar' : 'borrowAvatar'],
                                                                        },
                                                                        `${isPhoneClientWidth ? 1.8 : .6}rem`)
                                                                }
                                                                <div>
                                                                    {showPoolName(v.poolName)}
                                                                </div>
                                                            </div>
                                                        })()
                                                    }
                                                    {(() => {
                                                        const marginForOne = v.marginForOne, [poolName0, poolName1] = checkDataString(v, 'poolName').split('/')
                                                        return <div>{`${marginForOne ? 'Long' : 'Short'} ${poolName1} · ${marginForOne ? 'Short' : 'Long'} ${poolName0}`}</div>
                                                    })()}
                                                    <div className={isPhoneClientWidth
                                                        ? `childrenSpacingTopPhone ${isHistory ? '' : 'paddingPhone borderSmallGrayLinePhone borderRadiusPhone'}`
                                                        : `childrenSpacingTop ${isHistory ? '' : 'padding borderSmallGrayLine borderRadius'}`}>
                                                        {!isHistory && <div
                                                            className={isHistory ? (isPhoneClientWidth ? 'childrenSpacingTopSmallPhone' : 'childrenSpacingTopSmall') : ''}>
                                                            <div
                                                                className={`colorGray ${isPhoneClientWidth ? '' : 'smallFontSize'}`}>
                                                                Margin Amount
                                                            </div>
                                                            <div className={'flexCenter justifyContentSpaceBetween'}>
                                                                <div
                                                                    className={`saf1 ${isPhoneClientWidth ? '' : 'smallFontSize'} ${checkData([positionsOpacityShow, v.tokenId], true) ? 'opacityShow' : 'opacityHidden'}`}>{v.marginAmount} {v.marginSymbol}</div>
                                                                {isHistory
                                                                    ? <div/>
                                                                    : <div
                                                                        style={{padding: `${isPhoneClientWidth ? .15 : .05}rem ${isPhoneClientWidth ? .45 : .15}rem`}}
                                                                        onClick={() => toggleShowAdjust(true, v)}
                                                                        className={`flexCenter ${isPhoneClientWidth ? 'borderActiveColorSmallPhone childrenSpacingLeftPhone' : 'borderActiveColorSmall childrenSpacingLeft'} borderRadius999 cursorPointer`}>
                                                                        <img src={requireDefault('Adjust')} alt=""
                                                                             style={square(`${isPhoneClientWidth ? .9 : .3}rem`)}/>
                                                                        <div
                                                                            className={`activeColor ${isPhoneClientWidth ? '' : 'smallFontSize'}`}>Adjust
                                                                        </div>
                                                                    </div>
                                                                }
                                                            </div>
                                                        </div>}
                                                        {!isHistory &&
                                                            [
                                                                ['Margin Total', `${v.marginTotal} ${v.marginSymbol}`],
                                                                ['Supply APY', `${checkData0(v, 'lendingInterest')}%`,
                                                                    <img src={requireDefault('interestIncome')} alt=""
                                                                         style={{width: `${isPhoneClientWidth ? .9 : .3}rem`}}/>]
                                                            ].map(v1 => <div
                                                                className={'flexCenter justifyContentSpaceBetween'}>
                                                                <div
                                                                    className={`colorGray ${isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'}`}>
                                                                    {v1[0]}
                                                                </div>
                                                                <div
                                                                    className={`flex alignItemsCenter ${isPhoneClientWidth ? 'childrenSpacingLeftSmallPhone' : 'childrenSpacingLeftSmall'}`}>
                                                                    {v1[2]}
                                                                    <div
                                                                        className={`${isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'} ${checkData([positionsOpacityShow, v.tokenId], true) ? 'opacityShow' : 'opacityHidden'}`}>{v1[1]}
                                                                    </div>
                                                                </div>
                                                            </div>)
                                                        }
                                                    </div>
                                                    {closePositionData(false, v)}
                                                    {!isHistory && <div
                                                        className={`flexCenter justifyContentFlexEnd ${isPhoneClientWidth ? 'childrenSpacingLeftPhone' : 'childrenSpacingLeft'}`}>
                                                        {[
                                                            ['Close', () => toggleShowClosePosition(true, v), v['canNotClose']],
                                                            ['Repay', () => toggleShowRepaying(true, v)]
                                                        ].map(v =>
                                                            <div onClick={v[2] ? undefined : v[1]}
                                                                 className={`borderRadius999 ${v[2] ? 'backGroundColorGray' : 'backgroundActiveColor'} flexCenter saf1 colorWhite ${isPhoneClientWidth ? '' : 'smallFontSize'} cursorPointer`}
                                                                 style={{
                                                                     width: `${isPhoneClientWidth ? 6.5 : 1.5}rem`,
                                                                     height: `${isPhoneClientWidth ? 2.5 : .5}rem`
                                                                 }}
                                                            >{v[0]}</div>)}
                                                    </div>}
                                                </div>)
                                                : <div
                                                    className={`height100 flexColumnCenter ${isPhoneClientWidth ? 'childrenSpacingTopBigPhone' : 'childrenSpacingTopBig'}`}>
                                                    <img src={requireDefault('Group 427320250')}
                                                         alt=""
                                                         style={{width: `${isPhoneClientWidth ? 6 : 2}rem`}}/>
                                                    <pre
                                                        className={`textAlignCenter ${isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'}`}>{`Your active positions will 
appear here.`}</pre>
                                                </div>

                                        })(),
                                        !isHistory && lessThan(positions.length, total) &&
                                        <div
                                            className={`flexCenter ${isPhoneClientWidth ? 'paddingTopPhone borderTopSmallGrayLinePhone' : 'paddingTop borderTopSmallGrayLine'}`}
                                            style={{borderTopStyle: 'dashed'}}>
                                            <div onClick={() => oSF(true)}
                                                 style={{padding: `${isPhoneClientWidth ? .3 : .1}rem ${isPhoneClientWidth ? 1.5 : .5}rem`}}
                                                 className={`${isPhoneClientWidth ? 'borderSmallGrayLinePhone' : 'borderSmallGrayLine'} borderRadius999 cursorPointer flexCenter colorGray`}
                                            >
                                                More...
                                            </div>
                                        </div>
                                    ]
                            }
                        </div>
                    })()
                ],
                ...isShowBorrow
                    ? [
                        [
                            ['Borrow', 'Positions'],
                            (() => {
                                const total = checkData0(data, `${positionsKey}Total`),
                                    oSF = isOnClick => onScrollFunc(positionsScroll, positions, total, () => setData({[positionsPageKey]: positionsPage + 1}), isOnClick)
                                return <div style={isPhoneClientWidth ? {height: '50vh'} : {}}
                                            ref={positionsScroll}
                                            onScroll={() => isHistory && oSF()}
                                            className={`${isPhoneClientWidth ? 'borderRadiusPhone borderSmallGrayLinePhone paddingBigPhone childrenSpacingTopPhone' : 'borderRadius borderSmallGrayLine flexGrow1Column paddingBig childrenSpacingTop'} overflowYScroll boxSizingBorderBox backgroundWhite`}>
                                    {
                                        checkData([data, listLoadingKey], true)
                                            ? <div
                                                className={`height100 flexColumnCenter ${isPhoneClientWidth ? 'childrenSpacingTopBigPhone' : 'childrenSpacingTopBig'}`}>
                                                <img src={requireDefault('loading')}
                                                     alt=""
                                                     style={{width: `${isPhoneClientWidth ? 12 : 4}rem`}}/>
                                            </div>
                                            : [
                                                (() => {
                                                    const arr = isHistory ? positions : positions.filter(v => isNotNull(v.marginTotalWei))
                                                    return arr.length > 0
                                                        ? arr.map((v, i) => <div
                                                            className={isPhoneClientWidth ? 'childrenSpacingTopPhone' : 'childrenSpacingTop'}>
                                                            {i !== 0 && <img src={requireDefault('Line 3')} alt=""
                                                                             className={'width100'}/>}
                                                            <div
                                                                className={'flex alignItemsCenter justifyContentSpaceBetween'}>
                                                                <div
                                                                    className={`flex alignItemsCenter ${isPhoneClientWidth ? 'childrenSpacingLeftPhone' : 'childrenSpacingLeft'}`}>
                                                                    {(() => {
                                                                        const text = isBorrowPositions ? 'borrowIcon' : (v.marginForOne ? 'Buy' : 'Sell')
                                                                        return [<img src={requireDefault(text)} alt=""
                                                                                     style={{width: `${isPhoneClientWidth ? 1.5 : .5}rem`}}/>,
                                                                            <div
                                                                                className={`${isPhoneClientWidth ? 'bigFontSizePhone' : 'bigFontSize'} saf1`}>{isBorrowPositions ? 'Borrow' : text}</div>]
                                                                    })()}
                                                                </div>
                                                                {(() => {
                                                                    const iLC = isLiquidateCallFunc(v)
                                                                    return (isHistory || iLC) &&
                                                                        (() => {
                                                                            const {burnType} = v,
                                                                                isCurrentLiquidated = !isHistory && iLC,
                                                                                isLiquidated = isCurrentLiquidated || [2, 3].includes(burnType)
                                                                            return <div
                                                                                className={`flex alignItemsCenter ${isPhoneClientWidth ? 'childrenSpacingLeftSmallPhone' : 'childrenSpacingLeftSmall'}`}>
                                                                                <div
                                                                                    className={`borderRadius999 ${isLiquidated ? 'backGroundBlueGray' : 'backgroundRed'}`}
                                                                                    style={square(`${isPhoneClientWidth ? .5 : .15}rem`)}/>
                                                                                <div
                                                                                    className={`${isLiquidated ? 'colorGray' : 'colorRed'} saf1 ${isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'}`}>
                                                                                    {isCurrentLiquidated ? 'Liquidated' : [
                                                                                        'REPAY', 'CLOSE', 'LIQUIDATE_BURN', 'LIQUIDATE_CALL'
                                                                                    ][burnType]}
                                                                                </div>
                                                                            </div>
                                                                        })()
                                                                })()}
                                                            </div>
                                                            {
                                                                (() => {
                                                                    const marginForOne = v.marginForOne,
                                                                        currency0Name = v[marginForOne ? 'borrowSymbol' : 'marginSymbol'],
                                                                        currency1Name = v[marginForOne ? 'marginSymbol' : 'borrowSymbol']
                                                                    return <div
                                                                        className={`flex alignItemsCenter ${isPhoneClientWidth ? 'childrenSpacingLeftSmallPhone' : 'childrenSpacingLeftSmall'}`}>
                                                                        {
                                                                            tokenIcon(
                                                                                {
                                                                                    poolId: v.poolId,
                                                                                    currency0: v[marginForOne ? 'borrowToken' : 'marginToken'],
                                                                                    currency1: v[marginForOne ? 'marginToken' : 'borrowToken'],
                                                                                    currency0Name,
                                                                                    currency1Name,
                                                                                    currency0Avatar: v[marginForOne ? 'borrowAvatar' : 'marginAvatar'],
                                                                                    currency1Avatar: v[marginForOne ? 'marginAvatar' : 'borrowAvatar'],
                                                                                },
                                                                                `${isPhoneClientWidth ? 1.8 : .6}rem`)
                                                                        }
                                                                        <div>
                                                                            {showPoolName(v.poolName)}
                                                                        </div>
                                                                    </div>
                                                                })()
                                                            }
                                                            <div className={isPhoneClientWidth
                                                                ? `childrenSpacingTopPhone ${isHistory ? '' : 'paddingPhone borderSmallGrayLinePhone borderRadiusPhone'}`
                                                                : `childrenSpacingTop ${isHistory ? '' : 'padding borderSmallGrayLine borderRadius'}`}>
                                                                {!isHistory && <div
                                                                    className={isHistory ? (isPhoneClientWidth ? 'childrenSpacingTopSmallPhone' : 'childrenSpacingTopSmall') : ''}>
                                                                    <div
                                                                        className={`colorGray ${isPhoneClientWidth ? '' : 'smallFontSize'}`}>
                                                                        Collateral Amount
                                                                    </div>
                                                                    <div
                                                                        className={'flexCenter justifyContentSpaceBetween'}>
                                                                        <div
                                                                            className={`saf1 ${isPhoneClientWidth ? '' : 'smallFontSize'}`}>{v.marginAmount} {v.marginSymbol}</div>
                                                                        {isHistory
                                                                            ? <div/>
                                                                            : <div
                                                                                style={{padding: `${isPhoneClientWidth ? .15 : .05}rem ${isPhoneClientWidth ? .45 : .15}rem`}}
                                                                                onClick={() => toggleShowAdjust(true, v)}
                                                                                className={`flexCenter ${isPhoneClientWidth ? 'borderActiveColorSmallPhone childrenSpacingLeftPhone' : 'borderActiveColorSmall childrenSpacingLeft'} borderRadius999 cursorPointer`}>
                                                                                <img src={requireDefault('Adjust')}
                                                                                     alt=""
                                                                                     style={square(`${isPhoneClientWidth ? .9 : .3}rem`)}/>
                                                                                <div
                                                                                    className={`activeColor ${isPhoneClientWidth ? '' : 'smallFontSize'}`}>Adjust
                                                                                </div>
                                                                            </div>
                                                                        }
                                                                    </div>
                                                                </div>}
                                                                {!isHistory &&
                                                                    <div
                                                                        className={'flexCenter justifyContentSpaceBetween'}>
                                                                        <div
                                                                            className={`colorGray ${isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'}`}>
                                                                            Supply APY
                                                                        </div>
                                                                        <div
                                                                            className={`flex alignItemsCenter ${isPhoneClientWidth ? 'childrenSpacingLeftSmallPhone' : 'childrenSpacingLeftSmall'}`}>
                                                                            <img src={requireDefault('interestIncome')}
                                                                                 alt=""
                                                                                 style={{width: `${isPhoneClientWidth ? .9 : .3}rem`}}/>
                                                                            <div
                                                                                className={isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'}>{checkData0(v, 'lendingInterest')}%
                                                                            </div>
                                                                        </div>
                                                                    </div>}
                                                            </div>
                                                            {closePositionData(false, v)}
                                                            {!isHistory && <div
                                                                className={`flexCenter justifyContentFlexEnd ${isPhoneClientWidth ? 'childrenSpacingLeftPhone' : 'childrenSpacingLeft'}`}>
                                                                {[
                                                                    ...isBorrowPositions
                                                                        ? []
                                                                        : [['Close', () => toggleShowClosePosition(true, v)]],
                                                                    ['Repay', () => toggleShowRepaying(true, v)]
                                                                ].map(v =>
                                                                    <div onClick={v[1]}
                                                                         className={`borderRadius999 backgroundActiveColor flexCenter saf1 colorWhite ${isPhoneClientWidth ? '' : 'smallFontSize'} cursorPointer`}
                                                                         style={{
                                                                             width: `${isPhoneClientWidth ? 6.5 : 1.5}rem`,
                                                                             height: `${isPhoneClientWidth ? 2.5 : .5}rem`
                                                                         }}
                                                                    >{v[0]}</div>)}
                                                            </div>}
                                                        </div>)
                                                        : <div
                                                            className={`height100 flexColumnCenter ${isPhoneClientWidth ? 'childrenSpacingTopBigPhone' : 'childrenSpacingTopBig'}`}>
                                                            <img src={requireDefault('Group 427320250')}
                                                                 alt=""
                                                                 style={{width: `${isPhoneClientWidth ? 6 : 2}rem`}}/>
                                                            <pre
                                                                className={`textAlignCenter ${isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'}`}>{`Your active positions will 
appear here.`}</pre>
                                                        </div>

                                                })(),
                                                !isHistory && lessThan(positions.length, total) &&
                                                <div className={'flexCenter'}>
                                                    <div onClick={() => oSF(true)}
                                                         style={{padding: `${isPhoneClientWidth ? .3 : .1}rem ${isPhoneClientWidth ? 1.5 : .5}rem`}}
                                                         className={`${isPhoneClientWidth ? 'borderSmallGrayLinePhone' : 'borderSmallGrayLine'} borderRadius999 cursorPointer flexCenter colorGray`}
                                                    >
                                                        More...
                                                    </div>
                                                </div>
                                            ]
                                    }
                                </div>
                            })()
                        ],
                    ]
                    : [],
                ...['Liquidity', 'Supply'].map(v => [
                        [v, 'Positions'],
                        <div style={isPhoneClientWidth ? {height: '50vh'} : {}}
                             ref={positionsScroll}
                             onScroll={() => onScrollFunc(positionsScroll, poolPositions, checkData0(data, `${positionPoolData[1][2]}Total`), () => setData({[poolPositionsPageKey]: poolPositionsPage + 1}))}
                             className={`${isPhoneClientWidth ? 'borderRadiusPhone borderSmallGrayLinePhone paddingBigPhone childrenSpacingTopPhone' : 'borderRadius borderSmallGrayLine flexGrow1Column paddingBig childrenSpacingTop'} overflowYScroll boxSizingBorderBox backgroundWhite`}>
                            {
                                checkData([data, listLoadingKey], true)
                                    ? <div
                                        className={`height100 flexColumnCenter ${isPhoneClientWidth ? 'childrenSpacingTopBigPhone' : 'childrenSpacingTopBig'}`}>
                                        <img src={requireDefault('loading')}
                                             alt=""
                                             style={{width: `${isPhoneClientWidth ? 12 : 4}rem`}}/>
                                    </div>
                                    : (() => {
                                        const arr = isLiquidityPool
                                            ? poolPositions
                                            : poolPositions.filter(v => !equalTo(checkData0(v, 'amount')))
                                        return arr.length > 0
                                            ? arr.map((item, i) => {
                                                const symbols = checkDataString(item, 'name').split('/')
                                                return <div
                                                    className={`${isPhoneClientWidth ? 'childrenSpacingTopBigPhone paddingBottomBigPhone borderBottomSmallGrayLinePhone' : 'childrenSpacingTopBig paddingBottomBig borderBottomSmallGrayLine'} ${i !== 0 ? (isPhoneClientWidth ? 'paddingTopBigPhone' : 'paddingTopBig') : ''}`}>
                                                    <div
                                                        className={`flex alignItemsCenter ${isPhoneClientWidth ? 'justifyContentSpaceBetween childrenSpacingLeftBiggerPhone' : 'childrenSpacingLeftBigger'}`}>
                                                        <div
                                                            className={`flexCenter ${isPhoneClientWidth ? 'childrenSpacingLeftPhone' : 'childrenSpacingLeft'}`}>
                                                            {tokenIcon((() => {
                                                                const currency = checkDataString(item, 'name').split('/')
                                                                return {
                                                                    ...item,
                                                                    currency0Name: currency[0],
                                                                    currency1Name: currency[1],
                                                                }
                                                            })(), `${isPhoneClientWidth ? 2.1 : .7}rem`)}
                                                            <div>
                                                                <div>{item.name}</div>
                                                                {isLiquidityPool && showFees(item)}
                                                            </div>
                                                        </div>
                                                        {/*<div className={'colorGray'}>*/}
                                                        {/*    APY: {numToPercentage(checkData0(v, 'apy'),)}%*/}
                                                        {/*</div>*/}
                                                    </div>
                                                    {/*true*/}
                                                    {/*lending pool.png*/}
                                                    {/*swap pool.png*/}
                                                    {
                                                        [
                                                            isLiquidityPool
                                                                ? [
                                                                    'Swap pool',
                                                                    <div
                                                                        className={`${isPhoneClientWidth ? (isPhoneClientWidth ? 'childrenSpacingTopBigPhone' : 'childrenSpacingTopBig') : 'childrenSpacingTop'}`}>
                                                                        {
                                                                            levelKeys.map((levelKey, i2) => {
                                                                                const hasLevel = !notLiquidityLevelChain,
                                                                                    level = hasLevel ? i2 + 1 : 4,
                                                                                    levelLiquidity = checkData0(item, hasLevel ? `level${levelKey}Liquidity` : 'liquidity'),
                                                                                    totalSupply = checkData0(item, 'totalSupply'),
                                                                                    levelDivideSupply = divide(
                                                                                        levelLiquidity,
                                                                                        totalSupply
                                                                                    )
                                                                                // reserveO
                                                                                // aaa=
                                                                                // levelLiquidity/totalSupply*reserve0
                                                                                return (hasLevel ? greaterThan(levelLiquidity) : i2 + 1 === 4) &&
                                                                                    <div
                                                                                        className={isPhoneClientWidth ? 'childrenSpacingTopPhone paddingPhone borderSmallGrayLinePhone borderRadiusPhone' : 'childrenSpacingTop padding borderSmallGrayLine borderRadius'}>
                                                                                        {[
                                                                                            [
                                                                                                'Your Pools Share',
                                                                                                ...Array.from({length: 2}).map((_, i) =>
                                                                                                    getLevelShare(item, levelDivideSupply, i)),
                                                                                                `${percentageNum(times(divide(levelLiquidity, totalSupply), 100))}%`
                                                                                            ],
                                                                                            // [
                                                                                            //     'Fees',
                                                                                            //     ...Array.from({length: 2}).map((_, i) =>
                                                                                            //         num8(apiNumETH(
                                                                                            //             times(
                                                                                            //                 levelDivideSupply,
                                                                                            //                 plus(
                                                                                            //                     plus(
                                                                                            //                         checkData0(item, `swapFees${i}`),
                                                                                            //                         checkData0(item, `marginFees${i}`),
                                                                                            //                     ),
                                                                                            //                     isCloseFunc(i, level) ? 0 : checkData0(item, `interestFees${i}`)
                                                                                            //                 )
                                                                                            //             ),
                                                                                            //             item[`currency${i}Decimals`]
                                                                                            //         )))
                                                                                            // ]
                                                                                        ].map(
                                                                                            (v1, i1) =>
                                                                                                <div
                                                                                                    className={`${isPhoneClientWidth ? 'childrenSpacingTopPhone' : 'childrenSpacingTop'} positionRelative`}>
                                                                                                    <div
                                                                                                        className={'flexCenter justifyContentSpaceBetween'}>
                                                                                                        <div
                                                                                                            className={`flex alignItemsCenter ${isPhoneClientWidth ? 'childrenSpacingLeftSmallPhone' : 'childrenSpacingLeftSmall'}`}>
                                                                                                            <div
                                                                                                                className={`${isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'} colorGray saf1`}>
                                                                                                                {v1[0]}
                                                                                                            </div>
                                                                                                            {isNotNull(v1[3]) &&
                                                                                                                <div
                                                                                                                    className={`saf1 borderRadius999 activeColor ${isPhoneClientWidth ? 'paddingSmallPhone smallerFontSizePhone' : 'paddingSmall smallerFontSize'}`}
                                                                                                                    style={{background: '#FFF4F5'}}>
                                                                                                                    {v1[3]}
                                                                                                                </div>}
                                                                                                        </div>
                                                                                                        {!i1 &&
                                                                                                            <div
                                                                                                                onMouseEnter={() => setData({showBorrowable: {[`${i}${i2}`]: true}})}
                                                                                                                onMouseLeave={() => setData({showBorrowable: {[`${i}${i2}`]: false}})}
                                                                                                                className={`flexCenter ${isPhoneClientWidth ? 'childrenSpacingLeftSmallPhone' : 'childrenSpacingLeftSmall'}`}>
                                                                                                                {
                                                                                                                    [0, 1].map((v2, i2) => {
                                                                                                                            const iC = isCloseFunc(i2, level)
                                                                                                                            return <div
                                                                                                                                style={{
                                                                                                                                    ...square(`${isPhoneClientWidth ? 1.2 : .4}rem`),
                                                                                                                                    ...iC ? {filter: 'grayscale(100%)'} : {}
                                                                                                                                }}
                                                                                                                                className={'borderRadius999 positionRelative flexCenter overflowVisible'}
                                                                                                                            >
                                                                                                                                {tokenIcon(
                                                                                                                                    {
                                                                                                                                        tokenAddress: item[`currency${i2}`],
                                                                                                                                        symbol: symbols[i2]
                                                                                                                                    },
                                                                                                                                    '100%'
                                                                                                                                )}
                                                                                                                                {iC
                                                                                                                                    ?
                                                                                                                                    <div
                                                                                                                                        className={'positionAbsolute borderRadius999 width100 backgroundBlack'}
                                                                                                                                        style={{
                                                                                                                                            height: `${isPhoneClientWidth ? .09 : .03}rem`,
                                                                                                                                            transform: 'rotate(30deg)'
                                                                                                                                        }}/>
                                                                                                                                    :
                                                                                                                                    <div
                                                                                                                                        className={'positionAbsolute backgroundGreen borderRadius999'}
                                                                                                                                        style={{
                                                                                                                                            bottom: '0',
                                                                                                                                            right: '0',
                                                                                                                                            ...square(`${isPhoneClientWidth ? .3 : .1}rem`)
                                                                                                                                        }}/>
                                                                                                                                }
                                                                                                                            </div>
                                                                                                                        }
                                                                                                                    )
                                                                                                                }
                                                                                                            </div>
                                                                                                        }
                                                                                                    </div>
                                                                                                    {!i1 && checkDataBool(data, 'showBorrowable', `${i}${i2}`) &&
                                                                                                        // level
                                                                                                        // Neither Likwid nor ETH borrowable
                                                                                                        // Both Likwid and ETH borrowable
                                                                                                        // Only ETH borrowable
                                                                                                        <div
                                                                                                            style={{
                                                                                                                right: 0,
                                                                                                                borderWidth: `${isPhoneClientWidth ? .09 : .03}rem`
                                                                                                            }}
                                                                                                            className={`backgroundWhite borderRadius999 ${isPhoneClientWidth ? 'marginTopPhone paddingSmallPhone smallFontSizePhone borderActiveColorPhone' : 'marginTop paddingSmall smallFontSize borderActiveColor'} positionAbsolute`}>
                                                                                                            {(() => {
                                                                                                                const isOnly = [2, 3].includes(level),
                                                                                                                    isBoth = level === 4
                                                                                                                return `${isOnly ? 'Only' :
                                                                                                                    (isBoth ? 'Both' : 'Neither')
                                                                                                                } ${
                                                                                                                    isOnly
                                                                                                                        ? symbols[[0, 1, 0, 1][level]]
                                                                                                                        : symbols.join(isBoth ? ' and ' : ' nor ')} borrowable`
                                                                                                            })()}
                                                                                                        </div>}
                                                                                                    <div
                                                                                                        className={isPhoneClientWidth ? 'childrenSpacingTopPhone' : 'childrenSpacingTop'}>
                                                                                                        {[1, 2].map((v2, i2) => <div
                                                                                                                className={'flex flexCenter justifyContentSpaceBetween'}>
                                                                                                                <div
                                                                                                                    className={`${isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'} colorGray`}>{poolName(item, i2)}</div>
                                                                                                                <div
                                                                                                                    className={isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'}>{v1[v2]}</div>
                                                                                                            </div>
                                                                                                        )}
                                                                                                    </div>
                                                                                                    {
                                                                                                        // <div
                                                                                                        //     className={'flex justifyContentFlexEnd'}>
                                                                                                        //     <div
                                                                                                        //         style={{borderWidth: `${isPhoneClientWidth ? .09 : .03}rem`}}
                                                                                                        //         className={`borderRadius999 ${isPhoneClientWidth ? 'paddingSmallPhone childrenSpacingLeftSmallPhone' : 'paddingSmall childrenSpacingLeftSmall'} flexCenter borderActiveColor cursorPointer`}>
                                                                                                        //         <img
                                                                                                        //             src={requireDefault('Withdraw')}
                                                                                                        //             alt=""
                                                                                                        //             style={{width: `${isPhoneClientWidth ? .75 : .25}rem`}}/>
                                                                                                        //         <div
                                                                                                        //             className={`activeColor ${isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'}`}>Withdraw
                                                                                                        //         </div>
                                                                                                        //     </div>
                                                                                                        // </div>
                                                                                                        !i1 && <div
                                                                                                            className={`flex alignItemsCenter childrenFlexGrow1 ${isPhoneClientWidth ? `justifyContentCenter ${isPhoneClientWidth ? 'childrenSpacingLeftBigPhone' : 'childrenSpacingLeftBig'}` : `justifyContentCenter childrenSpacingLeft`}`}>
                                                                                                            {[
                                                                                                                ['Increase liquidity', () => windowReplace(`/pool/add?poolid=${item.poolId}&level=${level}`)],
                                                                                                                ['Remove liquidity', () => removeLiquidityOnclick(level, levelLiquidity, item)]
                                                                                                            ].map(v =>
                                                                                                                <div
                                                                                                                    style={{
                                                                                                                        height: `${isPhoneClientWidth ? 2 : .5}rem`
                                                                                                                    }}
                                                                                                                    onClick={v[1]}
                                                                                                                    className={`backgroundActiveColor colorWhite borderRadius999 saf1 ${isPhoneClientWidth ? 'paddingPhone' : 'padding smallFontSize'} flexCenter cursorPointer boxSizingBorderBox`}>
                                                                                                                    {v[0]}
                                                                                                                </div>)}
                                                                                                        </div>
                                                                                                    }
                                                                                                </div>)}
                                                                                    </div>
                                                                            })
                                                                        }
                                                                    </div>
                                                                ]
                                                                : [
                                                                    'Lending pool',
                                                                    (() => {
                                                                        const i2 = item.lendToken === item.currency0 ? 0 : 1,
                                                                            supplies = checkData0(item, `amount`)
                                                                        return !equalTo(supplies) &&
                                                                            <div className={isPhoneClientWidth
                                                                                ? 'paddingPhone borderSmallGrayLinePhone borderRadiusPhone childrenSpacingTopPhone'
                                                                                : 'padding borderSmallGrayLine borderRadius childrenSpacingTop'}
                                                                            >
                                                                                {(() => {
                                                                                    const currencyDecimals = item[`currency${i2}Decimals`],
                                                                                        symbol = symbols[i2]
                                                                                    return [
                                                                                        [
                                                                                            'Your Supplies',
                                                                                            `${numberETH(
                                                                                                checkData0(item, `withdrawMax${i2}`),
                                                                                                currencyDecimals
                                                                                            )} ${symbol}`
                                                                                        ],
                                                                                        // [
                                                                                        //     'Interest',
                                                                                        //     `${
                                                                                        //         numberETH(
                                                                                        //             minus(
                                                                                        //                 checkData0(item, `withdrawMax${i2}`),
                                                                                        //                 supplies
                                                                                        //             ),
                                                                                        //             currencyDecimals
                                                                                        //         )
                                                                                        //     } ${symbol}`
                                                                                        // ],
                                                                                        ['APY', `${checkData0(item, `lendingInterest${i2}`)}%`]
                                                                                    ].map(v => <div
                                                                                        className={'flexCenter justifyContentSpaceBetween'}>
                                                                                        <div
                                                                                            className={`${isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'} colorGray`}>{v[0]}</div>
                                                                                        <div
                                                                                            className={`${isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'}`}>{v[1]}</div>
                                                                                    </div>)
                                                                                })()}
                                                                                <div
                                                                                    className={`flex ${isPhoneClientWidth ? 'childrenSpacingLeftPhone' : 'childrenSpacingLeft'} justifyContentFlexEnd`}>
                                                                                    {
                                                                                        [
                                                                                            ['Deposit', 'supply'],
                                                                                            ['Withdraw', 'withdraw'],
                                                                                        ].map(v => <div
                                                                                            onClick={() => windowReplace(`/pool/${v[1]}?poolid=${item.poolId}&tokenIndex=${i2}`)}
                                                                                            style={{borderWidth: `${isPhoneClientWidth ? .09 : .03}rem`}}
                                                                                            className={`borderRadius999 ${isPhoneClientWidth ? 'paddingSmallPhone childrenSpacingLeftSmallPhone' : 'paddingSmall childrenSpacingLeftSmall'} flexCenter borderActiveColor cursorPointer`}>
                                                                                            <img
                                                                                                src={requireDefault('Withdraw')}
                                                                                                alt=""
                                                                                                style={{width: `${isPhoneClientWidth ? .75 : .25}rem`}}/>
                                                                                            <div
                                                                                                className={`activeColor ${isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'}`}>{v[0]}
                                                                                            </div>
                                                                                        </div>)
                                                                                    }
                                                                                </div>
                                                                            </div>
                                                                    })()
                                                                ]
                                                        ].map((v) => v[0] && <div
                                                            className={isPhoneClientWidth ? 'childrenSpacingTopBigPhone' : 'childrenSpacingTopBig'}>
                                                            {/*<div*/}
                                                            {/*    className={`flex alignItemsCenter ${isPhoneClientWidth ? 'childrenSpacingLeftPhone' : 'childrenSpacingLeft'}`}>*/}
                                                            {/*    <img src={requireDefault(v[0])} alt=""*/}
                                                            {/*         style={square(`${isPhoneClientWidth ? 1.2 : .4}rem`)}/>*/}
                                                            {/*    <div className={'saf1'}>{v[0]}</div>*/}
                                                            {/*</div>*/}
                                                            {v[1]}
                                                        </div>)
                                                    }
                                                </div>
                                            })
                                            : <div
                                                className={`height100 flexColumnCenter ${isPhoneClientWidth ? 'childrenSpacingTopBigPhone' : 'childrenSpacingTopBig'}`}>
                                                <img src={requireDefault('Group 427320250')}
                                                     alt=""
                                                     style={{width: `${isPhoneClientWidth ? 6 : 2}rem`}}/>
                                                <pre
                                                    className={`textAlignCenter ${isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'}`}>{`Your active positions will 
appear here.`}</pre>
                                            </div>
                                    })()
                            }
                        </div>
                    ]
                ),
                ...isShowBorrow
                    ? []
                    : [[]]
            ],
            settingContent = (dataKey = '') => {
                const showSettingsKey = `showSettings${dataKey}`,
                    showSettings = checkDataBool(data, showSettingsKey),
                    isAutoKey = `isAuto${dataKey}`,
                    maxSlippageKey = `maxSlippage${dataKey}`,
                    setMaxSlippage = (maxSlippage, isAuto) => setData({
                        [maxSlippageKey]: maxSlippage,
                        [isAutoKey]: !!isAuto
                    }),
                    toggleShowSettings = () => setData({[showSettingsKey]: !showSettings}),
                    setMaxSlippageInput = e => setMaxSlippage(e.target.value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, ".")
                        .replace(/^\./g, "").replace(".", "$#$").replace(/\./g, "").replace("$#$", ".")
                        .replace(/^(\-)*(\d+)\.(\d{1}).*$/, '$1$2.$3')),
                    transactionDeadlineKey = `transactionDeadline${dataKey}`,
                    setTransactionDeadline = e => setData({[transactionDeadlineKey]: e.target.value.replace(/[^\d]/g, '')}),
                    isAuto = checkData([data, isAutoKey], true)
                return <div className={'positionRelative flexCenter'}>
                    <img onClick={toggleShowSettings} className={'cursorPointer'}
                         src={requireDefault('setting')}
                         alt=""
                         style={{width: `${isPhoneClientWidth ? 2.1 : .7}rem`}}/>
                    {showSettings && <div style={{
                        zIndex: 2,
                        width: `${isPhoneClientWidth ? 26 : 6}rem`,
                        top: `${isPhoneClientWidth ? 2.5 : .7}rem`, ...isPhoneClientWidth ? {right: '40%'} : {}
                    }}
                                          className={`${isPhoneClientWidth ? 'borderRadiusPhone paddingBigPhone childrenSpacingTopBiggerPhone' : 'borderRadius paddingBig childrenSpacingTopBig'} positionAbsolute  boxShadow  backgroundWhite  boxSizingBorderBox`}>
                        <div className={'saf1 flexCenter'}>Swap Settings</div>
                        <div
                            className={isPhoneClientWidth ? 'childrenSpacingTopBigPhone' : 'childrenSpacingTopBig'}>
                            {[
                                [
                                    'Max Slippage',
                                    <div
                                        className={'flexCenter justifyContentSpaceBetween'}
                                        style={square('100%')}>
                                        <div onClick={() => setMaxSlippage(autoMaxSlippage, true)}
                                             className={`borderRadius999 ${isPhoneClientWidth ? 'smallFontSizePhone paddingSmallPhone' : 'smallFontSize paddingSmall'} flexCenter ${isAuto ? 'activeColor' : 'colorGray'} saf1 cursorPointer`}
                                             style={{background: isAuto ? '#FFF4F5' : '#F9F9F9'}}>Auto
                                        </div>
                                        <div className={'flexCenter childrenSpacingLeft'}>
                                            <input type="text"
                                                   className={`${isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'} 
                                                       ${isAuto ? 'colorGray' : ''} textAlignRight`}
                                                   value={checkData([data, maxSlippageKey], autoMaxSlippage)}
                                                   onChange={setMaxSlippageInput}
                                                   style={{width: isPhoneClientWidth ? '3rem' : '.7rem'}}
                                            />
                                            <div
                                                className={isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'}>%
                                            </div>
                                        </div>
                                    </div>
                                ],
                                [
                                    'Transaction Deadline',
                                    <div
                                        className={`width100 flexCenter ${isPhoneClientWidth ? 'childrenSpacingLeftPhone' : 'childrenSpacingLeft'}`}>
                                        <input type="text"
                                               className={`${isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'} saf1`}
                                               value={checkData([data, transactionDeadlineKey], defaultDeadlineSecond / 60)}
                                               onChange={setTransactionDeadline}
                                               style={{width: `${isPhoneClientWidth ? 3 : .3}rem`}}
                                        />
                                        <div
                                            className={`${isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'} colorGray`}>Minutes
                                        </div>
                                    </div>
                                ]
                            ].map(v => <div
                                className={'flexCenter justifyContentSpaceBetween'}>
                                <div
                                    className={isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'}>{v[0]}</div>
                                <div
                                    className={`${isPhoneClientWidth ? 'paddingSmallPhone borderSmallGrayLinePhone' : 'paddingSmall borderSmallGrayLine'} borderRadius999 flexCenter boxSizingBorderBox`}
                                    style={{
                                        width: '40%', height: `${isPhoneClientWidth ? 2.5 : .7}rem`
                                    }}
                                >
                                    {v[1]}
                                </div>
                            </div>)}
                            <div onClick={toggleShowSettings}
                                 className={`saf1 flexCenter ${isPhoneClientWidth ? 'paddingTopBottomPhone borderRadiusPhone' : 'paddingTopBottom borderRadius'}  activeColor cursorPointer`}
                                 style={{background: '#FFF4F5'}}>
                                Close
                            </div>
                        </div>
                    </div>}
                </div>
            },
            poolDataTokenId = checkData([data, 'poolDataTokenId']),
            poolDataTokenIdIsNotNull = isNotNull(poolDataTokenId),
            liquidityContent = (() => {
                const addLiquidityTokens = hexToNumber(token0Address) > hexToNumber(token1Address)
                        ? [token1Address, token0Address]
                        : tokenAddresses,
                    addLiquidity = () => {
                        const amounts = hexToNumber(token0Address) > hexToNumber(token1Address)
                            ? [token1NewAmountWei, token0NewAmountWei] : tokenDatas.map(v => v.newAmountWei)
                        return pairPositionWriteContract(
                            poolDataTokenIdIsNotNull ? 'increaseLiquidity' : 'addLiquidity',
                            token0IsETH ? token0NewAmountWei : undefined,
                            [
                                poolDataTokenIdIsNotNull
                                    ? poolDataTokenId
                                    : [
                                        // poolId,
                                        ...addLiquidityTokens,
                                        feeTierBigInt,
                                        marginFeeTierBigInt,
                                        // ...notLiquidityLevelChain ? [] : [liquidityLevel], address, deadline
                                    ],
                                ...poolDataTokenIdIsNotNull ? [] : [address],
                                ...amounts,
                                ...amounts.map(v => maxSlippageAmount(v)),
                                deadline
                            ],
                            hash => addRemoveApi('add', hash)
                        )
                    },
                    currentShares = checkData0(data, isPoolPositions ? 'removePoolCurrentShares' : 'currentShares'),
                    removeShares = divide(range, 100),
                    pD = isPoolPositions ? removePoolData : poolData,
                    levelKey = levelKeys[minus(checkData0(pD, 'level'), 1)],
                    removePoolOwnerLiquidityMax = checkData0(data, 'removePoolOwnerLiquidityMax'),
                    removePoolOwnerLiquidity = checkData0(data, 'removePoolOwnerLiquidity'),
                    isRemoveLiquidity = !showApprove && isPoolPositions,
                    levelLiquidity = checkData0(pD, !notLiquidityLevelChain ? `level${levelKey}Liquidity` : 'liquidity'),
                    setLevelLiquidity = (r, lL = levelLiquidity) => (
                        {
                            levelLiquidity0: num8(
                                times(
                                    getLevelShare(
                                        pD,
                                        divide(
                                            lL,
                                            checkData0(pD, 'totalSupply')
                                        ),
                                        0
                                    ),
                                    divide(r, 100)
                                )
                            ),
                            levelLiquidity1: num8(
                                times(
                                    getLevelShare(
                                        pD,
                                        divide(
                                            lL,
                                            checkData0(pD, 'totalSupply')
                                        ),
                                        1
                                    ),
                                    divide(r, 100)
                                )
                            )
                        }
                    )
                return maskContent(
                    isPoolPositions ? 'Remove liquidity' : liquidityTitle,
                    showLiquidity,
                    toggleShowLiquidity,
                    <div
                        style={{marginTop: `${isPhoneClientWidth ? 1.5 : .5}rem`}}
                        className={isPhoneClientWidth ? 'childrenSpacingTopBiggerPhone' : 'childrenSpacingTopBigger'}>
                        <div
                            className={isPhoneClientWidth ? 'childrenSpacingTopBigPhone' : 'childrenSpacingTopBig'}>
                            {!isPoolPositions && [
                                <div
                                    className={`flex alignItemsCenter ${isPhoneClientWidth ? 'childrenSpacingLeftSmallPhone' : 'childrenSpacingLeftSmall'}`}>
                                    {tokenIcon(isPoolCreate ? (() => {
                                        let obj = {poolId: 'poolId', name: tokenDataPoolName}
                                        tokenDatas.map((v, i) => obj = {
                                            ...obj,
                                            [`currency${i}`]: v.tokenAddress,
                                            [`currency${i}Avatar`]: v.avatar,
                                            [`currency${i}Name`]: v.name,
                                            [`currency${i}Symbol`]: v.symbol,
                                        })
                                        return obj
                                    })() : poolData, `${isPhoneClientWidth ? 1.5 : .4}rem`)}
                                    <div
                                        className={isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'}>
                                        {tokenDataPoolName}
                                    </div>
                                </div>,
                                <div
                                    className={`${isPhoneClientWidth ? 'childrenSpacingTopBigPhone paddingBigPhone borderRadiusPhone borderSmallGrayLinePhone' : 'childrenSpacingTopBig paddingBig borderRadius borderSmallGrayLine'}`}>
                                    {tokenDatas.map(v => <div
                                        className={'flexCenter justifyContentSpaceBetween'}>
                                        <div
                                            className={`saf flexCenter ${isPhoneClientWidth ? 'childrenSpacingLeftPhone' : 'childrenSpacingLeft'}`}>
                                            {tokenIcon(v, `${isPhoneClientWidth ? 2.5 : .56}rem`)}
                                            <div
                                                className={isPhoneClientWidth ? '' : 'smallFontSize'}>
                                                {v.symbol}
                                            </div>
                                        </div>
                                        <div
                                            className={isPhoneClientWidth ? '' : 'smallFontSize'}>{checkData0(v, 'newAmount')}</div>
                                    </div>)}
                                </div>]}
                            {(!isPoolCreate || isPoolPositions) && <div
                                className={`${isPhoneClientWidth ? 'borderRadiusPhone paddingBigPhone childrenSpacingTopPhone borderSmallGrayLinePhone' : 'borderRadius paddingBig childrenSpacingTopSmall borderSmallGrayLine'} flexColumnCenter backgroundGrey`}>
                                <div style={{color: '#7D7D7D'}}
                                     className={isPhoneClientWidth ? '' : 'smallerFontSize'}>
                                    Shares
                                </div>
                                <div
                                    className={`flexCenter ${isPhoneClientWidth ? 'childrenSpacingLeftSmallPhone' : 'childrenSpacingLeftSmall'}`}>
                                    <div className={isPhoneClientWidth ? 'bigFontSizePhone' : ''}>
                                        {percentageReplace(currentShares, true)}%
                                    </div>
                                    <img src={requireDefault('doubleArrow')} alt=""
                                         style={{width: `${isPhoneClientWidth ? 1.7 : .4}rem`}}/>
                                    <div className={isPhoneClientWidth ? 'bigFontSizePhone' : ''}>
                                        {(() => {
                                            const numWei = parseEtherNum(token0NewAmount, token0Decimals)
                                            return percentageReplace(
                                                ...isPoolPositions
                                                    ? [
                                                        divide(
                                                            times(
                                                                levelLiquidity, minus(1, removeShares)
                                                            ),
                                                            minus(
                                                                checkData0(pD, 'totalSupply'),
                                                                times(
                                                                    levelLiquidity, removeShares
                                                                )
                                                            )
                                                        ),
                                                        true
                                                    ]
                                                    : (
                                                        isPoolAddIncrease
                                                            ? [
                                                                divide(
                                                                    plus(
                                                                        numWei,
                                                                        times(
                                                                            currentShares, reserve0
                                                                        )
                                                                    ),
                                                                    plus(
                                                                        reserve0, numWei
                                                                    )
                                                                )
                                                            ]
                                                            : [
                                                                (() => {
                                                                    const p = plus(
                                                                        currentShares,
                                                                        divide(
                                                                            parseEtherNum(token0NewAmount, token0Decimals),
                                                                            reserve0
                                                                        )
                                                                    )
                                                                    return p > 1 ? 1 : p
                                                                })(),
                                                                true
                                                            ]
                                                    ),
                                                true
                                            )
                                        })()}%
                                    </div>
                                </div>
                            </div>}
                            {isPoolPositions && <div
                                className={`${isPhoneClientWidth ? 'childrenSpacingTopBigPhone paddingBigPhone borderRadiusPhone borderSmallGrayLinePhone' : 'childrenSpacingTopBig paddingBig borderRadius borderSmallGrayLine'}`}>
                                <div className={'flex childrenFlexGrow1'}>
                                    {removePoolTokenDatas.map((v, i) => <div
                                        className={'flexColumnCenter childrenSpacingTop'}>
                                        <div
                                            className={isPhoneClientWidth ? 'bigFontSizePhone' : 'bigFontSize'}>{
                                            checkData0(pD, `levelLiquidity${i}`)
                                        }</div>
                                        <div
                                            className={`flexCenter ${isPhoneClientWidth ? 'childrenSpacingLeftSmallPhone' : 'childrenSpacingLeftSmall'}`}>
                                            {tokenIcon(v, `${isPhoneClientWidth ? 1.7 : .4}rem`)}
                                            <div
                                                className={isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'}>{v.symbol}</div>
                                        </div>
                                    </div>)}
                                </div>
                                {rangeContent(range => setData({
                                    ...isRemoveLiquidity ? {
                                        removePoolOwnerLiquidity: toInt(times(removePoolOwnerLiquidityMax, divide(range, 100)))
                                    } : {},
                                    removePoolData: {
                                        ...removePoolData,
                                        ...setLevelLiquidity(range)
                                    }
                                }))}
                            </div>}
                            {
                                isRemoveLiquidity && (() => {
                                    const setRemovePoolOwnerLiquidityRange = rPOL => {
                                            const r = toInt(percentageReplace(
                                                divide(
                                                    rPOL,
                                                    removePoolOwnerLiquidityMax
                                                )
                                            ))
                                            setData({
                                                removePoolOwnerLiquidity: rPOL,
                                                range: r,
                                                removePoolData: {
                                                    ...removePoolData,
                                                    ...setLevelLiquidity(r, toInt(divide(rPOL, divide(r, 100))))
                                                }
                                            })
                                        },
                                        removePoolOwnerLiquidityMaxTrue = toInt(times(removePoolOwnerLiquidityMax, divide(checkData0(data, 'maxRangeTrue'), 100)))
                                    return <div
                                        className={`backgroundGrey ${isPhoneClientWidth ? 'paddingBigPhone childrenSpacingTopPhone borderRadiusPhone' : 'paddingBig childrenSpacingTopBig'}`}
                                        style={isPhoneClientWidth ? {} : {borderRadius: '.3rem'}}
                                    >
                                        <div
                                            className={`flex alignItemsCenter justifyContentSpaceBetween ${isPhoneClientWidth ? 'childrenSpacingLeftPhone' : 'childrenSpacingLeft'}`}>
                                            <input type="text"
                                                   placeholder='0'
                                                   value={removePoolOwnerLiquidity}
                                                   onChange={e => setRemovePoolOwnerLiquidityRange(e.target.value)}
                                                   className={`${isPhoneClientWidth ? 'biggerFontSizePhone' : 'biggerFontSize'} flexGrow1`}/>
                                        </div>
                                        <div className={'flexCenter justifyContentSpaceBetween'}>
                                            <div
                                                className={`${isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'} colorGray`}>
                                                {removePoolOwnerLiquidityMaxTrue}
                                            </div>
                                            <div
                                                className={`flexCenter ${isPhoneClientWidth ? 'childrenSpacingLeftPhone' : 'childrenSpacingLeft'}`}>
                                                <div
                                                    style={{fontSize: `${isPhoneClientWidth ? .6 : .15}rem`}}
                                                    onClick={() => setRemovePoolOwnerLiquidityRange(removePoolOwnerLiquidityMaxTrue)}
                                                    className={`backgroundActiveColor ${isPhoneClientWidth ? 'paddingSmallPhone' : 'paddingSmall'} borderRadius999 colorWhite cursorPointer`}>
                                                    MAX
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                })()
                            }
                        </div>
                        {showApprove
                            ? approveContent([{
                                symbol: tokenDataPoolName,
                                needApprove: tokenDataNeedApprove
                            }])
                            : <div style={isPhoneClientWidth ? {marginBottom: '2rem'} : {}}
                                   onClick={async () => {
                                       if (isPoolPositions) {
                                           const rPOL = toInt(removePoolOwnerLiquidity)
                                           pairPositionWriteContract(
                                               'removeLiquidity',
                                               undefined,
                                               [
                                                   removePoolData.tokenId,
                                                   ...notLiquidityLevelChain ? [] : [removePoolDataLevel],
                                                   rPOL,
                                                   ...removePoolTokenDatas.map(
                                                       (_, i) =>
                                                           maxSlippageAmount(
                                                               parseEtherNum(
                                                                   checkData0(pD, `levelLiquidity${i}`),
                                                                   pD[`currency${i}Decimals`]
                                                               ),
                                                               checkData([data, `maxSlippage${removeDataKey}`], autoMaxSlippage)
                                                           )
                                                   ),
                                                   defaultDeadline
                                                   // Number(plus(Math.floor(divide(Date.now(), 1000)), times(checkData([data, `transactionDeadline${removeDataKey}`], defaultDeadlineSecond / 60) || 0, 60)))
                                               ],
                                               hash => addRemoveApi('remove', hash)
                                           )
                                       } else {
                                           toggleShowApprove(tokenDataNeedApprove)
                                           const t1Allowance = () => token1Allowance().then(t1A => t1A > 0
                                                   ? erc20PairPositionApprove(token1Address, t1A, hash => waitForTransactionFunc(hash, t1Allowance))
                                                   : addLiquidity()),
                                               t0Allowance = () => token0Allowance().then(t0A => t0A > 0
                                                   ? erc20PairPositionApprove(token0Address, t0A, hash => waitForTransactionFunc(hash, t0Allowance))
                                                   : t1Allowance()),
                                               allowance = token0IsETH ? t1Allowance : t0Allowance;
                                           isPoolCreate
                                               ? vaultWriteContract(
                                                   'initialize',
                                                   undefined,
                                                   [
                                                       [
                                                           ...addLiquidityTokens,
                                                           feeTierBigInt,
                                                           marginFeeTierBigInt
                                                       ]
                                                   ],
                                                   hash => waitForTransactionFunc(
                                                       hash,
                                                       // () => requestApi(
                                                       //     'margin/pool/initialize',
                                                       //     {
                                                       //         tx: hash,
                                                       //         chainId,
                                                       //         sender: address,
                                                       //         name: tokenDataPoolName
                                                       //     },
                                                       //     'post'
                                                       // ).then(pI => {
                                                       //     poolId = pI
                                                       //     setData({isCreateInitializeEnd: true})
                                                       //     allowance()
                                                       // })
                                                       ({logs}) => {
                                                           setData({marginSuccess: true})
                                                           // poolId = logs[0].topics[0]
                                                           setData({isCreateInitializeEnd: true})
                                                           allowance()
                                                       }))
                                               : allowance()
                                       }
                                   }}
                                   className={`${isPhoneClientWidth ? 'borderRadiusPhone paddingTopBottomPhone' : 'borderRadius paddingTopBottomBig'} flexCenter colorWhite saf1 backgroundActiveColor cursorPointer`}>
                                {needApproveButton(tokenDataNeedApprove, isPoolPositions ? 'Remove' : liquidityButton)}
                            </div>}
                    </div>,
                    undefined,
                    undefined,
                    undefined,
                    isPoolPositions && settingContent(removeDataKey),
                )
            })(),
            togglePositionsPoolIndex = i => !equalTo(positionsPoolIndex, i) && setData({
                positionsPoolIndex: i,
                ...cleanPositionsPools
            }),
            {
                poolId: repayTokenDataPoolId,
                borrowToken: repayTokenDataBorrowToken,
                marginToken: repayTokenDataMarginToken,
                borrowSymbol: repayTokenDataBorrowSymbol = '',
                marginSymbol: repayTokenDataMarginSymbol = '',
                borrowAmountWei: repayTokenDataBorrowAmountWei = 0,
                borrowDecimals: repayTokenDataBorrowDecimals = defaultDecimals,
                marginDecimals: repayTokenDataMarginDecimals = defaultDecimals,
                tokenId: repayTokenDataTokenId,
                marginForOne: repayTokenDataMarginForOne
            } = repayTokenData,
            repayTokenDataBorrowTokenIsETH = isAddress0(repayTokenDataBorrowToken),
            repayTokenDataNewAmount = checkData0(data, 'repayTokenDataNewAmount'),
            repayTokenDataNewAmountWei = checkData([data, 'repayTokenDataNewAmountWei'], 0n),
            repayTokenDataBorrowAmount = checkData0(repayTokenData, 'borrowAmount'),
            repayTokenDataMarginAmount = checkData0(repayTokenData, 'marginAmount'),
            addAPY10 = num => plus(
                num,
                times(
                    divide(
                        divide(
                            divide(
                                times(
                                    num,
                                    divide(
                                        checkData0(repayTokenData, 'apy'),
                                        100
                                    ),
                                ),
                                365
                            ),
                            24
                        ),
                        60
                    ),
                    10
                )
            ),
            repayTokenDataBorrowAmountAPY = num8(ethCarry(formatEther(addAPY10(repayTokenDataBorrowAmountWei), repayTokenDataBorrowDecimals))),
            repayTokenDataNewAmountEligible = Number(repayTokenDataNewAmount) <= repayTokenDataBorrowAmountAPY,
            afterRepayTokenDataBorrowAmount = minus(repayTokenDataBorrowAmountAPY, repayTokenDataNewAmount),
            getRepayTokenPrice = amount => hexToNumber(repayTokenDataBorrowToken) > hexToNumber(repayTokenDataMarginToken)
                ? getAmountOut(amount, false, repayTokenDataPoolId, repayTokenDataMarginDecimals)
                : new Promise(resolve => resolve),
            ethBalance = checkData0(data, 'ethBalance'),
            getTokenBalance = tokenAddress => isAddress0(tokenAddress)
                ? ethBalance
                : checkDataString(tokenBalances, tokenAddress.toLowerCase()),
            increaseDecreaseIndex = checkData0(data, 'increaseDecreaseIndex'),
            isDecrease = increaseDecreaseIndex === 1,
            adjustAfterMarginAmount = (isDecrease ? minus : plus)(repayTokenDataMarginAmount, repayTokenDataNewAmount),
            positionsPoolsContent = (() => {
                const isNoMarginPositions = false,//!isMarginPositions,
                    content = <div style={{borderRadius: '.5rem'}}
                                   className={`boxSizingBorderBox ${isPhoneClientWidth ? 'childrenSpacingTopBigPhone' : 'backgroundWhite height100 flexGrow1 boxShadow paddingBig childrenSpacingTopBig'} flexColumn`}>
                        <div className={'flexCenter justifyContentSpaceBetween'}>
                            {addressData(true)}
                            <img onClick={() => {
                                toggleShowPositionsPools()
                                connect()
                            }} className={'cursorPointer'}
                                 src={requireDefault('Group 427320608')} alt=""
                                 style={{width: `${isPhoneClientWidth ? 2 : .7}rem`}}/>
                        </div>
                        <div
                            className={isPhoneClientWidth ? 'biggerFontSizePhone' : 'biggerFontSize'}>
                            {ethBalance} {coinName}
                        </div>
                        <div className={`flexColumn ${isPhoneClientWidth ? '' : 'flexGrow1Column'}`}>
                            <div style={{
                                paddingTop: `${isPhoneClientWidth ? .9 : .11}rem`,
                                marginBottom: `-${isPhoneClientWidth ? (isNoMarginPositions ? 5 : .9) : (isNoMarginPositions ? 1.2 : .3)}rem`,
                                backgroundSize: 'cover',
                                backgroundRepeat: 'no-repeat',
                                backgroundPosition: 'center center',
                                backgroundImage: `url(${requireDefault(`positions${positionsPoolIndex}`)})`
                            }} className={isPhoneClientWidth ? 'childrenSpacingTopPhone' : 'childrenSpacingTop'}>
                                <div
                                    className={`flex alignItemsCenter childrenFlexGrow1 ${isPhoneClientWidth ? '' : 'marginTopPhone'}`}>
                                    {positionsPools.map((v, i) =>
                                        <pre
                                            onClick={() => togglePositionsPoolIndex(i)}
                                            className={`${i === positionsPoolIndex ? 'saf1 activeColor' : ''} textAlignCenter cursorPointer`}>
                                            {v[0][0]}
                                            <div
                                                className={isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'}>{v[0][1]}</div>
                                        </pre>)}
                                </div>
                                {
                                    <div style={{
                                        paddingTop: `${isPhoneClientWidth ? (isNoMarginPositions ? 3.5 : 1) : (isNoMarginPositions ? .85 : .2)}rem`,
                                        paddingBottom: `${isPhoneClientWidth ? 2.1 : .52}rem`
                                    }}
                                         className={`${isPhoneClientWidth ? 'paddingPhone' : 'padding'} childrenSpacingLeft flexCenter childrenFlexGrow1`}>
                                        {(isPoolPositions
                                            ? [
                                                [isLiquidityPool ? 'Liquidity' : 'Supply', true],
                                                []
                                            ]
                                            : [
                                                ['Current Positions', !isHistory, false],
                                                ['Position History', isHistory, true]
                                            ]).map(v => <div style={{padding: `${isPhoneClientWidth ? .4 : .085}rem 0`}}
                                                             onClick={() => !isPoolPositions && !!isHistory !== v[2] && setData({
                                                                 isHistory: v[2],
                                                                 // [listLoadingKey]: undefined,
                                                                 [positionsPoolPageKey]: defaultPage
                                                             })}
                                                             className={`flexCenter borderRadius999 ${v[1] ? `backgroundWhite ${
                                                                 isPhoneClientWidth ? 'borderSmallGrayLinePhone' : 'borderSmallGrayLine'
                                                             }` : ''} ${isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'} cursorPointer`}>
                                            {v[0]}
                                            {v[1] && <img src={requireDefault('Group 427320172-1')} alt=""
                                                          className={isPhoneClientWidth ? 'paddingLeftSmallPhone' : 'paddingLeftSmall'}
                                                          style={square(`${isPhoneClientWidth ? 1.5 : .4}rem`)}
                                                          onClick={e => {
                                                              e.stopPropagation()
                                                              setData({[listLoadingKey]: undefined})
                                                              isFirstPage(checkData([data, positionsPoolPageKey], defaultPage))
                                                                  ? getPositionPool(isPoolPositions ? 1 : 0)
                                                                  : setData({
                                                                      [positionsPoolPageKey]: defaultPage
                                                                  })
                                                          }}
                                            />}
                                        </div>)}
                                    </div>
                                }
                            </div>
                            {positionsPools[positionsPoolIndex][1]}
                        </div>
                    </div>,
                    repayTokenDataBorrowBalance = checkData0(repayTokenData, 'borrowBalance'),
                    repayAmount = checkData0(data, 'repayAmount'),
                    repayMaxBalance = isLiquidateCall
                        ? numberETH(repayAmount, repayTokenDataBorrowDecimals)
                        : (lessThanOrEqualTo(repayTokenDataBorrowBalance, repayTokenDataBorrowAmountAPY) ? repayTokenDataBorrowBalance : repayTokenDataBorrowAmountAPY),
                    repayAdjust = showApprove
                        ? approveContent([{
                            ...repayTokenData,
                            symbol: showRepaying ? repayTokenDataBorrowSymbol : repayTokenDataMarginSymbol
                        }])
                        : <div style={isPhoneClientWidth ? {marginBottom: '2rem'} : {}}
                               onClick={() => {
                                   if (showRepaying && isLiquidateCall && lessThan(repayTokenDataBorrowBalance, repayMaxBalance)) {
                                       toast('Insufficient balance')
                                   } else {
                                       const repayToken = showRepaying ? repayTokenDataBorrowToken : repayTokenDataMarginToken,
                                           amountWei = showRepaying
                                               ? (isLiquidateCall
                                                       ? toInt(addAPY10(repayAmount))
                                                       : repayTokenDataNewAmountWei
                                               )
                                               : (BigInt(times(repayTokenDataNewAmountWei, isDecrease ? -1 : 1))),
                                           iA0 = isAddress0(repayToken),
                                           repay = () => marginPositionWriteContract(
                                               showRepaying ? (isLiquidateCall ? 'liquidateCall' : 'repay') : 'modify',
                                               (iA0 && amountWei > 0) ? amountWei : undefined,
                                               [
                                                   repayTokenDataTokenId,
                                                   ...(showRepaying && isLiquidateCall)
                                                       ? [defaultDeadline]
                                                       : [
                                                           amountWei,
                                                           ...showRepaying ? [defaultDeadline] : []
                                                       ]
                                               ],
                                               hash => waitForTransactionFunc(
                                                   hash,
                                                   () => {
                                                       searchPositionPool(0)
                                                       toggleShowLoading()
                                                       toggleShowRepaying()
                                                       toastSuccessful(hash)
                                                   }
                                               )),
                                           rTAllowance = isSet => erc20MarginPositionAllowance(repayToken, amountWei)
                                               .then(a => {
                                                   const needApprove = a > 0
                                                   setData({
                                                       repayTokenData: {
                                                           ...repayTokenData, needApprove
                                                       }
                                                   });
                                                   (needApprove ? () => {
                                                       isSet && toggleShowApprove(isSet);
                                                       erc20MarginPositionApprove(repayToken, a, hash => waitForTransactionFunc(hash, rTAllowance))
                                                   } : repay)()
                                               });
                                       showRepaying && lessThanOrEqualTo(amountWei)
                                           ? toast('Amount must be greater than zero.')
                                           : (iA0 ? repay() : rTAllowance(true))
                                   }
                               }}
                               className={`${isPhoneClientWidth ? 'borderRadiusPhone paddingTopBottomPhone' : 'borderRadius paddingTopBottomBig'} flexCenter colorWhite saf1 backgroundActiveColor cursorPointer`}>
                            {showRepaying ? 'Repay' : 'Adjust'}
                        </div>,
                    setRepayTokenNewAmount = async (nA, newAmountWei, changeRange = true) => {
                        const newAmountWeiIsNotNull = isNotNull(newAmountWei),
                            newAmount = newAmountWeiIsNotNull ? numberETH(newAmountWei, showAdjust ? repayTokenDataMarginDecimals : repayTokenDataBorrowDecimals) : getSetNewAmount(nA)
                        newAmountWei = newAmountWeiIsNotNull ? newAmountWei : parseEtherNum(newAmount, showAdjust ? repayTokenDataMarginDecimals : repayTokenDataBorrowDecimals)
                        setData({
                            repayTokenDataNewAmount: newAmount,
                            repayTokenDataNewAmountWei: newAmountWei,
                            ...showClosePosition && changeRange ? {
                                range: toInt(times(divide(newAmount, repayTokenDataBorrowAmount), 100))
                            } : {}
                        })
                    },
                    increaseDecrease = ['Increase', 'Decrease']
                return [isPhoneClientWidth ? maskContent(undefined, showPositionsPools, toggleShowPositionsPools, content) :
                    <div
                        className={`positionFixed boxSizingBorderBox flex childrenSpacingLeft positionsPools${showPositionsPools ? 'Show' : ''}`}
                        style={{
                            top: 0,
                            zIndex: 999,
                            width: '29.5vw',
                            height: '100vh',
                            padding: '.2rem',
                            paddingBottom: '1rem'
                        }}
                    >
                        <img onClick={() => toggleShowPositionsPools()} src={requireDefault('retract')} alt=""
                             className={'cursorPointer'}
                             style={{...square('.7rem'), marginTop: '.7rem'}}/>
                        {content}
                    </div>,
                    maskContent(
                        `Adjust ${isBorrowPositions ? 'Collacteral' : 'Margin'}`,
                        showAdjust,
                        toggleShowAdjust,
                        (() => {
                            const repayTokenDataBalance = checkData0(repayTokenData, 'balance'),
                                repayTokenIsETHPool = [repayTokenDataBorrowToken, repayTokenDataMarginToken].includes(address0),
                                {marginBalance, maxDecrease} = repayTokenData,
                                // maxBalance = isDecrease ? (lessThanOrEqualTo(marginBalance, maxDecrease) ? marginBalance : maxDecrease) : marginBalance,
                                maxBalance = isDecrease ? maxDecrease : marginBalance,
                                repayTokenDataMarginIsETH = isAddress0(repayTokenDataMarginToken)
                            return <div
                                className={isPhoneClientWidth ? 'childrenSpacingTopBiggerPhone' : 'childrenSpacingTopBigger'}>
                                <div/>
                                <div
                                    className={isPhoneClientWidth ? 'childrenSpacingTopBigPhone' : 'childrenSpacingTopBig'}>
                                    <div
                                        className={`flex alignItemsCenter ${isPhoneClientWidth ? 'childrenSpacingLeftPhone' : 'childrenSpacingLeft'}`}>
                                        {increaseDecrease.map((v, i) => <div
                                            style={{padding: isPhoneClientWidth ? '.3rem .9rem' : '.1rem .3rem'}}
                                            onClick={() => setData({increaseDecreaseIndex: i})}
                                            className={`cursorPointer borderRadius999 ${increaseDecreaseIndex === i ? 'backgroundGrey saf1' : ''}`}>
                                            {v}
                                        </div>)}
                                    </div>
                                    <div
                                        className={`backgroundGrey ${isPhoneClientWidth ? 'paddingBigPhone borderRadiusPhone borderSmallGrayLinePhone childrenSpacingTopPhone' : 'paddingBig borderRadius borderSmallGrayLine childrenSpacingTop'}`}>
                                        <div
                                            className={`flex alignItemsCenter justifyContentSpaceBetween ${isPhoneClientWidth ? 'childrenSpacingLeftPhone' : 'childrenSpacingLeft'}`}>
                                            <input type="text"
                                                   placeholder='0'
                                                   value={checkDataString(data, 'repayTokenDataNewAmount')}
                                                   onChange={e => setRepayTokenNewAmount(e.target.value)}
                                                   className={`${isPhoneClientWidth ? 'biggerFontSizePhone' : 'biggerFontSize'} flexGrow1`}/>
                                            <div
                                                className={`borderRadius999 saf flexCenter ${isPhoneClientWidth ? 'borderSmallGrayLinePhone childrenSpacingLeftPhone' : 'borderSmallGrayLine childrenSpacingLeft'}`}
                                                style={{
                                                    height: `${isPhoneClientWidth ? 2.5 : .8}rem`,
                                                    padding: `0 ${isPhoneClientWidth ? .7 : .3}rem`,
                                                }}>
                                                {tokenIcon({
                                                    tokenAddress: repayTokenDataMarginToken,
                                                    symbol: repayTokenDataMarginSymbol,
                                                    avatar: repayTokenDataMarginIsETH ? ethAvatar : repayTokenData.marginAvatar
                                                }, `${isPhoneClientWidth ? 1.5 : .5}rem`)}
                                                <div>{repayTokenDataMarginSymbol}</div>
                                            </div>
                                        </div>
                                        <div className={'flexCenter justifyContentSpaceBetween'}>
                                            <div
                                                className={`${isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'} colorGray`}>
                                                {/*{repayTokenIsETHPool ? checkData0(repayTokenData, isDecrease ? 'maxDecreasePrice' : 'marginBalancePrice') : ''}*/}
                                            </div>
                                            <div
                                                className={`flexCenter ${isPhoneClientWidth ? 'childrenSpacingLeftPhone' : 'childrenSpacingLeft'}`}>
                                                {(() => {
                                                    return [
                                                        <div
                                                            className={`${isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'}`}>
                                                            {maxBalance} {repayTokenDataMarginSymbol}
                                                        </div>,
                                                        <div style={{fontSize: `${isPhoneClientWidth ? .6 : .15}rem`}}
                                                             onClick={() => setRepayTokenNewAmount(maxBalance)}
                                                             className={`backgroundActiveColor ${isPhoneClientWidth ? 'paddingSmallPhone' : 'paddingSmall'} borderRadius999 colorWhite cursorPointer`}>
                                                            MAX
                                                        </div>
                                                    ]
                                                })()}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {(() => {
                                    const markPrice = divide(
                                            apiNumETH(checkData0(repayTokenData, `reserve${repayTokenDataMarginForOne ? 1 : 0}`), repayTokenDataMarginDecimals),
                                            apiNumETH(checkData0(repayTokenData, `reserve${repayTokenDataMarginForOne ? 0 : 1}`), repayTokenDataBorrowDecimals)
                                        ),
                                        {
                                            marginAmount, borrowAmount, marginTotal
                                        } = repayTokenData
                                    return <div
                                        className={isPhoneClientWidth ? 'childrenSpacingTopPhone' : 'childrenSpacingTop'}>
                                        {!isBorrowPositions && <div className={'flexCenter justifyContentSpaceBetween'}>
                                            <div
                                                className={`colorGray ${isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'}`}>
                                                Liq.Price
                                            </div>
                                            {rightArrowText(
                                                ...[marginAmount, adjustAfterMarginAmount].map(v => {
                                                    const num = divide(
                                                        plus(
                                                            marginTotal,
                                                            v
                                                        ),
                                                        times(
                                                            1.1,
                                                            borrowAmount
                                                        )
                                                    )
                                                    return [
                                                        `${num8(repayTokenDataMarginForOne ? divide(1, num) : num)} ${
                                                            checkDataString(repayTokenData.t0Symbol)
                                                        }`,
                                                        // <span
                                                        //     className={`colorGray ${isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'}`}>{
                                                        //     repayTokenDataMarginIsETH ? ` (${getTokenUSDTPrice(num)})` : ''
                                                        // }</span>
                                                    ]
                                                }))}
                                        </div>}
                                        <div className={'flexCenter justifyContentSpaceBetween'}>
                                            <div
                                                className={`colorGray ${isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'}`}>
                                                Margin Level
                                            </div>
                                            {rightArrowText(
                                                ...(isBorrowPositions
                                                    ? [
                                                        checkData0(repayTokenData, 'borrowListMarginLevel'),
                                                        checkData0(data, 'afterBorrowListMarginLevel')
                                                    ]
                                                    : [marginAmount, adjustAfterMarginAmount].map(v =>
                                                            percentageNum(
                                                                toFixed(
                                                                    divide(
                                                                        plus(parseEtherNum(v, repayTokenDataMarginDecimals), checkData0(repayTokenData, 'marginTotalWei')),
                                                                        times(checkData0(repayTokenData, 'markTokenNum'), repayTokenDataBorrowAmountWei)
                                                                    ),
                                                                    2
                                                                )
                                                            )
                                                        // {
                                                        //     return `${num8(divide(minus(times(markPrice, borrowAmount), marginTotal), v))}`
                                                        // }
                                                    ))
                                            )}
                                        </div>
                                    </div>
                                })()}
                                {repayAdjust}
                            </div>
                        })()),
                    maskContent(
                        `You’re Repaying${isLiquidateCall ? ' for Liquidation' : ''}`,
                        showRepaying,
                        toggleShowRepaying,
                        (() => {
                            const repayTokenDataBalance = checkData0(repayTokenData, 'borrowBalance'),
                                repayTokenIsETHPool = [repayTokenDataBorrowToken, repayTokenDataMarginToken].includes(address0)
                            return <div
                                className={isPhoneClientWidth ? 'childrenSpacingTopBiggerPhone' : 'childrenSpacingTopBigger'}>
                                <div/>
                                <div
                                    className={isPhoneClientWidth ? 'paddingBigPhone borderRadiusPhone borderSmallGrayLinePhone childrenSpacingTopPhone' : 'paddingBig borderRadius borderSmallGrayLine childrenSpacingTop'}>
                                    <div
                                        className={`colorGray ${isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'}`}>Amount
                                    </div>
                                    <div
                                        className={`flex alignItemsCenter justifyContentSpaceBetween ${isPhoneClientWidth ? 'childrenSpacingLeftPhone' : 'childrenSpacingLeft'}`}>
                                        <input type="text"
                                               placeholder='0'
                                               disabled={isLiquidateCall}
                                               value={isLiquidateCall ? repayMaxBalance : checkData([data, 'repayTokenDataNewAmount'])}
                                               onChange={e => setRepayTokenNewAmount(e.target.value)}
                                               className={`${isPhoneClientWidth ? 'biggerFontSizePhone' : 'biggerFontSize'} flexGrow1`}/>
                                        <div
                                            className={`borderRadius999 saf flexCenter ${isPhoneClientWidth ? 'borderSmallGrayLinePhone childrenSpacingLeftPhone' : 'borderSmallGrayLine childrenSpacingLeft'}`}
                                            style={{
                                                height: `${isPhoneClientWidth ? 2.5 : .8}rem`,
                                                padding: `0 ${isPhoneClientWidth ? .7 : .3}rem`,
                                            }}>
                                            {tokenIcon({
                                                tokenAddress: repayTokenDataBorrowToken,
                                                symbol: repayTokenDataBorrowSymbol, avatar: repayTokenData.borrowAvatar
                                            }, `${isPhoneClientWidth ? 1.5 : .5}rem`)}
                                            <div>{repayTokenDataBorrowSymbol}</div>
                                        </div>
                                    </div>
                                    <div className={'flexCenter justifyContentSpaceBetween'}>
                                        <div
                                            className={`${isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'} colorGray`}>
                                            {/*{repayTokenIsETHPool ? getTokenUSDTPrice(repayTokenDataBorrowTokenIsETH ? repayTokenDataNewAmount : checkData0(repayTokenData, 'price')) : ''}*/}
                                        </div>
                                        {!isLiquidateCall && <div
                                            className={`flexCenter ${isPhoneClientWidth ? 'childrenSpacingLeftPhone' : 'childrenSpacingLeft'}`}>
                                            {(() => {
                                                return [
                                                    <div
                                                        className={`${isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'}`}>
                                                        {repayMaxBalance} {repayTokenDataBorrowSymbol}
                                                    </div>,
                                                    <div style={{fontSize: `${isPhoneClientWidth ? .6 : .15}rem`}}
                                                         onClick={() => setRepayTokenNewAmount(repayMaxBalance)}
                                                         className={`backgroundActiveColor ${isPhoneClientWidth ? 'paddingSmallPhone' : 'paddingSmall'} borderRadius999 colorWhite cursorPointer`}>MAX
                                                    </div>
                                                ]
                                            })()}
                                        </div>}
                                    </div>
                                </div>
                                <div
                                    className={isPhoneClientWidth ? 'smallerFontSizePhone' : 'smallerFontSize'}>
                                    Transaction overview
                                </div>
                                {!isLiquidateCall && <div
                                    className={isPhoneClientWidth ? 'childrenSpacingTopPhone' : 'childrenSpacingTop'}>
                                    <div className={'flexCenter justifyContentSpaceBetween'}>
                                        <div
                                            className={`colorGray ${isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'}`}>
                                            Remaining Debt
                                        </div>
                                        {rightArrowText(...[repayTokenDataBorrowAmountAPY, afterRepayTokenDataBorrowAmount]
                                            .map(v => `${v} ${checkDataString(repayTokenDataBorrowSymbol)}`))}
                                    </div>
                                    {/*<div className={'flexCenter justifyContentSpaceBetween'}>*/}
                                    {/*    <div*/}
                                    {/*        className={`colorGray ${isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'}`}>Debt*/}
                                    {/*    </div>*/}
                                    {/*    {repayTokenIsETHPool && <div*/}
                                    {/*        className={`colorGray ${isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'}`}>*/}
                                    {/*        {*/}
                                    {/*            getTokenUSDTPrice(*/}
                                    {/*                repayTokenDataBorrowTokenIsETH*/}
                                    {/*                    ? repayTokenDataBorrowAmount*/}
                                    {/*                    : checkData0(repayTokenData, 'borrowPrice')*/}
                                    {/*            )*/}
                                    {/*        } → {*/}
                                    {/*        getTokenUSDTPrice(*/}
                                    {/*            repayTokenDataBorrowTokenIsETH*/}
                                    {/*                ? minus(afterRepayTokenDataBorrowAmount)*/}
                                    {/*                : checkData0(repayTokenData, 'afterBorrowPrice')*/}
                                    {/*        )}*/}
                                    {/*    </div>}*/}
                                    {/*</div>*/}
                                </div>}
                                {
                                    isBorrowPositions
                                        ? []
                                        : [
                                            <div
                                                className={isPhoneClientWidth ? 'childrenSpacingTopPhone' : 'childrenSpacingTop'}>
                                                <div className={'flexCenter justifyContentSpaceBetween'}>
                                                    <div
                                                        className={`colorGray ${isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'}`}>
                                                        Liq.Price
                                                    </div>
                                                    <div
                                                        className={isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'}>{checkDataString(repayTokenData, 'liqToken')}</div>
                                                </div>
                                                {/*<div className={'flexCenter justifyContentSpaceBetween'}>*/}
                                                {/*    <div*/}
                                                {/*        className={`colorGray ${isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'}`}></div>*/}
                                                {/*    <div*/}
                                                {/*        className={`colorGray ${isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'}`}>*/}
                                                {/*        {repayTokenIsETHPool ? `${checkDataString(repayTokenData, 'liqPrice')}` : ''}*/}
                                                {/*    </div>*/}
                                                {/*</div>*/}
                                            </div>,
                                            <img src={requireDefault('Line 4')} alt="" className={'width100'}/>,
                                            <div className={'flexCenter justifyContentSpaceBetween'}>
                                                <div
                                                    className={`colorGray ${isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'}`}>Margin
                                                </div>
                                                <div
                                                    className={`colorGreen saf1 ${isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'}`}>
                                                    {(() => {
                                                        const num = plus(checkData0(repayTokenData, 'marginAmount'), checkData0(repayTokenData, 'marginTotal'))
                                                        return num8(
                                                            isLiquidateCall
                                                                ? num
                                                                : times(
                                                                    divide(repayTokenDataNewAmount, repayTokenDataBorrowAmount),
                                                                    num
                                                                )
                                                        )
                                                    })()} {repayTokenDataMarginSymbol}
                                                </div>
                                            </div>
                                        ]
                                }
                                {repayAdjust}
                            </div>
                        })()),
                    maskContent(
                        'Close Position',
                        showClosePosition,
                        toggleShowClosePosition,
                        (() => {
                            const closePNL = checkData0(data, 'closePNL'), closePNLLessThan = lessThan(closePNL, 0),
                                closeMinAmount = maxSlippageAmount(
                                    parseEtherNum(checkData0(data, 'closeAmount'), repayTokenDataMarginDecimals),
                                    autoMaxSlippage
                                )
                            return <div
                                className={isPhoneClientWidth ? 'childrenSpacingTopBiggerPhone' : 'childrenSpacingTopBigger'}>
                                <div
                                    className={isPhoneClientWidth ? 'childrenSpacingTopBigPhone' : 'childrenSpacingTopBig'}>
                                    {closePositionData(true, repayTokenData)}
                                </div>
                                <div
                                    className={`${isPhoneClientWidth ? 'childrenSpacingTopBigPhone paddingBigPhone borderRadiusPhone borderSmallGrayLinePhone' : 'childrenSpacingTopBig paddingBig borderRadius borderSmallGrayLine'}`}>
                                    <div
                                        className={`flex alignItemsCenter ${isPhoneClientWidth ? 'childrenSpacingLeftPhone' : 'childrenSpacingLeft'} justifyContentSpaceBetween`}>
                                        <input type="text"
                                               placeholder='0'
                                               value={checkData([data, 'repayTokenDataNewAmount'])}
                                               onChange={e => setRepayTokenNewAmount(e.target.value)}
                                               className={`${isPhoneClientWidth ? 'biggerFontSizePhone' : 'biggerFontSize'} flexGrow1`}/>
                                        <div
                                            className={`borderRadius999 saf flexCenter ${isPhoneClientWidth ? 'borderSmallGrayLinePhone childrenSpacingLeftPhone' : 'borderSmallGrayLine childrenSpacingLeft'}`}
                                            style={{
                                                height: `${isPhoneClientWidth ? 2.5 : .8}rem`,
                                                padding: `0 ${isPhoneClientWidth ? .7 : .3}rem`,
                                            }}>
                                            {tokenIcon({
                                                tokenAddress: repayTokenDataBorrowToken,
                                                symbol: repayTokenDataBorrowSymbol,
                                                avatar: isAddress0(repayTokenDataBorrowToken) ? ethAvatar : repayTokenData.borrowAvatar
                                            }, `${isPhoneClientWidth ? 1.5 : .5}rem`)}
                                            <div>{repayTokenDataBorrowSymbol}</div>
                                        </div>
                                    </div>
                                    {/*<Slider min={0} max={100} step={25} value={range}*/}
                                    {/*        dots={true}*/}
                                    {/*        onChange={range => setData({range})}*/}
                                    {/*/>*/}
                                    {rangeContent(range => setRepayTokenNewAmount(undefined, times(repayTokenDataBorrowAmountWei, divide(range, 100)), false))}
                                </div>
                                <div
                                    className={isPhoneClientWidth ? 'childrenSpacingTopBigPhone' : 'childrenSpacingTopBig'}>
                                    <div className={'flexCenter justifyContentSpaceBetween'}>
                                        <div
                                            className={`colorGray ${isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'}`}>
                                            Estimated PNL
                                        </div>
                                        <div
                                            className={`saf1 ${isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'} 
                                    ${closePNLLessThan ? 'colorRed' : 'colorGreen'}`}>{
                                            closePNL
                                        } {checkDataString(repayTokenData.marginSymbol)}</div>
                                    </div>
                                    {(() => {
                                        const [a1, b] = feeDataFunc('closeFee')
                                        return <div className={'flexCenter justifyContentSpaceBetween'}>
                                            {showFeeData(a1, b)}
                                            <div
                                                className={`colorGray ${isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'}`}>
                                                {(() => {
                                                    const feeAmount = formatEther(checkData0(data, 'closeFeeAmount'), repayTokenDataMarginDecimals)
                                                    return `${num8(feeAmount)} ${repayTokenDataMarginSymbol}`//isAddress0(repayTokenDataMarginToken) ? getTokenUSDTPrice(feeAmount) : `${num8(feeAmount)} ${repayTokenDataMarginSymbol}`
                                                })()}
                                            </div>
                                        </div>
                                    })()}
                                    <div className={'flexCenter justifyContentSpaceBetween'}>
                                        <div
                                            className={`colorGray ${isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'}`}>
                                            Max Slippage
                                        </div>
                                        <div
                                            className={`flexCenter justifyContentSpaceBetween ${isPhoneClientWidth ? 'childrenSpacingLeftSmallPhone' : 'childrenSpacingLeftSmall'}`}>
                                            <div
                                                className={`colorGray ${isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'}`}>Auto
                                            </div>
                                            <div
                                                className={`${isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'}`}>{autoMaxSlippage}%
                                            </div>
                                        </div>
                                    </div>
                                    <div className={'flexCenter justifyContentSpaceBetween'}>
                                        <div
                                            className={`colorGray ${isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'}`}>
                                            Min. Received
                                        </div>
                                        <div
                                            className={`colorGray ${isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'}`}>{
                                            numberETH(closeMinAmount, repayTokenDataMarginDecimals)
                                        } {checkDataString(repayTokenData.marginSymbol)}</div>
                                    </div>
                                </div>
                                {highDynamicFees(feeDataFunc('closeFee')[1])}
                                <div style={isPhoneClientWidth ? {marginBottom: '2rem'} : {}}
                                     onClick={() => marginPositionWriteContract(
                                         'close',
                                         undefined,
                                         [
                                             repayTokenDataTokenId,
                                             BigInt(toInt(times(range, 10000))),
                                             toInt(closeMinAmount),
                                             defaultDeadline
                                         ],
                                         hash => waitForTransactionFunc(
                                             hash,
                                             () => {
                                                 searchPositionPool(0)
                                                 toggleShowLoading()
                                                 toggleShowRepaying()
                                                 toastSuccessful(hash)
                                             }
                                         ))}
                                     className={`${isPhoneClientWidth ? 'borderRadiusPhone paddingTopBottomPhone' : 'borderRadius paddingTopBottomBig'} flexCenter colorWhite saf1 backgroundActiveColor cursorPointer`}>
                                    Close
                                </div>
                            </div>
                        })()), liquidityContent]
            })(),
            searchName = checkData([data, 'searchName']),
            inputSearchName = checkData([data, 'inputSearchName']),
            clearSearchName = () => setData({searchName: '', inputSearchName: ''}),
            debounceSetSearchName = useCallback(
                debounce((value) => {
                    setData({searchName: value})
                }, 500),
                []
            ),
            setInputSearchName = value => {
                setData({inputSearchName: value})
                debounceSetSearchName(value)
            },
            searchNameToLowerCase = checkDataString(searchName).toLowerCase(),
            allTokensIncludesSearchName = allTokens.map(v => checkDataString(v, 'tokenAddress').toLowerCase()).includes(searchNameToLowerCase),
            searchNameIsNotNull = isNotNullOrEmpty(searchName),
            setPage = (page = defaultPage) => setData({page}),
            searchNameIsETHAddress = isETHAddress(searchName),
            erc20ContractData = async (tokenAddress, noLoading) => {
                !noLoading && toggleShowLoading(true)
                // 进一步验证是否符合 ERC-20 标准 (可选)
                try {
                    const obj = {tokenAddress}
                    for (const method of ['name', 'symbol', 'decimals', 'totalSupply', 'balanceOf']) {
                        const value = await (new slaveContractETH.Contract(erc20Abi, tokenAddress)).methods[method](...method === 'balanceOf' ? [address0] : []).call();
                        if (['name', 'symbol', 'decimals'].includes(method)) {
                            obj[method] = checkDataString(value).toString()
                        }
                    }
                    !noLoading && toggleShowLoading()
                    return obj; // 符合 ERC-20 接口
                } catch (error) {
                    !noLoading && toggleShowLoading()
                    return null; // 不符合 ERC-20 标准
                }
            },
            toggleShowTokenDetail = (showTokenDetail, v) => setData({showTokenDetail, tokenDetail: v}),
            {watchAssetAsync} = useWatchAsset(),
            watchAsset = (arr, symbol, decimals) => switchEthereumChain(
                async () => {
                    toggleShowLoading(true)
                    watchAssetAsync({
                        type: 'ERC20',
                        options: {
                            address: arr,
                            ...isNotNull(symbol) && isNotNull(decimals)
                                ? {
                                    symbol,
                                    decimals
                                }
                                : checkDataObject(await erc20ContractData(arr, true)),
                            image: getTokenIcon(arr)
                        }
                    }).then(() => {
                        toggleShowLoading()
                        toastSuccessful(true)
                    }).catch(e => {
                        toggleShowLoading()
                        toast(checkDataString(e, 'details'))
                    })
                },
                () => {
                    toggleShowSelectToken()
                    toggleShowTokenDetail()
                },
                true
            ),
            getPoolsIng = checkDataBool(data, 'getPoolsIng'),
            getTokensPools = (iST = isSelectToken, otherData = {}) => {
                const iFP = isFirstPage(),
                    setGetPoolsIng = getPoolsIng => setData({getPoolsIng});
                iFP && setGetPoolsIng(true);
                (
                    iFP && urlPoolId && !(isPoolDetail && iST)
                        ? getPoolDetail(urlPoolId)
                        : new Promise(resolve => resolve())
                ).then(async urlPool => {
                    if (iST && searchNameIsNotNull && await searchNameIsETHAddress) {
                        erc20ContractData(searchName).then(v => {
                            const vIsNotNull = isNotNull(v)
                            setData({tokens: vIsNotNull ? [v] : [], tokensTotal: vIsNotNull ? 1 : 0})
                        }).finally(() => setGetPoolsIng())
                    } else {
                        const obj = {
                            chainId, ...searchNameIsNotNull ? {
                                [iST ? 'symbol' : (
                                    isETHAddress(searchName)
                                        ? 'token'
                                        : 'name'
                                )]: searchName
                            } : {}
                        };
                        (
                            isPoolDetail && !iST
                                ? new Promise(resolve => resolve())
                                : requestApi(
                                    ...iST
                                        ? [`token/trending/${chainId}`, undefined]
                                        : [
                                            'margin/pool',
                                            {page, pageSize: isPoolList ? 30 : pageSize, ...obj, ...otherData}
                                        ], undefined, undefined, true)
                        ).then(async v => {
                            const arr = checkDataArray(...iST ? [v] : [v, 'items']),
                                arr1 = iST
                                    ? arr.map(v => ({
                                        ...v,
                                        avatar: v.logo,
                                        tokenAddress: v.address,
                                    }))
                                    : await (async () => {
                                        const arr1 = []
                                        await new Promise(async resolve => {
                                            if (isNotNullOrEmpty(arr)) {
                                                for (const i in arr) {
                                                    const v = arr[i]
                                                    arr1.push({
                                                        ...v,
                                                        currency0Decimals: await erc20CallDecimals(v.currency0),
                                                        currency1Decimals: await erc20CallDecimals(v.currency1),
                                                    });
                                                    i === minus(arr.length, 1) && resolve(arr1)
                                                }
                                            } else {
                                                resolve(arr1)
                                            }
                                        })
                                        return arr1
                                    })()
                            setData({
                                [iST ? 'tokens' : 'pools']:
                                    [
                                        ...iFP ? [] : pools,
                                        ...arr1
                                    ],
                                ...isNotNull(urlPool) ? {urlPools: [urlPool], urlPoolGetEnd: true} : {},
                                [iST ? 'tokensTotal' : 'poolsTotal']: iST ? arr.length : checkData0(v, 'total'),
                                ...!iST && Object.keys(poolData).length === 0
                                    ? {poolData: isNotNull(urlPool) ? urlPool : arr1[0]}
                                    : {}
                            })
                            setGetPoolsIng()
                            toggleShowLoading()
                        }).catch(() => setGetPoolsIng())
                    }
                }).catch(() => setGetPoolsIng())
            },
            searchToken = iST => isFirstPage() ? getTokensPools(iST) : setPage(),
            tokensPoolsScroll = React.createRef(),
            tokensPoolsOnScroll = () => onScrollFunc(tokensPoolsScroll, isSelectToken ? tokens : pools, checkData0(data, isSelectToken ? 'tokensTotal' : 'poolsTotal'), () => setPage(page + 1)),
            yourPoolsScroll = React.createRef(),
            claimedHistorysScroll = React.createRef(),
            tokenABPool = (tokenA, tokenB, setShowLoading, isList) => {
                setShowLoading && toggleShowLoading(true)
                return requestApi('margin/token/pool', {
                    chainId, tokenA, tokenB
                }).then(v => {
                    setShowLoading && toggleShowLoading()
                    return isList ? checkDataArray(v) : checkData([v, 0])
                })
            },
            searchAddressTokening = checkDataBool(data, 'searchAddressTokening'),
            toggleShowResearch = showResearch => setData({
                showResearch
            }),
            researchMask = maskContent(
                'Always do your research',
                checkDataBool(data, 'showResearch'),
                toggleShowResearch,
                <div
                    className={isPhoneClientWidth ? 'childrenSpacingTopBigPhone' : 'childrenSpacingTopBig'}>
                    <div>Anyone can create a token, including creating fake versions of existing
                        tokens that claim to represent projects. If you purchase this token, you
                        may not be able to sell it back.
                    </div>
                    <div onClick={() => toggleShowResearch()}
                         className={`${isPhoneClientWidth ? 'borderRadiusPhone paddingTopBottomPhone' : 'borderRadius paddingTopBottomBig'} flexCenter colorWhite saf1 backgroundActiveColor cursorPointer`}>
                        Confirm
                    </div>
                </div>,
                undefined,
                undefined,
                true
            ),
            showResearchIcon = v => !checkData([v, 'trending'], true) &&
                <img
                    className={'cursorPointer'}
                    onClick={event => {
                        event.stopPropagation()
                        toggleShowResearch(true)
                    }}
                    src={requireDefault('More info1')}
                    alt=""
                    style={{width: `${isPhoneClientWidth ? 1.2 : .4}rem`}}/>,
            selectTokenContent = (() => {
                const selectTokenOrPool = async v => {
                        const tokenAddress = checkDataString(v, 'tokenAddress'),
                            otherSelectTokenIndex = selectTokenIndex ? 0 : 1
                        let pD = {}
                        if (isSelectTokenNotNeedToken) {
                            const params = [tokenAddress, checkDataString(tokenDatas, otherSelectTokenIndex, 'tokenAddress')]
                            pD = checkDataObject(await tokenABPool(...selectTokenIndex ? params.reverse() : params, true))
                            Object.keys(pD).length === 0 && toast('Pool does not exist')
                        }
                        if (isSelectToken) {
                            setRecentSearchTokens(v)
                            if (!isPoolNeedUrlPoolId || isMarginOrTradeSupply) {
                                localStorage.setItem(pageTokenKey(selectTokenIndex), JSON.stringify(v))
                            }
                        } else {
                            localStorage.setItem(recentSearchesPoolsKey, JSON.stringify([
                                v,
                                ...recentSearchesPools.filter(v1 => v1.poolId !== v.poolId)
                            ]))
                        }
                        setData({
                            [isSelectToken ? `token${selectTokenIndex}Data` : 'poolData']: {
                                ...v,
                                ...isSelectToken
                                    ? {
                                        newAmount: undefined,
                                        newAmountWei: undefined,
                                        ...address
                                            ? await erc20CallBalance(checkDataString(tokenDatas, selectTokenIndex, 'tokenAddress').toLocaleLowerCase()).then(([balance, decimals]) => ({
                                                decimals, balance: numberETH(balance, decimals)
                                            }))
                                            : {}
                                    }
                                    : {}
                            },
                            ...isSelectTokenNotNeedToken
                                ? {poolData: pD}
                                : {},
                            // ...(isSelectToken && tokenAddress.toLocaleLowerCase() === checkDataString(tokenDatas, otherSelectTokenIndex, 'tokenAddress').toLocaleLowerCase())
                            //     ? {
                            //         [`token${otherSelectTokenIndex}Data`]: checkDataObject(tokenDatas, selectTokenIndex)
                            //     }
                            //     : {},
                            ...isSwap
                                ? {
                                    newAmount: undefined,
                                    newAmountWei: undefined,
                                    transitionPrice: undefined
                                }
                                : {}
                        })
                        if (!isSelectToken) {
                            setTokenData(token0Data, {
                                newAmount: undefined,
                                newAmountWei: undefined
                            })
                            setTokenData(token1Data, {
                                newAmount: undefined,
                                newAmountWei: undefined
                            })
                        }
                        toggleShowSelectToken()
                    },
                    toggleShowImportToken = (showImportToken, v) => setData({showImportToken, tokenDetail: v}),
                    tokenDetail = checkDataObject(data, 'tokenDetail')
                return [
                    maskContent(
                        `Select a ${isSelectToken ? 'Token' : 'Pool'}`,
                        showSelectToken,
                        toggleShowSelectToken,
                        [
                            <div
                                className={`borderRadius999 ${isPhoneClientWidth ? 'paddingPhone childrenSpacingLeftPhone' : 'padding childrenSpacingLeft'} flex alignItemsCenter backgroundGrey`}>
                                <img src={requireDefault('search')}
                                     alt=""
                                    // className={'cursorPointer'}
                                    // onClick={() => searchToken()}
                                     style={{width: `${isPhoneClientWidth ? 1.5 : .3}rem`}}/>
                                <input placeholder={'Search by name or address'}
                                       type="text"
                                       value={inputSearchName}
                                       className={'flexGrow1'}
                                    // onKeyUp={e => !isSelectToken && searchSymbolOnKeyUp(e, searchToken)}
                                       onChange={e => setInputSearchName(e.target.value)}
                                />
                            </div>,
                            <div ref={tokensPoolsScroll}
                                 onScroll={() => !isSelectToken && tokensPoolsOnScroll()}
                                 className={`overflowYScroll ${isPhoneClientWidth ? 'childrenSpacingTopBigPhone' : 'childrenSpacingTopBig'}`}
                                 style={{height: isPhoneClientWidth ? '60vh' : '10rem'}}>
                                {
                                    (isSelectToken ? searchAddressTokening : getPoolsIng)
                                        ? <div className={'flexCenter height100'}>
                                            <img src={requireDefault('loading')} alt=""
                                                 style={{width: `${isPhoneClientWidth ? 9 : 3}rem`}}/>
                                        </div>
                                        : [
                                            isSelectToken && !searchNameIsNotNull && recommendTokens.length > 0 &&
                                            <div
                                                className={`flex alignItemsCenter ${isPhoneClientWidth ? 'childrenSpacingLeftPhone' : 'childrenSpacingLeft'} overflowXScroll`}>
                                                {
                                                    recommendTokens.map(v =>
                                                        <div style={{background: '#F7F7F7'}}
                                                             onClick={() => selectTokenOrPool(v)}
                                                             className={`flexColumnCenter ${isPhoneClientWidth
                                                                 ? 'borderRadiusPhone paddingPhone childrenSpacingTopSmallPhone'
                                                                 : 'borderRadius padding childrenSpacingTopSmall'} flexShrink0 cursorPointer`}>
                                                            {tokenIcon(v, `${isPhoneClientWidth ? 2.4 : .8}rem`)}
                                                            <div
                                                                className={isPhoneClientWidth ? 'smallerFontSizePhone' : 'smallFontSize'}>{checkDataString(v, 'symbol')}</div>
                                                        </div>
                                                    )
                                                }
                                            </div>,
                                            (() => {
                                                const itemFunc = (v, noTVL, noTradingContest) => v[1].length > 0 && <div
                                                    className={isPhoneClientWidth ? 'childrenSpacingTopBigPhone' : 'childrenSpacingTopBig'}>
                                                    {v[0] && <div className={'colorGray'}>{v[0]}</div>}
                                                    {
                                                        v[1].map(v => {
                                                            const isImport = searchNameIsNotNull && !(allTokensIncludesSearchName ||
                                                                    allTokens.map(v => checkDataString(v, 'tokenAddress').toLowerCase()).includes(checkDataString(v, 'tokenAddress').toLowerCase())),
                                                                tokenAddress = v.tokenAddress,
                                                                tokenAddressIsAddress0 = isAddress0(tokenAddress)
                                                            return <div
                                                                onClick={() => (!isImport || !isSelectToken) && selectTokenOrPool(v)}
                                                                className={'flexCenter childrenFlexGrow1 justifyContentSpaceBetween cursorPointer'}>
                                                                <div
                                                                    className={`flexCenter flexGrow1 ${isPhoneClientWidth ? 'childrenSpacingLeftPhone' : 'childrenSpacingLeft'}`}>
                                                                    {tokenIcon(v, `${isPhoneClientWidth ? 2.4 : .8}rem`)}
                                                                    <div
                                                                        className={`${isPhoneClientWidth ? 'childrenSpacingTopSmallPhone' : 'childrenSpacingTopSmall'} flexGrow1`}>
                                                                        <div
                                                                            className={'flex alignItemsCenter justifyContentSpaceBetween'}>
                                                                            <div
                                                                                className={`flex alignItemsCenter ${isPhoneClientWidth ? 'childrenSpacingLeftPhone' : 'childrenSpacingLeft'}`}>
                                                                                <div>{isSelectToken ? checkDataString(v, 'symbol') : showPoolName(checkDataString(v, 'name'))}</div>
                                                                                {!isSelectToken && [showResearchIcon(v), ...noTradingContest ? [] : [tradingContest(v)]]}
                                                                            </div>
                                                                            {!isSelectToken && !noTVL && <div
                                                                                className={`flex justifyContentFlexEnd alignItemsCenter ${isPhoneClientWidth ? 'childrenSpacingLeftSmallPhone' : 'childrenSpacingLeftSmall'}`}>
                                                                                <div
                                                                                    className={`colorGray ${isPhoneClientWidth ? 'smallerFontSizePhone' : 'smallFontSize'}`}>TVL:
                                                                                </div>
                                                                                <div
                                                                                    className={'textOverflowEllipsis'}>{ovl({
                                                                                    ...v,
                                                                                    currency0Symbol: checkDataString(v, 'name').split('/')[0]
                                                                                }, 'tvlUsd', false, true)}</div>
                                                                            </div>}
                                                                        </div>
                                                                        {isSelectToken ? <div
                                                                                className={`colorGray textOverflowEllipsis ${isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'}`}>{
                                                                                checkDataString(v, 'name')
                                                                            }</div>
                                                                            : showFees(v)
                                                                        }
                                                                    </div>
                                                                </div>
                                                                {/*{!isSelectToken && <div*/}
                                                                {/*    className={'activeColor'}>{apr(v)}%</div>}*/}
                                                                {isSelectToken && (isImport
                                                                        ? <div
                                                                            className={'flex alignItemsCenter justifyContentFlexEnd'}>
                                                                            <div onClick={
                                                                                event => {
                                                                                    event.stopPropagation()
                                                                                    toggleShowImportToken(true, v)
                                                                                }
                                                                            }
                                                                                 style={{padding: `${isPhoneClientWidth ? .3 : .1}rem ${isPhoneClientWidth ? .9 : .3}rem`}}
                                                                                 className={`borderRadius999 backgroundActiveColor colorWhite ${
                                                                                     isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'
                                                                                 } cursorPointer`}>
                                                                                Import
                                                                            </div>
                                                                        </div>
                                                                        : <div
                                                                            className={`flexCenter ${isPhoneClientWidth ? 'childrenSpacingLeftPhone' : 'childrenSpacingLeft'}`}>
                                                                            <div
                                                                                className={isPhoneClientWidth ? 'childrenSpacingTopSmallPhone' : 'childrenSpacingTopSmall'}>
                                                                                <div
                                                                                    className={'textAlignRight'}>{getTokenBalance(tokenAddress)}</div>
                                                                                <div style={{opacity: 0}}
                                                                                     className={`colorGray textAlignRight ${isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'}`}>
                                                                                    $3465.78
                                                                                </div>
                                                                            </div>
                                                                            <img className={'cursorPointer'}
                                                                                 src={requireDefault('More info')}
                                                                                 alt=""
                                                                                 onClick={event => {
                                                                                     if (!tokenAddressIsAddress0) {
                                                                                         event.stopPropagation()
                                                                                         toggleShowTokenDetail(true, v)
                                                                                     }
                                                                                 }}
                                                                                 style={{width: `${isPhoneClientWidth ? 1.2 : .4}rem`, ...tokenAddressIsAddress0 ? {opacity: 0} : {}}}/>
                                                                        </div>
                                                                )
                                                                }
                                                            </div>
                                                        })
                                                    }
                                                </div>
                                                return [
                                                    !isSelectToken && <div
                                                        className={isPhoneClientWidth ? 'childrenSpacingTopBigPhone' : 'childrenSpacingTopBig'}>
                                                        {
                                                            isNotNullOrEmpty(recentSearchesPools) && [
                                                                <div className={'colorGray'}>Recent Searches</div>,
                                                                [['', recentSearchesPools]].map(v => itemFunc(v, true, true))
                                                            ]
                                                        }
                                                        <div className={'colorGray'}>Trending Pools</div>
                                                    </div>,
                                                    (
                                                        isSelectToken
                                                            ? (
                                                                searchNameIsNotNull
                                                                    ? [
                                                                        [
                                                                            '',
                                                                            [
                                                                                ...(() => {
                                                                                    const getItemSearchName = item => checkDataString(
                                                                                        item,
                                                                                        searchNameIsETHAddress ? 'tokenAddress' : 'symbol'
                                                                                    ).toLowerCase()
                                                                                    return allTokens.filter(item =>
                                                                                        getItemSearchName(item).includes(searchNameToLowerCase)
                                                                                    ).sort((a, b) => getItemSearchName(a).indexOf(searchNameToLowerCase) - getItemSearchName(b).indexOf(searchNameToLowerCase))
                                                                                        .sort((a, b) => {
                                                                                            a = getItemSearchName(a)
                                                                                            b = getItemSearchName(b)
                                                                                            const aStarts = a.startsWith(searchNameToLowerCase)
                                                                                            const bStarts = b.startsWith(searchNameToLowerCase)
                                                                                            if (aStarts && !bStarts) return -1
                                                                                            if (!aStarts && bStarts) return 1
                                                                                            const aIsDigit = /^\d/.test(a)
                                                                                            const bIsDigit = /^\d/.test(b)
                                                                                            if (aIsDigit && !bIsDigit) return -1
                                                                                            if (!aIsDigit && bIsDigit) return 1
                                                                                            return a.localeCompare(b)
                                                                                        })
                                                                                })(),
                                                                                ...searchAddressTokens
                                                                            ].filter((item, index, self) => {
                                                                                    const tokenAddress = checkDataString(item, 'tokenAddress').toLowerCase()
                                                                                    return !isAddress0(tokenAddress) &&
                                                                                        self.findIndex(obj => checkDataString(obj, 'tokenAddress').toLowerCase() === tokenAddress) === index
                                                                                }
                                                                            )
                                                                        ]
                                                                    ]
                                                                    : [
                                                                        [
                                                                            'Your Tokens',
                                                                            [
                                                                                ...greaterThan(ethBalance)
                                                                                    ? [ethToken]
                                                                                    : [],
                                                                                ...yourTokens
                                                                            ]
                                                                        ],
                                                                        //.filter(v => v.tokenAddress != checkData([[token1Data, token0Data], selectTokenIndex, 'tokenAddress']))
                                                                        ['Recent Searches', recentSearchTokens],
                                                                        ['Trending Tokens', tokens]
                                                                    ]
                                                            )
                                                            : [['', pools]]
                                                    ).map(v => itemFunc(v))
                                                ]
                                            })()
                                        ]
                                }
                            </div>
                        ],
                        9
                    ),
                    ...isSelectToken
                        ? [
                            maskContent(
                                checkDataString(tokenDetail, 'symbol'),
                                checkDataBool(data, 'showTokenDetail'),
                                toggleShowTokenDetail,
                                (() => {
                                    const tokenAddress = checkDataString(tokenDetail, 'tokenAddress')
                                    return [
                                        <div
                                            className={isPhoneClientWidth ? 'childrenSpacingTopPhone' : 'childrenSpacingTop'}>
                                            <div className={'colorGray'}>Contract Address</div>
                                            <div
                                                className={`borderRadius999 backgroundGrey flex alignItemsCenter ${isPhoneClientWidth ? 'paddingPhone childrenSpacingLeftPhone' : 'padding childrenSpacingLeft'}`}>
                                                <div
                                                    className={'flexGrow1'}>{leaveOut(tokenAddress, 9, 9)}</div>
                                                <img onClick={() => copyText(tokenAddress)}
                                                     src={requireDefault('copy1')} className={'cursorPointer'} alt=""
                                                     style={{width: `${isPhoneClientWidth ? .9 : .3}rem`}}/>
                                            </div>
                                        </div>,
                                        <div style={isPhoneClientWidth ? {marginBottom: '8rem'} : {}}
                                             className={`flex alignItemsCenter ${isPhoneClientWidth ? 'childrenSpacingLeftPhone' : 'childrenSpacingLeft'} childrenFlexGrow1`}>
                                            {
                                                [
                                                    ['Group 427320833', 'Open on Explorer', () => windowOpenTokenAddress(tokenAddress)],
                                                    ['Group 427320834', 'Add to your wallet', () => watchAsset(tokenAddress, tokenDetail.symbol, tokenDetail.decimals)]
                                                ].map(v => <div onClick={v[2]}
                                                                className={`${isPhoneClientWidth ? 'borderSmallGrayLinePhone borderRadiusPhone paddingPhone childrenSpacingTopPhone' : 'borderSmallGrayLine borderRadius padding childrenSpacingTop'} flexColumnCenter cursorPointer`}>
                                                    <img src={requireDefault(v[0])} alt=""
                                                         style={{width: `${isPhoneClientWidth ? 1.5 : .5}rem`}}/>
                                                    <div
                                                        className={isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'}>{v[1]}</div>
                                                </div>)
                                            }
                                        </div>
                                    ]
                                })(),
                                undefined,
                                true
                            ),
                            maskContent(
                                'Import token',
                                checkDataBool(data, 'showImportToken'),
                                toggleShowImportToken,
                                [
                                    <div
                                        className={`colorGray ${isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'}`}>
                                        Anyone can create a token, including creating fake versions of existing tokens
                                        that claim to represent projects. If you purchase this token, you may not be
                                        able to sell it back.
                                    </div>,
                                    <div
                                        className={isPhoneClientWidth ? 'childrenSpacingTopBiggerPhone' : 'childrenSpacingTopBigger'}>
                                        <div
                                            className={isPhoneClientWidth ? 'borderRadiusPhone paddingBigPhone childrenSpacingTopPhone borderSmallGrayLinePhone' : 'borderRadius paddingBig childrenSpacingTop borderSmallGrayLine'}>
                                            {
                                                [
                                                    ['Name', checkDataString(tokenDetail, 'name')],
                                                    ['Symbol', checkDataString(tokenDetail, 'symbol')],
                                                    ['Address', leaveOut(checkDataString(tokenDetail, 'tokenAddress')), 'activeColor']
                                                ].map(v => <div
                                                    className={'flex alignItemsCenter justifyContentSpaceBetween'}>
                                                    <div
                                                        className={`colorGray ${isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'}`}>{v[0]}</div>
                                                    <div
                                                        className={`${checkDataString(v[2])} ${isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'}`}>{v[1]}</div>
                                                </div>)
                                            }
                                        </div>
                                        <div style={isPhoneClientWidth ? {marginTop: '8rem'} : {}}
                                             onClick={() => {
                                                 toggleShowImportToken()
                                                 const obj = setRecentSearchTokens(tokenDetail)
                                                 if (obj) {
                                                     toggleShowSelectToken()
                                                     selectTokenOrPool(obj)
                                                 }
                                                 clearSearchName()
                                             }}
                                             className={`${isPhoneClientWidth ? 'borderRadiusPhone paddingTopBottomPhone bigFontSizePhone' : 'borderRadius paddingTopBottomBig bigFontSize'} 
                                             flexCenter colorWhite saf1 backgroundActiveColor  cursorPointer`}>
                                            I Understand
                                        </div>
                                    </div>
                                ]
                            )
                        ]
                        : []
                ]
            })(),
            getTask = c => requestApi(`point/task${isNotNull(c) ? `/${c}` : ''}`, {address}),
            defaultAuthorizePoints = 110,
            twitterAuthorizePoints = defaultAuthorizePoints,
            twitterAuthorizeData = {
                authorizeKey: 'x',
                authorizePoints: twitterAuthorizePoints,
                title: 'Follow & Share',
                needBind: true,
            },
            authorizeData = checkData([data, 'authorizeData'], twitterAuthorizeData),
            {authorizeKey} = authorizeData,
            cloudflareHumanDiv = <div
                className={'childrenDisplayBlock flexCenter'}
                style={{
                    transform: `scale(${document.body.clientWidth / (isPhoneClientWidth ? 600 : 1500)})`,
                }}
                id={'cloudflareHuman'}/>,
            bindCheck = (aK = authorizeKey) => requestApi(`${aK}/bind/check`),
            {authorizeKey: twitterAuthorizeAuthorizeKey} = twitterAuthorizeData,
            // showPointsChains = checkDataBool(data, 'showPointsChains'),
            // pointsChains = [
            //     // [1, 'Ethereum'],
            //     // [130, 'Unichain'],
            //     // [1101, 'Polygon'],
            //     // [42161, 'Arbitrum'],
            //     // [10, 'OP Mainnet'],
            //     // [8453, 'Base'],
            //     [56, 'BNB Chain'],
            //     // [97, 'BNB Smart Chain Testnet'],
            //     // [81457, 'Blast'],
            // ],
            // pointsChainIndex = checkData([data, 'pointsChainIndex'], checkData0(localStorage.getItem('pointsChainIndex'))),
            // pointsChain = checkData([pointsChains, pointsChainIndex], pointsChains[0]),
            pointsChainId = chainId,// pointsChain[0],
            lpPoint = () => requestApi('margin/lp/position', {
                owner: address,
                chainId: pointsChainId
            }).then(v => setData({v4postions: checkData0(v)})),
            lpActivityPoints = checkData([data, 'lpActivityPoints']),
            lpActivityPointsIsNotNull = isNotNull(lpActivityPoints),
            twitterCode = checkData([new URLSearchParams(location.search).get('code')]),
            urlState = checkDataString(new URLSearchParams(location.search).get('state')).split('_'),
            isTwitterAuthorizeAuthorize = aK => aK === twitterAuthorizeAuthorizeKey,
            toggleShowAuthorize = (showAuthorize, isCloudflare, aD = authorizeData) => showAuthorize
                ? switchEthereumChain(
                    () => {
                        toggleShowLoading(true)
                        const aK = aD.authorizeKey
                        loginThenFunc(() => bindCheck(aK).then(isBinded => setData({
                            ...ternaryObject(
                                isTwitterAuthorizeAuthorize(aK),
                                {isTwitterBinded: isBinded}
                            ),
                            isCloudflare,
                            showAuthorize,
                            authorizeData: aD,
                            showLoading: false,
                        })), toggleShowLoading)
                    },
                    undefined,
                    true
                )
                : setData({showAuthorize}),
            redirectURI = `https://likwid.fi/${pNs0}`,
            cloudflareHuman = document.getElementById('cloudflareHuman'),
            grant = (() => {
                const url = 'https://x.com/UniswapFND/status/1882152511320277094'
                return <div
                    style={isPhoneClientWidth ? {padding: '0 2.5rem'} : {}}
                    className={`flex flexWrap alignItemsCenter justifyContentSpaceBetween`}>
                    {
                        [
                            'Uniswap',
                            'Unichain',
                            'BNBChain',
                            'Monad'
                        ].map(v => <img src={requireDefault(v)} alt=""
                                        style={{
                                            ...isPhoneClientWidth ? {marginTop: '1rem'} : {},
                                            width: `${isPhoneClientWidth ? 11 : 5.7}rem`
                                        }}/>)
                    }
                    {(() => {
                        const list = l => <div
                                className={isPhoneClientWidth ? 'childrenSpacingTopBigPhone' : 'childrenSpacingTopBig'}>
                                {l.map(v => <div
                                    style={{
                                        padding: `0 ${isPhoneClientWidth ? 2.1 : .7}rem`,
                                        borderRadius: `${isPhoneClientWidth ? 2 : .5}rem`,
                                        width: isPhoneClientWidth ? '100%' : '8rem',
                                        height: `${isPhoneClientWidth ? 6 : 2}rem`
                                    }}
                                    className={`${isPhoneClientWidth ? 'borderSmallGrayLinePhone childrenSpacingLeftBigPhone' : 'borderSmallGrayLine childrenSpacingLeftBig'} flex alignItemsCenter boxSizingBorderBox`}
                                >
                                    <img src={requireDefault(v[0])} alt=""
                                         style={square(`${isPhoneClientWidth ? 2.1 : .7}rem`)}/>
                                    <div
                                        className={isPhoneClientWidth ? 'childrenSpacingTopSmallPhone' : 'childrenSpacingTopSmall'}>
                                        <div className={`saf1 ${isPhoneClientWidth ? 'bigFontSizePhone' : ''}`}>{v[1]}</div>
                                        <div>{v[2]}</div>
                                    </div>
                                </div>)}
                            </div>,
                            firstBatchGrants = <div className={'flexCenter'}
                                                    style={{
                                                        width: `${isPhoneClientWidth ? '100%' : '7rem'}`,
                                                        height: `${isPhoneClientWidth ? 8 : 4}rem`,
                                                        borderRadius: `${isPhoneClientWidth ? 1.5 : .5}rem`,
                                                        background: 'linear-gradient(180deg, rgba(255, 185, 194, .2) 0%, rgba(255, 243, 245, .2) 100%)'
                                                    }}
                            >
                                <div style={{marginTop: `${isPhoneClientWidth ? -7 : -3.5}rem`}}
                                     className={isPhoneClientWidth ? 'childrenSpacingTopPhone' : 'childrenSpacingTop'}>
                                    <div className={'flexCenter'}>
                                        <img src={requireDefault('Grant & Honor')} alt=""
                                             style={{width: `${isPhoneClientWidth ? 7 : 4.5}rem`}}/>
                                    </div>
                                    <div className={'flexColumnCenter positionRelative'}>
                                        <div
                                            className={`activeColor saf1 ${isPhoneClientWidth ? 'bigFontSizePhone' : 'bigFontSize'}`}>First
                                            Batch Grants
                                        </div>
                                        <div
                                            className={isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'}><span
                                            className={`saf1 ${isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'}`}>@UniswapFND</span> Security
                                            Fund
                                        </div>
                                        <img src={requireDefault('earOfWheat')} alt="" className={'positionAbsolute'}
                                             style={{
                                                 width: `${isPhoneClientWidth ? 20 : 6}rem`,
                                                 top: `${isPhoneClientWidth ? -.6 : -.2}rem`
                                             }}
                                        />
                                    </div>
                                </div>
                            </div>,
                            grant0 = [
                                'Group 427321040',
                                '1st Prize',
                                <div className={'childrenSpacingTopSmall'}>
                                    <div style={isPhoneClientWidth ? {fontSize: '.9rem'} : {}}
                                         className={isPhoneClientWidth ? '' : 'smallFontSize'}>Defi innovation on
                                    </div>
                                    <div style={isPhoneClientWidth ? {fontSize: '.9rem'} : {}}
                                         className={isPhoneClientWidth ? '' : 'smallFontSize'}><span
                                        style={isPhoneClientWidth ? {fontSize: '.9rem'} : {}}
                                        className={`saf1 ${isPhoneClientWidth ? '' : 'smallFontSize'}`}>@unichain @ETHDenver</span> 2025
                                    </div>
                                </div>
                            ],
                            grant1 = [
                                'Group 427321039',
                                'MVB9 Cohort',
                                <div className={'childrenSpacingTopSmall'}>
                                    <div style={isPhoneClientWidth ? {fontSize: '.9rem'} : {}}
                                         className={isPhoneClientWidth ? '' : 'smallFontSize'}>Incubated by <span
                                        style={isPhoneClientWidth ? {fontSize: '.9rem'} : {}}
                                        className={`saf1 ${isPhoneClientWidth ? '' : 'smallFontSize'}`}>{isPhoneClientWidth ?
                                        <br/> : ''}@yzilabs & @CoinMarketCap</span>
                                    </div>
                                </div>
                            ],
                            grant2 = [
                                'Group 427321040',
                                '1st Prize',
                                <div className={'childrenSpacingTopSmall'}>
                                    <div style={isPhoneClientWidth ? {fontSize: '.9rem'} : {}}
                                         className={isPhoneClientWidth ? '' : 'smallFontSize'}>Hashkey Hackathon
                                    </div>
                                </div>
                            ],
                            grant3 = [
                                'Group 427321037',
                                'Winner',
                                <div className={'childrenSpacingTopSmall'}>
                                    <div style={isPhoneClientWidth ? {fontSize: '.9rem'} : {}}
                                         className={isPhoneClientWidth ? '' : 'smallFontSize'}>Infinite Hackathon
                                        (<span style={isPhoneClientWidth ? {fontSize: '.9rem'} : {}}
                                               className={`saf1 ${isPhoneClientWidth ? '' : 'smallFontSize'}`}>@UniswapFND</span>)
                                    </div>
                                </div>
                            ],
                            grant4 = [
                                'Group 427321036',
                                'Champion',
                                <div className={'childrenSpacingTopSmall'}>
                                    <div style={isPhoneClientWidth ? {fontSize: '.9rem'} : {}}
                                         className={isPhoneClientWidth ? '' : 'smallFontSize'}>BNB Incubation
                                        Alliance (Denver)
                                    </div>
                                </div>
                            ],
                            grant5 = [
                                'Group 427321039',
                                'The cohort\'s choice',
                                <div className={'childrenSpacingTopSmall'}>
                                    <div style={isPhoneClientWidth ? {fontSize: '.9rem'} : {}}
                                         className={isPhoneClientWidth ? '' : 'smallFontSize'}><span
                                        style={isPhoneClientWidth ? {fontSize: '.9rem'} : {}}
                                        className={`saf1 ${isPhoneClientWidth ? '' : 'smallFontSize'}`}>@monad_xyz's</span> Monad
                                        Madness HK
                                    </div>
                                </div>
                            ]
                        return <div style={{marginTop: `${isPhoneClientWidth ? 4 : .7}rem`}}
                                    className={isPhoneClientWidth ? 'width100 childrenSpacingTopBigPhone' : 'width100 flex alignItemsFlexEnd justifyContentSpaceBetween'}>
                            {isPhoneClientWidth && <div className={'flexCenter'}>
                                {firstBatchGrants}
                            </div>}
                            {list(isPhoneClientWidth ? [grant0, grant3, grant1] : [grant0, grant1, grant2])}
                            {!isPhoneClientWidth && firstBatchGrants}
                            {list(isPhoneClientWidth ? [grant4, grant2, grant5] : [grant3, grant4, grant5])}
                        </div>
                    })()}
                </div>
            })(),
            showAPRDetailList = checkDataArray(data, 'showAPRDetailList'),
            setShowAPRDetail = (showAPRDetail, i = 0) => {
                showAPRDetailList[i] = showAPRDetail
                setData({showAPRDetailList})
            },
            getAPRs = v => {
                const swapFeesAPR = numToPercentage(checkData0(v, 'apr')),
                    rewardAPR = numToPercentage(checkData0(v, 'rewardApr')),
                    lendingAPR = numToPercentage(divide(plus(checkData0(v, 'lendingApr0'), checkData0(v, 'lendingApr1')), 2))
                return [swapFeesAPR, rewardAPR, lendingAPR, plus(plus(swapFeesAPR, rewardAPR), lendingAPR)]
            },
            aprDetail = (v, i = 0, isToRight) => showAPRDetailList[i] &&
                <div style={{top: 0, ...isPhoneClientWidth && isToRight ? {right: 0} : {}}}
                     className={'positionAbsolute zIndex999'}>
                    <div style={{
                        width: `${isPhoneClientWidth ? 18 : 6}rem`,
                        marginTop: `${isPhoneClientWidth ? 1.5 : .5}rem`,
                        boxShadow: `0 0 ${isPhoneClientWidth ? .3 : .1}rem rgba(161, 54, 69, 0.1)`
                    }}
                         className={`backgroundWhite ${isPhoneClientWidth ? 'borderRadiusPhone paddingBigPhone childrenSpacingTopPhone' : 'borderRadius paddingBig childrenSpacingTop'}`}>
                        <div className={`${isPhoneClientWidth ? 'smallerFontSizePhone' : 'smallerFontSize'} colorGray`}>
                            Swap Fees APR is calculated based on the fees generated by the pool over the
                            last 24
                            hours. The APR displayed is algorithmic and subject to change.
                        </div>
                        <div
                            className={`${isPhoneClientWidth ? 'borderRadiusPhone paddingBigPhone childrenSpacingTopPhone' : 'borderRadius paddingBig childrenSpacingTop'} backgroundGrey`}>
                            {(() => {
                                const [swapFeesAPR, rewardAPR, lendingAPR, totalAPR] = getAPRs(v),
                                    arr = [
                                        ['Swap Fees', swapFeesAPR],
                                        ['Rewards', rewardAPR],
                                        ['Lending', lendingAPR],
                                        ['Total', totalAPR]
                                    ]
                                return arr.map((v, i) => <div
                                    className={'flex alignItemsCenter justifyContentSpaceBetween'}>
                                    <div
                                        className={`${isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'} colorGray`}>{v[0]}</div>
                                    <div
                                        className={`${isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'} ${i === arr.length - 1 ? 'saf1' : ''}`}>{v[1]}%
                                    </div>
                                </div>)
                            })()}
                        </div>
                    </div>
                </div>,
            homeSecurity = useRef(null),
            homeUnifying = useRef(null),
            poolChain = item => {
                const chainLogo = coinNames(item.chainId)
                return <div className={'flex alignItemsCenter positionRelative'}>
                    {['logo0', 'logo1'].map((v, i) => {
                        const logo = item[v]
                        return <img
                            className={'borderRadius999'}
                            src={logo === 'NATIVE' ? requireDefault(chainLogo) : logo} alt=""
                            style={{
                                width: `${isPhoneClientWidth ? 2.1 : .7}rem`,
                                zIndex: i ? 0 : 1,
                                ...i
                                    ? {
                                        marginLeft: `-${isPhoneClientWidth ? .3 : .1}rem`,
                                    }
                                    : {}
                            }}/>
                    })}
                    <div className={'borderRadius999 positionAbsolute flexCenter backgroundWhite'}
                         style={{
                             bottom: 0,
                             right: `-${isPhoneClientWidth ? .3 : .1}rem`,
                             ...square(`${isPhoneClientWidth ? .9 : .3}rem`)
                         }}>
                        <img className={'borderRadius999'} src={requireDefault(chainLogo)} alt=""
                             style={square('85%')}/>
                    </div>
                </div>
            },
            earnYourPools = checkDataArray(data, 'earnYourPools'),
            getClaimeds = () => {
                const iFP = isFirstPage(claimedHistorysPage);
                iFP && setData({
                    getClaimedHistorysing: true
                })
                return requestApi(
                    'margin/reward/log/claimed',
                    {
                        chainId,
                        pageSize: 30,
                        sender: address,
                        page: claimedHistorysPage
                    }, undefined, undefined, true
                ).then(async v => setData(
                    {
                        claimedHistorys: [...iFP ? [] : claimedHistorys, ...checkDataArray(v, 'items')],
                        claimedHistorysTotal: checkData0(v, 'total')
                    }
                )).finally(() => {
                    setData({getClaimedHistorysing: false})
                    toggleShowLoading()
                })
            },
            showClaimedHistorys = checkDataBool(data, 'showClaimedHistorys'),
            claimedHistorys = checkDataArray(data, 'claimedHistorys'),
            setMarginTokenId = () => marginPositionTokenId().then(marginTokenId => setData({marginTokenId})),
            paths = {
                '/': isHome && (() => {
                    const toggleShowHomeTopPools = showHomeTopPools => setData({showHomeTopPools}),
                        container = <div>
                            <div
                                className={`positionRelative ${isPhoneClientWidth ? 'paddingLeftRightBigPhone childrenSpacingTopBigPhone' : 'flex justifyContentSpaceBetween'} boxSizingBorderBox`}
                                style={{
                                    zIndex: 100,
                                    ...isPhoneClientWidth
                                        ? {paddingTop: '5rem', paddingBottom: '5rem'}
                                        : {
                                            padding: '4rem 2rem 4rem 2rem',
                                            height: '17rem'
                                        }
                                }}>
                                <div
                                    className={`flexColumn justifyContentSpaceBetween height100 ${isPhoneClientWidth ? '' : 'flexGrow1'}`}>
                                    <div>
                                        {
                                            [
                                                'No oracles.',
                                                'No gatekeepers.',
                                                'Just DeFi.'
                                            ].map(v => <BlurText
                                                text={v}
                                                delay={150}
                                                animateBy="words"
                                                direction="top"
                                                className="text-2xl mb-8"
                                                fontSize={isPhoneClientWidth ? 2.5 : 1.5}
                                            />)
                                        }
                                        {/*<pre className={'saf1'} style={{fontSize: '1.5rem'}}>{`No oracles. No gatekeepers. Just `}<span className={'activeColor saf1'} style={{fontSize: '1.5rem'}}>DeFi.</span></pre>*/}
                                        <pre className={isPhoneClientWidth ? 'marginTopPhone' : ''}
                                             style={{fontSize: `${isPhoneClientWidth ? 1 : .4}rem`, opacity: .6}}>{`Likwid empowers permissionless margin trading 
and lending for any token`}</pre>
                                    </div>
                                    <div
                                        className={isPhoneClientWidth ? 'marginTopBigPhone childrenSpacingTopPhone' : 'childrenSpacingTop'}>
                                        {[
                                            ['Unified liquidity for ', 'Swap, Lending & Margin'],
                                            ['Leverage long-tail tokens from ', 'day one']
                                        ].map(v => <div className={'flex'}>
                                            <div
                                                className={`homeUnifiedLeverage borderRadius999 flex alignItemsCenter ${
                                                    isPhoneClientWidth ? 'paddingPhone childrenSpacingLeftPhone' : 'padding childrenSpacingLeft'
                                                }`}
                                            >
                                                <img src={requireDefault('tag1')} alt=""
                                                     style={square(`${isPhoneClientWidth ? .8 : .35}rem`)}/>
                                                <div className={'flex alignItemsCenter'}>
                                                <pre
                                                    className={isPhoneClientWidth ? 'smallFontSizePhone' : ''}>{v[0]}</pre>
                                                    <pre
                                                        className={`saf1 ${isPhoneClientWidth ? 'smallFontSizePhone' : ''}`}>{v[1]}</pre>
                                                </div>
                                            </div>
                                        </div>)}
                                    </div>
                                </div>
                                {(() => {
                                    const homePools = require('./homePools'),
                                        showHomeTopPools = checkDataBool(data, 'showHomeTopPools'),
                                        homeTopPoolIndex = checkData0(data, 'homeTopPoolIndex'),
                                        homePool = homePools[homeTopPoolIndex],
                                        homePoolSmbols = homePool.name.split('/'),
                                        homePoolIndex = checkData0(data, 'homePoolIndex')
                                    return <div style={isPhoneClientWidth ? {marginTop: '3rem'} : {width: '10rem'}}
                                                className={'flexColumn boxSizingBorderBox justifyContentSpaceBetween height100'}>
                                        <div
                                            className={`width100 boxSizingBorderBox ${isPhoneClientWidth ? 'childrenSpacingTopBigPhone' : 'childrenSpacingTopBigger'}`}
                                            style={{
                                                borderRadius: `${isPhoneClientWidth ? 1.5 : 1}rem`,
                                                padding: `${isPhoneClientWidth ? 1 : .8}rem`,
                                                border: `solid ${isPhoneClientWidth ? .15 : .05}rem white`,
                                                background: 'rgba(255,255,255,.4)'
                                            }}
                                        >
                                            {(() => {
                                                return <div className={'positionRelative'}>
                                                    <div className={'flex'}>
                                                        <div
                                                            onClick={e => {
                                                                e.stopPropagation()
                                                                toggleShowHomeTopPools(!showHomeTopPools)
                                                            }}
                                                            className={`cursorPointer flex alignItemsCenter ${isPhoneClientWidth ? 'childrenSpacingLeftPhone' : 'childrenSpacingLeftBig'}`}>
                                                            {poolChain(homePool)}
                                                            <div
                                                                className={`flex alignItemsFlexEnd ${isPhoneClientWidth ? 'childrenSpacingLeftPhone' : 'childrenSpacingLeft'}`}>
                                                                <div
                                                                    className={`${isPhoneClientWidth ? 'bigFontSizePhone' : 'bigFontSize'} lineHeight1`}>
                                                                    {homePool.name}
                                                                </div>
                                                                <img src={requireDefault('toBottom')} alt=""
                                                                     style={{width: `${isPhoneClientWidth ? .9 : .3}rem`}}/>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {showHomeTopPools && <div
                                                        className={'positionAbsolute backgroundWhite overflowHidden'}
                                                        style={{
                                                            borderRadius: `${isPhoneClientWidth ? 1 : .5}rem`,
                                                            top: `${isPhoneClientWidth ? 2.5 : 1}rem`,
                                                            zIndex: 100
                                                        }}
                                                    >
                                                        {homePools.map((v, i) => <div
                                                            onClick={() => {
                                                                setData({homeTopPoolIndex: i})
                                                                toggleShowHomeTopPools()
                                                            }}
                                                            className={`cursorPointer homeMarginMaxLeverages flex alignItemsCenter ${isPhoneClientWidth ? 'paddingBigPhone childrenSpacingLeftPhone' : 'paddingBig childrenSpacingLeftBig'}`}>
                                                            {poolChain(v)}
                                                            <div
                                                                className={`flex alignItemsFlexEnd ${isPhoneClientWidth ? 'childrenSpacingLeftPhone' : 'childrenSpacingLeft'}`}>
                                                                <div
                                                                    className={`${isPhoneClientWidth ? 'bigFontSizePhone' : 'bigFontSize'} lineHeight1`}>
                                                                    {v.name}
                                                                </div>
                                                            </div>
                                                        </div>)}
                                                    </div>}
                                                </div>
                                            })()}
                                            <div style={{borderRadius: `${isPhoneClientWidth ? 1 : .4}rem`}}
                                                 className={`flex overflowHidden childrenFlexGrow1 ${isPhoneClientWidth ? 'childrenSpacingLeftSmallPhone' : 'childrenSpacingLeftSmall'}`}>
                                                {marginMaxLeverages.map((v, i) => <div
                                                    onClick={() => toggleMarginMaxLeverageIndex(i)}
                                                    className={`flexCenter ${i === marginMaxLeverageIndex ? 'homeMarginMaxLeverageActive' : 'homeMarginMaxLeverages'} cursorPointer ${isPhoneClientWidth ? 'bigFontSizePhone' : 'bigFontSize'}`}
                                                    style={{
                                                        height: `${isPhoneClientWidth ? 3.5 : 1.3}rem`,
                                                        borderRadius: `${isPhoneClientWidth ? .3 : .1}rem`
                                                    }}>{v}</div>)}
                                            </div>
                                            <div style={{
                                                height: `${isPhoneClientWidth ? 3.5 : 1.3}rem`,
                                                borderRadius: `${isPhoneClientWidth ? 1 : .4}rem`,
                                                border: `solid ${isPhoneClientWidth ? .15 : .05}rem white`
                                            }}
                                                 className={`homeMarginInput flex alignItemsCenter backgroundWhite overflowHidden ${isPhoneClientWidth ? 'paddingPhone' : 'padding'} boxSizingBorderBox`}>
                                                <input type="text"
                                                       value={inputNewAmount}
                                                       onChange={e => setInputNewAmount(e.target.value)}
                                                       className={`flexGrow1 height100 ${isPhoneClientWidth ? 'biggerFontSizePhone' : 'biggerFontSize'}`}/>
                                                <div
                                                    style={{padding: `${isPhoneClientWidth ? .5 : .1}rem ${isPhoneClientWidth ? .9 : .3}rem`}}
                                                    className={`backgroundGrey borderRadius999 flex alignItemsCenter ${isPhoneClientWidth ? 'childrenSpacingLeftSmallPhone' : 'childrenSpacingLeftSmall'}`}>
                                                    <img className={'borderRadius999'}
                                                         src={(() => {
                                                             const logo = homePool[`logo${homePoolIndex}`]
                                                             return logo === 'NATIVE' ? requireDefault(coinNames(homePool.chainId)) : logo
                                                         })()}
                                                         alt=""
                                                         style={square(`${isPhoneClientWidth ? 1.2 : .5}rem`)}/>
                                                    <div
                                                        className={isPhoneClientWidth ? '' : 'bigFontSize'}>{homePoolSmbols[homePoolIndex]}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        {(() => {
                                            const t1Symbol = homePoolSmbols[1]
                                            return <div
                                                className={`flex alignItemsCenter childrenFlexGrow1 ${isPhoneClientWidth ? 'paddingTopBiggerPhone childrenSpacingLeftBigPhone' : 'childrenSpacingLeftBig'}`}>
                                                {[
                                                    [`Long ${t1Symbol}`, 1],
                                                    [`Short ${t1Symbol}`, 0]
                                                ].map((v, i) => {
                                                    const key = `${v}ToLeft`
                                                    return <div
                                                        onClick={() => windowOpen(`/trade/margin?chain=${checkData([searchChains.filter(v => equalTo(homePool.chainId, v[1].id)), 0, 0])}&poolid=${homePool.poolId}&marginMaxLeverageIndex=${marginMaxLeverageIndex}&amount=${inputNewAmount}&longShort=${i}`)}
                                                        onMouseEnter={() => setData({[key]: true, homePoolIndex: v[1]})}
                                                        onMouseLeave={() => setData({[key]: false})}
                                                        className={`homeLongShort width100 cursorPointer saf1 borderRadius999 flexCenter boxSizingBorderBox ${isPhoneClientWidth ? 'childrenSpacingLeftPhone' : 'childrenSpacingLeft'}`}
                                                        style={{
                                                            width: '5rem',
                                                            height: `${isPhoneClientWidth ? 3.5 : 1.5}rem`,
                                                            border: `solid ${isPhoneClientWidth ? .15 : .05}rem white`
                                                        }}
                                                    >
                                                        <div
                                                            className={`${isPhoneClientWidth ? 'smallFontSizePhone' : 'bigFontSize'} saf1`}>{v[0]}</div>
                                                        {checkDataBool(data, key) &&
                                                            <img src={requireDefault('Group 427321184')} alt=""
                                                                 style={square(`${isPhoneClientWidth ? 1 : .4}rem`)}/>}
                                                    </div>
                                                })}
                                            </div>
                                        })()}
                                    </div>
                                })()}
                                <div id={'homeBlurGradientBg'}
                                     className={'positionAbsolute zIndex-1 width100 height100'}
                                     style={{
                                         top: 0,
                                         bottom: 0,
                                         left: 0,
                                         right: 0,
                                         objectFit: 'fill',
                                         marginTop: 0,
                                         marginBottom: 0,
                                         background: '#FDE1E5',
                                         opacity: checkDataBool(data, 'showHomeBlurGradientBg') ? 1 : 0
                                     }}
                                />
                            </div>
                            <div
                                style={isPhoneClientWidth ? {
                                    paddingTop: '5rem',
                                    paddingBottom: '5rem'
                                } : {padding: '2rem'}}
                                className={`positionRelative zIndex1 ${isPhoneClientWidth ? 'paddingLeftRightBigPhone' : ''}`}>
                                <div className={'childrenSpacingTopBig'}>
                                    <ScrollFloat
                                        animationDuration={1}
                                        ease='back.inOut(2)'
                                        scrollStart='center bottom+=50%'
                                        scrollEnd='bottom bottom-=40%'
                                        stagger={0.03}
                                        textClassName={'flexCenter saf1'}
                                        textStyle={{fontSize: `${isPhoneClientWidth ? 2.5 : 1}rem`}}
                                        containerClassName={'flexCenter'}
                                    >
                                        Earn More as an LP
                                    </ScrollFloat>
                                    <pre className={'textAlignCenter '} style={{opacity: .6}}>{`LPs earn from Swap fees,
leverage fees and Lending interest — all in one pool`}</pre>
                                </div>
                                <div style={isPhoneClientWidth ? {marginTop: '2rem'} : {}}
                                     className={isPhoneClientWidth ? 'flexColumn alignItemsCenter childrenSpacingTopBiggerPhone' : 'flex justifyContentCenter childrenSpacingLeftBigger'}>
                                    {homeLPPools.map(v =>
                                        <SpotlightCard
                                            onClick={() => windowOpen(`/pool?chain=${checkData([searchChains.filter(v1 => equalTo(v.chainId, v1[1].id)), 0, 0])}&poolid=${v.poolId}`)}
                                            spotlightColor='rgba(255, 154, 167, .3)'
                                            className={`${isPhoneClientWidth ? 'card-spotlightPhone' : 'card-spotlight'} custom-spotlight-card homeEarnPools cursorPointer flexColumnCenter justifyContentSpaceBetween boxSizingBorderBox`}
                                        >
                                            {poolChain(v)}
                                            <div>{v.name}</div>
                                            <div
                                                className={`saf1 ${isPhoneClientWidth ? 'biggerFontSizePhone' : 'biggerFontSize'}`}>{checkData0(data, 'homeLPPoolsAPRS', `${v.chainId}${v.poolId}`)}%
                                            </div>
                                            <div
                                                className={`flexCenter ${isPhoneClientWidth ? 'childrenSpacingLeftSmallPhone' : 'childrenSpacingLeftSmall'}`}>
                                                <img src={requireDefault(coinNames(v.chainId))} alt=""
                                                     style={square(`${isPhoneClientWidth ? .9 : .3}rem`)}/>
                                                <div
                                                    className={isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'}>{
                                                    checkData(
                                                        [
                                                            coinDatas,
                                                            v.chainId,
                                                            'name'
                                                        ],
                                                        'Ethereum'
                                                    )
                                                }
                                                </div>
                                            </div>
                                        </SpotlightCard>)}
                                </div>
                                {(() => {
                                    const other = [
                                        <div className={'marginTopBig'}
                                             style={isPhoneClientWidth ? {marginTop: '17rem'} : {}}
                                        >
                                            <GradientText
                                                colors={['#FF8E9D', '#A54FFF', '#FF8E9D']}
                                                animationSpeed={3}
                                                showBorder={false}
                                                className={`custom-class ${isPhoneClientWidth ? 'biggerFontSizePhone' : 'biggerFontSize'} saf1`}
                                            >
                                                Security-First
                                            </GradientText>
                                        </div>,
                                        <pre
                                            className={`colorWhite ${isPhoneClientWidth ? 'smallFontSizePhone marginTopPhone' : 'smallFontSize'} textAlignCenter`}>{`Likwid runs on purpose-built smart contracts, 
audited by the best to ensure your funds stay safe.`}</pre>,
                                        <img src={requireDefault('Group 427321220')} alt=""
                                             className={'cursorPointer'}
                                             onClick={() => whitepaper('product/security-audits')}
                                             style={{
                                                 width: `${isPhoneClientWidth ? 9 : 3}rem`,
                                                 marginTop: `${isPhoneClientWidth ? 2.1 : .7}rem`
                                             }}/>
                                    ]
                                    return <div style={{
                                        marginTop: `${isPhoneClientWidth ? 7 : 4}rem`,
                                        borderRadius: `${isPhoneClientWidth ? 3 : 1.5}rem`,
                                        height: `${isPhoneClientWidth ? 45 : 10}rem`
                                    }}
                                                className={`flexColumn ${isPhoneClientWidth ? '' : 'justifyContentCenter'} alignItemsCenter positionRelative backgroundBlack childrenSpacingLeftBigger boxSizingBorderBox zIndex1`}>
                                        <img src={requireDefault(isPhoneClientWidth ? 'auditbg2' : 'audit')} alt=""
                                             style={{width: '95%', ...isPhoneClientWidth ? {top: '3rem'} : {}}}
                                             className={'positionAbsolute zIndex-1'}/>
                                        <div ref={homeSecurity} style={square(`${isPhoneClientWidth ? 15 : 8}rem`)}
                                             className={'flexColumnCenter childrenSpacingTopBig positionRelative'}>
                                            <img src={requireDefault('shield')} alt=""
                                                 style={{width: `${isPhoneClientWidth ? 4 : 2}rem`, ...isPhoneClientWidth ? {marginTop: '18rem'} : {}}}/>
                                            {!isPhoneClientWidth && other}
                                            <div
                                                className={'positionAbsolute width100 height100 flexCenter zIndex-1 marginTop0'}
                                                style={{
                                                    top: isPhoneClientWidth ? '9rem' : 0,
                                                    bottom: 0,
                                                    left: 0,
                                                    right: 0
                                                }}
                                            >
                                                <div style={{...square('100%'), transform: 'scale(1.3)'}}>
                                                    {homeSecurity.current && <Orb
                                                        onMouseContContainer={homeSecurity.current}
                                                        hoverIntensity={0.5}
                                                        rotateOnHover={true}
                                                        hue={0}
                                                        forceHoverState={false}
                                                    />}
                                                </div>
                                            </div>
                                        </div>
                                        {isPhoneClientWidth && other}
                                    </div>
                                })()}
                                <div
                                    className={'positionAbsolute zIndex-1 flex alignItemsCenter justifyContentSpaceBetween'}
                                    style={{
                                        top: 0,
                                        left: 0,
                                        right: 0,
                                        height: `${isPhoneClientWidth ? 117 : 15}rem`,
                                        background: 'linear-gradient(180deg, #FDE1E5 0%, #F5F8FF 100%)'
                                    }}>
                                    <img src={requireDefault(isPhoneClientWidth ? 'image 55' : 'image 53')} alt=""
                                         style={{
                                             width: `${isPhoneClientWidth ? 8 : 7}rem`,
                                             marginTop: `${isPhoneClientWidth ? -86 : 2}rem`
                                         }}/>
                                    <img src={requireDefault(isPhoneClientWidth ? 'image 54' : 'image 28')} alt=""
                                         style={{
                                             width: `${isPhoneClientWidth ? 8 : 7}rem`,
                                             marginTop: `${isPhoneClientWidth ? 14 : 12}rem`
                                         }}/>
                                </div>
                            </div>
                            <div ref={homeUnifying} style={isPhoneClientWidth ? {
                                paddingTop: '5rem',
                                paddingBottom: '5rem'
                            } : {padding: '2rem'}}
                                 className={`positionRelative zIndex1 ${isPhoneClientWidth ? 'paddingLeftRightBigPhone' : ''}`}>
                                <div className={'positionAbsolute'}
                                     style={{
                                         top: 0,
                                         left: 0,
                                         right: 0,
                                         height: '2rem',
                                         background: 'linear-gradient(180deg, #F5F8FF 0%, transparent 100%)'
                                     }}
                                ></div>
                                <pre className={'flexCenter saf1 textAlignCenter'}
                                     style={{fontSize: `${isPhoneClientWidth ? 2.3 : 1}rem`}}>{`Unifying DeFi through
one simple formula`}</pre>
                                <div style={{marginTop: '3rem', ...isPhoneClientWidth ? {} : {height: '6.5rem'}}}
                                     className={isPhoneClientWidth ? 'flexColumn alignItemsCenter childrenSpacingTopBiggerPhone' : 'flex alignItemsCenter justifyContentSpaceBetween'}>
                                    <div
                                        className={`${isPhoneClientWidth ? 'childrenSpacingTopBiggerPhone flexColumn alignItemsCenter' : 'height100'} flexColumn justifyContentSpaceBetween`}>
                                        <div
                                            className={`flexCenter ${isPhoneClientWidth ? 'homeXYPhone borderSmallBlackLinePhone' : 'homeXY borderSmallBlackLine'}`}
                                            style={{
                                                width: `${isPhoneClientWidth ? 17 : 8.5}rem`,
                                                height: `${isPhoneClientWidth ? 4 : 2}rem`,
                                                borderRadius: `${isPhoneClientWidth ? 1.4 : .7}rem`
                                            }}>
                                            <img style={{width: '80%'}}
                                                 src={requireDefault('Group 427321181')} alt=""/>
                                        </div>
                                        <div
                                            className={isPhoneClientWidth ? 'childrenSpacingTopBigPhone' : 'childrenSpacingTopBigger'}>
                                            {[
                                                'x, y：Real token reserves in the pool',
                                                'x′, y′： Virtual liquidity from active lending positions',
                                                'Unifies AMM + Lending into one liquidity pool'
                                            ].map(v => <div
                                                className={`flex alignItemsCenter ${isPhoneClientWidth ? 'childrenSpacingLeftPhone' : 'childrenSpacingLeft'}`}>
                                                <div className={'borderRadius999'}
                                                     style={{
                                                         ...square(`${isPhoneClientWidth ? .3 : .1}rem`),
                                                         border: `solid ${isPhoneClientWidth ? .3 : .1}rem #FF8E9D`
                                                     }}/>
                                                <div
                                                    className={isPhoneClientWidth ? '' : 'bigFontSize'}>{v}</div>
                                            </div>)}
                                        </div>
                                    </div>
                                    <img src={requireDefault('graphic')} alt=""
                                         style={isPhoneClientWidth ? {width: '90%'} : {}}
                                         className={isPhoneClientWidth ? '' : 'height100'}/>
                                </div>
                                <div className={'positionAbsolute zIndex-1'}
                                     style={{top: 0, bottom: 0, left: 0, right: 0}}
                                >
                                    {homeUnifying.current && <Squares
                                        onMouseContContainer={homeUnifying.current}
                                        speed={0.5}
                                        squareSize={40}
                                        direction='diagonal' // up, down, left, right, diagonal
                                        borderColor='#DFE1E5'
                                        hoverFillColor='#FDB2BD'
                                    />}
                                </div>
                            </div>
                            <div style={isPhoneClientWidth ? {
                                paddingTop: '5rem',
                                paddingBottom: '5rem'
                            } : {padding: '2rem'}} className={isPhoneClientWidth ? 'paddingLeftRightBigPhone' : ''}>
                                    <pre className={'flexCenter saf1 textAlignCenter'}
                                         style={{fontSize: `${isPhoneClientWidth ? 2.5 : 1}rem`}}>{`Grant & Honor`}</pre>
                                <div style={{marginTop: '1.5rem'}}>
                                    {[
                                        [
                                            'First Batch Grants',
                                            'Uniswap2',
                                            'Group 427321197',
                                            'Unichain1',
                                            '1st Prize-1',
                                        ],
                                        [
                                            '1st Prize-2',
                                            'BNBChain1',
                                            'Group 427321198',
                                            'Monad1',
                                            'Champion',
                                            'The cohort\'s choice'
                                        ],
                                    ].map((v, i) => <div className={'width100 overflowHidden'}>
                                        <div className={`flex grantHonor${i}`}>
                                            {Array.from({length: 100}).map(() => <div
                                                style={{marginTop: `${isPhoneClientWidth ? 1.5 : .5}rem`}}
                                                className={`boxSizingBorderBox flex alignItemsCenter`}>
                                                {v.map(v => <img className={'cursorPointer'}
                                                                 src={requireDefault(v)}
                                                                 alt=""
                                                                 style={{
                                                                     marginRight: `${isPhoneClientWidth ? 4 : 2}rem`,
                                                                     height: `${isPhoneClientWidth ? 5 : 2}rem`
                                                                 }}/>)}
                                            </div>)}
                                        </div>
                                    </div>)}
                                </div>
                            </div>
                        </div>
                    return <div onClick={() => toggleShowHomeTopPools()} style={{background: '#F5F8FF'}}>
                        {isPhoneClientWidth
                            ? pageTopFootPhone(<div>{container}</div>)
                            : <div>
                                {pageTop}
                                {container}
                                {pageFoot}
                            </div>}
                        {loading}
                    </div>
                })(),
                'trade/*': !isHome && (() => {
                    const marginSwapList = <div className={'flexCenter justifyContentSpaceBetween'}>
                            <div
                                className={`flexCenter`}>
                                {marginSwap.map((v, i) => {
                                    const isCurrent = marginSwapIndex === i || checkDataBool(data, `mouseTrade${i}`)
                                    return <div
                                        onMouseEnter={() => setData({
                                            [`mouseTrade${i}`]: true
                                        })}
                                        onMouseLeave={() => setData({
                                            [`mouseTrade${i}`]: false
                                        })}
                                        onClick={() => toggleMarginSwapIndex(i)}
                                        style={{
                                            width: `${isPhoneClientWidth ? 6 : 2}rem`,
                                            height: `${isPhoneClientWidth ? 3 : 1}rem`
                                        }}
                                        className={`flexCenter boxSizingBorderBox borderRadius999 cursorPointer ${isCurrent ? `backgroundGrey saf1 ${isPhoneClientWidth ? 'borderSmallGrayLinePhone' : 'borderSmallGrayLine'}` : ''}`}
                                    >
                                        {v[0]}
                                    </div>
                                })}
                            </div>
                            {settingContent()}
                        </div>,
                        marginSwapItem = marginSwap[marginSwapIndex][1](),
                        tradeButton = showApprove || isSwapNeedAddLending
                            ? approveContent([{
                                symbol: marginToken0Symbol, needApprove: marginToken0DataNeedApprove
                            }])
                            : <div style={isPhoneClientWidth ? {marginBottom: '2rem'} : {}}
                                   onClick={() => {
                                       let swapTokenId
                                       toggleShowApprove(marginToken0DataNeedApprove)
                                       const iA0 = marginToken0IsETH,
                                           amount = iA0 ? newAmountWei : undefined,
                                           margin = () => isMargin
                                               ? marginPositionTokenId().then(
                                                   tokenId => {
                                                       const tokenIdIsNotNull = isNotNull(tokenId)
                                                       return marginPositionWriteContract(
                                                           tokenIdIsNotNull ? 'margin' : 'addMargin',
                                                           amount,
                                                           [
                                                               ...tokenIdIsNotNull ? [] : [
                                                                   poolKey
                                                               ],
                                                               [
                                                                   tokenIdIsNotNull ? tokenId : marginForOne,
                                                                   isBorrow ? 0 : leverage,
                                                                   newAmountWei,
                                                                   isBorrow ? newBorrowAmountWei : borrowAmount,
                                                                   marginBorrowMax,
                                                                   ...tokenIdIsNotNull ? [] : [address],
                                                                   deadline
                                                               ]
                                                           ],
                                                           hash => waitForTransactionFunc(
                                                               hash,
                                                               () => {
                                                                   erc20CallBalanceOfTokens()
                                                                   setData({marginSuccess: true})
                                                                   setData({
                                                                       newAmount: undefined,
                                                                       newAmountWei: undefined,
                                                                       newBorrowAmount: undefined,
                                                                       newBorrowAmountWei: undefined,
                                                                       inputNewAmount: undefined
                                                                   })
                                                                   toggleShowLoadingShowPositionsPools(isBorrow ? 1 : 0)
                                                                   toggleShowMarginSelling()
                                                                   toastSuccessful(true)
                                                                   setMarginTokenId()
                                                               },
                                                               () => toggleShowMarginSelling()
                                                           )
                                                       )
                                                   }
                                               )
                                               : (() => {
                                                   const amountMinMax = (isExactOutput ? maxSlippageAmountPlus : maxSlippageAmount)(isExactOutput ? newAmountWei : transitionPriceWei),
                                                       wcFunc = tokenId => {
                                                           console.log('tokenId', tokenId);
                                                           return (isLendPositionSwap ? lendPositionWriteContract : pairPositionWriteContract)(
                                                               (isExactInput && isInputTransitionPrice) ? 'exactOutput' : 'exactInput',
                                                               isExactOutput ? (iA0 ? amountMinMax : undefined) : amount,
                                                               [[
                                                                   ...isLendPositionSwap ? [] : [poolDataPoolId],
                                                                   zeroForOne,
                                                                   isLendPositionSwap ? tokenId : address,
                                                                   ...(isExactInput && isInputTransitionPrice)
                                                                       ? [
                                                                           amountMinMax,
                                                                           transitionPriceWei
                                                                       ]
                                                                       : [
                                                                           newAmountWei,
                                                                           amountMinMax
                                                                       ],
                                                                   deadline
                                                               ]],
                                                               hash => waitForTransactionFunc(
                                                                   hash,
                                                                   () => {
                                                                       erc20CallBalanceOfTokens()
                                                                       toastSuccessful(true)
                                                                       toggleShowLoading()
                                                                       toggleShowSwapping()
                                                                       setData({
                                                                           newAmount: undefined,
                                                                           newAmountWei: undefined,
                                                                           inputNewAmount: undefined,
                                                                           transitionPrice: undefined,
                                                                           transitionPriceWei: undefined
                                                                       })
                                                                   },
                                                                   () => toggleShowSwapping()
                                                               ))
                                                       }
                                                   return isExactInput
                                                       ? wcFunc()
                                                       : (isNotNull(swapTokenId)
                                                           ? wcFunc(swapTokenId)
                                                           : lendPositionWriteContract(
                                                               'addLending',
                                                               undefined,
                                                               [
                                                                   poolKey,
                                                                   marginToken0TokenAddress.toLowerCase() === token0Address.toLowerCase(),
                                                                   address,
                                                                   0,
                                                                   deadline
                                                               ],
                                                               hash => waitForTransactionFunc(
                                                                   hash,
                                                                   ({logs}) => {
                                                                       setData({addLendingFinish: true})
                                                                       return wcFunc(hexToNumber(logs[0].topics[3]))
                                                                   },
                                                                   () => toggleShowSwapping()
                                                               )
                                                           ))
                                               })(),
                                           mT0Allowance = () => iA0
                                               ? margin()
                                               : marginToken0Allowance(isLendPositionSwap ? erc20LendPositionAllowance : undefined).then(
                                                   mT0A => mT0A > 0
                                                       ? (
                                                           isMargin ? erc20MarginPositionApprove : (isLendPositionSwap ? erc20LendPositionApprove : erc20PairPositionApprove)
                                                       )(marginToken0TokenAddress, mT0A, hash => waitForTransactionFunc(hash, mT0Allowance))
                                                       : margin()
                                               );
                                       isExactInput
                                           ? mT0Allowance()
                                           : lendPoolTokenId().then(
                                               tokenId => {
                                                   swapTokenId = tokenId
                                                   !isNotNull(tokenId) && setData({needAddLending: true})
                                               }
                                           ).catch(() => setData({needAddLending: true})).finally(mT0Allowance)
                                   }}
                                   className={`${isPhoneClientWidth ? 'borderRadiusPhone paddingTopBottomPhone' : 'borderRadius paddingTopBottomBig'} flexCenter colorWhite saf1 backgroundActiveColor cursorPointer`}>
                                {
                                    // needApproveButton(marginToken0DataNeedApprove, isBorrow ? 'Borrow' : (isMargin ? `Margin ${isMarginSell ? 'Sell' : 'Buy'}` : 'Swap'))
                                    needApproveButton(marginToken0DataNeedApprove, isBorrow ? 'Borrow' : (isMargin ? 'Confirm' : 'Swap'))
                                }
                            </div>
                    return <div>
                        {isPhoneClientWidth
                            ? pageTopFootPhone(
                                <div className={'positionRelative zIndex1'}>
                                    <div style={{
                                        top: 0,
                                        height: '30.04rem',
                                        backgroundSize: 'cover',
                                        backgroundRepeat: 'no-repeat',
                                        backgroundPosition: 'center center',
                                        backgroundImage: `url(${requireDefault('tradeBGPhone')})`
                                    }} className={'positionAbsolute width100 zIndex-1'}/>
                                    <div className={'childrenSpacingTopBigPhone paddingBigPhone'}
                                         style={{paddingTop: '4rem', paddingBottom: '3rem'}}
                                    >
                                        {marginSwapList}
                                        {marginSwapItem}
                                    </div>
                                </div>
                            )
                            : <div>
                                {pageTop}
                                <div style={{
                                    minHeight: '18rem',
                                    backgroundSize: 'cover',
                                    backgroundRepeat: 'no-repeat',
                                    backgroundPosition: 'center center',
                                    backgroundImage: `url(${requireDefault('tradeBG')})`
                                }}>
                                    <div className={'flexCenter'} style={{paddingTop: '2rem'}}>
                                        <div style={{width: '30%'}} className={'childrenSpacingTopBig'}>
                                            {marginSwapList}
                                            {marginSwapItem}
                                        </div>
                                    </div>
                                </div>
                                {pageFoot}
                            </div>}
                        {selectTokenContent}
                        {tradingContestMask}
                        {maskContent(
                            // `You’re ${isBorrow ? 'Borrow' : `Margin ${isMarginSell ? 'Selling' : 'Buying'}`}`,
                            `You’re ${isBorrow ? 'Borrow' : 'Confirming'}`,
                            showMarginSelling,
                            toggleShowMarginSelling,
                            <div
                                className={isPhoneClientWidth ? 'childrenSpacingTopBiggerPhone' : 'childrenSpacingTopBigger'}>
                                <div/>
                                {
                                    [
                                        ['Supply', newAmount, marginToken0Data, marginToken0Symbol],
                                        ...isBorrow ? [['Borrow', newBorrowAmount, marginToken1Data, marginToken1Symbol]] : []
                                    ].map(v => <div
                                        className={isPhoneClientWidth ? 'childrenSpacingTopPhone' : 'childrenSpacingTop'}>
                                        {isBorrow && <div className={'colorGray'}>{v[0]}</div>}
                                        <div
                                            className={`${isPhoneClientWidth ? 'paddingBigPhone borderRadiusPhone borderSmallGrayLinePhone' : 'paddingBig borderRadius borderSmallGrayLine'} flex alignItemsCenter justifyContentSpaceBetween childrenSpacingLeft`}>
                                            <div
                                                className={isPhoneClientWidth ? 'biggerFontSizePhone' : 'biggerFontSize'}>
                                                {v[1]}
                                            </div>
                                            <div
                                                className={`borderRadius999 saf flexCenter ${isPhoneClientWidth ? 'childrenSpacingLeftPhone' : 'childrenSpacingLeft'}`}
                                                style={{
                                                    height: `${isPhoneClientWidth ? 2 : .8}rem`,
                                                    padding: `0 ${isPhoneClientWidth ? .7 : .3}rem`,
                                                }}>
                                                {tokenIcon(v[2], `${isPhoneClientWidth ? 1.5 : .5}rem`)}
                                                <div>{v[3]}</div>
                                            </div>
                                        </div>
                                    </div>)
                                }
                                <div
                                    className={isPhoneClientWidth ? 'childrenSpacingTopBigPhone' : 'childrenSpacingTopBig'}>
                                    {marginData(true)}
                                </div>
                                {isMargin && !isBorrow && highDynamicFees(feeData[1])}
                                {tradeButton}
                            </div>,
                            '10'
                        )}
                        {maskContent(
                            'You’re Swapping',
                            showSwapping,
                            toggleShowSwapping,
                            <div
                                style={{marginTop: `${isPhoneClientWidth ? 3 : .7}rem`}}
                                className={isPhoneClientWidth ? 'childrenSpacingTopBiggerPhone' : 'childrenSpacingTopBigger'}>
                                <div
                                    className={isPhoneClientWidth ? 'childrenSpacingTopBigPhone' : 'childrenSpacingTopBig'}>
                                    {marginTokenDatas.map((v, i) => [
                                            <div
                                                className={isPhoneClientWidth ? 'paddingBigPhone borderRadiusPhone borderSmallGrayLinePhone childrenSpacingTopPhone' : 'paddingBig borderRadius borderSmallGrayLine childrenSpacingTop'}>
                                                <div
                                                    className={`flexCenter justifyContentSpaceBetween ${isPhoneClientWidth ? 'childrenSpacingLeftPhone' : 'childrenSpacingLeft'}`}>
                                                    <div
                                                        className={isPhoneClientWidth ? 'bigFontSizePhone' : 'bigFontSize'}>{i === 0 ? newAmount : transitionPrice}</div>
                                                    <div
                                                        className={`borderRadius999 saf flexCenter ${isPhoneClientWidth ? 'childrenSpacingLeftPhone borderSmallGrayLinePhone' : 'childrenSpacingLeft borderSmallGrayLine'}`}
                                                        style={{
                                                            height: `${isPhoneClientWidth ? 2.5 : .8}rem`,
                                                            padding: `0 ${isPhoneClientWidth ? .7 : .3}rem`,
                                                        }}>
                                                        {
                                                            (() => {
                                                                const size = `${isPhoneClientWidth ? 1.5 : .5}rem`,
                                                                    isL = i && !isExactInput
                                                                return [
                                                                    <div className={'positionRelative'}
                                                                         style={square(size)}>
                                                                        {tokenIcon(v, size)}
                                                                        {!!isL && <div
                                                                            className={'positionAbsolute width100 height100 boxSizingBorderBox flexCenter borderRadius999'}
                                                                            style={{top: 0}}
                                                                        ><img src={requireDefault('lToken')} alt=""
                                                                              className={'width100 height100'}/>
                                                                        </div>}
                                                                    </div>,
                                                                    <div>{isL ? 'l' : ''}{v.symbol}</div>
                                                                ]
                                                            })()
                                                        }
                                                    </div>
                                                </div>
                                                {/*<div*/}
                                                {/*    className={`${isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'} colorGray`}>{v.symbol}</div>*/}
                                            </div>,
                                            ...i === 0
                                                ? [
                                                    <div className={'flexCenter'}>
                                                        <img src={requireDefault('bottomArrow')} alt=""
                                                             style={{width: `${isPhoneClientWidth ? 1.5 : .5}rem`}}/>
                                                    </div>
                                                ]
                                                : [],
                                        ]
                                    )}
                                </div>
                                <div
                                    className={isPhoneClientWidth ? 'childrenSpacingTopBigPhone' : 'childrenSpacingTopBig'}>
                                    {swapFee(!isExactInput)}
                                </div>
                                {highDynamicFees(feeData[1])}
                                {tradeButton}
                            </div>)}
                        {positionsPoolsContent}
                        {depositMask}
                        {researchMask}
                        {loading}
                        {isSwap && maskContent(
                            'Notice',
                            checkDataBool(data, 'showDespite'),
                            toggleShowDespite,
                            <div
                                className={isPhoneClientWidth ? 'paddingPhone childrenSpacingTopBigPhone' : 'padding childrenSpacingTopBig'}>
                                        <pre className={isPhoneClientWidth ? 'textAlignCenter' : ''}>{isPhoneClientWidth
                                            ? `When real liquidity for a token is temporarily unavailable, 
LIKWID allows users to swap into a synthetic interest-bearing version (lToken).
These derivatives represent claims on the underlying token and can be redeemed once liquidity resumes.`
                                            : `When real liquidity for a token is temporarily unavailable, LIKWID allows users to swap into a synthetic interest-bearing version (lToken).
These derivatives represent claims on the underlying token and can be redeemed once liquidity resumes.`}</pre>
                                <div onClick={() => {
                                    toggleShowDespite()
                                    toggleShowSwapping(true)
                                }}
                                     className={`${isPhoneClientWidth ? 'borderRadiusPhone paddingTopBottomPhone' : 'borderRadius paddingTopBottomBig'} flexCenter colorWhite saf1 backgroundActiveColor cursorPointer`}>
                                    Confirm
                                </div>
                            </div>,
                            undefined,
                            undefined,
                            true
                        )}
                    </div>
                })(),
                'pool/*': !isHome && (() => {
                    const poolTitle = <div className={'flexCenter justifyContentSpaceBetween'}>
                        <div onClick={() => windowReplace('/pool')}
                             className={`flexCenter ${isPhoneClientWidth ? 'childrenSpacingLeftSmallPhone' : 'childrenSpacingLeftSmall'} cursorPointer`}>
                            <img src={requireDefault('leftArrow')} alt=""
                                 style={{width: `${isPhoneClientWidth ? .9 : .3}rem`}}/>
                            <div
                                className={`colorGray ${isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'}`}>
                                {liquidityTitle}
                            </div>
                        </div>
                        {settingContent()}
                    </div>
                    return isPoolSupplyWithdraw
                        ? (() => {
                            const container = [
                                <div
                                    className={isPhoneClientWidth ? 'childrenSpacingTopBigPhone' : 'childrenSpacingTopBig'}>
                                    {poolTitle}
                                </div>,
                                ...supplyWithdrawContainer
                            ]
                            return <div>
                                {isPhoneClientWidth
                                    ? pageTopFootPhone(
                                        <div className={'positionRelative zIndex1'}>
                                            <div style={{
                                                top: 0,
                                                height: '30.04rem',
                                                backgroundSize: 'cover',
                                                backgroundRepeat: 'no-repeat',
                                                backgroundPosition: 'center center',
                                                backgroundImage: `url(${requireDefault('tradeBGPhone')})`
                                            }} className={'positionAbsolute width100 zIndex-1'}/>
                                            <div className={'childrenSpacingTopBigPhone paddingBigPhone'}
                                                 style={{paddingTop: '4rem', paddingBottom: `21rem`}}
                                            >
                                                {container}
                                            </div>
                                        </div>
                                    )
                                    : <div>
                                        {pageTop}
                                        <div style={{
                                            minHeight: '18rem',
                                            backgroundSize: 'cover',
                                            backgroundRepeat: 'no-repeat',
                                            backgroundPosition: 'center center',
                                            backgroundImage: `url(${requireDefault('tradeBG')})`
                                        }}>
                                            <div className={'flexCenter'} style={{paddingTop: '2rem'}}>
                                                <div style={{width: '30%'}} className={'childrenSpacingTopBig'}>
                                                    {container}
                                                </div>
                                            </div>
                                        </div>
                                        {pageFoot}
                                    </div>}
                                {positionsPoolsContent}
                                {selectTokenContent}
                                {depositMask}
                                {loading}
                            </div>
                        })()
                        : (() => {
                            const content =
                                isPoolDetail
                                    ? (() => {
                                        const labelValue = v => <div
                                                className={`flex alignItemsCenter justifyContentSpaceBetween ${isPhoneClientWidth ? 'childrenSpacingLeftPhone' : 'childrenSpacingLeft'}`}>
                                                {v.map(
                                                    v => <div
                                                        className={`${isPhoneClientWidth ? 'childrenSpacingTopPhone' : 'childrenSpacingTopSmall'} flexGrow1`}>
                                                        <div
                                                            className={`colorGray ${isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'}`}>{v[0]}</div>
                                                        <div className={'flex alignItemsCenter'}>
                                                            {(() => {
                                                                const isAPR = v[0] === 'APR'
                                                                return <div
                                                                    onMouseEnter={() => isAPR && setShowAPRDetail(true)}
                                                                    onMouseLeave={() => isAPR && setShowAPRDetail()}
                                                                    style={isAPR ? {borderBottom: `${isPhoneClientWidth ? .06 : .02}rem dashed black`} : {}}
                                                                    className={`positionRelative flexColumn alignItemsCenter saf1 ${isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'}`}>
                                                                    {v[1]}
                                                                    {isAPR && aprDetail(poolData)}
                                                                </div>
                                                            })()}
                                                            <div
                                                                className={isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'}>{v[2]}</div>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>,
                                            proportion = (title0, title1, decimals, num, total) => {
                                                const numPercentageReplace = percentageReplace(divide(num, total))
                                                return <div
                                                    style={isPhoneClientWidth ? {width: '100%'} : {width: '90%'}}
                                                    className={isPhoneClientWidth ? 'childrenSpacingTopSmallPhone' : 'childrenSpacingTopSmall'}>
                                                    <div
                                                        className={`activeColor ${isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'}`}>
                                                        {title0}: {numberETH(num, decimals)}
                                                    </div>
                                                    <div
                                                        style={{
                                                            height: `${isPhoneClientWidth ? .3 : .1}rem`,
                                                            background: '#EFEFEF'
                                                        }}
                                                        className={'borderRadius999'}>
                                                        <div style={{width: `${numPercentageReplace}%`}}
                                                             className={'height100 backgroundActiveColor borderRadius999'}/>
                                                    </div>
                                                    {
                                                        (() => {
                                                            const num1 = minus(total, num)
                                                            return <div
                                                                className={`colorGray textAlignRight ${isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'}`}>
                                                                {title1}: {numberETH(num1, decimals)}
                                                            </div>
                                                        })()
                                                    }
                                                </div>
                                            },
                                            xRroportionNums = i => {
                                                const realReserve = checkData0(data, `realReserve${i}`),
                                                    pairReserve = checkData0(data, `pairReserve${i}`)
                                                return [
                                                    greaterThanOrEqualTo(realReserve, pairReserve) ? pairReserve : realReserve,
                                                    pairReserve
                                                ]
                                            },
                                            circularProgress = (
                                                size,
                                                strokeWidth,
                                                percentage,
                                                color = '#FF8E9D',
                                                bgColor = '#E8E8E8',
                                                remSize = document.body.clientWidth / 30
                                            ) => {
                                                const parseRem = value => {
                                                        if (typeof value === 'string' && value.endsWith('rem')) {
                                                            return parseFloat(value) * remSize
                                                        }
                                                        return parseFloat(value)
                                                    },
                                                    sizePx = parseRem(size),
                                                    strokePx = parseRem(strokeWidth),
                                                    radius = (sizePx - strokePx) / 2,
                                                    circumference = 2 * Math.PI * radius,
                                                    offset = circumference - (percentage / 100) * circumference
                                                return <svg width={size} height={size}
                                                            style={{marginLeft: `${isPhoneClientWidth ? 3 : 1}rem`}}>
                                                    <circle
                                                        stroke={bgColor}
                                                        fill="transparent"
                                                        strokeWidth={strokePx}
                                                        r={radius}
                                                        cx={sizePx / 2}
                                                        cy={sizePx / 2}
                                                    />
                                                    <circle
                                                        stroke={color}
                                                        fill="transparent"
                                                        strokeWidth={strokePx}
                                                        strokeLinecap="round"
                                                        strokeDasharray={circumference}
                                                        strokeDashoffset={offset}
                                                        r={radius}
                                                        cx={sizePx / 2}
                                                        cy={sizePx / 2}
                                                        transform={`rotate(-90 ${sizePx / 2} ${sizePx / 2})`}
                                                    />
                                                    <text
                                                        x="50%"
                                                        y="50%"
                                                        dy="0.3em"
                                                        textAnchor="middle"
                                                        className={'saf1'}
                                                        fontSize={`${isPhoneClientWidth ? .9 : .3}rem`}
                                                    >
                                                        {toFixed(minus(100, percentage), 2)}%
                                                    </text>
                                                </svg>
                                            }
                                        return <div className={isPhoneClientWidth ? '' : 'flexCenter'}
                                                    style={{
                                                        paddingTop: `${isPhoneClientWidth ? 0 : 2}rem`
                                                    }}>
                                            <div style={isPhoneClientWidth ? {} : {width: '55%'}}
                                                 className={isPhoneClientWidth ? 'childrenSpacingTopBiggerPhone' : 'childrenSpacingTopBigger'}>
                                                <div
                                                    className={isPhoneClientWidth ? 'childrenSpacingTopBigPhone' : 'childrenSpacingTopBig'}>
                                                    <div className={'flexCenter justifyContentSpaceBetween'}>
                                                        <div onClick={() => windowReplace('/pool')}
                                                             className={`flexCenter ${isPhoneClientWidth ? 'childrenSpacingLeftSmallPhone' : 'childrenSpacingLeftSmall'} cursorPointer`}>
                                                            <img src={requireDefault('leftArrow')} alt=""
                                                                 style={{width: `${isPhoneClientWidth ? .9 : .3}rem`}}/>
                                                            <div
                                                                className={`colorGray ${isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'}`}>
                                                                Back
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div
                                                    className={isPhoneClientWidth ? 'childrenSpacingTopBiggerPhone' : 'flex alignItemsCenter childrenSpacingLeft'}>
                                                    <div className={'flex alignItemsCenter childrenSpacingLeft'}>
                                                        {tokenIcon(poolData, `${isPhoneClientWidth ? 2.1 : .7}rem`)}
                                                        <div>
                                                            <div>{showPoolName(poolDataName)}</div>
                                                            {showFees(poolData)}
                                                        </div>
                                                        {showResearchIcon(poolData)}
                                                    </div>
                                                    <div
                                                        className={`flex alignItemsCenter ${isPhoneClientWidth ? 'childrenSpacingLeftPhone' : 'childrenSpacingLeft'}`}>{(
                                                        () => {
                                                            const sC = checkData([searchChains.filter(v => equalTo(chainId, v[1].id)), 0, 0])
                                                            return [
                                                                ['Margin-2', `/trade/margin?chain=${sC}&poolid=${poolDataPoolId}`, 'Margin'],
                                                                ['Swap-3', `/trade/swap?chain=${sC}&inputCurrency=${addressToCurrencyAddress(token0Address)}&outputCurrency=${addressToCurrencyAddress(token1Address)}`, 'Swap'],
                                                            ].map(v => <div
                                                                style={{padding: `${isPhoneClientWidth ? .45 : .15}rem ${isPhoneClientWidth ? .6 : .2}rem`}}
                                                                className={`${isPhoneClientWidth ? 'borderActiveColorSmallPhone childrenSpacingLeftSmallPhone' : 'borderActiveColorSmall childrenSpacingLeftSmall'} borderRadius999 flex alignItemsCenter cursorPointer`}
                                                                onClick={() => windowOpen(v[1])}
                                                            >
                                                                <img src={requireDefault(v[0])} alt=""
                                                                     style={square(`${isPhoneClientWidth ? .75 : .25}rem`)}/>
                                                                <div
                                                                    className={`${isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'} activeColor`}>
                                                                    Go to {v[2]}</div>
                                                            </div>)
                                                        }
                                                    )()}</div>
                                                </div>
                                                <div
                                                    className={`flex alignItemsCenter ${isPhoneClientWidth ? 'childrenSpacingLeftPhone' : 'childrenSpacingLeft'}`}>
                                                    {
                                                        tokenDatas.map((v, i) => {
                                                                const {tokenAddress} = v
                                                                return [
                                                                    <div
                                                                        className={`flex alignItemsCenter ${isPhoneClientWidth ? 'childrenSpacingLeftSmallPhone' : 'childrenSpacingLeftSmall'}`}>
                                                                        <div
                                                                            className={`flex alignItemsCenter ${isPhoneClientWidth
                                                                                ? 'childrenSpacingLeftSmallPhone paddingSmallPhone'
                                                                                : 'childrenSpacingLeftSmall paddingSmall'} borderRadius999 backgroundGrey`}>
                                                                            <div
                                                                                className={isPhoneClientWidth ? '' : 'smallFontSize'}>
                                                                                {leaveOut(tokenAddress, 7, 5)}
                                                                            </div>
                                                                            <img onClick={() => copyText(tokenAddress)}
                                                                                 className={'cursorPointer'}
                                                                                 src={requireDefault('copy1')}
                                                                                 alt=""
                                                                                 style={square(`${isPhoneClientWidth ? 1 : .2}rem`)}/>
                                                                        </div>
                                                                        <img
                                                                            onClick={() => windowOpenTokenAddress(tokenAddress)}
                                                                            className={'cursorPointer'}
                                                                            src={requireDefault('Group 427320833')}
                                                                            alt=""
                                                                            style={square(`${isPhoneClientWidth ? 1.1 : .3}rem`)}/>
                                                                    </div>,
                                                                    ...i
                                                                        ? []
                                                                        : [
                                                                            <div
                                                                                className={isPhoneClientWidth ? 'bigFontSizePhone' : 'bigFontSize'}>/</div>
                                                                        ]
                                                                ]
                                                            }
                                                        )
                                                    }
                                                </div>
                                                {(() => {
                                                    const itemFunc = v => <div
                                                        className={isPhoneClientWidth ? 'childrenSpacingTopPhone' : 'childrenSpacingTop'}>
                                                        <div
                                                            className={'flex alignItemsCenter justifyContentSpaceBetween'}>
                                                            <div
                                                                className={`flex alignItemsCenter ${isPhoneClientWidth ? 'childrenSpacingLeftPhone' : 'childrenSpacingLeft'}`}>
                                                                <img src={requireDefault(v[0])} alt=""
                                                                     style={{width: `${isPhoneClientWidth ? 1.5 : .5}rem`}}/>
                                                                <div
                                                                    className={`${isPhoneClientWidth ? 'bigFontSizePhone' : 'bigFontSize'} saf1`}>{v[0]}</div>
                                                                <img className={'cursorPointer'}
                                                                     onClick={() => windowOpenTokenAddress(v[4])}
                                                                     src={requireDefault('Group 427320870')} alt=""
                                                                     style={{width: `${isPhoneClientWidth ? 1.2 : .4}rem`}}/>
                                                            </div>
                                                            <div
                                                                style={isPhoneClientWidth ? {
                                                                    paddingTop: '.5rem',
                                                                    paddingBottom: '.5rem'
                                                                } : {}}
                                                                onClick={() => windowReplace(`/pool/${v[2]}?poolid=${poolDataPoolId}`)}
                                                                className={`flexCenter ${isPhoneClientWidth
                                                                    ? 'boxSizingBorderBox paddingPhone childrenSpacingLeftSmallPhone'
                                                                    : 'padding childrenSpacingLeftSmall'} backgroundActiveColor borderRadius999 cursorPointer`}>
                                                                <img src={requireDefault('add')} alt=""
                                                                     style={{width: `${isPhoneClientWidth ? .75 : .25}rem`}}/>
                                                                <div
                                                                    className={`colorWhite ${isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'}`}>{v[1]}</div>
                                                            </div>
                                                        </div>
                                                        {v[3]}
                                                    </div>
                                                    return [
                                                        itemFunc([
                                                            'Swap pool', 'Add liquidity', 'add',
                                                            <div
                                                                className={`overflowVisible ${isPhoneClientWidth
                                                                    ? 'borderRadiusPhone paddingBigPhone borderSmallGrayLinePhone childrenSpacingTopBigPhone'
                                                                    : 'flex borderRadius paddingBigger borderSmallGrayLine'} backgroundWhite`}>
                                                                <div
                                                                    className={`flexColumn justifyContentSpaceBetween ${isPhoneClientWidth ? 'childrenSpacingTopBigPhone' : 'childrenSpacingTop flexGrow1'}`}>
                                                                    {
                                                                        [
                                                                            [
                                                                                ['24h Volume', ovl(poolData, 'oneDayVolUsd', undefined, true)],
                                                                                ['24h fees', ovl(poolData, 'oneDayFeesUsd', undefined, true)]
                                                                            ],
                                                                            [
                                                                                ['TVL', ovl(poolData, 'tvlUsd', undefined, true)],
                                                                                ['APR', `${getAPRs(poolData)[3]}%`]
                                                                            ]
                                                                        ].map(labelValue)
                                                                    }
                                                                </div>
                                                                <div
                                                                    style={isPhoneClientWidth ? {} : {width: '60%'}}
                                                                    className={`${isPhoneClientWidth
                                                                        ? 'borderTopSmallGrayLinePhone paddingTopBigPhone childrenSpacingTopBigPhone'
                                                                        : 'borderLeftSmallGrayLine childrenSpacingTop'} flexColumn justifyContentSpaceBetween alignItemsFlexEnd`}
                                                                >
                                                                    {
                                                                        [
                                                                            [token0Symbol, token0Decimals],
                                                                            [token1Symbol, token1Decimals]
                                                                        ].map(([title, decimals], i) => proportion(
                                                                            title,
                                                                            `Debt ${title}`,
                                                                            decimals,
                                                                            ...xRroportionNums(i)
                                                                        ))
                                                                    }
                                                                </div>
                                                            </div>,
                                                            pairPositionAddress
                                                        ]),
                                                        <div className={'flex'}>
                                                            <div
                                                                className={`${isPhoneClientWidth
                                                                    ? 'width100 boxSizingBorderBox borderRadiusPhone paddingBigPhone borderSmallGrayLinePhone childrenSpacingTopPhone'
                                                                    : 'borderRadius paddingBigger borderSmallGrayLine childrenSpacingTop'} backgroundWhite`}>
                                                                <div>Liquidity Unlock Schedule</div>
                                                                {(() => {
                                                                    const stageLiquidities = checkData([data, 'stageLiquidities'], [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0]]),
                                                                        stageLiquiditiesLength = stageLiquidities.length,
                                                                        stageLiquiditie0Total = stageLiquidities.map(v => v[0]).reduce((a, b) => plus(a, b), 0),
                                                                        totalHeight = isPhoneClientWidth ? 3.6 : 1.2,
                                                                        showRatio0 = ratio => `${times(
                                                                            totalHeight,
                                                                            divide(
                                                                                percentageNum(times(divide(
                                                                                    ratio,
                                                                                    divide(
                                                                                        stageLiquidities.map(v => v[0]).reduce((a, b) => greaterThan(a, b) ? a : b),
                                                                                        stageLiquiditie0Total
                                                                                    )
                                                                                ), 100)),
                                                                                100
                                                                            )
                                                                        )}rem`
                                                                    return <div
                                                                        style={{
                                                                            ...isPhoneClientWidth ? {
                                                                                transform: `scale(${divide('5', stageLiquiditiesLength)})`,
                                                                                transformOrigin: 'left'
                                                                            } : {}
                                                                        }}
                                                                        className={`flex ${isPhoneClientWidth ? 'paddingTopPhone childrenSpacingLeftPhone justifyContentSpaceBetween' : 'paddingTop childrenSpacingLeft'}`}>{
                                                                        stageLiquidities.map(({
                                                                                                  0: v0,
                                                                                                  1: v1
                                                                                              }, i) => [
                                                                            (() => {
                                                                                const lastStageTimestampStore = checkData0(data, 'lastStageTimestampStore'),
                                                                                    stageDuration = checkData0(data, 'stageDuration'),
                                                                                    blockCurrentTime = checkData0(data, 'blockCurrentTime'),
                                                                                    [firstItem] = stageLiquidities,
                                                                                    stageLeavePartBool = lessThanOrEqualTo(divide(firstItem[1], firstItem[0]), divide(1, checkData0(data, 'stageLeavePart'))),
                                                                                    blockCurrentTimeBool = lessThanOrEqualTo(plus(lastStageTimestampStore, stageDuration), blockCurrentTime),
                                                                                    isFirst = i === 0,
                                                                                    isSecond = i === 1
                                                                                return <div
                                                                                    style={{width: `${isPhoneClientWidth ? 3 : .9}rem`}}
                                                                                    className={`flexColumn alignItemsCenter ${isPhoneClientWidth ? 'childrenSpacingTopSmallPhone' : 'childrenSpacingTopSmall'}`}>
                                                                                    {(() => {
                                                                                        const locked = !(isFirst || isSecond) || !(isFirst || (stageLeavePartBool && blockCurrentTimeBool)),
                                                                                            ratio0 = divide(v0, stageLiquiditie0Total)
                                                                                        return <div
                                                                                            style={{height: `${totalHeight}rem`}}
                                                                                            className={`${isPhoneClientWidth ? 'childrenSpacingTopSmallPhone' : 'childrenSpacingTopSmall'} flexColumn justifyContentFlexEnd`}>
                                                                                            <div
                                                                                                className={`saf1 textAlignCenter ${isPhoneClientWidth ? 'smallerFontSizePhone' : 'smallerFontSize'} flexGrow1Column flexColumn justifyContentFlexEnd`}>
                                                                                                {`${percentageNum(times(ratio0, 100))}%`}
                                                                                            </div>
                                                                                            <div
                                                                                                className={`${locked ? '' : 'borderSmallBlackLine'} boxSizingBorderBox positionRelative overflowHidden zIndex1`}
                                                                                                style={{
                                                                                                    height: showRatio0(ratio0),
                                                                                                    width: `${isPhoneClientWidth ? 3 : .9}rem`,
                                                                                                    borderTopLeftRadius: `${isPhoneClientWidth ? .45 : .15}rem`,
                                                                                                    borderTopRightRadius: `${isPhoneClientWidth ? .45 : .15}rem`,
                                                                                                    borderWidth: `${isPhoneClientWidth ? 0.105 : .035}rem`,
                                                                                                    ...locked ? {background: 'linear-gradient(180deg, #FFEBED 0%, #FCC4CB 100%)'} : {}
                                                                                                }}>
                                                                                                {(() => {
                                                                                                    const ratio1 = divide(v1, stageLiquiditie0Total)// `${percentageNum(times(divide(v1, stageLiquiditie0Total), 100))}%`
                                                                                                    return [
                                                                                                        <div
                                                                                                            className={'width100 height100 boxSizingBorderBox flexColumnCenter justifyContentSpaceBetween'}>
                                                                                                            <div/>
                                                                                                            <img
                                                                                                                src={requireDefault('lock1')}
                                                                                                                // className={'paddingTop'}
                                                                                                                alt=""
                                                                                                                style={{
                                                                                                                    opacity: locked ? 1 : 0,
                                                                                                                    width: `${isPhoneClientWidth ? .9 : .3}rem`
                                                                                                                }}/>
                                                                                                            {locked
                                                                                                                ?
                                                                                                                <div/>
                                                                                                                :
                                                                                                                <div
                                                                                                                    style={{paddingTop: `${isPhoneClientWidth ? .3 : .1}rem`}}
                                                                                                                    className={`saf1 ${isPhoneClientWidth ? 'smallerFontSizePhone' : 'smallerFontSize'}`}>
                                                                                                                    {`${percentageNum(times(ratio1, 100))}%`}
                                                                                                                </div>}
                                                                                                        </div>,
                                                                                                        !locked &&
                                                                                                        <div
                                                                                                            className={'positionAbsolute flexColumn zIndex-1'}
                                                                                                            style={{
                                                                                                                height: showRatio0(ratio1),
                                                                                                                bottom: 0,
                                                                                                                left: 0,
                                                                                                                right: 0
                                                                                                            }}>
                                                                                                            <div
                                                                                                                style={{background: locked ? '#FCC4CB' : '#A5EBCA'}}
                                                                                                                className={'flexGrow1Column'}/>
                                                                                                        </div>
                                                                                                    ]
                                                                                                })()}
                                                                                            </div>
                                                                                        </div>
                                                                                    })()}
                                                                                    {
                                                                                        (isFirst || (isSecond && stageLeavePartBool)) &&
                                                                                        <div
                                                                                            style={{fontSize: `${isPhoneClientWidth ? .45 : .15}rem`}}
                                                                                            className={`colorGray`}>{
                                                                                            isFirst || blockCurrentTimeBool ? 'Available' : 'Unlocks in'
                                                                                        }
                                                                                        </div>
                                                                                    }
                                                                                    {isSecond && stageLeavePartBool && !blockCurrentTimeBool &&
                                                                                        <div
                                                                                            style={{fontSize: `${isPhoneClientWidth ? .45 : .15}rem`}}
                                                                                            className={`saf1`}>
                                                                                            {(() => {
                                                                                                const seconds = minus(plus(lastStageTimestampStore, stageDuration), blockCurrentTime)
                                                                                                return `${Math.floor(seconds / 3600)}h ${Math.floor((seconds % 3600) / 60)}m`
                                                                                            })()}
                                                                                        </div>}
                                                                                </div>
                                                                            })(),
                                                                            i !== stageLiquiditiesLength - 1 &&
                                                                            <img
                                                                                src={requireDefault('Rectangle 34624629')}
                                                                                alt=""
                                                                                style={{
                                                                                    marginTop: `${isPhoneClientWidth ? 3.2 : 1.1}rem`,
                                                                                    height: `${isPhoneClientWidth ? .27 : .08}rem`
                                                                                }}/>
                                                                        ])
                                                                    }</div>
                                                                })()}
                                                            </div>
                                                        </div>,
                                                        itemFunc([
                                                            'Lending pool', 'Supply lending liquidity', 'supply',
                                                            <div
                                                                className={`overflowVisible ${isPhoneClientWidth
                                                                    ? 'borderRadiusPhone paddingBigPhone borderSmallGrayLinePhone childrenSpacingTopBigPhone'
                                                                    : 'borderRadius paddingBigger borderSmallGrayLine childrenSpacingTop'} backgroundWhite`}>
                                                                {
                                                                    [
                                                                        [token0Symbol, token0Decimals],
                                                                        [token1Symbol, token1Decimals]
                                                                    ].map(([title, decimals], i) => {
                                                                        const lendingRealReserve = numberETH(checkData0(data, `lendingRealReserve${i}`), decimals),
                                                                            total = num8(plus(
                                                                                lendingRealReserve,
                                                                                numberETH(checkData0(data, `lendingMirrorReserve${i}`), decimals)
                                                                            ))
                                                                        return <div
                                                                            className={`${isPhoneClientWidth ? 'childrenSpacingTopBigPhone' : 'flex'} ${i ? `${isPhoneClientWidth ? 'borderTopSmallGrayLinePhone paddingTopBigPhone' : 'borderTopSmallGrayLine paddingTop'}` : ''}`}>
                                                                            <div
                                                                                className={`flexColumn justifyContentSpaceBetween ${isPhoneClientWidth ? 'childrenSpacingTopPhone' : 'flexGrow1 childrenSpacingTop'}`}>
                                                                                {labelValue(
                                                                                    [
                                                                                        ['Borrow APR', `${percentageReplace(checkData0(data, `apy${i}`))}%`],
                                                                                        ['Supply APR', `${numToPercentage(checkData0(data, `lendingAPR${i}`))}%`]
                                                                                    ].map(v => [`${title} ${v[0]}`, v[1]])
                                                                                )}
                                                                            </div>
                                                                            <div
                                                                                style={isPhoneClientWidth ? {} : {width: '60%'}}
                                                                                className={`flexColumn justifyContentSpaceBetween alignItemsFlexEnd ${isPhoneClientWidth ? 'childrenSpacingTopPhone' : 'childrenSpacingTop'}`}
                                                                            >
                                                                                {
                                                                                    proportion(
                                                                                        title,
                                                                                        `Debt ${title}`,
                                                                                        decimals,
                                                                                        minus(
                                                                                            checkData0(data, `realReserve${i}`),
                                                                                            xRroportionNums(i)[0]
                                                                                        ),
                                                                                        checkData0(data, `lendReserve${i}`)
                                                                                    )
                                                                                }
                                                                            </div>
                                                                        </div>
                                                                    })
                                                                }
                                                            </div>,
                                                            lendPositionAddress
                                                        ])
                                                    ]
                                                })()}
                                                {
                                                    <div
                                                        className={isPhoneClientWidth ? 'childrenSpacingTopPhone' : 'flex alignItemsCenter childrenFlexGrow1 childrenSpacingLeftBigger'}>{
                                                        [
                                                            [token0Symbol, token0Decimals],
                                                            [token1Symbol, token1Decimals]
                                                        ].map(([symbol, decimals], i) => {
                                                            const suppliedReserve = numberETH(checkData0(data, `suppliedReserve${i}`), decimals),
                                                                borrowedReserve = numberETH(checkData0(data, `borrowedReserve${i}`), decimals)
                                                            return <div
                                                                className={`${isPhoneClientWidth ? 'borderRadiusPhone paddingPhone borderSmallGrayLinePhone justifyContentSpaceBetween' : 'borderRadius padding borderSmallGrayLine'} flex alignItemsCenter boxSizingBorderBox`}>
                                                                <div
                                                                    className={isPhoneClientWidth ? 'childrenSpacingTopBigPhone paddingPhone' : 'childrenSpacingTopBig paddingBig'}>
                                                                    <div
                                                                        className={isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'}>{symbol} Utilization
                                                                    </div>
                                                                    <div
                                                                        className={isPhoneClientWidth ? 'childrenSpacingTopPhone' : 'childrenSpacingTop'}>{
                                                                        [
                                                                            [`Borrowable: ${suppliedReserve}`, 'backgroundActiveColor'],
                                                                            [`Borrowed: ${borrowedReserve}`, 'backGroundColorGray'],
                                                                        ].map(v => <div
                                                                            className={`${isPhoneClientWidth ? 'childrenSpacingLeftSmall' : 'childrenSpacingLeftSmall'} flex alignItemsCenter`}>
                                                                            <div
                                                                                className={`borderRadius999 ${v[1]}`}
                                                                                style={square(`${isPhoneClientWidth ? .6 : .2}rem`)}/>
                                                                            <div
                                                                                className={`colorGray ${isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'}`}>{v[0]}</div>
                                                                        </div>)
                                                                    }</div>
                                                                </div>
                                                                {circularProgress(
                                                                    isPhoneClientWidth ? '5.4rem' : '1.8rem',
                                                                    isPhoneClientWidth ? '.75rem' : '.25rem',
                                                                    times(
                                                                        divide(
                                                                            suppliedReserve,
                                                                            plus(
                                                                                suppliedReserve,
                                                                                borrowedReserve
                                                                            )
                                                                        ),
                                                                        100
                                                                    )
                                                                )}
                                                            </div>
                                                        })
                                                    }</div>
                                                }
                                            </div>
                                        </div>
                                    })()
                                    : [
                                        isHandelLiquidity
                                            ? <div className={isPhoneClientWidth ? '' : 'flexCenter'}
                                                   style={{
                                                       paddingTop: `${isPhoneClientWidth ? 0 : 2}rem`
                                                   }}>
                                                <div style={isPhoneClientWidth ? {} : {width: '28%'}}
                                                     className={isPhoneClientWidth ? 'childrenSpacingTopBiggerPhone' : 'childrenSpacingTopBigger'}>
                                                    <div
                                                        className={isPhoneClientWidth ? 'childrenSpacingTopBigPhone' : 'childrenSpacingTopBig'}>
                                                        {poolTitle}
                                                        <div
                                                            className={`backgroundWhite overflowVisible ${isPhoneClientWidth ? 'borderSmallGrayLinePhone borderRadiusPhone paddingBigPhone childrenSpacingTopPhone' : 'borderSmallGrayLine borderRadius paddingBig childrenSpacingTop'}`}>
                                                            {selectTokenContainer}
                                                            {isPoolAddIncrease && <img src={requireDefault('Line 2')} alt=""
                                                                                       className={'width100'}/>}
                                                            {isPoolAdd && <div
                                                                className={'flex alignItemsCenter justifyContentSpaceBetween'}>
                                                                <div>Estimated APR：</div>
                                                                <div
                                                                    onMouseEnter={() => setShowAPRDetail(true)}
                                                                    onMouseLeave={() => setShowAPRDetail()}
                                                                    style={{borderBottom: `${isPhoneClientWidth ? .06 : .02}rem dashed black`}}
                                                                    className={`positionRelative flexColumn alignItemsCenter saf1`}>
                                                                    {getAPRs(poolData)[3]}%
                                                                    {aprDetail(poolData, undefined, true)}
                                                                </div>
                                                            </div>}
                                                        </div>
                                                    </div>
                                                    {(() => {
                                                        const showFeeTier = checkDataBool(data, 'showFeeTier')
                                                        return <div
                                                            className={`${isPhoneClientWidth ? 'borderRadiusPhone borderSmallGrayLinePhone paddingBigPhone childrenSpacingTopBigPhone' : 'borderRadius borderSmallGrayLine paddingBig childrenSpacingTopBig'} backgroundGrey`}>
                                                            <div
                                                                className={'flex alignItemsCenter justifyContentSpaceBetween'}>
                                                                <div
                                                                    className={'flex alignItemsCenter childrenSpacingLeftSmall'}>
                                                                    <div className={'colorGray'}>V2 LP -</div>
                                                                    {
                                                                        showFees({fee: feeTier, ...isPoolCreate && feeLT ? {} : {marginFee: marginFeeTier}}, '', true)
                                                                    }</div>
                                                                {isPoolCreate
                                                                    ? <div
                                                                        onClick={() => setData({showFeeTier: !showFeeTier})}
                                                                        className={'saf1 activeColor cursorPointer'}>{showFeeTier ? 'Hide' : 'More ⌵'}</div>
                                                                    : <img src={requireDefault('Fee Tier')} alt=""
                                                                           style={{width: `${isPhoneClientWidth ? 1.2 : .4}rem`}}/>
                                                                }
                                                            </div>
                                                            {showFeeTier && [
                                                                <div
                                                                    className={'flex alignItemsCenter justifyContentSpaceBetween childrenSpacingLeftBig'}>
                                                                    {feeTiers.map((v, i) => <div
                                                                        style={{width: '23%'}}
                                                                        onClick={() => setData({feeTierIndex: i})}
                                                                        className={`borderRadius999 cursorPointer ${feeTierIndex === i ? 'backgroundActiveColor colorWhite saf1' : 'backgroundWhite borderSmallGrayLine'} flexCenter paddingBig boxSizingBorderBox`}>
                                                                        {v}%
                                                                    </div>)}
                                                                </div>,
                                                                feeLT ? <div
                                                                        className={`flex ${isPhoneClientWidth ? 'childrenSpacingLeftPhone' : 'childrenSpacingLeft'}`}>
                                                                        <img src={requireDefault('attention 1')} alt=""
                                                                             style={square(`${isPhoneClientWidth ? 1.2 : .4}rem`)}/>
                                                                        <div
                                                                            className={`colorRed saf1 ${isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'}`}>
                                                                            If LP wants to support leverage trading, the
                                                                            handling
                                                                            fee
                                                                            must
                                                                            be greater than or equal to 0.3%
                                                                        </div>
                                                                    </div>
                                                                    : [
                                                                        <div>Margin Fee</div>,
                                                                        <div
                                                                            className={'flex alignItemsCenter justifyContentSpaceBetween childrenSpacingLeftBig'}>
                                                                            {marginFeeTiers.map((v, i) => <div
                                                                                style={{width: '23%'}}
                                                                                onClick={() => setData({marginFeeTierIndex: i})}
                                                                                className={`borderRadius999 cursorPointer ${marginFeeTierIndex === i ? 'backgroundActiveColor colorWhite saf1' : 'backgroundWhite borderSmallGrayLine'} flexCenter paddingBig boxSizingBorderBox`}>
                                                                                {v}%
                                                                            </div>)}
                                                                        </div>
                                                                    ]
                                                            ]}
                                                        </div>
                                                    })()}
                                                    <div
                                                        className={isPhoneClientWidth ? 'childrenSpacingTopBigPhone' : 'childrenSpacingTopBig'}>
                                                        {tokenDatas.map((v, i) => {
                                                            const balance = checkData0(v.balance),
                                                                isClose = checkDataBool(v, 'isClose')
                                                            return <div
                                                                className={isPhoneClientWidth ? 'childrenSpacingTopBigPhone' : 'childrenSpacingTopBig'}>
                                                                <div
                                                                    className={`${i === 0 ? 'backgroundGrey' : (isPhoneClientWidth ? 'borderSmallGrayLinePhone' : 'borderSmallGrayLine')} ${isPhoneClientWidth ? 'paddingBigPhone childrenSpacingTopBigPhone borderRadiusPhone' : 'paddingBig childrenSpacingTopBig borderRadius'}`}
                                                                >
                                                                    <div
                                                                        className={`flex alignItemsCenter justifyContentSpaceBetween ${isPhoneClientWidth ? 'childrenSpacingLeftPhone' : 'childrenSpacingLeft'}`}>
                                                                        <input type="text"
                                                                               placeholder='0'
                                                                               ref={i === 0 ? focusInput : undefined}
                                                                               value={checkDataString(v, 'newAmount')}
                                                                               onChange={e => setTokenNewAmount(v, e.target.value)}
                                                                               className={`${isPhoneClientWidth ? 'biggerFontSizePhone' : 'biggerFontSize'} flexGrow1`}/>
                                                                        <div
                                                                            className={`borderRadius999 saf backgroundWhite flexCenter ${isPhoneClientWidth ? 'borderSmallGrayLinePhone childrenSpacingLeftSmallPhone' : 'borderSmallGrayLine childrenSpacingLeft'}`}
                                                                            style={{
                                                                                height: `${isPhoneClientWidth ? 2.4 : .8}rem`,
                                                                                padding: `0 ${isPhoneClientWidth ? .7 : .3}rem`,
                                                                            }}>
                                                                            {tokenIcon(v, `${isPhoneClientWidth ? 1.5 : .5}rem`)}
                                                                            <div>{v.symbol}</div>
                                                                        </div>
                                                                    </div>
                                                                    <div
                                                                        className={'flexCenter justifyContentSpaceBetween'}>
                                                                        <div
                                                                            className={`${isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'} colorGray`}>
                                                                            {/*{i === 0 && `$${toFixed(times(token0NewAmount, checkData0(data, `${token0Address}Price`)), 2)}`}*/}
                                                                        </div>
                                                                        <div
                                                                            className={`flexCenter ${isPhoneClientWidth ? 'childrenSpacingLeftPhone' : 'childrenSpacingLeft'}`}>
                                                                            <div
                                                                                className={`${isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'}`}>
                                                                                {balance} {v.symbol}
                                                                            </div>
                                                                            <div
                                                                                onClick={() => setTokenNewAmount(v, balance)}
                                                                                style={{fontSize: `${isPhoneClientWidth ? .6 : .15}rem`}}
                                                                                className={`backgroundActiveColor ${isPhoneClientWidth ? 'paddingSmallPhone' : 'paddingSmall'} borderRadius999 colorWhite cursorPointer`}>MAX
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                {/*{*/}
                                                                {/*    (() => {*/}
                                                                {/*        const showSimultaneously = checkDataBool(v, 'showSimultaneously')*/}
                                                                {/*        return <div*/}
                                                                {/*            className={isPhoneClientWidth ? 'childrenSpacingTopPhone' : 'childrenSpacingTop'}>*/}
                                                                {/*            <div*/}
                                                                {/*                className={'flexCenter justifyContentSpaceBetween'}>*/}
                                                                {/*                <div*/}
                                                                {/*                    className={`flexCenter ${isPhoneClientWidth ? 'childrenSpacingLeftSmallPhone' : 'childrenSpacingLeftSmall'}`}>*/}
                                                                {/*                    <div*/}
                                                                {/*                        className={isPhoneClientWidth ? 'smallFontSizePhone' : 'smallerFontSize'}>*/}
                                                                {/*                        Simultaneously expanding lending*/}
                                                                {/*                        liquidity*/}
                                                                {/*                    </div>*/}
                                                                {/*                    <img className={'cursorPointer'}*/}
                                                                {/*                         onClick={() => setTokenData(v, {showSimultaneously: !showSimultaneously})}*/}
                                                                {/*                         src={requireDefault(showSimultaneously ? 'Group 427320353' : 'Group 427320354')}*/}
                                                                {/*                         alt=""*/}
                                                                {/*                         style={square(`${isPhoneClientWidth ? .9 : .3}rem`)}/>*/}
                                                                {/*                </div>*/}
                                                                {/*                <img className={'cursorPointer'}*/}
                                                                {/*                     onClick={() => setTokenData(v, {isClose: !isClose})}*/}
                                                                {/*                     src={requireDefault(isClose ? 'closeButton' : 'openButton')}*/}
                                                                {/*                     alt=""*/}
                                                                {/*                     style={{height: `${isPhoneClientWidth ? 1.5 : .5}rem`}}/>*/}
                                                                {/*            </div>*/}
                                                                {/*            {showSimultaneously &&*/}
                                                                {/*                <div*/}
                                                                {/*                    className={`colorGray ${isPhoneClientWidth ? 'smallFontSizePhone' : 'smallerFontSize'}`}>*/}
                                                                {/*                    The liquidity will simultaneously*/}
                                                                {/*                    earn*/}
                                                                {/*                    both*/}
                                                                {/*                    swap*/}
                                                                {/*                    fees*/}
                                                                {/*                    and*/}
                                                                {/*                    lending*/}
                                                                {/*                    interest . If deactivated, it will*/}
                                                                {/*                    only*/}
                                                                {/*                    accrue*/}
                                                                {/*                    swap*/}
                                                                {/*                    fee*/}
                                                                {/*                    revenue.*/}
                                                                {/*                </div>}*/}
                                                                {/*        </div>*/}
                                                                {/*    })()*/}
                                                                {/*}*/}
                                                            </div>
                                                        })}
                                                    </div>
                                                    {/*{isPoolAddIncrease && <div*/}
                                                    {/*    className={isPhoneClientWidth ? 'childrenSpacingTopPhone' : 'childrenSpacingTop'}>*/}
                                                    {/*    <div*/}
                                                    {/*        className={isPhoneClientWidth ? 'smallerFontSizePhone' : 'smallerFontSize'}>*/}
                                                    {/*        Estimated APR：*/}
                                                    {/*    </div>*/}
                                                    {/*    {*/}
                                                    {/*        tokenDatas.map((v, i) => {*/}
                                                    {/*            const {isClose} = v,*/}
                                                    {/*                swapFees = numToPercentage(checkData0(poolData, `apr${i}`)),*/}
                                                    {/*                lendingInterest = isClose*/}
                                                    {/*                    ? 0*/}
                                                    {/*                    : getLendingInterest(checkData0(data, `lendingAPR${i}`))*/}
                                                    {/*            return <div*/}
                                                    {/*                className={isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'}>{v.symbol}: {*/}
                                                    {/*                swapFees}%（swap fee）{*/}
                                                    {/*                isClose*/}
                                                    {/*                    ? ''*/}
                                                    {/*                    : `+ ${lendingInterest}%（lending interest）`*/}
                                                    {/*            }= {plus(swapFees, lendingInterest)}%</div>*/}
                                                    {/*        })*/}
                                                    {/*    }*/}
                                                    {/*</div>}*/}
                                                    {(() => {
                                                        const eligible =
                                                            // (!isPoolAddIncrease || poolDataPoolIdIsNotNull) &&
                                                            Number(checkData0(token0NewAmount)) <= Number(checkData0(token0Data, 'balance')) &&
                                                            Number(checkData0(token1NewAmount)) <= Number(checkData0(token1Data, 'balance'))
                                                        return <div
                                                            onClick={() => {
                                                                const func = () => eligible && switchEthereumChain(
                                                                    () => toggleShowLiquidity(true, true),
                                                                    undefined,
                                                                    true
                                                                )
                                                                if (isPoolCreate) {
                                                                    tokenABPool(token0Address, token1Address, undefined, true)
                                                                        .then(v => isNotNullOrEmpty(
                                                                            v.filter(({fee, marginFee}) =>
                                                                                equalTo(fee, feeTierBigInt) && equalTo(marginFee, marginFeeTierBigInt)
                                                                            )
                                                                        )
                                                                            ? toast('The pool already exists, please use to add liquidity')
                                                                            : func())
                                                                } else {
                                                                    func()
                                                                }
                                                            }}
                                                            style={eligible ? {} : {color: '#7D7D7D'}}
                                                            className={`${isPhoneClientWidth ? 'borderRadiusPhone paddingTopBottomPhone' : 'borderRadius paddingTopBottomBig bigFontSize'} 
                                                            flexCenter colorWhite saf1 ${eligible ? 'backgroundActiveColor' : 'backgroundGrey'} cursorPointer`}>
                                                            {liquidityButton}
                                                        </div>
                                                    })()}
                                                </div>
                                            </div>
                                            : [
                                                <div className={isPhoneClientWidth ? '' : 'flexColumn alignItemsCenter'}
                                                     style={{
                                                         paddingTop: `${isPhoneClientWidth ? 0 : 2}rem`
                                                     }}>
                                                    <div
                                                        className={isPhoneClientWidth ? 'childrenSpacingTopBigPhone paddingBottomBigPhone' : 'flex alignItemsFlexEnd childrenSpacingLeftBig paddingBottomBigger'}
                                                        style={{...isPhoneClientWidth ? {} : {width: '80%'}}}>
                                                        <div
                                                            className={`flex ${isPhoneClientWidth ? 'childrenSpacingLeftBigPhone' : 'childrenSpacingLeftBig flexGrow1'}`}>
                                                            {
                                                                [
                                                                    ['Total Debt', 'Total TVL', 'totalTvlUsd'],
                                                                    ['Volume (24h)', 'Total Volume (24h)', 'totalOneDayVolUsd'],
                                                                    ['Total Borrows', 'Total Borrows', 'totalBorrowUsd']
                                                                ].map(v => <div
                                                                    style={{background: 'linear-gradient(180deg, rgba(255, 185, 194, .2) 0%, rgba(255, 255, 255, .2) 100%)'}}
                                                                    className={`flexGrow1 ${isPhoneClientWidth ? 'borderRadiusPhone paddingPhone childrenSpacingTopPhone' : 'borderRadius paddingBig childrenSpacingTop'}`}>
                                                                    <div
                                                                        className={'flex alignItemsCenter childrenSpacingLeftSmall'}>
                                                                        <img src={requireDefault(v[0])} alt=""
                                                                             style={{width: `${isPhoneClientWidth ? .9 : .3}rem`}}/>
                                                                        <div
                                                                            className={isPhoneClientWidth ? 'smallerFontSizePhone' : 'smallFontSize'}>{v[1]}</div>
                                                                    </div>
                                                                    <div
                                                                        className={`saf1 ${isPhoneClientWidth ? '' : 'bigFontSize'}`}>{formatCurrencyCompact(checkData0(data, 'totalStatistics', v[2]))}</div>
                                                                </div>)
                                                            }
                                                        </div>
                                                        {!isPhoneClientWidth && <div style={{
                                                            background: '#EFEFEF',
                                                            width: '.03rem',
                                                            height: '2rem'
                                                        }}/>}
                                                        <div
                                                            className={`flex ${isPhoneClientWidth ? 'childrenSpacingLeftBigPhone' : 'childrenSpacingLeftBig flexGrow1'}`}>
                                                            {
                                                                [
                                                                    ['Total Debt', 'TVL', 'totalTvlUsd'],
                                                                    ['Volume (24h)', 'Volume (24h)', 'totalOneDayVolUsd'],
                                                                    ['Total Borrows', 'Borrows', 'totalBorrowUsd']
                                                                ].map(v => <div
                                                                    style={{
                                                                        background: '#F9F9F9',
                                                                        border: 'solid .02rem #EFEFEF'
                                                                    }}
                                                                    className={`positionRelative flexGrow1 ${isPhoneClientWidth ? 'borderRadiusPhone paddingPhone childrenSpacingTopPhone' : 'borderRadius paddingBig childrenSpacingTop'} overflowVisible`}>
                                                                    <div
                                                                        className={'flex alignItemsCenter childrenSpacingLeftSmall'}>
                                                                        <img src={requireDefault(v[0])} alt=""
                                                                             style={{width: `${isPhoneClientWidth ? .9 : .3}rem`}}/>
                                                                        <div
                                                                            className={isPhoneClientWidth ? 'smallerFontSizePhone' : 'smallFontSize'}>{v[1]}</div>
                                                                    </div>
                                                                    <div
                                                                        className={`saf1 ${isPhoneClientWidth ? '' : 'bigFontSize'}`}>{formatCurrencyCompact(checkData0(data, 'chainStatistics', v[2]))}</div>
                                                                    <div
                                                                        className={'borderRadius999 positionAbsolute backgroundWhite flexCenter'}
                                                                        style={{
                                                                            padding: `${isPhoneClientWidth ? .3 : .1}rem`,
                                                                            top: `-${isPhoneClientWidth ? .9 : .3}rem`,
                                                                            right: `-${isPhoneClientWidth ? .3 : .1}rem`,
                                                                            ...square(`${isPhoneClientWidth ? 1.2 : .4}rem`)
                                                                        }}
                                                                    >
                                                                        <img src={requireDefault(coinName)} alt=""
                                                                             style={square('95%')}/>
                                                                    </div>
                                                                </div>)
                                                            }
                                                        </div>
                                                    </div>
                                                    <div style={isPhoneClientWidth ? {} : {width: '80%'}}
                                                         className={isPhoneClientWidth ? 'childrenSpacingTopBigPhone' : 'childrenSpacingTopBig'}>
                                                        <div
                                                            className={isPhoneClientWidth ? 'childrenSpacingTopPhone' : 'flexCenter justifyContentSpaceBetween'}>
                                                            <div className={'saf1'}>Pools</div>
                                                            <div
                                                                className={`flex alignItemsCenter ${isPhoneClientWidth ? 'justifyContentSpaceBetween flexWrap' : 'childrenSpacingLeft'}`}>
                                                                {[
                                                                    ['Create a Pair', 'create'],
                                                                    ['Add liquidity', 'add'],
                                                                    ['Supply lending liquidity', 'supply'],
                                                                ].map(v =>
                                                                    <div
                                                                        style={isPhoneClientWidth ? {
                                                                            width: '48%',
                                                                            paddingTop: '.5rem', paddingBottom: '.5rem',
                                                                        } : {}}
                                                                        onClick={() => windowReplace(`/pool/${v[1]}`)}
                                                                        className={`flexCenter ${isPhoneClientWidth ? 'marginTopPhone boxSizingBorderBox paddingPhone childrenSpacingLeftSmallPhone' : 'padding childrenSpacingLeftSmall'} backgroundActiveColor borderRadius999 cursorPointer`}>
                                                                        <img src={requireDefault('add')} alt=""
                                                                             style={{width: `${isPhoneClientWidth ? .75 : .25}rem`}}/>
                                                                        <div
                                                                            className={`colorWhite ${isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'}`}>{v[0]}</div>
                                                                    </div>)}
                                                                <div style={isPhoneClientWidth ? {
                                                                    width: '48%',
                                                                    paddingTop: '.45rem', paddingBottom: '.45rem',
                                                                } : {}}
                                                                     className={`borderRadius999 ${isPhoneClientWidth ? 'marginTopPhone boxSizingBorderBox paddingPhone borderSmallGrayLinePhone childrenSpacingLeftSmallPhone' : 'padding borderSmallGrayLine childrenSpacingLeft'} flex alignItemsCenter backgroundWhite`}>
                                                                    <img src={requireDefault('search')}
                                                                         onClick={() => searchToken()}
                                                                         alt="" className={'cursorPointer'}
                                                                         style={{width: `${isPhoneClientWidth ? 1 : .3}rem`}}/>
                                                                    <input placeholder='Search Tokens' type="text"
                                                                           className={isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'}
                                                                           style={{width: `${isPhoneClientWidth ? 9 : 2.5}rem`}}
                                                                           value={inputSearchName}
                                                                        // onKeyUp={e => searchSymbolOnKeyUp(e, searchToken)}
                                                                           onChange={e => setInputSearchName(e.target.value)}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className={isPhoneClientWidth ? 'overflowXScroll' : ''}>
                                                            {(() => {
                                                                const ratios = [3, 17, 17, 17, 17, 17, 6],
                                                                    arr = ['#', 'Pool', 'APR', ...['TVL'].map(v =>
                                                                        <div
                                                                            className={`flex alignItemsCenter ${isPhoneClientWidth ? 'childrenSpacingLeftSmallPhone' : 'childrenSpacingLeftSmall'} flexGrow1`}>
                                                                            <img src={requireDefault('bottomArrow1')}
                                                                                 alt=""
                                                                                 style={{width: `${isPhoneClientWidth ? .75 : .25}rem`}}/>
                                                                            <div
                                                                                className={isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'}>{v}</div>
                                                                        </div>), '1D vol', '7D vol', '1D vol/TVL'],
                                                                    itemClass = i => `flex alignItemsCenter ${(i === 0 || i >= arr.length - 3) ? '' : 'flexGrow1'} ${[0, 1].includes(i) ? '' : (i === arr.length - 1 ? '' : '')}`
                                                                return <div
                                                                    className={'flexColumn'}
                                                                    style={{height: `${isPhoneClientWidth ? '27rem' : '55vh'}`, ...isPhoneClientWidth ? {width: '80rem'} : {}}}>
                                                                    <div
                                                                        className={`backgroundGrey boxSizingBorderBox flexCenter ${isPhoneClientWidth ? 'borderSmallGrayLinePhone' : 'borderSmallGrayLine'}`}
                                                                        style={{
                                                                            height: `${isPhoneClientWidth ? 2.4 : .8}rem`,
                                                                            padding: `${isPhoneClientWidth ? 1.7 : .4}rem`,
                                                                            borderTopLeftRadius: `${isPhoneClientWidth ? .9 : .3}rem`,
                                                                            borderTopRightRadius: `${isPhoneClientWidth ? .9 : .3}rem`
                                                                        }}>
                                                                        {arr.map((v, i) => <div
                                                                            className={itemClass(i)}
                                                                            style={{width: `${ratios[i]}%`}}
                                                                        >
                                                                            {typeof v === 'string' ? <div
                                                                                className={`${isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'}`}
                                                                                style={{
                                                                                    color: '#7D7D7D',
                                                                                }}>{v}</div> : v}
                                                                        </div>)}
                                                                    </div>
                                                                    <div ref={tokensPoolsScroll}
                                                                         onScroll={tokensPoolsOnScroll}
                                                                         className={'flexGrow1Column backgroundWhite overflowYScroll'}>
                                                                        {getPoolsIng
                                                                            ? <div
                                                                                className={'width100 height100 flexCenter'}>
                                                                                <img src={requireDefault('loading')}
                                                                                     alt=""
                                                                                     style={{width: `${isPhoneClientWidth ? 10 : 5}rem`}}/>
                                                                            </div>
                                                                            : pools.map((item, itemI) => {
                                                                                const {name} = item,
                                                                                    nameArr = name.split('/')
                                                                                item = {
                                                                                    ...item,
                                                                                    currency0Symbol: checkData([item, 'currency0Symbol'], nameArr[0]),
                                                                                    currency1Symbol: checkData([item, 'currency1Symbol'], nameArr[1]),
                                                                                }

                                                                                const tvl = ovl(item, 'tvlUsd', false, true),
                                                                                    oneDayVol = ovl(item, 'oneDayVolUsd', false, true)
                                                                                return <div
                                                                                    onClick={() => windowReplace(`/pool?poolid=${item.poolId}`)}
                                                                                    style={{padding: `${isPhoneClientWidth ? 1 : .2}rem ${isPhoneClientWidth ? 1.7 : .4}rem`}}
                                                                                    className={'flexCenter justifyContentSpaceBetween boxSizingBorderBox marginSwap cursorPointer'}>
                                                                                    {[
                                                                                        <div
                                                                                            style={{fontSize: `${isPhoneClientWidth ? .81 : .27}rem`}}
                                                                                            className={'colorGray'}>{itemI + 1}</div>,
                                                                                        <div
                                                                                            className={`flexCenter ${isPhoneClientWidth ? 'childrenSpacingLeftSmallPhone' : 'childrenSpacingLeftSmall'}`}>
                                                                                            {tokenIcon(item, `${isPhoneClientWidth ? 1.5 : .5}rem`)}
                                                                                            <div>
                                                                                                <div
                                                                                                    style={{fontSize: `${isPhoneClientWidth ? .8 : .27}rem`}}>
                                                                                                    {showPoolName(item.name)}
                                                                                                </div>
                                                                                                {showFees(item, 'smallerFontSize')}
                                                                                            </div>
                                                                                            {showResearchIcon(item)}
                                                                                        </div>,
                                                                                        `${getAPRs(item)[3]}%`,
                                                                                        // [0, 1].map(v1 => `${numToPercentage(checkData0(v, `lendingApr${v1}`))}%`).join(' / '),
                                                                                        ...[
                                                                                            tvl,
                                                                                            oneDayVol,
                                                                                            ovl(item, 'sevenDayVolUsd', false, true)
                                                                                        ].map(v => {
                                                                                            const [v0, v1] = v.split(' '),
                                                                                                isUSD1 = v1 === 'USD1'
                                                                                            return <div
                                                                                                className={`width100 flex alignItemsCenter ${isPhoneClientWidth ? 'childrenSpacingLeftSmallPhone' : 'childrenSpacingLeftSmall'}`}>
                                                                                                <div
                                                                                                    style={{
                                                                                                        maxWidth: '55%',
                                                                                                        fontSize: `${isPhoneClientWidth ? .8 : .27}rem`
                                                                                                    }}
                                                                                                    className={'textOverflowEllipsis'}>{isUSD1 ? '$' : ''}{isUSD1 ? toFixed(v0, 2) : v0}</div>
                                                                                                {!!v1 && !isUSD1 && <div
                                                                                                    style={{fontSize: `${isPhoneClientWidth ? .8 : .27}rem`}}>{v1}</div>}
                                                                                            </div>
                                                                                        }),
                                                                                        toFixed(divide(checkData0(item, 'oneDayVol'), checkData0(item, 'tvl')), 2)
                                                                                    ].map((v, i) =>
                                                                                        <div
                                                                                            className={itemClass(i)}
                                                                                            style={{width: `${ratios[i]}%`}}>
                                                                                            {
                                                                                                typeof v === 'string'
                                                                                                    ? (() => {
                                                                                                        const isAPR = i === 2
                                                                                                        return <div
                                                                                                            onMouseEnter={() => isAPR && setShowAPRDetail(true, itemI)}
                                                                                                            onMouseLeave={() => isAPR && setShowAPRDetail(false, itemI)}
                                                                                                            className={`positionRelative flexColumn alignItemsCenter`}
                                                                                                            style={{
                                                                                                                fontSize: `${isPhoneClientWidth ? .8 : .27}rem`,
                                                                                                                ...isAPR ? {borderBottom: `${isPhoneClientWidth ? .06 : .02}rem dashed black`} : {}
                                                                                                            }}>
                                                                                                            {v}
                                                                                                            {isAPR && aprDetail(item, itemI, true)}
                                                                                                        </div>
                                                                                                    })()
                                                                                                    : v
                                                                                            }
                                                                                        </div>)}
                                                                                </div>
                                                                            })}
                                                                    </div>
                                                                </div>
                                                            })()}
                                                        </div>
                                                    </div>
                                                </div>
                                            ]
                                    ]
                            return <div>
                                {isPhoneClientWidth
                                    ? pageTopFootPhone(<div className={'positionRelative zIndex1'}>
                                        <div style={{
                                            top: 0,
                                            height: '30.04rem',
                                            backgroundSize: 'cover',
                                            backgroundRepeat: 'no-repeat',
                                            backgroundPosition: 'center center',
                                            backgroundImage: `url(${requireDefault('tradeBGPhone')})`
                                        }} className={'positionAbsolute width100 zIndex-1'}/>
                                        <div className={'childrenSpacingTopBiggerPhone paddingBigPhone'}
                                             style={{
                                                 paddingTop: '4rem',
                                                 paddingBottom: `${isHandelLiquidity ? 19 : 3}rem`
                                             }}
                                        >
                                            {content}
                                        </div>
                                    </div>)
                                    : (isPoolList
                                            ? <div style={{
                                                height: '100vh',
                                                backgroundSize: 'cover',
                                                backgroundRepeat: 'no-repeat',
                                                backgroundPosition: 'center center',
                                                backgroundImage: `url(${requireDefault('tradeBG')})`
                                            }} className={'overflowYScroll'}>
                                                {pageTop}
                                                {content}
                                                {pageFoot}
                                            </div>
                                            : <div>
                                                {pageTop}
                                                <div style={{
                                                    backgroundSize: 'cover',
                                                    backgroundRepeat: 'no-repeat',
                                                    backgroundPosition: 'center center',
                                                    backgroundImage: `url(${requireDefault('tradeBG')})`
                                                }}>
                                                    {content}
                                                </div>
                                                {pageFoot}
                                            </div>
                                    )
                                }
                                {positionsPoolsContent}
                                {selectTokenContent}
                                {liquidityContent}
                                {researchMask}
                                {loading}
                            </div>
                        })()
                })(),
                earn: !isHome && (() => {
                    const tGAuthorizePoints = defaultAuthorizePoints,
                        tGAuthorizeAuthorizeKey = 'tg',
                        isTwitterAuthorized = checkData0(data, 'xPoint') > 0,
                        isTGAuthorized = checkData0(data, 'tgPoint') > 0,
                        twitterTGAuthorize = [
                            [isTwitterAuthorized, twitterAuthorizeData],
                            [isTGAuthorized, {
                                authorizeKey: tGAuthorizeAuthorizeKey,
                                authorizePoints: tGAuthorizePoints,
                                title: 'Join TG Group',
                            }],
                        ],
                        lpsIndex = checkData0(data, 'lpsIndex'),
                        toggleShowApply = showApply => setData({showApply, ...showApply ? {} : {applyPoolData: undefined}}),
                        toggleShowClaimedHistorys = showClaimedHistorys => {
                            setData({showClaimedHistorys})
                            if (showClaimedHistorys) {
                                isFirstPage(claimedHistorysPage) ? getClaimeds() : setData({claimedHistorysPage: defaultPage})
                            }
                        },
                        content = <div className={'flexColumnCenter'}
                                       style={{
                                           paddingTop: `${isPhoneClientWidth ? 0 : 2}rem`,
                                           ...isPhoneClientWidth ? {paddingBottom: '10rem'} : {}
                                       }}>
                            <div style={{alignItems: 'flex-start'}}
                                 className={`${isPhoneClientWidth ? 'childrenSpacingTopBiggerPhone' : 'flex childrenSpacingLeftBigger'}`}>
                                <div
                                    className={isPhoneClientWidth ? 'childrenSpacingTopBigPhone' : 'childrenSpacingTopBig'}>
                                    <div
                                        className={`positionRelative boxSizingBorderBox overflowHidden ${isPhoneClientWidth ? 'childrenSpacingTopBigPhone' : 'childrenSpacingTopBigger'}`}
                                        style={{
                                            width: `${isPhoneClientWidth ? 28 : 11.5}rem`,
                                            padding: `${isPhoneClientWidth ? 1 : .5}rem`,
                                            borderRadius: `${isPhoneClientWidth ? 1.5 : .5}rem`,
                                            background: 'linear-gradient(180deg, rgba(255, 185, 194, 0.2) 0%, rgba(255, 219, 223, 0.1) 100%)'
                                        }}>
                                        <div
                                            className={`flex alignItemsCenter childrenSpacingLeft`}
                                            style={{fontSize: `${isPhoneClientWidth ? 1.7 : .45}rem`}}>
                                            <img src={requireDefault('$oLIKWID')} alt=""
                                                 style={square(`${isPhoneClientWidth ? 1.5 : .5}rem`)}/>
                                            <div>$oLIKWID Rewards Earned</div>
                                            {/*<img className={'cursorPointer'} src={requireDefault('tips1')}*/}
                                            {/*     alt=""*/}
                                            {/*     style={square(`${isPhoneClientWidth ? .9 : .3}rem`)}/>*/}
                                        </div>
                                        {(() => {
                                            const oLIKWIDReward = checkDataObject(data, 'oLIKWIDReward'),
                                                oLIKWIDRewardBalance = checkData0(oLIKWIDReward, 'balance')
                                            return <div className={'flex alignItemsCenter justifyContentSpaceBetween'}>
                                                <div
                                                    className={`flex alignItemsFlexEnd ${isPhoneClientWidth ? 'childrenSpacingLeftPhone' : 'childrenSpacingLeft'}`}>
                                                    <div style={{lineHeight: '.8'}}
                                                         className={`activeColor1 saf1 ${isPhoneClientWidth ? 'biggerFontSizePhone' : 'biggerFontSize'}`}>
                                                        {numberETH(oLIKWIDRewardBalance)}
                                                    </div>
                                                    <div
                                                        className={`colorGray ${isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'}`}>({
                                                        formatCurrencyCompact(checkData0(oLIKWIDReward, 'usd'))
                                                    })
                                                    </div>
                                                </div>
                                                <div className={'flex alignItemsCenter childrenSpacingLeft'}>
                                                    <img className={'cursorPointer'} src={requireDefault('History')}
                                                         alt=""
                                                         style={square(`${isPhoneClientWidth ? 1.5 : .55}rem`)}
                                                         onClick={() => toggleShowClaimedHistorys(true)}
                                                    />
                                                    <div className={'borderRadius999 colorWhite saf1 cursorPointer'}
                                                         onClick={() => oLIKWIDClaim(oLIKWIDRewardBalance)}
                                                         style={{
                                                             padding: `${isPhoneClientWidth ? .3 : .1}rem ${isPhoneClientWidth ? 1.5 : .5}rem`,
                                                             background: 'linear-gradient(180deg, #FFB9C2 0%, #FC1A50 100%)'
                                                         }}>Claim
                                                    </div>
                                                </div>
                                            </div>
                                        })()}
                                        <div style={{borderColor: 'rgba(255, 142, 157, .13)'}}
                                             className={`flex alignItemsCenter justifyContentSpaceBetween ${isPhoneClientWidth ? 'paddingTopPhone borderTopSmallGrayLinePhone' : 'paddingTop borderTopSmallGrayLine'}`}>
                                            <pre
                                                className={`colorGray ${isPhoneClientWidth ? 'smallerFontSizePhone' : 'smallerFontSize'}`}>{`$oLIKWID is an option token. 
Option tokens can be exercised and converted into ${isPhoneClientWidth ? '\n' : ''}$LIKWID at a fixed exercise price.`}</pre>
                                            <div
                                                onClick={() => windowOpen('https://likwidfi.gitbook.io/likwid-protocol-docs/tokenomics/olikwid-likwid-option-token')}
                                                className={`${isPhoneClientWidth ? 'smallerFontSizePhone' : 'smallerFontSize'} cursorPointer saf1`}>
                                                Learn more
                                            </div>
                                        </div>
                                        <img className={'positionAbsolute zIndex-1'}
                                             src={requireDefault('image 27')}
                                             alt=""
                                             style={{
                                                 bottom: `-${isPhoneClientWidth ? 2.1 : .7}rem`,
                                                 right: `-${isPhoneClientWidth ? 1.8 : .6}rem`,
                                                 height: '120%'
                                             }}/>
                                    </div>
                                    <div
                                        className={`flex alignItemsCenter ${isPhoneClientWidth ? 'childrenSpacingLeftBiggerPhone' : 'childrenSpacingLeftBigger'}`}>
                                        {['Reward-Eligible LPs', 'Your LPs'].map((v, i) => <div
                                            onClick={() => setData({lpsIndex: i})}
                                            className={`cursorPointer ${lpsIndex === i ? 'saf1' : ''}`}>{v}</div>)}
                                    </div>
                                    <div
                                        className={`${isPhoneClientWidth ? 'borderRadiusPhone overflowHidden borderSmallGrayLinePhone' : 'borderRadius borderSmallGrayLine'} flexColumn backgroundWhite`}
                                        style={{height: `${isPhoneClientWidth ? 19.5 : 6.5}rem`}}>
                                        {
                                            [
                                                [
                                                    <div
                                                        className={`backgroundGrey flex ${isPhoneClientWidth ? 'paddingPhone' : 'paddingBig'}`}>
                                                        {['Pool', 'TVL', 'APR', 'Reward APR', ''].map((v, i) =>
                                                            <div style={[1, 3].includes(i) ? {width: '15%'} : {}}
                                                                 className={`${isPhoneClientWidth ? 'smallerFontSizePhone textOverflowEllipsis' : 'smallFontSize'} ${[1, 3].includes(i) ? '' : 'flexGrow1'} colorGray ${i ? 'flexCenter' : ''}`}>{v}</div>)}
                                                    </div>,
                                                    <div ref={tokensPoolsScroll}
                                                         onScroll={tokensPoolsOnScroll}
                                                         className={`${isPhoneClientWidth ? 'paddingPhone' : 'paddingBig'} flexGrow1Column overflowYScroll`}>
                                                        {pools.map((v, i) => <div
                                                            style={{marginTop: `${i ? (isPhoneClientWidth ? 1.5 : .48) : 0}rem`}}
                                                            className={'flex'}>
                                                            <div
                                                                className={`flexGrow1 flex alignItemsCenter ${isPhoneClientWidth ? 'childrenSpacingLeftSmallPhone' : 'childrenSpacingLeftSmall'}`}>
                                                                {tokenIcon(v, `${isPhoneClientWidth ? 1.5 : .5}rem`)}
                                                                <div className={'textOverflowEllipsis'}
                                                                     style={{fontSize: `${isPhoneClientWidth ? .8 : .27}rem`}}>
                                                                    {showPoolName(v.name)}
                                                                </div>
                                                                {showResearchIcon(v)}
                                                            </div>
                                                            <div style={{width: '15%'}}
                                                                 className={`flexCenter ${isPhoneClientWidth ? 'smallFontSizePhone' : ''} `}>{formatCurrencyCompact(checkData0(v, 'tvlUsd'))}
                                                            </div>
                                                            <div className={'flexGrow1 flexCenter'}
                                                            >
                                                                <div
                                                                    onMouseEnter={() => setShowAPRDetail(true, i)}
                                                                    onMouseLeave={() => setShowAPRDetail(false, i)}
                                                                    className={`${isPhoneClientWidth ? 'smallFontSizePhone' : ''} positionRelative flexColumn alignItemsCenter`}
                                                                    style={{borderBottom: `${isPhoneClientWidth ? .06 : .02}rem dashed black`}}>
                                                                    {getAPRs(v)[3]}%
                                                                    {aprDetail(v, i)}
                                                                </div>
                                                            </div>
                                                            <div style={{width: '15%'}}
                                                                 className={`flexCenter activeColor saf1 ${isPhoneClientWidth ? 'smallFontSizePhone' : ''} `}>{numToPercentage(checkData0(v, 'rewardApr'))}%
                                                            </div>
                                                            <div
                                                                className={'flexGrow1 flexCenter justifyContentFlexEnd'}>
                                                                <div
                                                                    onClick={() => windowReplace(`/pool/add?poolid=${v.poolId}`)}
                                                                    style={{padding: `${isPhoneClientWidth ? .1 : .1}rem`}}
                                                                    className={`backgroundGrey ${isPhoneClientWidth ? 'biggerFontSize borderSmallGrayLinePhone' : 'smallerFontSize borderSmallGrayLine'} cursorPointer borderRadius999 saf1`}>
                                                                    + Add liquidity
                                                                </div>
                                                            </div>
                                                        </div>)}
                                                    </div>
                                                ],
                                                [
                                                    <div
                                                        className={`backgroundGrey flex ${isPhoneClientWidth ? 'paddingPhone' : 'paddingBig'}`}>
                                                        {['Pool', 'Balance', 'Reward APR', 'Reward Earned', ''].map((v, i) =>
                                                            <div style={[2, 4].includes(i) ? {width: '15%'} : {}}
                                                                 className={`${isPhoneClientWidth ? 'smallerFontSizePhone textOverflowEllipsis' : 'smallFontSize'} ${[2, 4].includes(i) ? '' : 'flexGrow1'} colorGray ${i ? 'flexCenter' : ''}`}>{v}</div>)}
                                                    </div>,
                                                    (() => {
                                                        return <div
                                                            ref={yourPoolsScroll}
                                                            onScroll={() => onScrollFunc(yourPoolsScroll, earnYourPools, checkData0(data, 'earnYourPoolsTotal'), () => setData({earnYourPoolsPage: earnYourPoolsPage + 1}))}
                                                            className={`${isPhoneClientWidth ? 'paddingPhone' : 'paddingBig'} flexGrow1Column overflowYScroll`}>
                                                            {earnYourPools.map((v, i) => <div
                                                                style={{
                                                                    marginTop: `${i ? .48 : 0}rem`,
                                                                    alignItems: 'flex-start'
                                                                }}
                                                                className={`flex ${isPhoneClientWidth ? 'childrenSpacingTopYourPoolsSmallPhone' : 'childrenSpacingTopYourPoolsSmall'}`}>
                                                                <div
                                                                    className={`flexGrow1 flex alignItemsCenter ${isPhoneClientWidth ? 'childrenSpacingLeftSmallPhone' : 'childrenSpacingLeftSmall'}`}>
                                                                    {tokenIcon(v, `${isPhoneClientWidth ? 1.5 : .5}rem`)}
                                                                    <div className={'textOverflowEllipsis'}
                                                                         style={{fontSize: `${isPhoneClientWidth ? .8 : .27}rem`}}>
                                                                        {showPoolName(v.name)}
                                                                    </div>
                                                                    {showResearchIcon(v)}
                                                                </div>
                                                                <div
                                                                    className={`flexGrow1 flexCenter ${isPhoneClientWidth ? 'smallerFontSizePhone' : 'smallFontSize'}`}>{
                                                                    formatCurrencyCompact(checkData0(v, 'liquidityUsd'))
                                                                }
                                                                </div>
                                                                <div style={{width: '15%'}}
                                                                     className={`flexCenter activeColor saf1 ${isPhoneClientWidth ? 'smallerFontSizePhone' : ''}`}>{numToPercentage(checkData0(v, 'rewardApr'))}%
                                                                </div>
                                                                <div className={'flexGrow1 flexCenter'}>
                                                                    <div className={'flexColumnCenter'}>
                                                                        <div
                                                                            className={`activeColor saf1 ${isPhoneClientWidth ? 'smallerFontSizePhone' : ''}`}>{numberETH(checkData0(v, 'rewardAmount'))}
                                                                        </div>
                                                                        <div
                                                                            className={`colorGray ${isPhoneClientWidth ? 'smallerFontSizePhone' : 'smallFontSize'}`}>({formatCurrencyCompact(checkData0(v, 'rewardAmountUsd'))})
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div style={{width: '15%'}}
                                                                     className={isPhoneClientWidth ? 'childrenSpacingTopSmallPhone' : 'childrenSpacingTop'}>
                                                                    {[
                                                                        ['Increase', () => windowReplace(`/pool/add?poolid=${v.poolId}`)],
                                                                        ['Remove', () => setData({
                                                                            earnIsPoolPositions: true,
                                                                            earnIsPoolPositionData: v
                                                                        })]
                                                                    ].map(v => <div
                                                                        className={'flexCenter justifyContentFlexEnd'}>
                                                                        <div
                                                                            onClick={v[1]}
                                                                            style={{padding: `${isPhoneClientWidth ? .3 : .1}rem ${isPhoneClientWidth ? .6 : .2}rem`}}
                                                                            className={`backgroundGrey borderSmallGrayLine cursorPointer borderRadius999 ${isPhoneClientWidth ? 'biggerFontSize' : 'smallerFontSize'} saf1`}>
                                                                            {v[0]}
                                                                        </div>
                                                                    </div>)}
                                                                </div>
                                                            </div>)}
                                                        </div>
                                                    })()
                                                ]
                                            ][lpsIndex]
                                        }
                                    </div>
                                    <div
                                        className={`boxSizingBorderBox ${isPhoneClientWidth ? 'paddingBigPhone borderRadiusPhone' : 'paddingBig borderRadius'} backgroundActiveColor borderActiveColor flex alignItemsCenter justifyContentSpaceBetween`}
                                        style={{
                                            borderColor: 'rgba(255, 142, 157, 0.2)',
                                            background: 'linear-gradient(180deg, rgba(255, 185, 194, .1) 0%, rgba(255, 255, 255, .1) 100%)'
                                        }}>
                                        <div>
                                            <div
                                                className={isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'}>
                                                I Want to Incentivize a Pool
                                            </div>
                                            <div
                                                className={`colorGray ${isPhoneClientWidth ? 'smallerFontSizePhone' : 'smallerFontSize'}`}>
                                                A new LP gets $oLIKWID liquidity incentives if it passes the
                                                audit
                                            </div>
                                        </div>
                                        <div style={{
                                            padding: `${isPhoneClientWidth ? .3 : .1}rem ${isPhoneClientWidth ? 1 : .5}rem`
                                        }}
                                             onClick={() => toggleShowApply(true)}
                                             className={`borderRadius999 backgroundActiveColor colorWhite ${isPhoneClientWidth ? 'smallerFontSizePhone' : 'smallerFontSize'} saf1 cursorPointer`}>
                                            Apply
                                        </div>
                                    </div>
                                </div>
                                <div
                                    className={`positionRelative boxSizingBorderBox backgroundWhite ${isPhoneClientWidth ? 'borderSmallGrayLinePhone childrenSpacingTopBiggerPhone' : 'borderSmallGrayLine childrenSpacingTopBig'}`}
                                    style={{
                                        width: `${isPhoneClientWidth ? 28 : 10}rem`,
                                        padding: `${isPhoneClientWidth ? 1.5 : .5}rem ${isPhoneClientWidth ? 1.3 : .7}rem`,
                                        borderRadius: `${isPhoneClientWidth ? 1.5 : .5}rem`,
                                    }}>
                                    <img className={'positionAbsolute'} src={requireDefault('airdrop')} alt=""
                                         style={{
                                             ...square(`${isPhoneClientWidth ? 11 : 3}rem`),
                                             top: `${isPhoneClientWidth ? .2 : -.5}rem`,
                                             right: `${isPhoneClientWidth ? .2 : .1}rem`
                                         }}/>
                                    <div
                                        className={`${isPhoneClientWidth ? 'childrenSpacingLeftPhone' : 'childrenSpacingLeft'} flex alignItemsCenter`}>
                                        <img src={requireDefault('Points')} alt=""
                                             style={{width: `${isPhoneClientWidth ? 1.5 : .5}rem`}}/>
                                        <div>Points</div>
                                    </div>
                                    <div
                                        className={`saf1`}
                                        style={{fontSize: `${isPhoneClientWidth ? 1.7 : .5}rem`}}>
                                        {checkData0(data, 'points')}
                                    </div>
                                    <div style={{border: 'solid .02rem #999797', opacity: .5}}/>
                                    <div
                                        className={`flex childrenFlexGrow1 ${isPhoneClientWidth ? 'childrenSpacingLeftPhone' : 'childrenSpacingLeft'}`}>
                                        {
                                            [
                                                ['Migrate', checkData0(data, 'migratePoints')],
                                                ['LIKWID.FI', checkData0(data, 'LIKWIDFipoints')]
                                            ].map(v => <div
                                                className={isPhoneClientWidth ? 'childrenSpacingTopPhone' : 'childrenSpacingTop'}>
                                                <div
                                                    className={`${isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'} colorGray`}>{v[0]}</div>
                                                <div
                                                    className={`${isPhoneClientWidth ? 'bigFontSizePhone' : 'bigFontSize'} saf1`}>{v[1]}</div>
                                            </div>)
                                        }
                                    </div>
                                    <div style={{border: 'solid .02rem #999797', opacity: .5}}/>
                                    <div
                                        className={`saf1`}
                                        style={{fontSize: `${isPhoneClientWidth ? 1.7 : .4}rem`}}>
                                        Rules
                                    </div>
                                    {chainId == 10143 &&
                                        <div
                                            className={`${isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'} activeColor`}>
                                            During the Monad testnet, the upper limit per address is 350
                                        </div>}
                                    {
                                        [
                                            ['Swap Native Tokens', 'swapAnyToken', '50 / 1'],
                                            ['Margin Buy / Sell Native Tokens', 'marginAnyToken', '100 / 1'],
                                            ['Borrow Native Tokens', 'borrowAnyPools', '50 / 1'],
                                            ['Supply Native Tokens', 'supplyAnyPools', '50 / 1'],
                                            // (() => {
                                            //     const identifyTeamIsNotNull = isNotNull(checkData([data, 'identifyTeam']))
                                            //     return ['Identify product defects and have them \nrecognized by the development team.', 'identifyTeam', 800, identifyTeamIsNotNull ? 'Done' : 'Report', () => !identifyTeamIsNotNull && windowOpen('https://t.me/likwid_fi')]
                                            // })(),
                                            // (() => {
                                            //     const provideTeamIsNotNull = isNotNull(checkData([data, 'provideTeam']))
                                            //     return ['Provide constructive suggestions for the product \nthat are adopted by the development team.', 'provideTeam', 800, provideTeamIsNotNull ? 'Done' : 'Report', () => !provideTeamIsNotNull && windowOpen('https://t.me/likwid_fi')]
                                            // })(),
                                            ...twitterTGAuthorize.map(
                                                v => {
                                                    const [isAuthorized, aD] = v
                                                    return [aD.title, `${aD.authorizeKey}Point`, aD.authorizePoints, isAuthorized ? 'Done' : 'Authorize', () => !isAuthorized && toggleShowAuthorize(true, undefined, aD), `Complete ${aD.authorizeKey.toLocaleUpperCase()} authorization before starting the task`]
                                                }
                                            )
                                        ].map((v, i) => {
                                            const isDone = v[3] === 'Done', p = checkData([data, v[1]])
                                            return [
                                                i === 4 &&
                                                <div style={{border: 'solid .02rem #999797', opacity: .5}}/>,
                                                <div
                                                    className={`flex alignItemsCenter ${isPhoneClientWidth ? 'childrenSpacingLeftPhone' : 'childrenSpacingLeft'}`}>
                                                    <div
                                                        className={`flex alignItemsCenter ${isPhoneClientWidth ? 'childrenSpacingLeftPhone' : 'childrenSpacingLeft'} flexGrow1`}>
                                                <pre style={{lineHeight: '1.5'}}
                                                     className={`${isPhoneClientWidth ? '' : 'smallFontSize'} flexGrow1`}>
                                                    {v[0]}
                                                    {v[5] && <div
                                                        style={{borderColor: 'rgba(0,0,0,.3)', borderWidth: '.07rem'}}
                                                        className={`colorGray ${isPhoneClientWidth ? 'borderBottomSmallLinePhone smallFontSizePhone' : 'smallerFontSize'}`}>{v[5]}</div>}

                                                    {isPhoneClientWidth && v[3] &&
                                                        <div
                                                            className={'flex alignItemsCenter justifyContentSpaceBetween paddingTopPhone'}>
                                                            <div
                                                                style={{width: `${isPhoneClientWidth ? 3 : 1.2}rem`, ...isNotNull(p) ? {} : {color: '#CCCCCC'}}}
                                                                className={`saf1 ${isNotNull(p) ? 'activeColor' : ''} ${isPhoneClientWidth ? '' : 'smallFontSize'}`}>+ {percentageNum(checkData([p], v[2]))}</div>
                                                            <div
                                                                onClick={checkDataFunction(v, 4)}
                                                                className={`borderRadius999 ${isDone ? '' : 'backgroundActiveColor'} colorWhite saf1 ${isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'} cursorPointer flexCenter`}
                                                                style={{
                                                                    ...isDone
                                                                        ? {background: '#4BD695'}
                                                                        : {},
                                                                    width: `${isPhoneClientWidth ? 6 : 1.6}rem`,
                                                                    height: v[3] ? `${isPhoneClientWidth ? 1.7 : .5}rem` : 0
                                                                }}>
                                                                {isDone ? [
                                                                    v[3],
                                                                    <img
                                                                        src={requireDefault('Ellipse 45')}
                                                                        alt=""
                                                                        style={{
                                                                            width: `${isPhoneClientWidth ? .7 : .25}rem`,
                                                                            marginLeft: `${isPhoneClientWidth ? .3 : .1}rem`
                                                                        }}
                                                                    />
                                                                ] : v[3]}
                                                            </div>
                                                        </div>
                                                    }
                                            </pre>
                                                    </div>
                                                    {(!isPhoneClientWidth || !v[3]) &&
                                                        <div
                                                            style={{width: `${isPhoneClientWidth ? 5 : 1.2}rem`, ...isNotNull(p) ? {} : {color: '#CCCCCC'}}}
                                                            className={`saf1 ${isNotNull(p) ? 'activeColor' : ''} ${isPhoneClientWidth ? 'textAlignRight' : 'smallFontSize'}`}>+ {percentageNum(checkData([p], v[2]))}</div>}
                                                    {!isPhoneClientWidth && <div
                                                        onClick={checkDataFunction(v, 4)}
                                                        className={`borderRadius999 ${isDone ? '' : 'backgroundActiveColor'} colorWhite flexCenter saf1 ${isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'} cursorPointer flexCenter`}
                                                        style={{
                                                            ...isDone
                                                                ? {background: '#4BD695'}
                                                                : {},
                                                            width: `${isPhoneClientWidth ? 6 : 1.6}rem`,
                                                            height: v[3] ? `${isPhoneClientWidth ? 1.7 : .5}rem` : 0
                                                        }}>
                                                        {isDone ? [
                                                            v[3],
                                                            <img
                                                                src={requireDefault('Ellipse 45')}
                                                                alt=""
                                                                style={{
                                                                    width: `${isPhoneClientWidth ? .7 : .25}rem`,
                                                                    marginLeft: `${isPhoneClientWidth ? .3 : .1}rem`
                                                                }}
                                                            />
                                                        ] : v[3]}
                                                    </div>}
                                                </div>
                                            ]
                                        })
                                    }
                                    <div
                                        className={`${isPhoneClientWidth ? 'borderRadiusPhone paddingPhone smallFontSizePhone childrenSpacingLeftSmallPhone' : 'borderRadius padding smallFontSize childrenSpacingLeftSmall alignItemsCenter'} flex activeColor`}
                                        style={{background: 'rgba(255, 185, 194, .1)'}}>
                                        <img src={requireDefault('tips-one 1')} alt=""
                                             style={square(`${isPhoneClientWidth ? .9 : .3}rem`)}/>
                                        <pre
                                            className={isPhoneClientWidth ? 'smallFontSizePhone paddingLeftSmallPhone' : 'smallerFontSize paddingLeftSmall'}
                                            style={{
                                                color: 'rgb(255, 142, 157)',
                                                borderLeft: `dashed ${isPhoneClientWidth ? .3 : .1}vw rgb(255, 142, 157)`
                                            }}>{`Sybil-resistant mechanisms will be applied during future redemptions for governance tokens.`}</pre>
                                    </div>
                                </div>
                            </div>
                        </div>
                    return <div>
                        {isPhoneClientWidth ? pageTopFootPhone(<div className={'positionRelative zIndex1'}>
                                <div style={{
                                    top: 0,
                                    height: '30.04rem',
                                    backgroundSize: 'cover',
                                    backgroundRepeat: 'no-repeat',
                                    backgroundPosition: 'center center',
                                    backgroundImage: `url(${requireDefault('tradeBGPhone')})`
                                }} className={'positionAbsolute width100 zIndex-1'}/>
                                <div className={'childrenSpacingTopBiggerPhone paddingBigPhone'}
                                     style={{
                                         paddingTop: '4rem', paddingBottom: `3rem`
                                     }}
                                >
                                    {content}
                                </div>
                            </div>)
                            : <div>
                                {pageTop}
                                <div style={{
                                    minHeight: '17rem',
                                    backgroundSize: 'cover',
                                    backgroundRepeat: 'no-repeat',
                                    backgroundPosition: 'center center',
                                    backgroundImage: `url(${requireDefault('tradeBG')})`
                                }}>
                                    {content}
                                </div>
                                {pageFoot}
                            </div>}
                        {
                            (() => {
                                const showAuthorize = checkDataBool(data, 'showAuthorize'),
                                    {authorizePoints} = authorizeData
                                return showAuthorize &&
                                    <div className={'positionFixed flexColumnCenter'}
                                         style={{
                                             top: 0,
                                             left: 0,
                                             right: 0,
                                             bottom: 0,
                                             zIndex: 1000,
                                             background: 'rgba(0,0,0,.56)',
                                         }}>
                                        <div
                                            className={`${isPhoneClientWidth ? 'childrenSpacingTopBigPhone borderRadiusPhone' : 'childrenSpacingTopBigger'} boxSizingBorderBox backgroundWhite`}
                                            style={{
                                                width: isPhoneClientWidth ? '84%' : '9rem',
                                                maxHeight: '100vh',
                                                ...ternaryObject(
                                                    !isPhoneClientWidth,
                                                    {borderRadius: '.5rem'}
                                                ),
                                                padding: `${isPhoneClientWidth ? 1.5 : .7}rem`,
                                            }}>
                                            <div className={'flexCenter justifyContentSpaceBetween'}>
                                                <div className={'saf'}
                                                     style={{fontSize: `${isPhoneClientWidth ? 1.5 : .5}rem`}}>
                                                    {authorizeData.title}
                                                </div>
                                                <img onClick={() => toggleShowAuthorize()}
                                                     className={'cursorPointer'}
                                                     src={requireDefault('close')}
                                                     alt=""
                                                     style={{width: `${isPhoneClientWidth ? 1.5 : .5}rem`}}/>
                                            </div>
                                            <div
                                                className={isPhoneClientWidth ? 'childrenSpacingTopBigPhone' : 'childrenSpacingTopBigger'}>
                                                <div
                                                    className={`${isPhoneClientWidth ? 'childrenSpacingLeftPhone' : 'childrenSpacingLeft'} flexCenter`}>
                                                    <img src={requireDefault('integral')} alt=""
                                                         style={{width: `${isPhoneClientWidth ? 2.7 : .9}rem`}}/>
                                                    <div
                                                        className={`saf1 ${isPhoneClientWidth ? 'biggerFontSizePhone' : 'biggerFontSize'}`}>
                                                        {authorizePoints}
                                                    </div>
                                                </div>
                                                {
                                                    (() => {
                                                        const verify = () => requestApi(
                                                                `${authorizeKey}/verify`,
                                                                undefined,
                                                                'post'
                                                            ).then(r => {
                                                                toggleShowLoading()
                                                                if (isNotNull(r)) {
                                                                    toastSuccessful(true)
                                                                    getTask().then(v => setData({
                                                                        points: percentageNum(checkData0(v, -1)),
                                                                        migratePoints: percentageNum(checkData0(v, -2)),
                                                                        LIKWIDFipoints: percentageNum(checkData0(v, -3)),
                                                                        xPoint: checkData([v, 10, 'point']),
                                                                        tgPoint: checkData([v, 11, 'point']),
                                                                    }))
                                                                    toggleShowAuthorize()
                                                                } else if (authorizeKey === tGAuthorizeAuthorizeKey) {
                                                                    toast('Send my code on LIKWID Community')
                                                                    setData({tGShareDone: false})
                                                                }
                                                            }),
                                                            isTwitterBinded = checkDataBool(data, 'isTwitterBinded')
                                                        return (isTwitterBinded || !authorizeData.needBind)
                                                            ? <div
                                                                className={isPhoneClientWidth ? 'childrenSpacingTopBigPhone' : 'childrenSpacingTop'}>
                                                                {
                                                                    {
                                                                        x: () => {
                                                                            const twitterFollowDone = checkDataBool(data, 'twitterFollowDone'),
                                                                                twitterShareDone = checkDataBool(data, 'twitterShareDone')
                                                                            return [
                                                                                ['Follow @likwid_fi on X', 'Follow',
                                                                                    () => {
                                                                                        setData({twitterFollowDone: true})
                                                                                        windowOpen('https://x.com/intent/user?screen_name=likwid_fi')
                                                                                    }, true, twitterFollowDone],
                                                                                ['Share likwid platform on X', 'Share',
                                                                                    () => {
                                                                                        setData({twitterShareDone: true})
                                                                                        windowOpen(`https://x.com/share?text=${encodeURIComponent(`🚀 Likwid is Live: The First Oracle-Free Leveraged Trading Protocol 

Likwid empowers permissionless margin trading (long/short) and lending for any token — no oracles, no gatekeepers. 

Share this post and earn points! Let’s build the future together! 🚀💧"
https://likwid.fi/

#LIKWID`)}`)
                                                                                    }, twitterFollowDone, twitterShareDone],
                                                                                [`Get ${twitterAuthorizePoints} droplets`, 'Verify', () => {
                                                                                    toggleShowLoading(true)
                                                                                    verify()
                                                                                }, twitterFollowDone && twitterShareDone],
                                                                            ]
                                                                        },
                                                                        tg: () => {
                                                                            const tGFollowDone = checkDataBool(data, 'tGFollowDone'),
                                                                                tGShareDone = checkDataBool(data, 'tGShareDone')
                                                                            return [
                                                                                ['Join the LIKWID Community', 'Join',
                                                                                    () => {
                                                                                        setData({tGFollowDone: true})
                                                                                        windowOpen(likwidMemeTG)
                                                                                    }, true, tGFollowDone],
                                                                                ['Send my code on LIKWID Community', 'Send',
                                                                                    () => {
                                                                                        setData({tGShareDone: true})
                                                                                        requestApi('tg/code', {address}).then(code =>
                                                                                            (isPhoneClientWidth ? windowReplaceExternal : windowOpen)(`https://telegram.me/share/url?url=%2fcode%20likwid_${code}`))
                                                                                    }, tGFollowDone, tGShareDone],
                                                                                [`Get ${tGAuthorizePoints} droplets`, 'Verify', () => {
                                                                                    toggleShowLoading(true)
                                                                                    verify()
                                                                                }, tGFollowDone && tGShareDone],
                                                                            ]
                                                                        }
                                                                    }[authorizeKey]().map(v => {
                                                                        const isTrue = v[3], isDone = v[4]
                                                                        return <div
                                                                            className={'flexCenter justifyContentSpaceBetween'}>
                                                                            <div
                                                                                className={isPhoneClientWidth ? 'smallerFontSizePhone' : 'smallFontSize'}>{v[0]}</div>
                                                                            <div style={{
                                                                                padding: `${isPhoneClientWidth ? .2 : .1}rem 0`,
                                                                                width: `${isPhoneClientWidth ? 4 : 1.3}rem`,
                                                                                ...ternaryObject(
                                                                                    isDone,
                                                                                    {background: isDone ? '#4BD695' : '#FF7789'}
                                                                                )
                                                                            }}
                                                                                 onClick={() => isTrue && !isDone && v[2]()}
                                                                                 className={`${isTrue ? 'backgroundActiveColor' : 'backgroundWhite'} flexCenter ${isPhoneClientWidth ? 'childrenSpacingLeftSmallPhone borderSmallGrayLinePhone' : 'childrenSpacingLeftSmall borderSmallGrayLine'} borderRadius999 cursorPointer`}>
                                                                                <div
                                                                                    className={`${isTrue ? 'colorWhite' : 'colorGray'} ${isPhoneClientWidth ? 'smallerFontSizePhone' : 'smallFontSize'}`}>{isDone ? 'Done' : v[1]}</div>
                                                                                {isDone &&
                                                                                    <img
                                                                                        src={requireDefault('Ellipse 45')}
                                                                                        alt=""
                                                                                        style={{width: `${isPhoneClientWidth ? .7 : .25}rem`}}
                                                                                    />}
                                                                            </div>
                                                                        </div>
                                                                    })
                                                                }
                                                            </div>
                                                            : [
                                                                <div
                                                                    className={`textAlignCenter ${isPhoneClientWidth ? 'smallFontSizePhone' : ''}`}>
                                                                    Complete {authorizeKey.toLocaleUpperCase()} authorization
                                                                    before
                                                                    starting the
                                                                    task
                                                                </div>,
                                                                checkDataBool(data, 'isCloudflare')
                                                                    ? cloudflareHumanDiv
                                                                    : <div
                                                                        onClick={() => {
                                                                            const code_challenge = require('uuid').v4().slice(0, 10)
                                                                            windowReplaceExternal(
                                                                                'https://x.com/i/oauth2/authorize?response_type=code' +
                                                                                '&client_id=MUpkUS14Y3VFaWNGV1hFQnpoNUk6MTpjaQ' +
                                                                                `&redirect_uri=${redirectURI}` +
                                                                                '&scope=offline.access%20tweet.read%20users.read' +
                                                                                `&state=${[
                                                                                    code_challenge,
                                                                                ].join('_')}` +
                                                                                `&code_challenge=${code_challenge}` +
                                                                                '&code_challenge_method=plain'
                                                                            )
                                                                        }}
                                                                        className={`saf1 backgroundActiveColor colorWhite flexCenter cursorPointer width100 ${isPhoneClientWidth ? 'childrenSpacingLeftBigPhone borderRadiusPhone' : 'childrenSpacingLeftBig borderRadius'}`}
                                                                        style={{
                                                                            padding: `${isPhoneClientWidth ? .75 : .25}rem 0`,
                                                                        }}>
                                                                        Authorize
                                                                    </div>
                                                            ]
                                                    })()
                                                }
                                            </div>
                                        </div>
                                    </div>
                            })()
                        }
                        {maskContent(
                            'History',
                            showClaimedHistorys,
                            toggleShowClaimedHistorys,
                            <div style={{height: `${isPhoneClientWidth ? '70vh' : '10rem'}`}}
                                 className={'borderRadius flexColumn'}>
                                <div
                                    className={`backgroundGrey ${isPhoneClientWidth ? 'paddingBigPhone' : 'paddingBig'} flex alignItemsCenter childrenFlexGrow1`}>
                                    {['Claim Date', 'Claim Amount', ''].map((v, i) => <div
                                        className={`${i === 1 ? 'flexCenter' : ''} colorGray ${isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'}`}>{v}</div>)}
                                </div>
                                {(() => {
                                    return <div
                                        ref={claimedHistorysScroll}
                                        onScroll={() => onScrollFunc(claimedHistorysScroll, claimedHistorys, checkData0(data, 'claimedHistorysTotal'), () => setData({claimedHistorysPage: claimedHistorysPage + 1}))}
                                        className={`flexGrow1Column overflowYScroll boxSizingBorderBox  ${isPhoneClientWidth ? 'paddingBigPhone childrenSpacingTopBigPhone' : 'paddingBig childrenSpacingTopBig'}`}>
                                        {checkDataBool(data, 'getClaimedHistorysing')
                                            ? <div
                                                className={`height100 flexColumnCenter ${isPhoneClientWidth ? 'childrenSpacingTopBigPhone' : 'childrenSpacingTopBig'}`}>
                                                <img src={requireDefault('loading')}
                                                     alt=""
                                                     style={{width: `${isPhoneClientWidth ? 12 : 4}rem`}}/>
                                            </div>
                                            : (claimedHistorys.length
                                                ? claimedHistorys.map(v => {
                                                    const rewardAmount = times(checkData0(v, 'rewardAmount'), -1)
                                                    return <div
                                                        className={'flex alignItemsCenter childrenFlexGrow1'}>
                                                        <div
                                                            className={isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'}>{(new Date(checkDataString(v, 'createTime'))).toLocaleDateString(undefined, {
                                                            year: '2-digit',
                                                            month: '2-digit',
                                                            day: '2-digit',
                                                            hour: '2-digit',
                                                            minute: '2-digit'
                                                        })}</div>
                                                        <div
                                                            className={`${isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'} flexCenter`}>{numberETH(rewardAmount)}</div>
                                                        <div className={'flex justifyContentFlexEnd'}>
                                                            <div
                                                                onClick={() => oLIKWIDClaim(rewardAmount, v.id)}
                                                                className={`cursorPointer backgroundActiveColor borderRadius999 flexCenter saf1 ${isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'} colorWhite`}
                                                                style={{
                                                                    width: `${isPhoneClientWidth ? 4.5 : 1.5}rem`,
                                                                    height: `${isPhoneClientWidth ? 1.5 : .5}rem`
                                                                }}>Retry
                                                            </div>
                                                        </div>
                                                    </div>
                                                })
                                                : <div
                                                    className={`height100 flexColumnCenter ${isPhoneClientWidth ? 'childrenSpacingTopBigPhone' : 'childrenSpacingTopBig'}`}>
                                                    <img src={requireDefault('Group 427320250')}
                                                         alt=""
                                                         style={{width: `${isPhoneClientWidth ? 6 : 2}rem`}}/>
                                                    <pre
                                                        className={`textAlignCenter ${isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'}`}>{`Your histories will 
appear here.`}</pre>
                                                </div>)
                                        }
                                    </div>
                                })()}
                            </div>,
                            10
                        )}
                        {maskContent(
                            'I Want to Incentivize a Pool',
                            checkDataBool(data, 'showApply'),
                            toggleShowApply,
                            (() => {
                                const applyPoolData = {rewards: false, ...checkDataObject(data, 'applyPoolData')},
                                    setApplyPoolData = aPD => setData({applyPoolData: {...applyPoolData, ...aPD}}),
                                    applyPoolDataRewards = checkDataBool(applyPoolData, 'rewards')
                                return <div
                                    className={isPhoneClientWidth ? 'childrenSpacingTopBigPhone' : 'childrenSpacingTopBig'}>
                                    <div
                                        className={isPhoneClientWidth ? 'childrenSpacingTopPhone' : 'childrenSpacingTop'}>
                                        <div
                                            className={`saf1 ${isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'}`}>Token
                                            Symbol
                                        </div>
                                        <div
                                            className={`${isPhoneClientWidth ? 'borderRadiusPhone paddingPhone borderSmallGrayLinePhone' : 'borderRadius padding borderSmallGrayLine'} backgroundGrey`}>
                                            <input placeholder={'LIKWID'}
                                                   value={checkDataString(applyPoolData, 'symbol')}
                                                   onChange={e => setApplyPoolData({symbol: e.target.value})}
                                                   className={`width100`}
                                                   type="text"/>
                                        </div>
                                    </div>
                                    <div
                                        className={isPhoneClientWidth ? 'childrenSpacingTopPhone' : 'childrenSpacingTop'}>
                                        <div
                                            className={`saf1 ${isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'}`}>Token
                                            Logo
                                        </div>
                                        <div className={'positionRelative'}>
                                            <div
                                                className={`${isPhoneClientWidth ? 'borderRadiusPhone paddingPhone borderSmallGrayLinePhone childrenSpacingTopPhone' : 'borderRadius padding borderSmallGrayLine childrenSpacingTop'} backgroundGrey flexColumnCenter`}>
                                                <img
                                                    src={checkData([applyPoolData, 'logo'], requireDefault('upload button'))}
                                                    alt=""
                                                    style={square(`${isPhoneClientWidth ? 3 : 1}rem`)}/>
                                                <div
                                                    className={isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'}>
                                                    Drag and Drop file here or Choose file
                                                </div>
                                            </div>
                                            <input onChange={event => {
                                                toggleShowLoading(true)
                                                const formData = new FormData(),
                                                    removeValue = () => document.getElementById('uploadLogo').value = null;
                                                formData.append('file', event.target.files[0]);
                                                requestApi(
                                                    'upload/logo', formData, 'post',
                                                    {'Content-Type': 'multipart/form-data'}
                                                ).then(logo => {
                                                    if (isNotNullOrEmpty(logo)) {
                                                        setApplyPoolData({logo})
                                                    } else {
                                                        removeValue()
                                                    }
                                                    toggleShowLoading()
                                                }).catch(removeValue)
                                            }}
                                                   style={{
                                                       top: 0,
                                                       bottom: 0,
                                                       left: 0,
                                                       right: 0,
                                                       opacity: 0,
                                                   }}
                                                   className={`positionAbsolute cursorPointer`}
                                                   type="file"/>
                                        </div>
                                    </div>
                                    <div
                                        className={isPhoneClientWidth ? 'childrenSpacingTopPhone' : 'childrenSpacingTop'}>
                                        <div
                                            className={`saf1 ${isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'}`}>
                                            Token Address
                                        </div>
                                        <div
                                            className={`${isPhoneClientWidth ? 'borderRadiusPhone paddingPhone borderSmallGrayLinePhone' : 'borderRadius padding borderSmallGrayLine'} backgroundGrey`}>
                                            <input value={checkDataString(applyPoolData, 'address')}
                                                   onChange={e => setApplyPoolData({address: e.target.value})}
                                                   className={`width100`}
                                                   type="text"/>
                                        </div>
                                    </div>
                                    <div
                                        className={isPhoneClientWidth ? 'childrenSpacingTopPhone' : 'childrenSpacingTop'}>
                                        <div
                                            className={`saf1 ${isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'}`}>Telegram
                                        </div>
                                        <div
                                            className={`${isPhoneClientWidth ? 'borderRadiusPhone paddingPhone borderSmallGrayLinePhone' : 'borderRadius padding borderSmallGrayLine'} backgroundGrey`}>
                                            <input placeholder={likwidMemeTG}
                                                   value={checkDataString(applyPoolData, 'telegram')}
                                                   onChange={e => setApplyPoolData({telegram: e.target.value})}
                                                   className={`width100`}
                                                   type="text"/>
                                        </div>
                                    </div>
                                    <div
                                        className={isPhoneClientWidth ? 'childrenSpacingTopPhone' : 'childrenSpacingTop'}>
                                        <div
                                            className={`saf1 ${isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'}`}>X.com
                                        </div>
                                        <div
                                            className={`${isPhoneClientWidth ? 'borderRadiusPhone paddingPhone borderSmallGrayLinePhone' : 'borderRadius padding borderSmallGrayLine'} backgroundGrey`}>
                                            <input placeholder={twitterURL}
                                                   value={checkDataString(applyPoolData, 'x')}
                                                   onChange={e => setApplyPoolData({x: e.target.value})}
                                                   className={`width100`}
                                                   type="text"/>
                                        </div>
                                    </div>
                                    <div
                                        className={isPhoneClientWidth ? 'childrenSpacingTopPhone' : 'childrenSpacingTop'}>
                                        <div
                                            className={`saf1 ${isPhoneClientWidth ? 'smallFontSizePhone' : 'smallFontSize'}`}>
                                            Provide additional rewards
                                        </div>
                                        {[['Not available', false], ['Available', true]].map((v, i) => <div
                                            onClick={() => setApplyPoolData({rewards: v[1]})}
                                            className={`cursorPointer ${isPhoneClientWidth ? 'childrenSpacingLeftSmallPhone' : 'childrenSpacingLeftSmall'} flex alignItemsCenter`}
                                        >
                                            {(() => {
                                                const isCurrent = applyPoolDataRewards === v[1]
                                                return <div
                                                    className={`borderRadius999 ${isCurrent ? 'borderActiveColor' : 'backgroundGrey'} ${isPhoneClientWidth ? 'borderSmallGrayLinePhone' : 'borderSmallGrayLine'} flexCenter`}
                                                    style={{borderWidth: `${isPhoneClientWidth ? .09 : .03}rem`, ...square(`${isPhoneClientWidth ? .6 : .2}rem`)}}>
                                                    {isCurrent && <div style={square('80%')}
                                                                       className={'backgroundActiveColor borderRadius999'}/>}
                                                </div>
                                            })()}
                                            <div
                                                className={isPhoneClientWidth ? 'smallerFontSizePhone' : 'smallerFontSize'}>{v[0]}</div>
                                        </div>)}
                                        <div
                                            className={`flex ${isPhoneClientWidth ? 'borderRadiusPhone paddingPhone childrenSpacingLeftSmallPhone' : 'borderRadius padding childrenSpacingLeftSmall'}`}
                                            style={{
                                                background: 'linear-gradient(180deg, rgba(255, 185, 194, .2) 0%, rgba(255, 255, 255, .2) 100%)'
                                            }}>
                                            <img src={requireDefault('tips')} alt=""
                                                 style={square(`${isPhoneClientWidth ? .6 : .2}rem`)}/>
                                            <div
                                                className={isPhoneClientWidth ? 'smallerFontSizePhone' : 'smallerFontSize'}>
                                                LIKWID will review the applied projects. After the review is
                                                passed,
                                                APR rewards will be given to the LP established by the project
                                                and
                                                Native token, USDT, and USDC. If the project party is also
                                                willing to
                                                give additional rewards, LIKWID will give more APR
                                            </div>
                                        </div>
                                    </div>
                                    <div className={'flexCenter'}>
                                        <div
                                            onClick={() => requestApi(
                                                'margin/incentivize/token',
                                                {
                                                    chainId,
                                                    ...applyPoolData,
                                                    name: checkDataString(applyPoolData, 'symbol')
                                                },
                                                'post'
                                            ).then(v => {
                                                if (checkDataBool(v)) {
                                                    toastSuccessful(true)
                                                    toggleShowApply()
                                                }
                                            })}
                                            style={{padding: `${isPhoneClientWidth ? .3 : .1}rem ${isPhoneClientWidth ? 1.5 : .5}rem`}}
                                            className={`backgroundActiveColor borderRadius999 colorWhite flexCenter saf1 cursorPointer`}>
                                            Apply
                                        </div>
                                    </div>
                                </div>
                            })()
                        )}
                        {positionsPoolsContent}
                        {selectTokenContent}
                        {liquidityContent}
                        {loading}
                    </div>
                })()
            },
            pathNames = Object.keys(paths), [firstPath] = pathNames, useRefEffect = (fn = () => {
            }, inputs = []) => {
                const didMountRef = useRef(false)
                useEffect(() => {
                    fn(didMountRef.current)
                    if (!didMountRef.current) didMountRef.current = true
                }, inputs);
            }, maxSecond = 5, setMarginSecond = checkData0(data, 'setMarginSecond'),
            reloadMargin = setMarginSecond === maxSecond,
            reloadMarginShowMarginData = reloadMargin && showMarginData && !isBorrow,
            setTransitionPriceSecond = checkData0(data, 'setTransitionPriceSecond'),
            reloadSwap = setTransitionPriceSecond === maxSecond;
        [
            [
                () => {
                    localStorage.removeItem('wagmi.recentConnectorId')
                    setData({init: true})
                    setTimeout(
                        () => setData({loaded: true}),
                        3000
                    )
                    const getTop = () => setData({
                        isTop: (window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop) === 0
                    })
                    getTop()
                    window.addEventListener('scroll', getTop)
                },
            ],
            [
                () => {
                    if (devCount === 10) {
                        sessionDev ? sessionStorage.removeItem('dev') : sessionStorage.setItem('dev', 1)
                        location.reload()
                    }
                },
                [devCount]
            ],
            ...isEarn
                ? [
                    // [
                    //     () => {
                    //         const getLPTvl = () => {
                    //             setData({opacityShow: false})
                    //             return requestApi('margin/lp/tvl', {chainId: pointsChainId}).then(lpTvl => setTimeout(() => setData({
                    //                 lpTvl,
                    //                 opacityShow: true
                    //             }), 500)).catch(() => setTimeout(
                    //                 () => setData({opacityShow: true}), 500
                    //             ))
                    //         }
                    //         getLPTvl()
                    //         const setIntervalGetLPTvl = checkData([data, 'setIntervalGetLPTvl'])
                    //         if (isNotNull(setIntervalGetLPTvl)) {
                    //             clearInterval(setIntervalGetLPTvl)
                    //         }
                    //         setData({setIntervalGetLPTvl: setInterval(getLPTvl, 5000)})
                    //     },
                    //     // [pointsChainId]
                    // ],
                    [
                        () => address && getOLIKWIDReward(),
                        [address]
                    ],
                    [
                        () => getTokensPools(true)
                    ],
                    [
                        () => getTokensPools(false, {rewards: true}),
                        [page]
                    ],
                    [
                        () => earnIsPoolPositions && removeLiquidityOnclick(4, checkData0(earnIsPoolPositionData, 'liquidity'), earnIsPoolPositionData),
                        [earnIsPoolPositions]
                    ],
                    [
                        () => address && showClaimedHistorys && getClaimeds(),
                        [address, claimedHistorysPage]
                    ],
                    ...isEarn
                        ? [
                            [
                                () => address && requestApi(
                                    'margin/pool/liquidity/list',
                                    {
                                        chainId,
                                        page: earnYourPoolsPage,
                                        pageSize: 5,
                                        owner: address
                                    }, undefined, undefined, true
                                ).then(async v => {
                                    setData(
                                        {
                                            earnYourPools: [...isFirstPage(earnYourPoolsPage) ? [] : earnYourPools, ...await getLiquiditySupplyPositions(checkDataArray(v, 'items'), true)],
                                            earnYourPoolsTotal: checkData0(v, 'total')
                                        }
                                    )
                                    toggleShowLoading()
                                }),
                                [address, earnYourPoolsPage]
                            ]
                        ]
                        : [],
                    [
                        () => {
                            if (address) {
                                getTask(chainId).then(v => setData({
                                    swapAnyToken: checkData([v, 14, 'point']),
                                    marginAnyToken: checkData([v, 15, 'point']),
                                    borrowAnyPools: checkData([v, 16, 'point']),
                                    supplyAnyPools: checkData([v, 17, 'point']),
                                    lpActivityPoints: checkData([v, 18, 'point']),
                                }))
                                getTask().then(v => {
                                        setData({
                                            points: percentageNum(checkData0(v, -1)),
                                            xPoint: checkData([v, 10, 'point']),
                                            tgPoint: checkData([v, 11, 'point']),
                                            migratePoints: percentageNum(checkData0(v, -2)),
                                            LIKWIDFipoints: percentageNum(checkData0(v, -3)),
                                            identifyTeam: checkData([v, 12, 'point']),
                                            provideTeam: checkData([v, 13, 'point']),
                                        })
                                        lpPoint()
                                    }
                                )
                            }
                        },
                        [address]
                    ],
                    [
                        () => {
                            if (address) {
                                lpPoint()
                            }
                        },
                        // [pointsChainId]
                    ],
                    [
                        () => {
                            isNotNullOrEmpty(twitterCode) && address && token() && bindCheck().then(
                                isTwitterBinded => !isTwitterBinded && getTask().then(v => checkData0(v, 10, 'point') <= 0 && toggleShowAuthorize(true, true))
                            )
                        },
                        [isNotNull(address)]
                    ],
                    [
                        () => {
                            // console.log('cloudflareUpdate');
                            const setIntervalCloudflareUpdate = checkData([data, 'setIntervalCloudflareUpdate'])
                            if (isNotNull(setIntervalCloudflareUpdate)) {
                                clearInterval(setIntervalCloudflareUpdate)
                            }
                            setData({
                                setIntervalCloudflareUpdate: setInterval(() =>
                                    setData({cloudflareUpdate: checkData0(data, 'cloudflareUpdate') + 1}), 1000)
                            })
                            if (isNotNull(cloudflareHuman)) {
                                _turnstileCb(cloudflareHuman)
                            }
                        },
                        [cloudflareHuman],
                    ],
                    [
                        () => {
                            if (isNotNullOrEmpty(cloudflareHumanToken)) {
                                requestApi(
                                    `${authorizeKey}/bind`,
                                    {
                                        redirectURI,
                                        code: twitterCode,
                                        token: cloudflareHumanToken,
                                        codeVerifier: checkDataString(urlState, 0)
                                    },
                                    'post'
                                ).then(r => isNotNull(r) && setData({
                                    ...ternaryObject(
                                        isTwitterAuthorizeAuthorize(authorizeKey),
                                        {isTwitterBinded: true}
                                    ),
                                    showAuthorize: true
                                }))
                            }
                        },
                        [cloudflareHumanToken]
                    ]
                ]
                : [],
            ...isHome
                ? [
                    [
                        () => {
                            new BlurGradientBg({
                                dom: 'homeBlurGradientBg',
                                colors: ["#f2f2f2", "#eaecf1", "#ff8e9d", "#f2f2f2"],
                                loop: true
                            })
                            setTimeout(
                                () => setData({showHomeBlurGradientBg: true}),
                                100
                            )
                        }
                    ],
                    [
                        async () => {
                            const obj = {}
                            await Promise.all(
                                homeLPPools.map(async v => {
                                    const {poolId, chainId} = v
                                    obj[`${chainId}${poolId}`] = await requestApi(`margin/pool?poolIds=${poolId}`, {
                                        page,
                                        chainId,
                                        pageSize: 1
                                    }).then(v => getAPRs(checkDataObject(v, 'items', 0))[3])
                                })
                            )
                            setData({homeLPPoolsAPRS: obj})
                        }
                    ]
                ]
                : [
                    ...isOnlyMargin
                        ? [[
                            () => {
                                showTradingContest
                                    ? requestApi(
                                        'margin/trading/rank',
                                        {page: tradingContestPage, pageSize: 20, poolId: tradingContestPool.poolId, chainId}
                                    ).then(v => setData({
                                        tradingContestList: checkDataArray(v, 'items'),
                                        tradingContestTotal: checkDataArray(v, 'total')
                                    }))
                                    : setData({tradingContestPage: defaultPage})
                            },
                            [showTradingContest, tradingContestPage]
                        ]]
                        : [],
                    [
                        () => {
                            showPositionsPools && toggleShowPositionsPools()
                            if (address) {
                                slaveContractETH.getBalance(address).then(ethBalance => setData({ethBalance: numberETH(ethBalance)}))
                            }
                        },
                        [address]
                    ],
                    [
                        () => {
                            const {current} = focusInput
                            current && current.focus()
                        }
                    ],
                    [
                        () => {
                            !isPoolList && !isEarn && searchToken()
                            isSelectToken && requestApi(
                                `token/recommended/${chainId}`
                            ).then(v => setData({
                                recommendTokens: v.map(v => ({
                                    ...v,
                                    avatar: v.logo,
                                    tokenAddress: v.address,
                                }))
                            }))
                            !isHome && !isSelectToken && !isPoolList && !isEarn && searchToken(true)
                        },
                    ],
                    // [
                    //     () => {
                    //         if (tokenRecentSearchTokens.length > 0) {
                    //             if (isSelectToken && address && showSelectToken) {
                    //                 axios({
                    //                     method: 'post',
                    //                     url: rpc,
                    //                     headers: {'Content-Type': 'application/json'},
                    //                     data: JSON.stringify({
                    //                         jsonrpc: '2.0',
                    //                         method: 'alchemy_getTokenBalances',
                    //                         headers: {'Content-Type': 'application/json'},
                    //                         params: [`${address}`, 'erc20'],
                    //                         id: chainId
                    //                     })
                    //                 }).then(response =>
                    //                         setData({
                    //                             yourTokens: checkDataArray(response, 'data', 'result', 'tokenBalances')
                    //                                 .filter(token => token['tokenBalance'] !== '0x0000000000000000000000000000000000000000000000000000000000000000' &&
                    //                                     tokenRecentSearchTokens.map(v => checkDataString(v, 'tokenAddress').toLowerCase()).includes(checkDataString(token, 'contractAddress').toLowerCase())
                    //                                 ).map(v => {
                    //                                     const tokenMetadata = checkDataObject(tokenRecentSearchTokensMetadatas, checkDataString(v, 'contractAddress').toLowerCase())
                    //                                     return {
                    //                                         balance: numberETH(utils.hexToNumber(v['tokenBalance']), tokenMetadata.decimals),
                    //                                         ...tokenMetadata
                    //                                     }
                    //                                 })
                    //                         })
                    //                     // {
                    //                     //     // console.log(response);
                    //                     //     // const nonZeroBalances =
                    //                     //     //     response['data']['result']['tokenBalances'].filter(token => {
                    //                     //     //         return token['tokenBalance'] !== '0'
                    //                     //     //     })
                    //                     //     // for (const i in nonZeroBalances) {
                    //                     //     //     const token = nonZeroBalances[i]
                    //                     //     //     let balance = token['tokenBalance']
                    //                     //     //     console.log(Web3.utils.hexToNumber(balance));
                    //                     //     //     // const tokenAddress = token['contractAddress']
                    //                     //     //     // axios({
                    //                     //     //     //     method: 'post',
                    //                     //     //     //     url: rpc,
                    //                     //     //     //     headers: {'Content-Type': 'application/json'},
                    //                     //     //     //     data: JSON.stringify({
                    //                     //     //     //         jsonrpc: '2.0',
                    //                     //     //     //         method: 'alchemy_getTokenMetadata',
                    //                     //     //     //         params: [`${tokenAddress}`],
                    //                     //     //     //         id: chainId
                    //                     //     //     //     })
                    //                     //     //     // }).then(metadata => {
                    //                     //     //     //     metadata = metadata.data.result
                    //                     //     //     //     console.log(metadata);
                    //                     //     //     //     balance = balance / Math.pow(10, metadata['decimals']);
                    //                     //     //     //     balance = balance.toFixed(2);
                    //                     //     //     //     console.log(`${tokenAddress} ${metadata['name']}: ${balance} ${metadata['symbol']}`)
                    //                     //     //     // }).catch(error => console.log('error', error))
                    //                     //     // }
                    //                     // }
                    //                 ).catch(() => {
                    //                 })
                    //             }
                    //         }
                    //     },
                    //     [JSON.stringify(tokenRecentSearchTokens), address, showSelectToken]
                    // ],
                    ...tokenDatas.map(v => {
                        const {tokenAddress} = v
                        return [
                            () => {
                                if (tokenAddress) {
                                    setTokenData(v, {balance: 0})
                                    erc20CallDecimals(tokenAddress).then(async decimals => {
                                        // const name = await erc20Call(tokenAddress, 'name').catch(() => {
                                        //     }),
                                        //     symbol = await erc20Call(tokenAddress, 'symbol').catch(() => {
                                        //     })
                                        // console.log(i, tokenAddress, decimals, name, symbol, '---------------');
                                        setTokenData(v, {
                                            decimals,
                                            ...[inputCurrencyAddress, outputCurrencyAddress].includes(tokenAddress.toLowerCase())
                                                ? (isAddress0(tokenAddress)
                                                    ? {
                                                        name: coinName,
                                                        symbol: coinName
                                                    }
                                                    : {
                                                        name: await erc20Call(tokenAddress, 'name').catch(() => {
                                                        }),
                                                        symbol: await erc20Call(tokenAddress, 'symbol').catch(() => {
                                                        })
                                                    })
                                                : {},
                                            ...address
                                                ? {balance: numberETH(checkData0(await erc20CallBalance(tokenAddress), 0), decimals)}
                                                : {}
                                        })
                                    })
                                }
                            },
                            [tokenAddress, chainId, address]
                        ]
                    }),
                    ...(() => {
                        const func = () => {
                            if (poolDataPoolIdIsNotNull) {
                                const needOpacityShow = !isPool && (!isNotNullOrEmpty(newAmountStr) || isBorrow)
                                if (needOpacityShow) {
                                    setData({opacityShow: false})
                                }
                                getReserves(poolDataPoolId).then(([reserve0, reserve1]) => {
                                        console.log(reserve0, reserve1, '++++++++++++++');
                                        needOpacityShow
                                            ? setTimeout(
                                                () => setData({
                                                    reserve0,
                                                    reserve1,
                                                    opacityShow: true
                                                }),
                                                500
                                            )
                                            : setData({
                                                reserve0,
                                                reserve1,
                                            })
                                    }
                                ).catch(() => {
                                    if (needOpacityShow) {
                                        setTimeout(
                                            () => setData({opacityShow: true}),
                                            500
                                        )
                                    }
                                })
                            }
                        }
                        return [
                            [
                                func,
                                [chainId, poolDataPoolId]
                            ],
                            [
                                () => {
                                    if (reloadMargin) {
                                        func()
                                    }
                                },
                                [reloadMargin]
                            ]
                        ]
                    })(),
                    [
                        () => {
                            if (isSwap) {
                                if (greaterThan(newAmount, swapMax)) {
                                    toast(`The maximum amount is  ${swapMax}`)
                                }
                            }
                        },
                        [newAmount, swapMax]
                    ],
                    [
                        () => {
                            if (isPool && address && poolDataTokenIdIsNotNull) {
                                pairPositionGetPositionState(poolDataTokenId)
                                    .then(({liquidity = 0}) => setData({
                                        ownerLiquidity: liquidity,
                                        currentShares: divide(liquidity, poolData.totalSupply)
                                    }))
                            }
                        },
                        [chainId, address, poolDataTokenId, liquidityLevel]
                    ],
                    [
                        () => {
                            if (showLiquidity && removePoolDataPoolIdIsNotNull && address) {
                                setData({
                                    removePoolOwnerLiquidityMax: removePoolData.liquidity,
                                    removePoolCurrentShares: divide(removePoolData.liquidity, removePoolData.totalSupply)
                                })
                            }
                        },
                        [chainId, showLiquidity, address, removePoolDataPoolId, removePoolDataLevel]
                    ],
                    // [
                    //     () => {
                    //         if (isPool && address) {
                    //             searchPositionPool(1)
                    //         }
                    //     },
                    //     [address]
                    // ],
                    ...(() => {
                        const func = () => {
                            if (isTrade && poolDataPoolIdIsNotNull) {
                                getPoolStateInfo(poolDataPoolId)
                                    .then(v => setData({
                                                swapReserve0: checkData0(v, 'realReserve0'),
                                                swapReserve1: checkData0(v, 'realReserve1'),
                                                swapMirrorReserve0: checkData0(v, 'mirrorReserve0'),
                                                swapMirrorReserve1: checkData0(v, 'mirrorReserve1'),
                                                // liquidationLTV: numToPercentage(_liquidationLTV),
                                                truncatedReserve0: checkData0(v, 'truncatedReserve0'),
                                                truncatedReserve1: checkData0(v, 'truncatedReserve1'),
                                            }
                                        )
                                    )
                            }
                        }
                        return [
                            [func, [chainId, poolDataPoolId]],
                            [
                                () => {
                                    if (isMargin ? reloadMarginShowMarginData : reloadSwap) {
                                        func()
                                    }
                                },
                                [isMargin ? reloadMarginShowMarginData : reloadSwap]
                            ]
                        ]
                    })(),
                    // ...(() => {
                    //     const func = () => {
                    //         if (isTrade && !isSwap && poolDataPoolIdIsNotNull) {
                    //             marginFeesCall(
                    //                 'getPoolFees',
                    //                 pairPoolManagerAddress,
                    //                 poolDataPoolId,
                    //                 ...isMargin ? [true, 0] : [zeroForOne, newAmountWei],
                    //                 0
                    //             ).then(({_fee, _marginFee}) => setData({
                    //                         fee: numToPercentage(_marginFee),
                    //                         swapFee: numToPercentage(_fee),
                    //                     }
                    //                 )
                    //             )
                    //         }
                    //     }
                    //     return [
                    //         [func, [chainId, poolDataPoolId, ...isMargin ? [] : [zeroForOne, newAmountWei]]],
                    //         [
                    //             () => {
                    //                 if (reloadMarginShowMarginData) {
                    //                     func()
                    //                 }
                    //             },
                    //             [reloadMarginShowMarginData]
                    //         ]
                    //     ]
                    // })(),
                    // ...(() => {
                    //     const func = () => {
                    //         if (isMargin && !isBorrow && poolDataPoolIdIsNotNull) {
                    //             console.log(marginForOne,'-=-=-=');
                    //             marginFeesCall(
                    //                 'getPoolFees',
                    //                 pairPoolManagerAddress,
                    //                 poolDataPoolId,
                    //                 !marginForOne,
                    //                 0,
                    //                 marginTotal
                    //             ).then(({_fee}) => setData({_fee}))
                    //         }
                    //     }
                    //     return [
                    //         [func, [chainId, poolDataPoolId, marginTotal, marginForOne]],
                    //         [
                    //             () => {
                    //                 if (reloadMarginShowMarginData) {
                    //                     func()
                    //                 }
                    //             },
                    //             [reloadMarginShowMarginData]
                    //         ]
                    //     ]
                    // })(),
                    // [
                    //     () => {
                    //         if (isSwap && poolDataPoolIdIsNotNull) {
                    //             greaterThan(swapReserve, 0) && getAmountInFunc(
                    //                 BigInt(toInt(minus(swapReserve, 1))), undefined, undefined).then(swapMax =>
                    //                 setData({swapMax: lessThanOrEqualTo(swapMax, 0) ? 0 : numberETH(minus(swapMax, 1), marginToken0DataDecimals)})
                    //             )
                    //         }
                    //     },
                    //     [swapReserve0, swapReserve1, poolDataPoolId, zeroForOne]
                    // ],
                    ...(isPoolAddIncrease || isPoolDetail)
                        ? [
                            [
                                () => {
                                    if (poolDataPoolIdIsNotNull) {
                                        getAPY(poolDataPoolId, true)
                                            .then(apy0 => getAPY(poolDataPoolId, false)
                                                .then(apy1 => setData({
                                                        apy0: divide(apy0, 1000000),
                                                        apy1: divide(apy1, 1000000)
                                                    })
                                                )
                                            )
                                    }
                                },
                                [poolDataPoolId]
                            ],
                        ]
                        : [],
                    ...isPoolDetail
                        ? [
                            [
                                () => {
                                    if (poolDataPoolIdIsNotNull) {
                                        getPoolStateInfo(poolDataPoolId)
                                            .then(v => setData({
                                                suppliedReserve0: checkData0(v, 'realReserve0'),
                                                suppliedReserve1: checkData0(v, 'realReserve1'),
                                                borrowedReserve0: checkData0(v, 'mirrorReserve0'),
                                                borrowedReserve1: checkData0(v, 'mirrorReserve1'),
                                            }))
                                    }
                                },
                                [poolDataPoolId]
                            ],
                            [
                                () => {
                                    if (poolDataPoolIdIsNotNull) {
                                        // returns (uint24 stageSize, uint24 stageLeavePart, uint24 stageDuration, uint256 lastStageTimestamp) 这个方法返回4个值
                                        helperCall('getStageState', poolDataPoolId)
                                            .then(({
                                                       stageSize,
                                                       stageLeavePart,
                                                       stageDuration,
                                                       lastStageTimestamp
                                                   }) => helperCall('getStageLiquidities', poolDataPoolId).then(
                                                    stageLiquidities => slaveContractETH.getBlock()
                                                        .then(({timestamp}) =>
                                                            setData({
                                                                stageSize,
                                                                stageLiquidities,
                                                                stageLeavePart,
                                                                lastStageTimestampStore: lastStageTimestamp,
                                                                stageDuration,
                                                                blockCurrentTime: timestamp
                                                            })
                                                        )
                                                )
                                            ).catch(() => setData({
                                                stageLiquidities: [[1, 1], [0, 0], [0, 0], [0, 0], [0, 0]]
                                            })
                                        )
                                    }
                                },
                                [poolDataPoolId]
                            ],
                        ]
                        : [],
                    ...(isPoolAddIncrease || isPoolDetail)
                        ? [
                            [
                                () => {
                                    if (poolDataPoolIdIsNotNull) {
                                        getLendingAPR(poolDataPoolId, isPoolDetail ? false : marginForOne, token0NewAmountWei)
                                            .then(lendingAPR0 => setData({lendingAPR0}))
                                    }
                                },
                                [poolDataPoolId, marginForOne, token0NewAmountWei]
                            ],
                            [
                                () => {
                                    if (poolDataPoolIdIsNotNull) {
                                        getLendingAPR(poolDataPoolId, isPoolDetail ? true : marginForOne, token1NewAmountWei)
                                            .then(lendingAPR1 => setData({lendingAPR1}))
                                    }
                                },
                                [poolDataPoolId, marginForOne, token1NewAmountWei]
                            ]
                        ]
                        : [],
                    ...(isPoolDetail || isPoolWithdraw)
                        ? [
                            [
                                () => {
                                    if (poolDataPoolIdIsNotNull) {
                                        getPoolStateInfo(poolDataPoolId).then(
                                            ({
                                                 realReserve0,
                                                 realReserve1,
                                                 pairReserve0,
                                                 pairReserve1,
                                                 lendReserve0,
                                                 lendReserve1,
                                                 lendingRealReserve0,
                                                 lendingRealReserve1,
                                                 lendingMirrorReserve0,
                                                 lendingMirrorReserve1
                                             }) => {
                                                setData({
                                                    realReserve0,
                                                    realReserve1,
                                                    pairReserve0,
                                                    pairReserve1,
                                                    lendReserve0,
                                                    lendReserve1,
                                                    lendingRealReserve0,
                                                    lendingRealReserve1,
                                                    lendingMirrorReserve0,
                                                    lendingMirrorReserve1
                                                })
                                            }
                                        )
                                    }
                                },
                                [poolDataPoolId]
                            ]
                        ]
                        : [],
                    ...(isTrade || isSupply)
                        ? [
                            ...(() => {
                                const func = () => {
                                    if (poolDataPoolIdIsNotNull) {
                                        getAPY(poolDataPoolId, marginForOne)
                                            .then(v => setData({apy: numToPercentage(v)}))
                                    }
                                }
                                return [
                                    [
                                        func,
                                        [chainId, poolDataPoolId, marginForOne]
                                    ],
                                    [
                                        () => {
                                            if (reloadMarginShowMarginData) {
                                                func()
                                            }
                                        },
                                        [reloadMarginShowMarginData]
                                    ]
                                ]
                            })(),
                            ...(() => {
                                const func = () => {
                                    if ((isMargin || isSupply) && poolDataPoolIdIsNotNull) {
                                        getLendingAPR(
                                            poolDataPoolId,
                                            marginForOne,
                                            (isBorrow || isSupply)
                                                ? newAmountWei
                                                : plus(
                                                    newAmountWei,
                                                    isAfterMerged ? afterMarginTotal : marginTotal
                                                )
                                        ).then(lendingAPR => setData({lendingAPR}))
                                    }
                                }
                                return [
                                    [
                                        func,
                                        [
                                            poolDataPoolId,
                                            marginForOne,
                                            newAmountWei,
                                            ...(isBorrow || isSupply) ? [] : [
                                                isAfterMerged, afterMarginTotal, marginTotal
                                            ]
                                        ]
                                    ],
                                    [
                                        () => {
                                            if (reloadMarginShowMarginData) {
                                                func()
                                            }
                                        },
                                        [reloadMarginShowMarginData]
                                    ]
                                ]
                            })(),
                        ]
                        : [],
                    ...(() => {
                        const func = () => {
                            if (isSwap && poolDataPoolIdIsNotNull && !isInputTransitionPrice) {
                                setData({opacityShow: false})
                                setTransitionPrice(true)
                            }
                        }
                        return [
                            [func, [chainId, poolDataPoolId, zeroForOne, newAmountWei]],
                            [
                                () => {
                                    if (reloadSwap) {
                                        func()
                                    }
                                },
                                [reloadSwap]
                            ]
                        ]
                    })(),
                    ...(() => {
                        const func = () => {
                            if (isSwap && poolDataPoolIdIsNotNull && isInputTransitionPrice) {
                                setNewAmountTransitionPrice()
                            }
                        }
                        return [
                            [func, [chainId, poolDataPoolId, zeroForOne, transitionPriceWei]],
                            [
                                () => {
                                    if (reloadSwap) {
                                        func()
                                    }
                                },
                                [reloadSwap]
                            ]
                        ]
                    })(),
                    // ...(() => {
                    //     const func = () => {
                    //         if (isTrade && poolDataPoolIdIsNotNull && (!isSwap || !isInputTransitionPrice)) {
                    //             setTransitionPrice()
                    //         }
                    //     }
                    //     return [[func, [chainId, poolDataPoolId, zeroForOne, newAmountWei]], [() => {
                    //         if (reloadMarginShowMarginData) {
                    //             func()
                    //         }
                    //     }, [reloadMarginShowMarginData]],]
                    // })(),
                    // ...isSupplyWithdraw
                    //     ? [
                    //         [
                    //             () => {
                    //                 if (poolDataPoolIdIsNotNull) {
                    //                     setTransitionPrice()
                    //                 }
                    //             },
                    //             [poolDataPoolId, zeroForOne, newAmountWei]
                    //         ],
                    //         [
                    //             () => {
                    //                 setData({
                    //                     newAmount: undefined, newAmountWei: undefined, inputNewAmount: undefined
                    //                 })
                    //             },
                    //             [isMarginSell]
                    //         ]
                    //     ]
                    //     : [],
                    [
                        () => {
                            if (isMargin) {
                                setTimeout(() => setData({setMarginSecond: (setMarginSecond === maxSecond ? 0 : setMarginSecond) + 1}), 1000)
                            }
                        },
                        [setMarginSecond]
                    ],
                    [
                        () => {
                            if (showAdjust) {
                                setData({
                                    repayTokenDataNewAmount: undefined,
                                    repayTokenDataNewAmountWei: undefined
                                })
                            }
                        },
                        [increaseDecreaseIndex]
                    ],
                    [
                        () => {
                            if (isSwap) {
                                setData({newAmount: undefined, newAmountWei: undefined, inputNewAmount: undefined})
                            }
                        },
                        [poolDataPoolId, isMarginSell]
                    ],
                    [
                        () => {
                            if (isSwap) {
                                setTimeout(() => setData({setTransitionPriceSecond: (setTransitionPriceSecond === maxSecond ? 0 : setTransitionPriceSecond) + 1}), 1000)
                            }
                        },
                        [setTransitionPriceSecond, poolDataPoolId]
                    ],
                    ...(() => {
                        const func = () => {
                            if (isTrade && poolDataPoolIdIsNotNull) {
                                setData({unitPrice: num8(divide(newAmount, transitionPrice))})
                            }
                        }
                        return [
                            [
                                func,
                                [chainId, poolDataPoolId, newAmount, transitionPrice]
                            ],
                            [
                                () => {
                                    if (reloadMarginShowMarginData) {
                                        func()
                                    }
                                },
                                [reloadMarginShowMarginData]
                            ],
                        ]
                    })(),
                    ...[
                        [
                            () => helperCall('minMarginLevels').then(
                                ({0: minMarginLevel, 1: minBorrowLevel}) =>
                                    setData({
                                        minMarginLevel: divide(minMarginLevel, 1000000),
                                        minBorrowLevel: divide(minBorrowLevel, 1000000)
                                    })
                            )
                        ],
                        [
                            () => {
                                if (poolDataPoolIdIsNotNull) {
                                    greaterThan(newAmountWei)
                                        ? helperGetAmountOut(newAmountWei).then(async ({amountOut: borrowMax}) => {
                                            const afterBorrowMax = marginTokenId
                                                    ? (await helperGetAmountOut(toInt(plus(newAmountWei, positionMarginAmount)))).amountOut
                                                    : 0,
                                                borrowMaxMinMarginLevel = divide(borrowMax, minBorrowLevel),
                                                afterBorrowMaxMinMarginLevel = (() => {
                                                    const a = minus(divide(afterBorrowMax, minBorrowLevel), positionBorrowAmount)
                                                    return lessThan(a) ? 0 : a
                                                })(),
                                                borrowMaxAmountETH = toFixed(
                                                    times(
                                                        numberETH(
                                                            marginTokenId ? (
                                                                    lessThan(borrowMaxMinMarginLevel, afterBorrowMaxMinMarginLevel)
                                                                        ? borrowMaxMinMarginLevel
                                                                        : afterBorrowMaxMinMarginLevel
                                                                )
                                                                : borrowMaxMinMarginLevel,
                                                            marginToken1DataDecimals
                                                        ),
                                                        '0.99'
                                                    ),
                                                    greaterThan(marginToken1DataDecimals, 8) ? 8 : marginToken1DataDecimals
                                                )
                                            setData({
                                                beforeBorrowMaxAmount: formatEther(borrowMax, marginToken1DataDecimals),
                                                afterBorrowMaxAmount: formatEther(afterBorrowMax, marginToken1DataDecimals)
                                            })
                                            setNewBorrowAmount(borrowMaxAmountETH, borrowMaxAmountETH)
                                        })
                                        : setNewBorrowAmount()
                                }
                            },
                            [marginTokenId, positionMarginAmount, positionBorrowAmount, poolDataPoolId, newAmountWei, minBorrowLevel]
                        ],
                        // [
                        //     () => {
                        //         if (poolDataPoolIdIsNotNull) {
                        //             helperGetAmountOut(plus(newAmountWei, isAfterMerged ? positionMarginAmount : 0)).then(borrowMax => {
                        //                 console.log(borrowMax,'+++++++++++');
                        //                 setData({beforeBorrowMaxAmount: formatEther(borrowMax, marginToken1DataDecimals)})
                        //                 }
                        //             )
                        //         }
                        //     },
                        //     [isAfterMerged, positionMarginAmount, poolDataPoolId, newAmountWei, marginForOne, minMarginLevel, marginToken1DataDecimals, minBorrowLevel]
                        // ],
                        // [
                        //     () => {
                        //         setData({
                        //             borrowMarginLevel: getBorrowMarginLevel(newBorrowAmount)
                        //         })
                        //     },
                        //     [minMarginLevel, newBorrowAmount, borrowMaxAmount]
                        // ],
                        [
                            () => {
                                borrowMaxAmountToast()
                            },
                            [newBorrowAmount, borrowMaxAmount]
                        ]
                    ].map(v => [
                        () => {
                            if (isBorrow) {
                                v[0]()
                            }
                        },
                        v[1]
                    ]),
                    ...(() => {
                        const func = async () => {
                            if (isBorrow && poolDataPoolIdIsNotNull) {
                                const index = isMarginSell ? 1 : 0;
                                getPoolStateInfo(poolDataPoolId)
                                    .then(v => {
                                        const realReserve = checkData0(v, `realReserve${index}`),
                                            pairReserve = checkData0(v, `pairReserve${index}`)
                                        return helperGetAmountIn(
                                            toInt(times(
                                                lessThan(realReserve, pairReserve) ? realReserve : pairReserve,
                                                0.2
                                            ))
                                        ).then(({amountIn}) => setData({
                                            marginMax: numberETH(
                                                amountIn,
                                                marginToken0DataDecimals
                                            )
                                        }))
                                    }).finally(() => setData({getMarginMaxing: false}))
                            }
                        }
                        return [
                            [func, [chainId, poolDataPoolId, swapReserve0, swapReserve1, isMarginSell, zeroForOne, marginToken0DataDecimals]],
                            // [
                            //     () => {
                            //         if (reloadMarginShowMarginData) {
                            //             func()
                            //         }
                            //     },
                            //     [reloadMarginShowMarginData]
                            // ]
                        ]
                    })(),
                    ...isOnlyMargin
                        ? [
                            [

                                () => {
                                    if (!checkDataBool(data, 'setURLAmounted')) {
                                        const urlAmount = new URLSearchParams(location.search).get('amount')
                                        if (greaterThan(urlAmount)) {
                                            setInputNewAmount(urlAmount)
                                            setData({setURLAmounted: true})
                                        }
                                    }
                                },
                                [marginToken0DataDecimals]
                            ]
                        ]
                        : [],
                    [
                        () => {
                            if (isOnlyMargin && poolDataPoolIdIsNotNull) {
                                const index = isMarginSell ? 0 : 1,
                                    mul = ['0.15', '0.12', '0.09', '0.05', '0.017'][marginMaxLeverageIndex];
                                getPoolStateInfo(poolDataPoolId)
                                    .then(v => {
                                        const realReserve = checkData0(v, `realReserve${index}`),
                                            num = times(checkData0(v, `pairReserve${index}`), mul)
                                        setData({
                                            marginMax: numberETH(
                                                divide(greaterThan(num, realReserve) ? realReserve : num, leverage),
                                                marginToken0DataDecimals
                                            )
                                        })
                                    }).finally(() => setData({getMarginMaxing: false}))
                            }
                        },
                        [chainId, poolDataPoolId, marginForOne, leverage, marginToken0DataDecimals]
                    ],
                    [
                        () => {
                            if (!leverageIsComposite) {
                                toast(`Influence must be greater than ${leverageMin} and less than ${leverageMax}`)
                            }
                        },
                        [leverage]
                    ],
                    [
                        () => {
                            if (poolDataPoolIdIsNotNull && (!isNotNullOrEmpty(newAmountStr) || isBorrow || isTradeSupply)) {
                                // 0x089f50ac197c68e1bab2782435ce50f1afc8c656
                                // 0x4cc04330394860449b7a4b7e043eb01b943df9e0
                                // console.log(token0Symbol, token0Decimals, token1Symbol, token1Decimals);
                                console.log('Entry Price', num8(reserve0DivideReserve1));
                                setData({
                                    entryToken: num8(reserve0DivideReserve1)
                                })
                            }
                        },
                        [newAmountStr, reserve0DivideReserve1, poolDataPoolId, newAmountStr]
                    ],
                    [
                        () => {
                            if (isMargin || isSupplyWithdraw) {
                                setData({newAmount: undefined, newAmountWei: undefined, inputNewAmount: undefined})
                            }
                        },
                        [isMarginSell, poolDataPoolId]
                    ],
                    ...(() => {
                        const func = (needToast = true) => {
                            if (isMargin && poolDataPoolIdIsNotNull && newAmountNumber > 0 && !(isBorrow || isTradeSupply)) {
                                if (marginIsComposite && leverageIsComposite) {
                                    setData({opacityShow: false})
                                    const marginTotal = toInt(times(newAmountWei, leverage))
                                    // getAmountInFunc(marginTotal, marginForOne, undefined)
                                    helperGetAmountIn(
                                        marginTotal,
                                        marginForOne,
                                        poolDataPoolId,
                                        true
                                    ).then(({amountIn: borrowAmount, fee: _fee}) => helperCall(
                                        'getPoolFees',
                                        poolDataPoolId,
                                        ...isMargin ? [true, 0] : [zeroForOne, newAmountWei],
                                        0
                                    ).then(({_fee: _swap_fee, _marginFee}) => setTimeout(
                                        () => {
                                            _marginFee = numToPercentage(_marginFee)
                                            const marginTotalNoFee = toInt(
                                                minus(
                                                    marginTotal,
                                                    parseEtherNum(num8(times(times(newAmount, leverage), divide(_marginFee, 100))), marginToken0DataDecimals)
                                                )
                                            )
                                            setData({
                                                fee: _marginFee,
                                                swapFee: numToPercentage(_swap_fee),
                                                marginTotal: marginTotalNoFee, borrowAmount,
                                                ...isNotNullOrEmpty(newAmountStr)
                                                    ? {
                                                        entryToken: num8(divide(
                                                            ...(() => {
                                                                const arr = [
                                                                    numberETH(borrowAmount, marginToken1DataDecimals),
                                                                    numberETH(marginTotalNoFee, marginToken0DataDecimals)
                                                                ]
                                                                return isMarginSell ? arr.reverse() : arr
                                                            })()
                                                        ))
                                                    }
                                                    : {},
                                                opacityShow: true,
                                                ...isSwap ? {} : {_fee}
                                            })
                                        }, 500)
                                    )).catch(() =>
                                        setTimeout(() => setData({
                                            opacityShow: true
                                        }), 500))
                                } else {
                                    needToast && (isOnlyMargin ? isNotNull(checkData([data, 'marginMax'])) : true) && toast(`The maximum amount is ${marginMax}`)
                                }
                            }
                        }
                        return [
                            [func, [isMarginSell, chainId, zeroForOne, newAmountWei, marginMax]], [() => {
                                if (reloadMargin) {
                                    func(false)
                                }
                            },
                                [reloadMargin]
                            ]
                        ]
                    })(),
                    ...(() => {
                        const func = () => {
                            if (isMargin && poolDataPoolIdIsNotNull && isETHPool && !token0IsETH) {
                                getAmountOut(parseEtherNum(entryToken, token0Decimals), !zeroForOne).then(entryTokenETH => setData({entryTokenETH}))
                            }
                        }
                        return [
                            [func, [chainId, poolDataPoolId, zeroForOne, entryToken, isETHPool, token0IsETH, token0Decimals]], [() => {
                                if (reloadMarginShowMarginData) {
                                    func()
                                }
                            }, [reloadMarginShowMarginData]
                            ],
                        ]
                    })(),
                    ...(() => {
                        const func = () => {
                            if (isMargin && poolDataPoolIdIsNotNull && isETHPool && !token0IsETH) {
                                getAmountOut(parseEtherNum(liqToken, token0Decimals)).then(liqTokenETH => setData({liqTokenETH}))
                            }
                        }
                        return [
                            [func, [chainId, poolDataPoolId, zeroForOne, liqToken, isETHPool, token0IsETH, token0Decimals]], [() => {
                                if (reloadMarginShowMarginData) {
                                    func()
                                }
                            },
                                [reloadMarginShowMarginData]
                            ],
                        ]
                    })(), ...(() => {
                        const func = () => {
                            if (isMargin && poolDataPoolIdIsNotNull && isETHPool && !marginToken0IsETH) {
                                getAmountOut(parseEtherNum(showLiqToken, marginToken0DataDecimals)).then(showLiqTokenETH => setData({showLiqTokenETH}))
                            }
                        }
                        return [
                            [func, [chainId, poolDataPoolId, zeroForOne, showLiqToken, isETHPool, marginToken0IsETH, marginToken0DataDecimals]],
                            [
                                () => {
                                    if (reloadMarginShowMarginData) {
                                        func()
                                    }
                                },
                                [reloadMarginShowMarginData]
                            ],
                        ]
                    })(),
                    [
                        () => {
                            if (isMargin && poolDataPoolIdIsNotNull && address) {
                                setMarginTokenId()
                            }
                        },
                        [poolDataPoolId, marginForOne, address]
                    ],
                    ...(() => {
                        const func = () => {
                            if (isMargin && poolDataPoolIdIsNotNull && marginTokenId) {
                                getPositionState(marginTokenId).then(({
                                                                          marginAmount,
                                                                          marginTotal,
                                                                          debtAmount,
                                                                      }) => setData({
                                    positionMarginAmount: marginAmount,
                                    positionMarginTotal: marginTotal,
                                    positionBorrowAmount: debtAmount,
                                }))
                            }
                        }
                        return [
                            [
                                func,
                                [poolDataPoolId, marginTokenId]
                            ],
                            [
                                () => {
                                    if (reloadMarginShowMarginData) {
                                        func()
                                    }
                                },
                                [reloadMarginShowMarginData]
                            ]
                        ]
                    })(),
                    [
                        () => {
                            if (showRepaying && !repayTokenDataNewAmountEligible) {
                                toast(`The maximum amount is ${repayTokenDataBorrowAmountAPY}`)
                            }
                        },
                        [showRepaying, repayTokenDataNewAmountWei, repayTokenDataBorrowAmountAPY]
                    ],
                    [
                        () => {
                            if (showRepaying && isLiquidateCall && isNotNull(repayTokenDataTokenId)) {
                                helperCall('getLiquidateRepayAmount', repayTokenDataTokenId).catch(() => 0n).then(
                                    repayAmount => setData({repayAmount})
                                )
                            }
                        },
                        [showRepaying, isLiquidateCall, repayTokenDataTokenId]
                    ],
                    [
                        () => {
                            if (showRepaying && !repayTokenDataBorrowTokenIsETH && repayTokenDataNewAmountEligible) {
                                getRepayTokenPrice(repayTokenDataNewAmountWei).then(price =>
                                    getRepayTokenPrice(parseEtherNum(repayTokenDataBorrowAmountAPY, repayTokenDataBorrowDecimals)).then(borrowPrice => {
                                        const afterRepayTokenDataBorrowAmountWei = parseEtherNum(afterRepayTokenDataBorrowAmount, repayTokenDataBorrowDecimals)
                                        getRepayTokenPrice(afterRepayTokenDataBorrowAmountWei > 0 ? afterRepayTokenDataBorrowAmountWei : 0)
                                            .then(afterBorrowPrice =>
                                                setData({
                                                    repayTokenData: {
                                                        ...repayTokenData,
                                                        price,
                                                        borrowPrice,
                                                        afterBorrowPrice
                                                    }
                                                })
                                            )
                                    }))
                            }
                        },
                        [showRepaying, repayTokenDataPoolId, repayTokenDataNewAmountWei]
                    ],
                    [
                        () => {
                            if (showAdjust && isBorrowPositions) {
                                helperGetAmountOut(
                                    lessThan(adjustAfterMarginAmount)
                                        ? 0
                                        : parseEtherNum(adjustAfterMarginAmount, repayTokenDataMarginDecimals),
                                    !repayTokenData.marginForOne,
                                    repayTokenDataPoolId
                                ).then(v => setData({
                                    afterBorrowListMarginLevel: percentageNum(
                                        divide(
                                            formatEther(
                                                v.amountOut,
                                                repayTokenDataBorrowDecimals
                                            ),
                                            repayTokenDataBorrowAmount
                                        )
                                    )
                                }))
                            }
                        },
                        [showAdjust, repayTokenDataPoolId, adjustAfterMarginAmount]
                    ],
                    [
                        () => {
                            if (!isPoolDetail && isSelectTokenNotNeedToken && token1AddressIsNotNull &&
                                (!isPoolNeedUrlPoolId || !urlPoolId || checkDataBool(data, 'urlPoolGetEnd'))) {
                                tokenABPool(token0Address, token1Address).then(v =>
                                    v
                                        ? setData({poolData: v})
                                        : toast('Pool does not exist')
                                )
                            }
                        },
                        [token1AddressIsNotNull]
                    ],
                    ...isPoolAddIncrease
                        ? [
                            [
                                () => poolDataPoolIdIsNotNull && requestApi(
                                    'margin/pool/liquidity/list',
                                    {
                                        page: 1,
                                        pageSize: 1,
                                        chainId,
                                        poolId: poolDataPoolId,
                                        owner: address
                                    }).then(
                                    v => setData({poolDataTokenId: checkData([v, 'items', 0, 'tokenId'])})
                                ),
                                [address, poolDataPoolId]
                            ]
                        ]
                        : [],
                    [
                        () => {
                            if (isSwap && marginToken0TokenAddress !== marginToken1TokenAddress) {
                                tokenABPool(marginToken0TokenAddress, marginToken1TokenAddress, undefined, true).then(v => {
                                        v = v.filter(({fee}) => lessThanOrEqualTo(fee, toFeeTierBigInt(feeTiers[feeTiers.length - 1])))
                                        setData({
                                            poolData: isNotNullOrEmpty(v)
                                                ? checkDataObject(
                                                    v.reduce((a, b) => greaterThan(checkData0(a, 'pairReserve0'), checkData0(b, 'pairReserve0')) ? a : b)
                                                )
                                                : {}
                                        })
                                    }
                                )
                            }
                        },
                        [marginToken0TokenAddress, marginToken1TokenAddress]
                    ],
                    // ...[
                    //     [inputCurrencyAddressIsNotNull, inputCurrencyAddress, 'inputCurrency'],
                    //     [outputCurrencyAddressIsNotNull, outputCurrencyAddress, 'outputCurrency']
                    // ].map(v => [
                    //     async () => {
                    //         if (isSwap && v[0]) {
                    //             const tokenAddress = v[1],
                    //                 key = v[2]
                    //             if (isAddress0(tokenAddress)) {
                    //                 setData({[key]: ethToken})
                    //             } else {
                    //                 const name = await erc20Call(tokenAddress, 'name').catch(() => {
                    //                     }),
                    //                     symbol = await erc20Call(tokenAddress, 'symbol').catch(() => {
                    //                     }),
                    //                     decimals = await erc20Call(tokenAddress, 'decimals').catch(() => {
                    //                     })
                    //                 if (![name, symbol, decimals].includes(undefined)) {
                    //                     setData({[key]: {tokenAddress, name, symbol, decimals}})
                    //                 }
                    //             }
                    //         }
                    //     }
                    // ]),
                    [
                        () => {
                            if (showClosePosition) {
                                const rS = divide(range, 100)
                                helperGetAmountIn(
                                    toInt(times(repayTokenDataBorrowAmountWei, rS)),
                                    !repayTokenDataMarginForOne,
                                    repayTokenDataPoolId
                                ).then(v =>
                                    helperGetAmountIn(
                                        toInt(repayTokenDataNewAmountWei),
                                        !repayTokenDataMarginForOne,
                                        repayTokenDataPoolId,
                                        true
                                    ).catch(() => ({fee: 0, feeAmount: 0})).then(({fee, feeAmount}) => {
                                        const closeAmount = minus(
                                            times(plus(repayTokenDataMarginAmount, repayTokenData.marginTotal), rS),
                                            formatEther(v.amountIn, repayTokenDataMarginDecimals)
                                        )
                                        setData({
                                            closeAmount,
                                            closePNL: num8(minus(closeAmount, times(repayTokenDataMarginAmount, rS))),
                                            closeFee: fee,
                                            closeFeeAmount: feeAmount
                                        })
                                    })
                                )
                            } else {
                                setData({closePNL: undefined, closeFee: undefined, closeFeeAmount: undefined})
                            }
                        },
                        [showClosePosition, repayTokenDataNewAmountWei, repayTokenDataTokenId]
                    ],
                    [
                        () => {
                            if (showSelectToken && searchNameIsETHAddress && !allTokensIncludesSearchName &&
                                !searchAddressTokening
                            ) {
                                setData({searchAddressTokening: true})
                                erc20ContractData(searchName, true).then(
                                    v => setData({
                                        searchAddressTokens: v ? [v] : undefined,
                                        searchAddressTokening: undefined
                                    })
                                )
                            } else {
                                setData({searchAddressTokens: undefined})
                            }
                        },
                        [searchNameToLowerCase]
                    ],
                    [
                        () => {
                            !isPoolList && clearSearchName()
                            // searchToken
                        },
                        [showSelectToken]
                    ],
                    [
                        () => setData({beforeAfterMergedIndex: undefined}),
                        [isMarginSell]
                    ],
                    ...isPoolWithdraw
                        ? [
                            [
                                () => {
                                    if (poolDataPoolIdIsNotNull && address) {
                                        lendPoolTokenId().then(
                                            tokenId => isNotNull(tokenId) && getLendingTotal(tokenId).then(withdrawMax => setData({withdrawMax}))
                                        )
                                    }
                                },
                                [address, marginToken0TokenAddress, marginToken0DataDecimals, poolDataPoolId]
                            ]
                        ]
                        : [],
                    [
                        () => {
                            if (!isSelectToken && (isPool || showSelectToken)) {
                                !isPoolList && !isEarn && !isPoolDetail && searchToken()
                            }
                        },
                        [showSelectToken, searchName]
                    ],
                    ...isPoolList
                        ? [
                            [
                                () => {
                                    getTokensPools(true)
                                }
                            ],
                            [
                                () => {
                                    getTokensPools()
                                },
                                [page]
                            ],
                            [
                                () => [
                                    [0, 'totalStatistics'], [chainId, 'chainStatistics']
                                ].map(v => requestApi('margin/pool/statistics', {chainId: v[0]}).then(
                                    v1 => setData({[v[1]]: v1})
                                ))
                            ],
                        ]
                        : []
                ],
            // [
            //     () => {
            //         if (searchChainIsIncludes && !checkDataBool(data, 'switched') && chainId != defaultChain.id) {
            //             switchNetwork(defaultChain)
            //             setData({
            //                 switched: true
            //             })
            //         }
            //     },
            //     [chainId]
            // ],
            ...isSelectToken
                ? []
                : [
                    [
                        () => {
                            !isPoolList && !isPoolDetail && !isEarn && !isHome && getTokensPools()
                        },
                        [page]
                    ],
                    [
                        () => !isPoolList && poolDataPoolIdIsNotNull &&
                            getPoolDetail(poolDataPoolId).then(
                                v => setData({poolDataTVL: v.tvl, poolDataTradingContest: v.tradingContest})
                            ),
                        [poolDataPoolId]
                    ]
                ],
            // ...isHandelLiquidity
            //     ? [
            //         [
            //             () => getTokenPrice(token0Address),
            //             [token0Address]
            //         ]
            //     ]
            //     : [],
            [
                () => poolDataPoolIdIsNotNull && pairPositionCall('poolKeys', poolDataPoolId)
                    .then(({
                               currency0,
                               currency1,
                               fee,
                               marginFee
                           }) => setData({poolKey: [currency0, currency1, fee, marginFee]})),
                [poolDataPoolId]
            ]
        ].map(v => useEffect(
            () => {
                checkDataFunction(v, 0)()
            },
            checkDataArray(v, 1)
        ));
        [
            // [
            //     isLoadEnd => !isHome && isLoadEnd && getTokensPools(),
            //     [page]
            // ],
            [
                isLoadEnd => {
                    if (!isHome && isLoadEnd && isMarginPositions && address) {
                        getPositionPool(0)
                    }
                },
                [positionsPage, isHistory, positionsPoolIndex]
            ],
            [
                isLoadEnd => {
                    if (!isHome && isLoadEnd && !isMarginPositions && address) {
                        getPositionPool(1)
                    }
                },
                [poolPositionsPage, isHistory, positionsPoolIndex]
            ],
            [
                () => {
                    setData({[listLoadingKey]: undefined})
                },
                [isHistory, positionsPoolIndex]
            ],
            [
                isLoadEnd => {
                    if (isLoadEnd) {
                        if (!switchSearchNetwork) {
                            const newUrl = new URL(locationHref)
                            newUrl.searchParams.delete('poolid')
                            newUrl.searchParams.delete('chain')
                            locationHrefTo(newUrl.href)
                        }
                    } else {
                        if (searchChainIsIncludes && !equalTo(chainId, searchChainId)) {
                            switchSearchNetwork = true
                            switchNetwork(searchChainData)
                            location.reload()
                        }
                    }
                },
                [chainId]
            ],
            // [
            //     isLoadEnd => {
            //         if (isLoadEnd) {
            //             const newUrl = new URL(locationHref)
            //             newUrl.searchParams.delete('poolid')
            //             if (searchChainIsIncludes) {
            //                 if (checkDataBool(data, 'loaded')) {
            //                     newUrl.searchParams.delete('chain')
            //                     locationHrefTo(newUrl.href)
            //                 } else {
            //                     if (chainId == defaultChain.id) {
            //                         locationHrefTo(newUrl.href)
            //                     }
            //                 }
            //             } else {
            //                 locationHrefTo(newUrl.href)
            //             }
            //         }
            //     },
            //     [chainId]
            // ],
            [
                isLoadEnd => {
                    isLoadEnd && prevAddress.current && sessionStorage.removeItem('token')
                    prevAddress.current = address
                    isEarn && token() && bindCheck(twitterAuthorizeAuthorizeKey).then(isTwitterBinded => setData({isTwitterBinded}))
                },
                [address]
            ],
            [
                isLoadEnd => {
                    isPoolList && !isPoolDetail && isLoadEnd && searchToken()
                },
                [searchName]
            ]
        ].map(v => useRefEffect(...v));

        function replaceHome() {
            windowReplace(firstPath)
        }

        function toggleShowLoadingShowPositionsPools(i) {
            if (showPositionsPools) {
                toggleShowLoading()
            } else {
                !showLoading && toggleShowLoading(true)
                setTimeout(
                    () => {
                        toggleShowLoading()
                        toggleShowPositionsPools(i, [0, 1].includes(i) ? 0 : 1)
                    },
                    i === 2 ? 5000 : 0
                )
            }
        }

        // useAppKitAccount({
        //     onConnect: () => {
        //     },
        //     onDisconnect: () => {
        //     },
        // })
        // useAppKitNetwork()
        return [
            contextHolder,
            <Routes onChang={(() => document.title = `LIKWID${pathname ? `-${pNs1 ? pathname : pNs0}` : ''}`)()}>
                <Route path='*' element={<Navigate to={firstPath}/>}/>
                {pathNames.map(v => <Route key={v} path={v} element={paths[v]}/>)}
            </Routes>
        ]
    })
// createWeb3Modal({
//     wagmiConfig,
//     projectId,
//     chains,
//     themeVariables: {'--w3m-accent': '#FFB9C2'},
//     featuredWalletIds: ['c57ca95b47569778a828d19178114f4db188b89b763c899ba0be274e97267d96', '4622a2b2d6af1c9844944291e5e7351a6aa24cd7b23099efac1b2fd875da31a0', '0b415a746fb9ee99cce155c2ceca0c6f6061b1dbca2d722b3ba16381d0562150', '971e689d0a5be527bac79629b4ee9b925e82208e5168b733496a09c0faed0709'],
//     chainImages: (() => {
//         const walletConnectChainIcon = chain => requireDefault(`walletConnectChainIcons/${chain}`)
//         return {
//             1: walletConnectChainIcon('ETH'),
//             56: walletConnectChainIcon('BNB'),
//             97: walletConnectChainIcon('BNB'),
//             59144: walletConnectChainIcon('Linea'),
//             8453: walletConnectChainIcon('Base'),
//             534352: walletConnectChainIcon('Scroll'),
//             42161: walletConnectChainIcon('Arbitrum'),
//             10: walletConnectChainIcon('Optimism'),
//             1101: walletConnectChainIcon('Polygon zkEVM'),
//             81457: walletConnectChainIcon('Blast'),
//             60808: walletConnectChainIcon('BOB'),
//             421614: walletConnectChainIcon('Arbitrum'),
//             2442: walletConnectChainIcon('Polygon zkEVM'),
//             111: walletConnectChainIcon('BOB'),
//             167000: walletConnectChainIcon('Taiko'),
//             28516: walletConnectChainIcon('Vizing'),
//             28518: walletConnectChainIcon('Vizing'),
//         }
//     })()
// })
createAppKit({
    projectId,
    allowUnsupportedChain: location.pathname.slice(1).split('/')[0] === '',
    networks: chains,
    adapters: [wagmiAdapter],
    metadata: {
        name: 'LIKWID',
        description: 'LIKWID',
        url: 'https://likwid.fi',
        icons: ['https://likwid.fi/logo.png'],
    },
    features: {
        socials: [],
        send: false,
        email: false,
        swaps: false,
        onramp: false,
        emailShowWallets: false
    },
    featuredWalletIds: [
        'c57ca95b47569778a828d19178114f4db188b89b763c899ba0be274e97267d96',
        '971e689d0a5be527bac79629b4ee9b925e82208e5168b733496a09c0faed0709',
        '8a0ee50d1f22f6651afcae7eb4253e52a3310b90af5daef78a8c4929a9bb99d4',
        '4622a2b2d6af1c9844944291e5e7351a6aa24cd7b23099efac1b2fd875da31a0',
        'c03dfee351b6fcc421b4494ea33b9d4b92a984f87aa76d1663bb28705e95034a',
        '2bd8c14e035c2d48f184aaa168559e86b0e3433228d3c4075900a221785019b0'
    ],
    themeVariables: {'--w3m-accent': '#FFB9C2'},
    chainImages: (() => {
        const walletConnectChainIcon = chain => requireDefault(`walletConnectChainIcons/${chain}`)
        return {
            1: walletConnectChainIcon('ETH'),
            56: walletConnectChainIcon('BNB'),
            97: walletConnectChainIcon('BNB'),
            130: walletConnectChainIcon('Unichain'),
            1301: walletConnectChainIcon('Unichain'),
            59144: walletConnectChainIcon('Linea'),
            8453: walletConnectChainIcon('Base'),
            534352: walletConnectChainIcon('Scroll'),
            42161: walletConnectChainIcon('Arbitrum'),
            10: walletConnectChainIcon('Optimism'),
            1101: walletConnectChainIcon('Polygon zkEVM'),
            81457: walletConnectChainIcon('Blast'),
            60808: walletConnectChainIcon('BOB'),
            421614: walletConnectChainIcon('Arbitrum'),
            2442: walletConnectChainIcon('Polygon zkEVM'),
            111: walletConnectChainIcon('BOB'),
            10143: walletConnectChainIcon('Monad'),
            167000: walletConnectChainIcon('Taiko'),
            28516: walletConnectChainIcon('Vizing'),
            28518: walletConnectChainIcon('Vizing'),
            11155111: walletConnectChainIcon('ETH'),
            1439: walletConnectChainIcon('Injective'),
            1776: walletConnectChainIcon('Injective'),
            57054: walletConnectChainIcon('Sonic Blaze'),
            998: walletConnectChainIcon('Hyperliquid Testnet'),
            50312: walletConnectChainIcon('Somnia'),
        }
    })()
})
export default () => <WagmiProvider config={wagmiConfig}>
    <QueryClientProvider client={queryClient}><Profile/></QueryClientProvider>
</WagmiProvider>